import * as React$1 from "react";
import React, { Component, cloneElement, createElement, createRef, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { get, isEmpty, isNil, isNumber, trim } from "lodash-es";
import { v4 } from "uuid";
import { addDays, addHours, addMinutes, addMonths, addQuarters, addSeconds, addWeeks, addYears, differenceInCalendarDays, differenceInCalendarMonths, differenceInCalendarQuarters, differenceInCalendarYears, differenceInDays, endOfDay, endOfMonth, endOfWeek, endOfYear, format, getDate, getDay, getHours, getISOWeek, getMinutes, getMonth, getQuarter, getSeconds, getTime, getYear, isAfter, isBefore, isDate, isEqual, isSameDay, isSameMonth, isSameQuarter, isSameYear, isValid, isWithinInterval, max, min, parse, parseISO, setHours, setMinutes, setMonth, setQuarter, setSeconds, setYear, startOfDay, startOfMonth, startOfQuarter, startOfWeek, startOfYear, subDays, subMonths, subQuarters, subWeeks, subYears, toDate } from "date-fns";
import { jsx, jsxs } from "react/jsx-runtime";
import ReactDOM, * as ReactDOM$1 from "react-dom";
import "@tecnobit-srl/content-types-form-date/css";
import { FormLabel } from "@tecnobit-srl/content-types-form-label/lazy";
import { FontAwesome } from "@tecnobit-srl/ui-font-awesome";
import { FormError } from "@tecnobit-srl/content-types-form-error/lazy";
import { usePage } from "@tecnobit-srl/router";
import { useFormContext } from "react-hook-form";
import { useFormContext as useFormContext$1, useFormStepContext } from "@tecnobit-srl/hook-use-form-context";
import { useFormValidation } from "@tecnobit-srl/hook-use-form-validation";
import { useFormPrefillValues } from "@tecnobit-srl/hook-use-form-prefill-values";
//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esmMin = (fn, res, err) => () => {
	if (err) throw err[0];
	try {
		return fn && (res = fn(fn = 0)), res;
	} catch (e) {
		throw err = [e], e;
	}
};
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
		key = keys[i];
		if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: ((k) => from[k]).bind(null, key),
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toCommonJS = (mod) => __hasOwnProp.call(mod, "module.exports") ? mod["module.exports"] : __copyProps(__defProp({}, "__esModule", { value: true }), mod);
//#endregion
//#region ../../styled-system/styled-system/helpers.js
function isObject(v) {
	return typeof v === "object" && v != null && !Array.isArray(v);
}
var HAS_OWN = Object.prototype.hasOwnProperty;
function isBaseCondition(v) {
	return v === "base";
}
function filterBaseConditions(c) {
	const out = [];
	for (let i = 0; i < c.length; i++) if (!isBaseCondition(c[i])) out.push(c[i]);
	return out;
}
function toHash(v) {
	let h = 5381;
	for (let i = v.length; i;) h = h * 33 ^ v.charCodeAt(--i);
	let x = h >>> 0, out = "";
	for (; x > 52; x = x / 52 | 0) {
		const c = x % 52;
		out = String.fromCharCode(c + (c > 25 ? 39 : 97)) + out;
	}
	const c = x % 52;
	return String.fromCharCode(c + (c > 25 ? 39 : 97)) + out;
}
function toResponsiveObject(values, breakpoints) {
	const out = {};
	for (let i = 0; i < values.length; i++) if (values[i] != null) out[breakpoints[i]] = values[i];
	return out;
}
function walkObject(target, fn, options) {
	options ||= {};
	const { stop, getKey } = options;
	const inner = (value, path = []) => {
		if (!value || typeof value !== "object") return fn(value, path);
		if (stop?.(value, path)) return fn(value, path);
		const out = Array.isArray(value) ? [] : {};
		for (const prop in value) {
			if (!HAS_OWN.call(value, prop) || prop === "__proto__") continue;
			const key = getKey?.(prop, value[prop]) ?? prop;
			path.push(key);
			const next = inner(value[prop], path);
			path.pop();
			if (next != null) out[key] = next;
		}
		return out;
	};
	return inner(target);
}
function normalizeStyleObject(styles, context, shorthand) {
	const { utility, conditions } = context;
	const { hasShorthand, resolveShorthand } = utility;
	shorthand = shorthand !== false;
	return walkObject(styles, (value) => {
		if (Array.isArray(value)) return toResponsiveObject(value, conditions.breakpoints.keys);
		return value;
	}, {
		stop: Array.isArray,
		getKey: shorthand ? (prop) => hasShorthand ? resolveShorthand(prop) : prop : void 0
	});
}
function flatHashOrNull(args) {
	let h = 5381;
	for (let a = 0; a < args.length; a++) {
		const obj = args[a];
		if (obj === null || typeof obj !== "object") {
			h = h * 33 ^ 1;
			continue;
		}
		for (const k in obj) {
			const v = obj[k];
			const tv = typeof v;
			if (v !== null && tv === "object") return null;
			for (let i = 0; i < k.length; i++) h = h * 33 ^ k.charCodeAt(i);
			if (tv === "string") for (let i = 0; i < v.length; i++) h = h * 33 ^ v.charCodeAt(i);
			else if (tv === "number") h = h * 33 ^ (v | 0);
			else if (tv === "boolean") h = h * 33 ^ (v ? 991 : 997);
			else h = h * 33 ^ 2;
		}
	}
	return h >>> 0;
}
function flatArgsEqual(a, b) {
	if (a.length !== b.length) return false;
	for (let i = 0; i < a.length; i++) {
		const oa = a[i];
		const ob = b[i];
		if (oa === ob) continue;
		if (oa === null || ob === null || typeof oa !== "object" || typeof ob !== "object") return false;
		let n = 0;
		for (const k in oa) {
			if (oa[k] !== ob[k]) return false;
			n++;
		}
		if (n !== Object.keys(ob).length) return false;
	}
	return true;
}
function memo(fn) {
	const cache = /* @__PURE__ */ new Map();
	const stringCache = /* @__PURE__ */ new Map();
	const seen = /* @__PURE__ */ new WeakSet();
	const newNode = () => ({
		objects: /* @__PURE__ */ new WeakMap(),
		prims: /* @__PURE__ */ new Map(),
		out: void 0,
		has: false
	});
	const root = newNode();
	let lastHash;
	let lastKey;
	let lastValue;
	let hasLast = false;
	let misses = 0;
	const step = (node, v) => {
		if (v !== null && typeof v === "object") {
			let next = node.objects.get(v);
			if (next === void 0) {
				next = newNode();
				node.objects.set(v, next);
			}
			return next;
		}
		let next = node.prims.get(v);
		if (next === void 0) {
			if (node.prims.size > 64) node.prims.clear();
			next = newNode();
			node.prims.set(v, next);
		}
		return next;
	};
	const walk = (node, v) => {
		if (Array.isArray(v)) {
			node = step(node, "\0[");
			for (let i = 0; i < v.length; i++) node = walk(node, v[i]);
			return step(node, "\0]");
		}
		return step(node, v);
	};
	const readWalk = (node, v) => {
		if (node === void 0) return void 0;
		if (Array.isArray(v)) {
			node = node.prims.get("\0[");
			for (let i = 0; i < v.length && node !== void 0; i++) node = readWalk(node, v[i]);
			return node === void 0 ? void 0 : node.prims.get("\0]");
		}
		return v !== null && typeof v === "object" ? node.objects.get(v) : node.prims.get(v);
	};
	const markSeen = (v) => {
		if (Array.isArray(v)) {
			let all = true;
			for (let i = 0; i < v.length; i++) if (!markSeen(v[i])) all = false;
			return all;
		}
		if (v === null || typeof v !== "object") return true;
		if (seen.has(v)) return true;
		seen.add(v);
		return false;
	};
	return ((...args) => {
		let composed = false;
		for (let i = 0; i < args.length; i++) if (Array.isArray(args[i])) {
			composed = true;
			break;
		}
		if (composed) {
			let node = root;
			for (let i = 0; i < args.length && node !== void 0; i++) node = readWalk(node, args[i]);
			if (node !== void 0 && node.has) return node.out;
			const composedKey = JSON.stringify(args);
			let composedOut = hasLast && lastHash === void 0 && composedKey === lastKey ? lastValue : stringCache.get(composedKey);
			if (composedOut === void 0) {
				composedOut = fn(...args);
				stringCache.set(composedKey, composedOut);
				if (stringCache.size > 500) stringCache.delete(stringCache.keys().next().value);
			}
			let reused = false;
			if ((++misses & 3) === 0) {
				reused = true;
				for (let i = 0; i < args.length; i++) if (!markSeen(args[i])) reused = false;
			}
			if (reused) {
				let insert = root;
				for (let i = 0; i < args.length; i++) insert = walk(insert, args[i]);
				insert.out = composedOut;
				insert.has = true;
			}
			lastHash = void 0;
			lastKey = composedKey;
			lastValue = composedOut;
			hasLast = true;
			return composedOut;
		}
		const hash = flatHashOrNull(args);
		if (hash !== null) {
			if (hasLast && lastHash === hash && flatArgsEqual(args, lastKey)) return lastValue;
			let bucket = cache.get(hash);
			if (bucket) {
				for (let i = 0; i < bucket.length; i++) if (flatArgsEqual(args, bucket[i].args)) {
					lastHash = hash;
					lastKey = args;
					lastValue = bucket[i].out;
					hasLast = true;
					return bucket[i].out;
				}
			}
			const out = fn(...args);
			if (!bucket) {
				bucket = [];
				cache.set(hash, bucket);
			}
			bucket.push({
				args,
				out
			});
			if (bucket.length > 8) bucket.shift();
			if (cache.size > 500) cache.delete(cache.keys().next().value);
			lastHash = hash;
			lastKey = args;
			lastValue = out;
			hasLast = true;
			return out;
		}
		const key = JSON.stringify(args);
		if (hasLast && lastHash === void 0 && key === lastKey) return lastValue;
		const cached = stringCache.get(key);
		if (cached !== void 0) {
			lastHash = void 0;
			lastKey = key;
			lastValue = cached;
			hasLast = true;
			return cached;
		}
		const out = fn(...args);
		stringCache.set(key, out);
		if (stringCache.size > 500) stringCache.delete(stringCache.keys().next().value);
		lastHash = void 0;
		lastKey = key;
		lastValue = out;
		hasLast = true;
		return out;
	});
}
function weakMemo(fn) {
	const cache = /* @__PURE__ */ new WeakMap();
	return ((arg) => {
		if (!arg || typeof arg !== "object") return fn(arg);
		if (cache.has(arg)) return cache.get(arg);
		const out = fn(arg);
		cache.set(arg, out);
		return out;
	});
}
function mergeProps(...src) {
	const out = {};
	for (const obj of src) {
		if (!obj) continue;
		for (const k in obj) {
			if (!HAS_OWN.call(obj, k) || k === "__proto__" || k === "constructor" || k === "prototype") continue;
			const prev = out[k];
			const next = obj[k];
			out[k] = isObject(prev) && isObject(next) ? mergeProps(prev, next) : next;
		}
	}
	return out;
}
var WHITESPACE_REGEX = /[\n\s]+/g;
var sanitizeStyleValue = (value) => typeof value === "string" ? value.replace(WHITESPACE_REGEX, " ") : value;
function resolveStyleArgs(styles, context) {
	const out = [];
	const visit = (items) => {
		for (let i = 0; i < items.length; i++) {
			const style = items[i];
			if (Array.isArray(style)) {
				visit(style);
				continue;
			}
			if (!isObject(style)) continue;
			for (const key in style) if (style[key] !== void 0) {
				out.push(style);
				break;
			}
		}
	};
	visit(styles);
	if (out.length < 2) return out;
	for (let i = 0; i < out.length; i++) out[i] = normalizeStyleObject(out[i], context);
	return out;
}
function createSerializeCss(context) {
	const u = context.utility;
	const c = context.conditions;
	const hash = context.hash;
	const fmt = (s) => u.prefix ? u.prefix + "-" + s : s;
	const toClass = (paths, name) => {
		const parts = c.finalize(paths);
		parts.push(hash ? name : fmt(name));
		return hash ? fmt(u.toHash(parts, toHash)) : parts.join(":");
	};
	return weakMemo(memo(function serializeCss({ base, ...styles } = {}) {
		const obj = normalizeStyleObject(base ? Object.assign(styles, base) : styles, context);
		const set = /* @__PURE__ */ new Set();
		walkObject(obj, (value, paths) => {
			if (value == null) return;
			const important = isImportant(value);
			const [prop, ...all] = c.shift(paths);
			const cond = filterBaseConditions(all);
			const res = u.transform(prop, withoutSpace(withoutImportant(sanitizeStyleValue(value))));
			let name = toClass(cond, res.className);
			if (important) name += "!";
			set.add(name);
		});
		let out = "";
		for (const name of set) out += out ? " " + name : name;
		return out;
	}));
}
function createMergeCss(context) {
	return function mergeCss() {
		return mergeProps(...resolveStyleArgs(arguments, context));
	};
}
function createSerializeCssArgs(serializeCss, mergeCss) {
	return memo(function serializeCssArgs(...styles) {
		return serializeCss(mergeCss(...styles));
	});
}
var HYPHENATE_PROPERTY_REGEX = /[A-Z]/g;
var MS_PROPERTY_REGEX = /^ms-/;
function hypenateProperty(property) {
	return property.startsWith("--") ? property : property.replace(HYPHENATE_PROPERTY_REGEX, "-$&").replace(MS_PROPERTY_REGEX, "-ms-").toLowerCase();
}
function withoutSpace(str) {
	return typeof str === "string" && str.indexOf(" ") >= 0 ? str.replaceAll(" ", "_") : str;
}
var IMPORTANT_REGEX = /\s*!(important)?\s*$/i;
function isImportant(value) {
	return typeof value === "string" ? IMPORTANT_REGEX.test(value) : false;
}
function withoutImportant(value) {
	return typeof value === "string" ? value.replace(IMPORTANT_REGEX, "").trim() : value;
}
//#endregion
//#region ../../styled-system/styled-system/css/conditions.js
var conditions = /* @__PURE__ */ new Set(/* @__PURE__ */ "2xl,2xlDown,2xlOnly,2xlToDesktop,2xlToTablet,2xlToXs,@/2xl,@/2xlDown,@/2xlOnly,@/2xlTo3xl,@/2xlTo4xl,@/2xlTo5xl,@/2xlTo6xl,@/2xlTo7xl,@/2xlTo8xl,@/2xs,@/2xsDown,@/2xsOnly,@/2xsTo2xl,@/2xsTo3xl,@/2xsTo4xl,@/2xsTo5xl,@/2xsTo6xl,@/2xsTo7xl,@/2xsTo8xl,@/2xsToLg,@/2xsToMd,@/2xsToSm,@/2xsToXl,@/2xsToXs,@/3xl,@/3xlDown,@/3xlOnly,@/3xlTo4xl,@/3xlTo5xl,@/3xlTo6xl,@/3xlTo7xl,@/3xlTo8xl,@/3xs,@/3xsDown,@/3xsOnly,@/3xsTo2xl,@/3xsTo2xs,@/3xsTo3xl,@/3xsTo4xl,@/3xsTo5xl,@/3xsTo6xl,@/3xsTo7xl,@/3xsTo8xl,@/3xsToLg,@/3xsToMd,@/3xsToSm,@/3xsToXl,@/3xsToXs,@/4xl,@/4xlDown,@/4xlOnly,@/4xlTo5xl,@/4xlTo6xl,@/4xlTo7xl,@/4xlTo8xl,@/5xl,@/5xlDown,@/5xlOnly,@/5xlTo6xl,@/5xlTo7xl,@/5xlTo8xl,@/6xl,@/6xlDown,@/6xlOnly,@/6xlTo7xl,@/6xlTo8xl,@/7xl,@/7xlDown,@/7xlOnly,@/7xlTo8xl,@/8xl,@/8xlDown,@/8xlOnly,@/lg,@/lgDown,@/lgOnly,@/lgTo2xl,@/lgTo3xl,@/lgTo4xl,@/lgTo5xl,@/lgTo6xl,@/lgTo7xl,@/lgTo8xl,@/lgToXl,@/md,@/mdDown,@/mdOnly,@/mdTo2xl,@/mdTo3xl,@/mdTo4xl,@/mdTo5xl,@/mdTo6xl,@/mdTo7xl,@/mdTo8xl,@/mdToLg,@/mdToXl,@/sm,@/smDown,@/smOnly,@/smTo2xl,@/smTo3xl,@/smTo4xl,@/smTo5xl,@/smTo6xl,@/smTo7xl,@/smTo8xl,@/smToLg,@/smToMd,@/smToXl,@/xl,@/xlDown,@/xlOnly,@/xlTo2xl,@/xlTo3xl,@/xlTo4xl,@/xlTo5xl,@/xlTo6xl,@/xlTo7xl,@/xlTo8xl,@/xs,@/xsDown,@/xsOnly,@/xsTo2xl,@/xsTo3xl,@/xsTo4xl,@/xsTo5xl,@/xsTo6xl,@/xsTo7xl,@/xsTo8xl,@/xsToLg,@/xsToMd,@/xsToSm,@/xsToXl,_active,_after,_anyPointerCoarse,_anyPointerFine,_anyPointerNone,_atValue,_autofill,_backdrop,_before,_checked,_closed,_complete,_current,_currentPage,_currentStep,_dark,_default,_disabled,_dragging,_empty,_enabled,_even,_expanded,_file,_first,_firstLetter,_firstLine,_firstOfType,_focus,_focusVisible,_focusWithin,_fullscreen,_grabbed,_groupActive,_groupChecked,_groupDisabled,_groupExpanded,_groupFocus,_groupFocusVisible,_groupFocusWithin,_groupHover,_groupInvalid,_hidden,_highContrast,_highlighted,_horizontal,_hover,_icon,_inRange,_incomplete,_indeterminate,_inert,_invalid,_invertedColors,_landscape,_last,_lastOfType,_lessContrast,_light,_loading,_ltr,_marker,_moreContrast,_motionReduce,_motionSafe,_noscript,_now,_odd,_only,_onlyOfType,_open,_optional,_osDark,_osLight,_outOfRange,_overValue,_peerActive,_peerChecked,_peerDisabled,_peerExpanded,_peerFocus,_peerFocusVisible,_peerFocusWithin,_peerHover,_peerInvalid,_peerPlaceholderShown,_placeholder,_placeholderShown,_pointerCoarse,_pointerFine,_pointerNone,_portrait,_pressed,_print,_rangeEnd,_rangeStart,_readOnly,_readWrite,_required,_rtl,_scrollbar,_scrollbarThumb,_scrollbarTrack,_selected,_selection,_starting,_target,_today,_topmost,_unavailable,_underValue,_userInvalid,_userValid,_valid,_vertical,_visited,base,desktop,desktopDown,desktopOnly,lg,lgDown,lgOnly,lgTo2xl,lgToDesktop,lgToTablet,lgToXl,lgToXs,md,mdDown,mdOnly,mdTo2xl,mdToDesktop,mdToLg,mdToTablet,mdToXl,mdToXs,sm,smDown,smOnly,smTo2xl,smToDesktop,smToLg,smToMd,smToTablet,smToXl,smToXs,tablet,tabletDown,tabletOnly,tabletToDesktop,xl,xlDown,xlOnly,xlTo2xl,xlToDesktop,xlToTablet,xlToXs,xs,xsDown,xsOnly,xsToDesktop,xsToTablet".split(","));
var conditionRe = /^@|&/;
var underscoreRe = /^_/;
var selectorRe = /&|@/;
var breakpointKeys = [
	"base",
	"sm",
	"md",
	"lg",
	"xl",
	"2xl",
	"xs",
	"tablet",
	"desktop"
];
function isCondition(v) {
	return conditions.has(v) || conditionRe.test(v);
}
function finalizeConditions(paths) {
	return paths.map((p) => {
		if (conditions.has(p)) return p.replace(underscoreRe, "");
		if (selectorRe.test(p)) return `[${withoutSpace(p.trim())}]`;
		return p;
	});
}
function sortConditions(paths) {
	return [...paths].sort((a, b) => {
		const aa = isCondition(a);
		const bb = isCondition(b);
		return aa && !bb ? 1 : !aa && bb ? -1 : 0;
	});
}
//#endregion
//#region ../../styled-system/styled-system/css/css.js
var utilities = "WebkitTextFillColor:wktf-c,accentColor:ac-c,alignContent:ac,alignItems:ai,alignSelf:as,animation:anim,animationComposition:anim-comp,animationDelay:anim-dly,animationDirection:anim-dir,animationDuration:anim-dur,animationFillMode:anim-fm,animationIterationCount:anim-ic,animationName:anim-n,animationPlayState:anim-ps,animationRange:anim-r,animationRangeEnd:anim-re,animationRangeStart:anim-rs,animationState:anim-s,animationTimeline:anim-tl,animationTimingFunction:anim-tmf,appearance:ap,aspectRatio:asp,backdropBlur:bkdp-blur,backdropBrightness:bkdp-brightness,backdropContrast:bkdp-contrast,backdropFilter:bkdp,backdropGrayscale:bkdp-grayscale,backdropHueRotate:bkdp-hue-rotate,backdropInvert:bkdp-invert,backdropOpacity:bkdp-opacity,backdropSaturate:bkdp-saturate,backdropSepia:bkdp-sepia,backfaceVisibility:bfv,background:bg/1,backgroundAttachment:bg-a/bgAttachment,backgroundBlendMode:bg-bm/bgBlendMode,backgroundClip:bg-cp/bgClip,backgroundColor:bg-c/bgColor,backgroundConic:bg-conic/bgConic,backgroundGradient:bg-grad/bgGradient,backgroundImage:bg-i/bgImage,backgroundLinear:bg-linear/bgLinear,backgroundOrigin:bg-o/bgOrigin,backgroundPosition:bg-p/bgPosition,backgroundPositionX:bg-p-x/bgPositionX,backgroundPositionY:bg-p-y/bgPositionY,backgroundRadial:bg-radial/bgRadial,backgroundRepeat:bg-r/bgRepeat,backgroundSize:bg-s/bgSize,blockSize:h-bs,border:bd,borderBlock:bd-y/borderY,borderBlockColor:bd-y-c/borderYColor,borderBlockEnd:bd-be,borderBlockEndColor:bd-be-c,borderBlockEndWidth:bd-be-w,borderBlockStart:bd-bs,borderBlockStartColor:bd-bs-c,borderBlockStartWidth:bd-bs-w,borderBlockWidth:bd-y-w/borderYWidth,borderBottom:bd-b,borderBottomColor:bd-b-c,borderBottomLeftRadius:bdr-bl/roundedBottomLeft,borderBottomRadius:bdr-b/roundedBottom,borderBottomRightRadius:bdr-br/roundedBottomRight,borderBottomWidth:bd-b-w,borderCollapse:bd-cl,borderColor:bd-c,borderEndEndRadius:bdr-ee/roundedEndEnd,borderEndRadius:bdr-e/roundedEnd,borderEndStartRadius:bdr-es/roundedEndStart,borderInline:bd-x/borderX,borderInlineColor:bd-x-c/borderXColor,borderInlineEnd:bd-e/borderEnd,borderInlineEndColor:bd-e-c/borderEndColor,borderInlineEndWidth:bd-e-w/borderEndWidth,borderInlineStart:bd-s/borderStart,borderInlineStartColor:bd-s-c/borderStartColor,borderInlineStartWidth:bd-s-w/borderStartWidth,borderInlineWidth:bd-x-w/borderXWidth,borderLeft:bd-l,borderLeftColor:bd-l-c,borderLeftRadius:bdr-l/roundedLeft,borderLeftWidth:bd-l-w,borderRadius:bdr/rounded,borderRight:bd-r,borderRightColor:bd-r-c,borderRightRadius:bdr-r/roundedRight,borderRightWidth:bd-r-w,borderSpacing:bd-sp,borderSpacingX:bd-sx,borderSpacingY:bd-sy,borderStartEndRadius:bdr-se/roundedStartEnd,borderStartRadius:bdr-s/roundedStart,borderStartStartRadius:bdr-ss/roundedStartStart,borderTop:bd-t,borderTopColor:bd-t-c,borderTopLeftRadius:bdr-tl/roundedTopLeft,borderTopRadius:bdr-t/roundedTop,borderTopRightRadius:bdr-tr/roundedTopRight,borderTopWidth:bd-t-w,borderWidth:bd-w,boxDecorationBreak:bx-db,boxShadow:bx-sh/shadow,boxShadowColor:bx-sh-c/shadowColor,boxSize:size,boxSizing:bx-s,caretColor:ca-c,clipPath:cp-path,color:c,columnGap:cg,container:cq,containerName:cq-n,containerType:cq-t,display:d,divideColor:dvd-c,divideStyle:dvd-s,divideX:dvd-x,divideY:dvd-y,flexBasis:flex-b,flexDirection:flex-d/flexDir,flexGrow:flex-g,flexShrink:flex-sh,focusRingColor:focus-ring-c,focusRingOffset:focus-ring-o,focusRingStyle:focus-ring-s,focusRingWidth:focus-ring-w,focusVisibleRing:focus-v-ring,fontFamily:ff,fontFeatureSettings:ff-s,fontKerning:fk,fontPalette:fp,fontSize:fs,fontSizeAdjust:fs-a,fontSmoothing:fsmt,fontVariant:fv,fontVariantAlternates:fv-alt,fontVariantCaps:fv-caps,fontVariantNumeric:fv-num,fontVariationSettings:fv-s,fontWeight:fw,gradientFrom:grad-from,gradientFromPosition:grad-from-pos,gradientTo:grad-to,gradientToPosition:grad-to-pos,gradientVia:grad-via,gradientViaPosition:grad-via-pos,gridAutoColumns:grid-ac,gridAutoFlow:grid-af,gridAutoRows:grid-ar,gridColumn:grid-c,gridColumnEnd:grid-ce,gridColumnGap:grid-cg,gridColumnStart:grid-cs,gridGap:grid-g,gridRow:grid-r,gridRowGap:grid-rg,gridTemplateColumns:grid-tc,gridTemplateRows:grid-tr,height:h/1,hideBelow:show,hideFrom:hide,hyphens:hy,inlineSize:w-is,insetBlock:inset-y/insetY,insetBlockEnd:inset-be,insetBlockStart:inset-bs,insetInline:inset-x/insetX,insetInlineEnd:inset-e/end/insetEnd,insetInlineStart:inset-s/insetStart/start,justifyContent:jc,letterSpacing:ls,lineClamp:lc,lineHeight:lh,listStyle:li-s,listStyleImage:li-img,listStylePosition:li-pos,listStyleType:li-t,margin:m/1,marginBlock:my/marginY/1,marginBlockEnd:mbe,marginBlockStart:mbs,marginBottom:mb/1,marginInline:mx/marginX/1,marginInlineEnd:me/marginEnd/1,marginInlineStart:ms/marginStart/1,marginLeft:ml/1,marginRight:mr/1,marginTop:mt/1,mask:msk,maskBottomFrom:msk-b-from,maskBottomFromColor:msk-b-from-c,maskBottomTo:msk-b-to,maskBottomToColor:msk-b-to-c,maskClip:msk-cp,maskComposite:msk-cmp,maskConic:msk-conic,maskConicFrom:msk-conic-from,maskConicFromColor:msk-conic-from-c,maskConicTo:msk-conic-to,maskConicToColor:msk-conic-to-c,maskImage:msk-i,maskLeftFrom:msk-l-from,maskLeftFromColor:msk-l-from-c,maskLeftTo:msk-l-to,maskLeftToColor:msk-l-to-c,maskLinear:msk-linear,maskLinearFrom:msk-linear-from,maskLinearFromColor:msk-linear-from-c,maskLinearTo:msk-linear-to,maskLinearToColor:msk-linear-to-c,maskMode:msk-md,maskOrigin:msk-o,maskPosition:msk-p,maskRadial:msk-radial,maskRadialAt:msk-radial-at,maskRadialFrom:msk-radial-from,maskRadialFromColor:msk-radial-from-c,maskRadialShape:msk-radial-shape,maskRadialSize:msk-radial-sz,maskRadialTo:msk-radial-to,maskRadialToColor:msk-radial-to-c,maskRepeat:msk-r,maskRightFrom:msk-r-from,maskRightFromColor:msk-r-from-c,maskRightTo:msk-r-to,maskRightToColor:msk-r-to-c,maskSize:msk-s,maskTopFrom:msk-t-from,maskTopFromColor:msk-t-from-c,maskTopTo:msk-t-to,maskTopToColor:msk-t-to-c,maskType:msk-t,maskXFrom:msk-x-from,maskXFromColor:msk-x-from-c,maskXTo:msk-x-to,maskXToColor:msk-x-to-c,maskYFrom:msk-y-from,maskYFromColor:msk-y-from-c,maskYTo:msk-y-to,maskYToColor:msk-y-to-c,maxBlockSize:max-b,maxHeight:max-h/maxH,maxInlineSize:max-w-is,maxWidth:max-w/maxW,minBlockSize:min-h-bs,minHeight:min-h/minH,minInlineSize:min-w-is,minWidth:min-w/minW,mixBlendMode:mix-bm,objectFit:obj-f,objectPosition:obj-p,opacity:op,outline:ring/1,outlineColor:ring-c/ringColor,outlineOffset:ring-o/ringOffset,outlineWidth:ring-w/ringWidth,overflow:ov,overflowAnchor:ov-a,overflowBlock:ov-b,overflowClipBox:ovcp-bx,overflowClipMargin:ovcp-m,overflowInline:ov-i,overflowWrap:ov-wrap,overflowX:ov-x,overflowY:ov-y,overscrollBehavior:ovs-b,overscrollBehaviorBlock:ovs-bb,overscrollBehaviorInline:ovs-bi,overscrollBehaviorX:ovs-bx,overscrollBehaviorY:ovs-by,padding:p/1,paddingBlock:py/paddingY/1,paddingBlockEnd:pbe,paddingBlockStart:pbs,paddingBottom:pb/1,paddingInline:px/paddingX/1,paddingInlineEnd:pe/paddingEnd/1,paddingInlineStart:ps/paddingStart/1,paddingLeft:pl/1,paddingRight:pr/1,paddingTop:pt/1,position:pos/1,rowGap:rg,scrollBehavior:scr-bhv,scrollMargin:scr-m,scrollMarginBlock:scr-my/scrollMarginY,scrollMarginBlockEnd:scr-mbe,scrollMarginBlockStart:scr-mbt,scrollMarginBottom:scr-mb,scrollMarginInline:scr-mx/scrollMarginX,scrollMarginInlineEnd:scr-me,scrollMarginInlineStart:scr-ms,scrollMarginLeft:scr-ml,scrollMarginRight:scr-mr,scrollMarginTop:scr-mt,scrollPadding:scr-p,scrollPaddingBlock:scr-py/scrollPaddingY,scrollPaddingBlockEnd:scr-pbe,scrollPaddingBlockStart:scr-pbs,scrollPaddingBottom:scr-pb,scrollPaddingInline:scr-px/scrollPaddingX,scrollPaddingInlineEnd:scr-pe,scrollPaddingInlineStart:scr-ps,scrollPaddingLeft:scr-pl,scrollPaddingRight:scr-pr,scrollPaddingTop:scr-pt,scrollSnapAlign:scr-sa,scrollSnapCoordinate:scrs-c,scrollSnapDestination:scrs-d,scrollSnapMargin:scrs-m,scrollSnapMarginBottom:scrs-mb,scrollSnapMarginLeft:scrs-ml,scrollSnapMarginRight:scrs-mr,scrollSnapMarginTop:scrs-mt,scrollSnapPointsX:scrs-px,scrollSnapPointsY:scrs-py,scrollSnapStop:scrs-s,scrollSnapStrictness:scrs-strt,scrollSnapType:scrs-t,scrollSnapTypeX:scrs-tx,scrollSnapTypeY:scrs-ty,scrollTimeline:scrtl,scrollTimelineAxis:scrtl-a,scrollTimelineName:scrtl-n,scrollbar:scr-bar,scrollbarColor:scr-bar-c,scrollbarGutter:scr-bar-g,scrollbarThumb:scr-bar-th,scrollbarTrack:scr-bar-tk,scrollbarWidth:scr-bar-w,spaceX:sx,spaceY:sy,srOnly:sr,stroke:stk,strokeDasharray:stk-dsh,strokeDashoffset:stk-do,strokeLinecap:stk-lc,strokeLinejoin:stk-lj,strokeMiterlimit:stk-ml,strokeOpacity:stk-op,strokeWidth:stk-w,tableLayout:tbl,textAlign:ta,textDecoration:td,textDecorationColor:td-c,textDecorationStyle:td-s,textDecorationThickness:td-t,textEmphasisColor:te-c,textGradient:txt-grad,textIndent:ti,textOverflow:tov,textShadow:tsh,textShadowColor:tsh-c/textShadowColor,textSizeAdjust:txt-adj,textStyle:textStyle,textTransform:tt,textUnderlineOffset:tu-o,textWrap:tw,touchAction:tch-a,transform:trf,transformBox:trf-b,transformOrigin:trf-o,transformStyle:trf-s,transition:trs,transitionDelay:trs-dly,transitionDuration:trs-dur,transitionProperty:trs-prop,transitionTimingFunction:trs-tmf,translateX:/x,translateY:/y,translateZ:/z,truncate:trunc,userSelect:us,verticalAlign:va,visibility:vis,width:w/1,wordBreak:wb,zIndex:z";
function createCssContext() {
	const classNameByProp = /* @__PURE__ */ new Map();
	const shorthands = /* @__PURE__ */ new Map();
	utilities.split(",").forEach((utility) => {
		const [prop, meta] = utility.split(":");
		const [className, ...shorthandList] = meta.split("/");
		if (className) classNameByProp.set(prop, className);
		shorthandList.forEach((shorthand) => {
			const key = shorthand === "1" ? className : shorthand;
			shorthands.set(key, prop);
		});
	});
	const resolveShorthand = (prop) => shorthands.get(prop) || prop;
	return {
		hash: true,
		conditions: {
			shift: sortConditions,
			finalize: finalizeConditions,
			breakpoints: { keys: breakpointKeys }
		},
		utility: {
			prefix: null,
			hasShorthand: true,
			toHash(path, hashFn) {
				return hashFn(path.join(":"));
			},
			transform(prop, value) {
				const key = resolveShorthand(prop);
				return { className: `${classNameByProp.get(key) || hypenateProperty(key)}_${withoutSpace(value)}` };
			},
			resolveShorthand
		}
	};
}
var cssContext = /* @__PURE__ */ createCssContext();
var serializeCss = /* @__PURE__ */ createSerializeCss(cssContext);
var mergeCss = /* @__PURE__ */ createMergeCss(cssContext);
var serializeCssArgs = /* @__PURE__ */ createSerializeCssArgs(serializeCss, mergeCss);
var css = /* @__PURE__ */ Object.assign(function css(...styles) {
	if (styles.length === 1 && isObject(styles[0])) return serializeCss(styles[0]);
	return serializeCssArgs(...styles);
}, { raw: function cssRaw(...styles) {
	return mergeCss(...styles);
} });
//#endregion
//#region ../../styled-system/styled-system/css/cx.js
/**
* Conditionally join classNames into a single string
*/
function cx(...args) {
	let str = "", i = 0, arg;
	for (; i < arguments.length;) if ((arg = arguments[i++]) && typeof arg === "string") {
		str && (str += " ");
		str += arg;
	}
	return str;
}
//#endregion
//#region ../../../../../node_modules/date-fns/locale/en-US/_lib/formatDistance.js
var formatDistanceLocale$10 = {
	lessThanXSeconds: {
		one: "less than a second",
		other: "less than {{count}} seconds"
	},
	xSeconds: {
		one: "1 second",
		other: "{{count}} seconds"
	},
	halfAMinute: "half a minute",
	lessThanXMinutes: {
		one: "less than a minute",
		other: "less than {{count}} minutes"
	},
	xMinutes: {
		one: "1 minute",
		other: "{{count}} minutes"
	},
	aboutXHours: {
		one: "about 1 hour",
		other: "about {{count}} hours"
	},
	xHours: {
		one: "1 hour",
		other: "{{count}} hours"
	},
	xDays: {
		one: "1 day",
		other: "{{count}} days"
	},
	aboutXWeeks: {
		one: "about 1 week",
		other: "about {{count}} weeks"
	},
	xWeeks: {
		one: "1 week",
		other: "{{count}} weeks"
	},
	aboutXMonths: {
		one: "about 1 month",
		other: "about {{count}} months"
	},
	xMonths: {
		one: "1 month",
		other: "{{count}} months"
	},
	aboutXYears: {
		one: "about 1 year",
		other: "about {{count}} years"
	},
	xYears: {
		one: "1 year",
		other: "{{count}} years"
	},
	overXYears: {
		one: "over 1 year",
		other: "over {{count}} years"
	},
	almostXYears: {
		one: "almost 1 year",
		other: "almost {{count}} years"
	}
};
var formatDistance$11 = (token, count, options) => {
	let result;
	const tokenValue = formatDistanceLocale$10[token];
	if (typeof tokenValue === "string") result = tokenValue;
	else if (count === 1) result = tokenValue.one;
	else result = tokenValue.other.replace("{{count}}", count.toString());
	if (options?.addSuffix) {
		if (options.comparison && options.comparison > 0) return "in " + result;
		else return result + " ago";
	}
	return result;
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/en-US/_lib/formatRelative.js
var formatRelativeLocale$11 = {
	lastWeek: "'last' eeee 'at' p",
	yesterday: "'yesterday at' p",
	today: "'today at' p",
	tomorrow: "'tomorrow at' p",
	nextWeek: "eeee 'at' p",
	other: "P"
};
var formatRelative$11 = (token, _date, _baseDate, _options) => formatRelativeLocale$11[token];
//#endregion
//#region ../../../../../node_modules/date-fns/locale/_lib/buildLocalizeFn.js
/**
* The localize function argument callback which allows to convert raw value to
* the actual type.
*
* @param value - The value to convert
*
* @returns The converted value
*/
/**
* The map of localized values for each width.
*/
/**
* The index type of the locale unit value. It types conversion of units of
* values that don't start at 0 (i.e. quarters).
*/
/**
* Converts the unit value to the tuple of values.
*/
/**
* The tuple of localized era values. The first element represents BC,
* the second element represents AD.
*/
/**
* The tuple of localized quarter values. The first element represents Q1.
*/
/**
* The tuple of localized day values. The first element represents Sunday.
*/
/**
* The tuple of localized month values. The first element represents January.
*/
function buildLocalizeFn(args) {
	return (value, options) => {
		const context = options?.context ? String(options.context) : "standalone";
		let valuesArray;
		if (context === "formatting" && args.formattingValues) {
			const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
			const width = options?.width ? String(options.width) : defaultWidth;
			valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
		} else {
			const defaultWidth = args.defaultWidth;
			const width = options?.width ? String(options.width) : args.defaultWidth;
			valuesArray = args.values[width] || args.values[defaultWidth];
		}
		const index = args.argumentCallback ? args.argumentCallback(value) : value;
		return valuesArray[index];
	};
}
//#endregion
//#region ../../../../../node_modules/date-fns/locale/en-US/_lib/localize.js
var eraValues$11 = {
	narrow: ["B", "A"],
	abbreviated: ["BC", "AD"],
	wide: ["Before Christ", "Anno Domini"]
};
var quarterValues$11 = {
	narrow: [
		"1",
		"2",
		"3",
		"4"
	],
	abbreviated: [
		"Q1",
		"Q2",
		"Q3",
		"Q4"
	],
	wide: [
		"1st quarter",
		"2nd quarter",
		"3rd quarter",
		"4th quarter"
	]
};
var monthValues$11 = {
	narrow: [
		"J",
		"F",
		"M",
		"A",
		"M",
		"J",
		"J",
		"A",
		"S",
		"O",
		"N",
		"D"
	],
	abbreviated: [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec"
	],
	wide: [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December"
	]
};
var dayValues$11 = {
	narrow: [
		"S",
		"M",
		"T",
		"W",
		"T",
		"F",
		"S"
	],
	short: [
		"Su",
		"Mo",
		"Tu",
		"We",
		"Th",
		"Fr",
		"Sa"
	],
	abbreviated: [
		"Sun",
		"Mon",
		"Tue",
		"Wed",
		"Thu",
		"Fri",
		"Sat"
	],
	wide: [
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday"
	]
};
var dayPeriodValues$11 = {
	narrow: {
		am: "a",
		pm: "p",
		midnight: "mi",
		noon: "n",
		morning: "morning",
		afternoon: "afternoon",
		evening: "evening",
		night: "night"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "midnight",
		noon: "noon",
		morning: "morning",
		afternoon: "afternoon",
		evening: "evening",
		night: "night"
	},
	wide: {
		am: "a.m.",
		pm: "p.m.",
		midnight: "midnight",
		noon: "noon",
		morning: "morning",
		afternoon: "afternoon",
		evening: "evening",
		night: "night"
	}
};
var formattingDayPeriodValues$7 = {
	narrow: {
		am: "a",
		pm: "p",
		midnight: "mi",
		noon: "n",
		morning: "in the morning",
		afternoon: "in the afternoon",
		evening: "in the evening",
		night: "at night"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "midnight",
		noon: "noon",
		morning: "in the morning",
		afternoon: "in the afternoon",
		evening: "in the evening",
		night: "at night"
	},
	wide: {
		am: "a.m.",
		pm: "p.m.",
		midnight: "midnight",
		noon: "noon",
		morning: "in the morning",
		afternoon: "in the afternoon",
		evening: "in the evening",
		night: "at night"
	}
};
var ordinalNumber$11 = (dirtyNumber, _options) => {
	const number = Number(dirtyNumber);
	const rem100 = number % 100;
	if (rem100 > 20 || rem100 < 10) switch (rem100 % 10) {
		case 1: return number + "st";
		case 2: return number + "nd";
		case 3: return number + "rd";
	}
	return number + "th";
};
var localize$11 = {
	ordinalNumber: ordinalNumber$11,
	era: buildLocalizeFn({
		values: eraValues$11,
		defaultWidth: "wide"
	}),
	quarter: buildLocalizeFn({
		values: quarterValues$11,
		defaultWidth: "wide",
		argumentCallback: (quarter) => quarter - 1
	}),
	month: buildLocalizeFn({
		values: monthValues$11,
		defaultWidth: "wide"
	}),
	day: buildLocalizeFn({
		values: dayValues$11,
		defaultWidth: "wide"
	}),
	dayPeriod: buildLocalizeFn({
		values: dayPeriodValues$11,
		defaultWidth: "wide",
		formattingValues: formattingDayPeriodValues$7,
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/_lib/buildMatchFn.js
function buildMatchFn(args) {
	return (string, options = {}) => {
		const width = options.width;
		const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
		const matchResult = string.match(matchPattern);
		if (!matchResult) return null;
		const matchedString = matchResult[0];
		const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
		const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString)) : findKey(parsePatterns, (pattern) => pattern.test(matchedString));
		let value;
		value = args.valueCallback ? args.valueCallback(key) : key;
		value = options.valueCallback ? options.valueCallback(value) : value;
		const rest = string.slice(matchedString.length);
		return {
			value,
			rest
		};
	};
}
function findKey(object, predicate) {
	for (const key in object) if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
}
function findIndex(array, predicate) {
	for (let key = 0; key < array.length; key++) if (predicate(array[key])) return key;
}
//#endregion
//#region ../../../../../node_modules/date-fns/locale/_lib/buildMatchPatternFn.js
function buildMatchPatternFn(args) {
	return (string, options = {}) => {
		const matchResult = string.match(args.matchPattern);
		if (!matchResult) return null;
		const matchedString = matchResult[0];
		const parseResult = string.match(args.parsePattern);
		if (!parseResult) return null;
		let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
		value = options.valueCallback ? options.valueCallback(value) : value;
		const rest = string.slice(matchedString.length);
		return {
			value,
			rest
		};
	};
}
var match$11 = {
	ordinalNumber: buildMatchPatternFn({
		matchPattern: /^(\d+)(th|st|nd|rd)?/i,
		parsePattern: /\d+/i,
		valueCallback: (value) => parseInt(value, 10)
	}),
	era: buildMatchFn({
		matchPatterns: {
			narrow: /^(b|a)/i,
			abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
			wide: /^(before christ|before common era|anno domini|common era)/i
		},
		defaultMatchWidth: "wide",
		parsePatterns: { any: [/^b/i, /^(a|c)/i] },
		defaultParseWidth: "any"
	}),
	quarter: buildMatchFn({
		matchPatterns: {
			narrow: /^[1234]/i,
			abbreviated: /^q[1234]/i,
			wide: /^[1234](th|st|nd|rd)? quarter/i
		},
		defaultMatchWidth: "wide",
		parsePatterns: { any: [
			/1/i,
			/2/i,
			/3/i,
			/4/i
		] },
		defaultParseWidth: "any",
		valueCallback: (index) => index + 1
	}),
	month: buildMatchFn({
		matchPatterns: {
			narrow: /^[jfmasond]/i,
			abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
			wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
		},
		defaultMatchWidth: "wide",
		parsePatterns: {
			narrow: [
				/^j/i,
				/^f/i,
				/^m/i,
				/^a/i,
				/^m/i,
				/^j/i,
				/^j/i,
				/^a/i,
				/^s/i,
				/^o/i,
				/^n/i,
				/^d/i
			],
			any: [
				/^ja/i,
				/^f/i,
				/^mar/i,
				/^ap/i,
				/^may/i,
				/^jun/i,
				/^jul/i,
				/^au/i,
				/^s/i,
				/^o/i,
				/^n/i,
				/^d/i
			]
		},
		defaultParseWidth: "any"
	}),
	day: buildMatchFn({
		matchPatterns: {
			narrow: /^[smtwf]/i,
			short: /^(su|mo|tu|we|th|fr|sa)/i,
			abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
			wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
		},
		defaultMatchWidth: "wide",
		parsePatterns: {
			narrow: [
				/^s/i,
				/^m/i,
				/^t/i,
				/^w/i,
				/^t/i,
				/^f/i,
				/^s/i
			],
			any: [
				/^su/i,
				/^m/i,
				/^tu/i,
				/^w/i,
				/^th/i,
				/^f/i,
				/^sa/i
			]
		},
		defaultParseWidth: "any"
	}),
	dayPeriod: buildMatchFn({
		matchPatterns: {
			narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
			any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
		},
		defaultMatchWidth: "any",
		parsePatterns: { any: {
			am: /^a/i,
			pm: /^p/i,
			midnight: /^mi/i,
			noon: /^no/i,
			morning: /morning/i,
			afternoon: /afternoon/i,
			evening: /evening/i,
			night: /night/i
		} },
		defaultParseWidth: "any"
	})
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/_lib/buildFormatLongFn.js
function buildFormatLongFn(args) {
	return (options = {}) => {
		const width = options.width ? String(options.width) : args.defaultWidth;
		return args.formats[width] || args.formats[args.defaultWidth];
	};
}
//#endregion
//#region ../../../../../node_modules/date-fns/locale/en-GB.js
/**
* @category Locales
* @summary English locale (United Kingdom).
* @language English
* @iso-639-2 eng
* @author Alex [@glintik](https://github.com/glintik)
*/
var enGB = {
	code: "en-GB",
	formatDistance: formatDistance$11,
	formatLong: {
		date: buildFormatLongFn({
			formats: {
				full: "EEEE, d MMMM yyyy",
				long: "d MMMM yyyy",
				medium: "d MMM yyyy",
				short: "dd/MM/yyyy"
			},
			defaultWidth: "full"
		}),
		time: buildFormatLongFn({
			formats: {
				full: "HH:mm:ss zzzz",
				long: "HH:mm:ss z",
				medium: "HH:mm:ss",
				short: "HH:mm"
			},
			defaultWidth: "full"
		}),
		dateTime: buildFormatLongFn({
			formats: {
				full: "{{date}} 'at' {{time}}",
				long: "{{date}} 'at' {{time}}",
				medium: "{{date}}, {{time}}",
				short: "{{date}}, {{time}}"
			},
			defaultWidth: "full"
		})
	},
	formatRelative: formatRelative$11,
	localize: localize$11,
	match: match$11,
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 4
	}
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/it/_lib/formatDistance.js
var formatDistanceLocale$9 = {
	lessThanXSeconds: {
		one: "meno di un secondo",
		other: "meno di {{count}} secondi"
	},
	xSeconds: {
		one: "un secondo",
		other: "{{count}} secondi"
	},
	halfAMinute: "alcuni secondi",
	lessThanXMinutes: {
		one: "meno di un minuto",
		other: "meno di {{count}} minuti"
	},
	xMinutes: {
		one: "un minuto",
		other: "{{count}} minuti"
	},
	aboutXHours: {
		one: "circa un'ora",
		other: "circa {{count}} ore"
	},
	xHours: {
		one: "un'ora",
		other: "{{count}} ore"
	},
	xDays: {
		one: "un giorno",
		other: "{{count}} giorni"
	},
	aboutXWeeks: {
		one: "circa una settimana",
		other: "circa {{count}} settimane"
	},
	xWeeks: {
		one: "una settimana",
		other: "{{count}} settimane"
	},
	aboutXMonths: {
		one: "circa un mese",
		other: "circa {{count}} mesi"
	},
	xMonths: {
		one: "un mese",
		other: "{{count}} mesi"
	},
	aboutXYears: {
		one: "circa un anno",
		other: "circa {{count}} anni"
	},
	xYears: {
		one: "un anno",
		other: "{{count}} anni"
	},
	overXYears: {
		one: "più di un anno",
		other: "più di {{count}} anni"
	},
	almostXYears: {
		one: "quasi un anno",
		other: "quasi {{count}} anni"
	}
};
var formatDistance$10 = (token, count, options) => {
	let result;
	const tokenValue = formatDistanceLocale$9[token];
	if (typeof tokenValue === "string") result = tokenValue;
	else if (count === 1) result = tokenValue.one;
	else result = tokenValue.other.replace("{{count}}", count.toString());
	if (options?.addSuffix) {
		if (options.comparison && options.comparison > 0) return "tra " + result;
		else return result + " fa";
	}
	return result;
};
var formatLong$10 = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE d MMMM y",
			long: "d MMMM y",
			medium: "d MMM y",
			short: "dd/MM/y"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "HH:mm:ss zzzz",
			long: "HH:mm:ss z",
			medium: "HH:mm:ss",
			short: "HH:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} {{time}}",
			long: "{{date}} {{time}}",
			medium: "{{date}} {{time}}",
			short: "{{date}} {{time}}"
		},
		defaultWidth: "full"
	})
};
-(Math.pow(10, 8) * 24 * 60 * 60 * 1e3);
/**
* @constant
* @name constructFromSymbol
* @summary Symbol enabling Date extensions to inherit properties from the reference date.
*
* The symbol is used to enable the `constructFrom` function to construct a date
* using a reference date and a value. It allows to transfer extra properties
* from the reference date to the new date. It's useful for extensions like
* [`TZDate`](https://github.com/date-fns/tz) that accept a time zone as
* a constructor argument.
*/
var constructFromSymbol = Symbol.for("constructDateFrom");
//#endregion
//#region ../../../../../node_modules/date-fns/constructFrom.js
/**
* @name constructFrom
* @category Generic Helpers
* @summary Constructs a date using the reference date and the value
*
* @description
* The function constructs a new date using the constructor from the reference
* date and the given value. It helps to build generic functions that accept
* date extensions.
*
* It defaults to `Date` if the passed reference date is a number or a string.
*
* Starting from v3.7.0, it allows to construct a date using `[Symbol.for("constructDateFrom")]`
* enabling to transfer extra properties from the reference date to the new date.
* It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
* that accept a time zone as a constructor argument.
*
* @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
*
* @param date - The reference date to take constructor from
* @param value - The value to create the date
*
* @returns Date initialized using the given date and value
*
* @example
* import { constructFrom } from "./constructFrom/date-fns";
*
* // A function that clones a date preserving the original type
* function cloneDate<DateType extends Date>(date: DateType): DateType {
*   return constructFrom(
*     date, // Use constructor from the given date
*     date.getTime() // Use the date value to create a new date
*   );
* }
*/
function constructFrom(date, value) {
	if (typeof date === "function") return date(value);
	if (date && typeof date === "object" && constructFromSymbol in date) return date[constructFromSymbol](value);
	if (date instanceof Date) return new date.constructor(value);
	return new Date(value);
}
//#endregion
//#region ../../../../../node_modules/date-fns/_lib/normalizeDates.js
function normalizeDates(context, ...dates) {
	const normalize = constructFrom.bind(null, context || dates.find((date) => typeof date === "object"));
	return dates.map(normalize);
}
//#endregion
//#region ../../../../../node_modules/date-fns/_lib/defaultOptions.js
var defaultOptions = {};
function getDefaultOptions() {
	return defaultOptions;
}
//#endregion
//#region ../../../../../node_modules/date-fns/toDate.js
/**
* @name toDate
* @category Common Helpers
* @summary Convert the given argument to an instance of Date.
*
* @description
* Convert the given argument to an instance of Date.
*
* If the argument is an instance of Date, the function returns its clone.
*
* If the argument is a number, it is treated as a timestamp.
*
* If the argument is none of the above, the function returns Invalid Date.
*
* Starting from v3.7.0, it clones a date using `[Symbol.for("constructDateFrom")]`
* enabling to transfer extra properties from the reference date to the new date.
* It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
* that accept a time zone as a constructor argument.
*
* **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
*
* @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
* @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
*
* @param argument - The value to convert
*
* @returns The parsed date in the local time zone
*
* @example
* // Clone the date:
* const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
* //=> Tue Feb 11 2014 11:30:30
*
* @example
* // Convert the timestamp to date:
* const result = toDate(1392098430000)
* //=> Tue Feb 11 2014 11:30:30
*/
function toDate$1(argument, context) {
	return constructFrom(context || argument, argument);
}
//#endregion
//#region ../../../../../node_modules/date-fns/startOfWeek.js
/**
* The {@link startOfWeek} function options.
*/
/**
* @name startOfWeek
* @category Week Helpers
* @summary Return the start of a week for the given date.
*
* @description
* Return the start of a week for the given date.
* The result will be in the local timezone.
*
* @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
* @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
*
* @param date - The original date
* @param options - An object with options
*
* @returns The start of a week
*
* @example
* // The start of a week for 2 September 2014 11:55:00:
* const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
* //=> Sun Aug 31 2014 00:00:00
*
* @example
* // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
* const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
* //=> Mon Sep 01 2014 00:00:00
*/
function startOfWeek$1(date, options) {
	const defaultOptions = getDefaultOptions();
	const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
	const _date = toDate$1(date, options?.in);
	const day = _date.getDay();
	const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	_date.setDate(_date.getDate() - diff);
	_date.setHours(0, 0, 0, 0);
	return _date;
}
//#endregion
//#region ../../../../../node_modules/date-fns/isSameWeek.js
/**
* The {@link isSameWeek} function options.
*/
/**
* @name isSameWeek
* @category Week Helpers
* @summary Are the given dates in the same week (and month and year)?
*
* @description
* Are the given dates in the same week (and month and year)?
*
* @param laterDate - The first date to check
* @param earlierDate - The second date to check
* @param options - An object with options
*
* @returns The dates are in the same week (and month and year)
*
* @example
* // Are 31 August 2014 and 4 September 2014 in the same week?
* const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
* //=> true
*
* @example
* // If week starts with Monday,
* // are 31 August 2014 and 4 September 2014 in the same week?
* const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
*   weekStartsOn: 1
* })
* //=> false
*
* @example
* // Are 1 January 2014 and 1 January 2015 in the same week?
* const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
* //=> false
*/
function isSameWeek(laterDate, earlierDate, options) {
	const [laterDate_, earlierDate_] = normalizeDates(options?.in, laterDate, earlierDate);
	return +startOfWeek$1(laterDate_, options) === +startOfWeek$1(earlierDate_, options);
}
//#endregion
//#region ../../../../../node_modules/date-fns/locale/it/_lib/formatRelative.js
var weekdays = [
	"domenica",
	"lunedì",
	"martedì",
	"mercoledì",
	"giovedì",
	"venerdì",
	"sabato"
];
function lastWeek(day) {
	switch (day) {
		case 0: return "'domenica scorsa alle' p";
		default: return "'" + weekdays[day] + " scorso alle' p";
	}
}
function thisWeek(day) {
	return "'" + weekdays[day] + " alle' p";
}
function nextWeek(day) {
	switch (day) {
		case 0: return "'domenica prossima alle' p";
		default: return "'" + weekdays[day] + " prossimo alle' p";
	}
}
var formatRelativeLocale$10 = {
	lastWeek: (date, baseDate, options) => {
		const day = date.getDay();
		if (isSameWeek(date, baseDate, options)) return thisWeek(day);
		else return lastWeek(day);
	},
	yesterday: "'ieri alle' p",
	today: "'oggi alle' p",
	tomorrow: "'domani alle' p",
	nextWeek: (date, baseDate, options) => {
		const day = date.getDay();
		if (isSameWeek(date, baseDate, options)) return thisWeek(day);
		else return nextWeek(day);
	},
	other: "P"
};
var formatRelative$10 = (token, date, baseDate, options) => {
	const format = formatRelativeLocale$10[token];
	if (typeof format === "function") return format(date, baseDate, options);
	return format;
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/it/_lib/localize.js
var eraValues$10 = {
	narrow: ["aC", "dC"],
	abbreviated: ["a.C.", "d.C."],
	wide: ["avanti Cristo", "dopo Cristo"]
};
var quarterValues$10 = {
	narrow: [
		"1",
		"2",
		"3",
		"4"
	],
	abbreviated: [
		"T1",
		"T2",
		"T3",
		"T4"
	],
	wide: [
		"1º trimestre",
		"2º trimestre",
		"3º trimestre",
		"4º trimestre"
	]
};
var monthValues$10 = {
	narrow: [
		"G",
		"F",
		"M",
		"A",
		"M",
		"G",
		"L",
		"A",
		"S",
		"O",
		"N",
		"D"
	],
	abbreviated: [
		"gen",
		"feb",
		"mar",
		"apr",
		"mag",
		"giu",
		"lug",
		"ago",
		"set",
		"ott",
		"nov",
		"dic"
	],
	wide: [
		"gennaio",
		"febbraio",
		"marzo",
		"aprile",
		"maggio",
		"giugno",
		"luglio",
		"agosto",
		"settembre",
		"ottobre",
		"novembre",
		"dicembre"
	]
};
var dayValues$10 = {
	narrow: [
		"D",
		"L",
		"M",
		"M",
		"G",
		"V",
		"S"
	],
	short: [
		"dom",
		"lun",
		"mar",
		"mer",
		"gio",
		"ven",
		"sab"
	],
	abbreviated: [
		"dom",
		"lun",
		"mar",
		"mer",
		"gio",
		"ven",
		"sab"
	],
	wide: [
		"domenica",
		"lunedì",
		"martedì",
		"mercoledì",
		"giovedì",
		"venerdì",
		"sabato"
	]
};
var dayPeriodValues$10 = {
	narrow: {
		am: "m.",
		pm: "p.",
		midnight: "mezzanotte",
		noon: "mezzogiorno",
		morning: "mattina",
		afternoon: "pomeriggio",
		evening: "sera",
		night: "notte"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "mezzanotte",
		noon: "mezzogiorno",
		morning: "mattina",
		afternoon: "pomeriggio",
		evening: "sera",
		night: "notte"
	},
	wide: {
		am: "AM",
		pm: "PM",
		midnight: "mezzanotte",
		noon: "mezzogiorno",
		morning: "mattina",
		afternoon: "pomeriggio",
		evening: "sera",
		night: "notte"
	}
};
var formattingDayPeriodValues$6 = {
	narrow: {
		am: "m.",
		pm: "p.",
		midnight: "mezzanotte",
		noon: "mezzogiorno",
		morning: "di mattina",
		afternoon: "del pomeriggio",
		evening: "di sera",
		night: "di notte"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "mezzanotte",
		noon: "mezzogiorno",
		morning: "di mattina",
		afternoon: "del pomeriggio",
		evening: "di sera",
		night: "di notte"
	},
	wide: {
		am: "AM",
		pm: "PM",
		midnight: "mezzanotte",
		noon: "mezzogiorno",
		morning: "di mattina",
		afternoon: "del pomeriggio",
		evening: "di sera",
		night: "di notte"
	}
};
var ordinalNumber$10 = (dirtyNumber, _options) => {
	const number = Number(dirtyNumber);
	return String(number);
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/it.js
/**
* @category Locales
* @summary Italian locale.
* @language Italian
* @iso-639-2 ita
* @author Alberto Restifo [@albertorestifo](https://github.com/albertorestifo)
* @author Giovanni Polimeni [@giofilo](https://github.com/giofilo)
* @author Vincenzo Carrese [@vin-car](https://github.com/vin-car)
*/
var it = {
	code: "it",
	formatDistance: formatDistance$10,
	formatLong: formatLong$10,
	formatRelative: formatRelative$10,
	localize: {
		ordinalNumber: ordinalNumber$10,
		era: buildLocalizeFn({
			values: eraValues$10,
			defaultWidth: "wide"
		}),
		quarter: buildLocalizeFn({
			values: quarterValues$10,
			defaultWidth: "wide",
			argumentCallback: (quarter) => quarter - 1
		}),
		month: buildLocalizeFn({
			values: monthValues$10,
			defaultWidth: "wide"
		}),
		day: buildLocalizeFn({
			values: dayValues$10,
			defaultWidth: "wide"
		}),
		dayPeriod: buildLocalizeFn({
			values: dayPeriodValues$10,
			defaultWidth: "wide",
			formattingValues: formattingDayPeriodValues$6,
			defaultFormattingWidth: "wide"
		})
	},
	match: {
		ordinalNumber: buildMatchPatternFn({
			matchPattern: /^(\d+)(º)?/i,
			parsePattern: /\d+/i,
			valueCallback: (value) => parseInt(value, 10)
		}),
		era: buildMatchFn({
			matchPatterns: {
				narrow: /^(aC|dC)/i,
				abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
				wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^a/i, /^(d|e)/i] },
			defaultParseWidth: "any"
		}),
		quarter: buildMatchFn({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^t[1234]/i,
				wide: /^[1234](º)? trimestre/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (index) => index + 1
		}),
		month: buildMatchFn({
			matchPatterns: {
				narrow: /^[gfmalsond]/i,
				abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
				wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^g/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^g/i,
					/^l/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ge/i,
					/^f/i,
					/^mar/i,
					/^ap/i,
					/^mag/i,
					/^gi/i,
					/^l/i,
					/^ag/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: buildMatchFn({
			matchPatterns: {
				narrow: /^[dlmgvs]/i,
				short: /^(do|lu|ma|me|gi|ve|sa)/i,
				abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
				wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^d/i,
					/^l/i,
					/^m/i,
					/^m/i,
					/^g/i,
					/^v/i,
					/^s/i
				],
				any: [
					/^d/i,
					/^l/i,
					/^ma/i,
					/^me/i,
					/^g/i,
					/^v/i,
					/^s/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: buildMatchFn({
			matchPatterns: {
				narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
				any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^mezza/i,
				noon: /^mezzo/i,
				morning: /mattina/i,
				afternoon: /pomeriggio/i,
				evening: /sera/i,
				night: /notte/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 4
	}
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/es/_lib/formatDistance.js
var formatDistanceLocale$8 = {
	lessThanXSeconds: {
		one: "menos de un segundo",
		other: "menos de {{count}} segundos"
	},
	xSeconds: {
		one: "1 segundo",
		other: "{{count}} segundos"
	},
	halfAMinute: "medio minuto",
	lessThanXMinutes: {
		one: "menos de un minuto",
		other: "menos de {{count}} minutos"
	},
	xMinutes: {
		one: "1 minuto",
		other: "{{count}} minutos"
	},
	aboutXHours: {
		one: "alrededor de 1 hora",
		other: "alrededor de {{count}} horas"
	},
	xHours: {
		one: "1 hora",
		other: "{{count}} horas"
	},
	xDays: {
		one: "1 día",
		other: "{{count}} días"
	},
	aboutXWeeks: {
		one: "alrededor de 1 semana",
		other: "alrededor de {{count}} semanas"
	},
	xWeeks: {
		one: "1 semana",
		other: "{{count}} semanas"
	},
	aboutXMonths: {
		one: "alrededor de 1 mes",
		other: "alrededor de {{count}} meses"
	},
	xMonths: {
		one: "1 mes",
		other: "{{count}} meses"
	},
	aboutXYears: {
		one: "alrededor de 1 año",
		other: "alrededor de {{count}} años"
	},
	xYears: {
		one: "1 año",
		other: "{{count}} años"
	},
	overXYears: {
		one: "más de 1 año",
		other: "más de {{count}} años"
	},
	almostXYears: {
		one: "casi 1 año",
		other: "casi {{count}} años"
	}
};
var formatDistance$9 = (token, count, options) => {
	let result;
	const tokenValue = formatDistanceLocale$8[token];
	if (typeof tokenValue === "string") result = tokenValue;
	else if (count === 1) result = tokenValue.one;
	else result = tokenValue.other.replace("{{count}}", count.toString());
	if (options?.addSuffix) {
		if (options.comparison && options.comparison > 0) return "en " + result;
		else return "hace " + result;
	}
	return result;
};
var formatLong$9 = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE, d 'de' MMMM 'de' y",
			long: "d 'de' MMMM 'de' y",
			medium: "d MMM y",
			short: "dd/MM/y"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "HH:mm:ss zzzz",
			long: "HH:mm:ss z",
			medium: "HH:mm:ss",
			short: "HH:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'a las' {{time}}",
			long: "{{date}} 'a las' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/es/_lib/formatRelative.js
var formatRelativeLocale$9 = {
	lastWeek: "'el' eeee 'pasado a la' p",
	yesterday: "'ayer a la' p",
	today: "'hoy a la' p",
	tomorrow: "'mañana a la' p",
	nextWeek: "eeee 'a la' p",
	other: "P"
};
var formatRelativeLocalePlural = {
	lastWeek: "'el' eeee 'pasado a las' p",
	yesterday: "'ayer a las' p",
	today: "'hoy a las' p",
	tomorrow: "'mañana a las' p",
	nextWeek: "eeee 'a las' p",
	other: "P"
};
var formatRelative$9 = (token, date, _baseDate, _options) => {
	if (date.getHours() !== 1) return formatRelativeLocalePlural[token];
	else return formatRelativeLocale$9[token];
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/es/_lib/localize.js
var eraValues$9 = {
	narrow: ["AC", "DC"],
	abbreviated: ["AC", "DC"],
	wide: ["antes de cristo", "después de cristo"]
};
var quarterValues$9 = {
	narrow: [
		"1",
		"2",
		"3",
		"4"
	],
	abbreviated: [
		"T1",
		"T2",
		"T3",
		"T4"
	],
	wide: [
		"1º trimestre",
		"2º trimestre",
		"3º trimestre",
		"4º trimestre"
	]
};
var monthValues$9 = {
	narrow: [
		"e",
		"f",
		"m",
		"a",
		"m",
		"j",
		"j",
		"a",
		"s",
		"o",
		"n",
		"d"
	],
	abbreviated: [
		"ene",
		"feb",
		"mar",
		"abr",
		"may",
		"jun",
		"jul",
		"ago",
		"sep",
		"oct",
		"nov",
		"dic"
	],
	wide: [
		"enero",
		"febrero",
		"marzo",
		"abril",
		"mayo",
		"junio",
		"julio",
		"agosto",
		"septiembre",
		"octubre",
		"noviembre",
		"diciembre"
	]
};
var dayValues$9 = {
	narrow: [
		"d",
		"l",
		"m",
		"m",
		"j",
		"v",
		"s"
	],
	short: [
		"do",
		"lu",
		"ma",
		"mi",
		"ju",
		"vi",
		"sá"
	],
	abbreviated: [
		"dom",
		"lun",
		"mar",
		"mié",
		"jue",
		"vie",
		"sáb"
	],
	wide: [
		"domingo",
		"lunes",
		"martes",
		"miércoles",
		"jueves",
		"viernes",
		"sábado"
	]
};
var dayPeriodValues$9 = {
	narrow: {
		am: "a",
		pm: "p",
		midnight: "mn",
		noon: "md",
		morning: "mañana",
		afternoon: "tarde",
		evening: "tarde",
		night: "noche"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "medianoche",
		noon: "mediodia",
		morning: "mañana",
		afternoon: "tarde",
		evening: "tarde",
		night: "noche"
	},
	wide: {
		am: "a.m.",
		pm: "p.m.",
		midnight: "medianoche",
		noon: "mediodia",
		morning: "mañana",
		afternoon: "tarde",
		evening: "tarde",
		night: "noche"
	}
};
var formattingDayPeriodValues$5 = {
	narrow: {
		am: "a",
		pm: "p",
		midnight: "mn",
		noon: "md",
		morning: "de la mañana",
		afternoon: "de la tarde",
		evening: "de la tarde",
		night: "de la noche"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "medianoche",
		noon: "mediodia",
		morning: "de la mañana",
		afternoon: "de la tarde",
		evening: "de la tarde",
		night: "de la noche"
	},
	wide: {
		am: "a.m.",
		pm: "p.m.",
		midnight: "medianoche",
		noon: "mediodia",
		morning: "de la mañana",
		afternoon: "de la tarde",
		evening: "de la tarde",
		night: "de la noche"
	}
};
var ordinalNumber$9 = (dirtyNumber, _options) => {
	return Number(dirtyNumber) + "º";
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/es.js
/**
* @category Locales
* @summary Spanish locale.
* @language Spanish
* @iso-639-2 spa
* @author Juan Angosto [@juanangosto](https://github.com/juanangosto)
* @author Guillermo Grau [@guigrpa](https://github.com/guigrpa)
* @author Fernando Agüero [@fjaguero](https://github.com/fjaguero)
* @author Gastón Haro [@harogaston](https://github.com/harogaston)
* @author Yago Carballo [@YagoCarballo](https://github.com/YagoCarballo)
*/
var es = {
	code: "es",
	formatDistance: formatDistance$9,
	formatLong: formatLong$9,
	formatRelative: formatRelative$9,
	localize: {
		ordinalNumber: ordinalNumber$9,
		era: buildLocalizeFn({
			values: eraValues$9,
			defaultWidth: "wide"
		}),
		quarter: buildLocalizeFn({
			values: quarterValues$9,
			defaultWidth: "wide",
			argumentCallback: (quarter) => Number(quarter) - 1
		}),
		month: buildLocalizeFn({
			values: monthValues$9,
			defaultWidth: "wide"
		}),
		day: buildLocalizeFn({
			values: dayValues$9,
			defaultWidth: "wide"
		}),
		dayPeriod: buildLocalizeFn({
			values: dayPeriodValues$9,
			defaultWidth: "wide",
			formattingValues: formattingDayPeriodValues$5,
			defaultFormattingWidth: "wide"
		})
	},
	match: {
		ordinalNumber: buildMatchPatternFn({
			matchPattern: /^(\d+)(º)?/i,
			parsePattern: /\d+/i,
			valueCallback: function(value) {
				return parseInt(value, 10);
			}
		}),
		era: buildMatchFn({
			matchPatterns: {
				narrow: /^(ac|dc|a|d)/i,
				abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
				wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				any: [/^ac/i, /^dc/i],
				wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
			},
			defaultParseWidth: "any"
		}),
		quarter: buildMatchFn({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^T[1234]/i,
				wide: /^[1234](º)? trimestre/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (index) => index + 1
		}),
		month: buildMatchFn({
			matchPatterns: {
				narrow: /^[efmajsond]/i,
				abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
				wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^e/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^en/i,
					/^feb/i,
					/^mar/i,
					/^abr/i,
					/^may/i,
					/^jun/i,
					/^jul/i,
					/^ago/i,
					/^sep/i,
					/^oct/i,
					/^nov/i,
					/^dic/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: buildMatchFn({
			matchPatterns: {
				narrow: /^[dlmjvs]/i,
				short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
				abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
				wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^d/i,
					/^l/i,
					/^m/i,
					/^m/i,
					/^j/i,
					/^v/i,
					/^s/i
				],
				any: [
					/^do/i,
					/^lu/i,
					/^ma/i,
					/^mi/i,
					/^ju/i,
					/^vi/i,
					/^sa/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: buildMatchFn({
			matchPatterns: {
				narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
				any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^mn/i,
				noon: /^md/i,
				morning: /mañana/i,
				afternoon: /tarde/i,
				evening: /tarde/i,
				night: /noche/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 1
	}
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/fr/_lib/formatDistance.js
var formatDistanceLocale$7 = {
	lessThanXSeconds: {
		one: "moins d’une seconde",
		other: "moins de {{count}} secondes"
	},
	xSeconds: {
		one: "1 seconde",
		other: "{{count}} secondes"
	},
	halfAMinute: "30 secondes",
	lessThanXMinutes: {
		one: "moins d’une minute",
		other: "moins de {{count}} minutes"
	},
	xMinutes: {
		one: "1 minute",
		other: "{{count}} minutes"
	},
	aboutXHours: {
		one: "environ 1 heure",
		other: "environ {{count}} heures"
	},
	xHours: {
		one: "1 heure",
		other: "{{count}} heures"
	},
	xDays: {
		one: "1 jour",
		other: "{{count}} jours"
	},
	aboutXWeeks: {
		one: "environ 1 semaine",
		other: "environ {{count}} semaines"
	},
	xWeeks: {
		one: "1 semaine",
		other: "{{count}} semaines"
	},
	aboutXMonths: {
		one: "environ 1 mois",
		other: "environ {{count}} mois"
	},
	xMonths: {
		one: "1 mois",
		other: "{{count}} mois"
	},
	aboutXYears: {
		one: "environ 1 an",
		other: "environ {{count}} ans"
	},
	xYears: {
		one: "1 an",
		other: "{{count}} ans"
	},
	overXYears: {
		one: "plus d’un an",
		other: "plus de {{count}} ans"
	},
	almostXYears: {
		one: "presqu’un an",
		other: "presque {{count}} ans"
	}
};
var formatDistance$8 = (token, count, options) => {
	let result;
	const form = formatDistanceLocale$7[token];
	if (typeof form === "string") result = form;
	else if (count === 1) result = form.one;
	else result = form.other.replace("{{count}}", String(count));
	if (options?.addSuffix) {
		if (options.comparison && options.comparison > 0) return "dans " + result;
		else return "il y a " + result;
	}
	return result;
};
var formatLong$8 = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE d MMMM y",
			long: "d MMMM y",
			medium: "d MMM y",
			short: "dd/MM/y"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "HH:mm:ss zzzz",
			long: "HH:mm:ss z",
			medium: "HH:mm:ss",
			short: "HH:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'à' {{time}}",
			long: "{{date}} 'à' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/fr/_lib/formatRelative.js
var formatRelativeLocale$8 = {
	lastWeek: "eeee 'dernier à' p",
	yesterday: "'hier à' p",
	today: "'aujourd’hui à' p",
	tomorrow: "'demain à' p'",
	nextWeek: "eeee 'prochain à' p",
	other: "P"
};
var formatRelative$8 = (token, _date, _baseDate, _options) => formatRelativeLocale$8[token];
//#endregion
//#region ../../../../../node_modules/date-fns/locale/fr/_lib/localize.js
var eraValues$8 = {
	narrow: ["av. J.-C", "ap. J.-C"],
	abbreviated: ["av. J.-C", "ap. J.-C"],
	wide: ["avant Jésus-Christ", "après Jésus-Christ"]
};
var quarterValues$8 = {
	narrow: [
		"T1",
		"T2",
		"T3",
		"T4"
	],
	abbreviated: [
		"1er trim.",
		"2ème trim.",
		"3ème trim.",
		"4ème trim."
	],
	wide: [
		"1er trimestre",
		"2ème trimestre",
		"3ème trimestre",
		"4ème trimestre"
	]
};
var monthValues$8 = {
	narrow: [
		"J",
		"F",
		"M",
		"A",
		"M",
		"J",
		"J",
		"A",
		"S",
		"O",
		"N",
		"D"
	],
	abbreviated: [
		"janv.",
		"févr.",
		"mars",
		"avr.",
		"mai",
		"juin",
		"juil.",
		"août",
		"sept.",
		"oct.",
		"nov.",
		"déc."
	],
	wide: [
		"janvier",
		"février",
		"mars",
		"avril",
		"mai",
		"juin",
		"juillet",
		"août",
		"septembre",
		"octobre",
		"novembre",
		"décembre"
	]
};
var dayValues$8 = {
	narrow: [
		"D",
		"L",
		"M",
		"M",
		"J",
		"V",
		"S"
	],
	short: [
		"di",
		"lu",
		"ma",
		"me",
		"je",
		"ve",
		"sa"
	],
	abbreviated: [
		"dim.",
		"lun.",
		"mar.",
		"mer.",
		"jeu.",
		"ven.",
		"sam."
	],
	wide: [
		"dimanche",
		"lundi",
		"mardi",
		"mercredi",
		"jeudi",
		"vendredi",
		"samedi"
	]
};
var dayPeriodValues$8 = {
	narrow: {
		am: "AM",
		pm: "PM",
		midnight: "minuit",
		noon: "midi",
		morning: "mat.",
		afternoon: "ap.m.",
		evening: "soir",
		night: "mat."
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "minuit",
		noon: "midi",
		morning: "matin",
		afternoon: "après-midi",
		evening: "soir",
		night: "matin"
	},
	wide: {
		am: "AM",
		pm: "PM",
		midnight: "minuit",
		noon: "midi",
		morning: "du matin",
		afternoon: "de l’après-midi",
		evening: "du soir",
		night: "du matin"
	}
};
var ordinalNumber$8 = (dirtyNumber, options) => {
	const number = Number(dirtyNumber);
	const unit = options?.unit;
	if (number === 0) return "0";
	const feminineUnits = [
		"year",
		"week",
		"hour",
		"minute",
		"second"
	];
	let suffix;
	if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "ère" : "er";
	else suffix = "ème";
	return number + suffix;
};
var LONG_MONTHS_TOKENS = ["MMM", "MMMM"];
//#endregion
//#region ../../../../../node_modules/date-fns/locale/fr.js
/**
* @category Locales
* @summary French locale.
* @language French
* @iso-639-2 fra
* @author Jean Dupouy [@izeau](https://github.com/izeau)
* @author François B [@fbonzon](https://github.com/fbonzon)
*/
var fr = {
	code: "fr",
	formatDistance: formatDistance$8,
	formatLong: formatLong$8,
	formatRelative: formatRelative$8,
	localize: {
		preprocessor: (date, parts) => {
			if (date.getDate() === 1) return parts;
			if (!parts.some((part) => part.isToken && LONG_MONTHS_TOKENS.includes(part.value))) return parts;
			return parts.map((part) => part.isToken && part.value === "do" ? {
				isToken: true,
				value: "d"
			} : part);
		},
		ordinalNumber: ordinalNumber$8,
		era: buildLocalizeFn({
			values: eraValues$8,
			defaultWidth: "wide"
		}),
		quarter: buildLocalizeFn({
			values: quarterValues$8,
			defaultWidth: "wide",
			argumentCallback: (quarter) => quarter - 1
		}),
		month: buildLocalizeFn({
			values: monthValues$8,
			defaultWidth: "wide"
		}),
		day: buildLocalizeFn({
			values: dayValues$8,
			defaultWidth: "wide"
		}),
		dayPeriod: buildLocalizeFn({
			values: dayPeriodValues$8,
			defaultWidth: "wide"
		})
	},
	match: {
		ordinalNumber: buildMatchPatternFn({
			matchPattern: /^(\d+)(ième|ère|ème|er|e)?/i,
			parsePattern: /\d+/i,
			valueCallback: (value) => parseInt(value)
		}),
		era: buildMatchFn({
			matchPatterns: {
				narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
				abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
				wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^av/i, /^ap/i] },
			defaultParseWidth: "any"
		}),
		quarter: buildMatchFn({
			matchPatterns: {
				narrow: /^T?[1234]/i,
				abbreviated: /^[1234](er|ème|e)? trim\.?/i,
				wide: /^[1234](er|ème|e)? trimestre/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (index) => index + 1
		}),
		month: buildMatchFn({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
				wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^mar/i,
					/^av/i,
					/^ma/i,
					/^juin/i,
					/^juil/i,
					/^ao/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: buildMatchFn({
			matchPatterns: {
				narrow: /^[lmjvsd]/i,
				short: /^(di|lu|ma|me|je|ve|sa)/i,
				abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
				wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^d/i,
					/^l/i,
					/^m/i,
					/^m/i,
					/^j/i,
					/^v/i,
					/^s/i
				],
				any: [
					/^di/i,
					/^lu/i,
					/^ma/i,
					/^me/i,
					/^je/i,
					/^ve/i,
					/^sa/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: buildMatchFn({
			matchPatterns: {
				narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
				any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^min/i,
				noon: /^mid/i,
				morning: /mat/i,
				afternoon: /ap/i,
				evening: /soir/i,
				night: /nuit/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 4
	}
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/de/_lib/formatDistance.js
var formatDistanceLocale$6 = {
	lessThanXSeconds: {
		standalone: {
			one: "weniger als 1 Sekunde",
			other: "weniger als {{count}} Sekunden"
		},
		withPreposition: {
			one: "weniger als 1 Sekunde",
			other: "weniger als {{count}} Sekunden"
		}
	},
	xSeconds: {
		standalone: {
			one: "1 Sekunde",
			other: "{{count}} Sekunden"
		},
		withPreposition: {
			one: "1 Sekunde",
			other: "{{count}} Sekunden"
		}
	},
	halfAMinute: {
		standalone: "eine halbe Minute",
		withPreposition: "einer halben Minute"
	},
	lessThanXMinutes: {
		standalone: {
			one: "weniger als 1 Minute",
			other: "weniger als {{count}} Minuten"
		},
		withPreposition: {
			one: "weniger als 1 Minute",
			other: "weniger als {{count}} Minuten"
		}
	},
	xMinutes: {
		standalone: {
			one: "1 Minute",
			other: "{{count}} Minuten"
		},
		withPreposition: {
			one: "1 Minute",
			other: "{{count}} Minuten"
		}
	},
	aboutXHours: {
		standalone: {
			one: "etwa 1 Stunde",
			other: "etwa {{count}} Stunden"
		},
		withPreposition: {
			one: "etwa 1 Stunde",
			other: "etwa {{count}} Stunden"
		}
	},
	xHours: {
		standalone: {
			one: "1 Stunde",
			other: "{{count}} Stunden"
		},
		withPreposition: {
			one: "1 Stunde",
			other: "{{count}} Stunden"
		}
	},
	xDays: {
		standalone: {
			one: "1 Tag",
			other: "{{count}} Tage"
		},
		withPreposition: {
			one: "1 Tag",
			other: "{{count}} Tagen"
		}
	},
	aboutXWeeks: {
		standalone: {
			one: "etwa 1 Woche",
			other: "etwa {{count}} Wochen"
		},
		withPreposition: {
			one: "etwa 1 Woche",
			other: "etwa {{count}} Wochen"
		}
	},
	xWeeks: {
		standalone: {
			one: "1 Woche",
			other: "{{count}} Wochen"
		},
		withPreposition: {
			one: "1 Woche",
			other: "{{count}} Wochen"
		}
	},
	aboutXMonths: {
		standalone: {
			one: "etwa 1 Monat",
			other: "etwa {{count}} Monate"
		},
		withPreposition: {
			one: "etwa 1 Monat",
			other: "etwa {{count}} Monaten"
		}
	},
	xMonths: {
		standalone: {
			one: "1 Monat",
			other: "{{count}} Monate"
		},
		withPreposition: {
			one: "1 Monat",
			other: "{{count}} Monaten"
		}
	},
	aboutXYears: {
		standalone: {
			one: "etwa 1 Jahr",
			other: "etwa {{count}} Jahre"
		},
		withPreposition: {
			one: "etwa 1 Jahr",
			other: "etwa {{count}} Jahren"
		}
	},
	xYears: {
		standalone: {
			one: "1 Jahr",
			other: "{{count}} Jahre"
		},
		withPreposition: {
			one: "1 Jahr",
			other: "{{count}} Jahren"
		}
	},
	overXYears: {
		standalone: {
			one: "mehr als 1 Jahr",
			other: "mehr als {{count}} Jahre"
		},
		withPreposition: {
			one: "mehr als 1 Jahr",
			other: "mehr als {{count}} Jahren"
		}
	},
	almostXYears: {
		standalone: {
			one: "fast 1 Jahr",
			other: "fast {{count}} Jahre"
		},
		withPreposition: {
			one: "fast 1 Jahr",
			other: "fast {{count}} Jahren"
		}
	}
};
var formatDistance$7 = (token, count, options) => {
	let result;
	const tokenValue = options?.addSuffix ? formatDistanceLocale$6[token].withPreposition : formatDistanceLocale$6[token].standalone;
	if (typeof tokenValue === "string") result = tokenValue;
	else if (count === 1) result = tokenValue.one;
	else result = tokenValue.other.replace("{{count}}", String(count));
	if (options?.addSuffix) {
		if (options.comparison && options.comparison > 0) return "in " + result;
		else return "vor " + result;
	}
	return result;
};
var formatLong$7 = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE, do MMMM y",
			long: "do MMMM y",
			medium: "do MMM y",
			short: "dd.MM.y"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "HH:mm:ss zzzz",
			long: "HH:mm:ss z",
			medium: "HH:mm:ss",
			short: "HH:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'um' {{time}}",
			long: "{{date}} 'um' {{time}}",
			medium: "{{date}} {{time}}",
			short: "{{date}} {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/de/_lib/formatRelative.js
var formatRelativeLocale$7 = {
	lastWeek: "'letzten' eeee 'um' p",
	yesterday: "'gestern um' p",
	today: "'heute um' p",
	tomorrow: "'morgen um' p",
	nextWeek: "eeee 'um' p",
	other: "P"
};
var formatRelative$7 = (token, _date, _baseDate, _options) => formatRelativeLocale$7[token];
//#endregion
//#region ../../../../../node_modules/date-fns/locale/de/_lib/localize.js
var eraValues$7 = {
	narrow: ["v.Chr.", "n.Chr."],
	abbreviated: ["v.Chr.", "n.Chr."],
	wide: ["vor Christus", "nach Christus"]
};
var quarterValues$7 = {
	narrow: [
		"1",
		"2",
		"3",
		"4"
	],
	abbreviated: [
		"Q1",
		"Q2",
		"Q3",
		"Q4"
	],
	wide: [
		"1. Quartal",
		"2. Quartal",
		"3. Quartal",
		"4. Quartal"
	]
};
var monthValues$7 = {
	narrow: [
		"J",
		"F",
		"M",
		"A",
		"M",
		"J",
		"J",
		"A",
		"S",
		"O",
		"N",
		"D"
	],
	abbreviated: [
		"Jan",
		"Feb",
		"Mär",
		"Apr",
		"Mai",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Okt",
		"Nov",
		"Dez"
	],
	wide: [
		"Januar",
		"Februar",
		"März",
		"April",
		"Mai",
		"Juni",
		"Juli",
		"August",
		"September",
		"Oktober",
		"November",
		"Dezember"
	]
};
var formattingMonthValues$1 = {
	narrow: monthValues$7.narrow,
	abbreviated: [
		"Jan.",
		"Feb.",
		"März",
		"Apr.",
		"Mai",
		"Juni",
		"Juli",
		"Aug.",
		"Sep.",
		"Okt.",
		"Nov.",
		"Dez."
	],
	wide: monthValues$7.wide
};
var dayValues$7 = {
	narrow: [
		"S",
		"M",
		"D",
		"M",
		"D",
		"F",
		"S"
	],
	short: [
		"So",
		"Mo",
		"Di",
		"Mi",
		"Do",
		"Fr",
		"Sa"
	],
	abbreviated: [
		"So.",
		"Mo.",
		"Di.",
		"Mi.",
		"Do.",
		"Fr.",
		"Sa."
	],
	wide: [
		"Sonntag",
		"Montag",
		"Dienstag",
		"Mittwoch",
		"Donnerstag",
		"Freitag",
		"Samstag"
	]
};
var dayPeriodValues$7 = {
	narrow: {
		am: "vm.",
		pm: "nm.",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "Morgen",
		afternoon: "Nachm.",
		evening: "Abend",
		night: "Nacht"
	},
	abbreviated: {
		am: "vorm.",
		pm: "nachm.",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "Morgen",
		afternoon: "Nachmittag",
		evening: "Abend",
		night: "Nacht"
	},
	wide: {
		am: "vormittags",
		pm: "nachmittags",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "Morgen",
		afternoon: "Nachmittag",
		evening: "Abend",
		night: "Nacht"
	}
};
var formattingDayPeriodValues$4 = {
	narrow: {
		am: "vm.",
		pm: "nm.",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "morgens",
		afternoon: "nachm.",
		evening: "abends",
		night: "nachts"
	},
	abbreviated: {
		am: "vorm.",
		pm: "nachm.",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "morgens",
		afternoon: "nachmittags",
		evening: "abends",
		night: "nachts"
	},
	wide: {
		am: "vormittags",
		pm: "nachmittags",
		midnight: "Mitternacht",
		noon: "Mittag",
		morning: "morgens",
		afternoon: "nachmittags",
		evening: "abends",
		night: "nachts"
	}
};
var ordinalNumber$7 = (dirtyNumber) => {
	return Number(dirtyNumber) + ".";
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/de.js
/**
* @category Locales
* @summary German locale.
* @language German
* @iso-639-2 deu
* @author Thomas Eilmsteiner [@DeMuu](https://github.com/DeMuu)
* @author Asia [@asia-t](https://github.com/asia-t)
* @author Van Vuong Ngo [@vanvuongngo](https://github.com/vanvuongngo)
* @author RomanErnst [@pex](https://github.com/pex)
* @author Philipp Keck [@Philipp91](https://github.com/Philipp91)
*/
var de = {
	code: "de",
	formatDistance: formatDistance$7,
	formatLong: formatLong$7,
	formatRelative: formatRelative$7,
	localize: {
		ordinalNumber: ordinalNumber$7,
		era: buildLocalizeFn({
			values: eraValues$7,
			defaultWidth: "wide"
		}),
		quarter: buildLocalizeFn({
			values: quarterValues$7,
			defaultWidth: "wide",
			argumentCallback: (quarter) => quarter - 1
		}),
		month: buildLocalizeFn({
			values: monthValues$7,
			formattingValues: formattingMonthValues$1,
			defaultWidth: "wide"
		}),
		day: buildLocalizeFn({
			values: dayValues$7,
			defaultWidth: "wide"
		}),
		dayPeriod: buildLocalizeFn({
			values: dayPeriodValues$7,
			defaultWidth: "wide",
			formattingValues: formattingDayPeriodValues$4,
			defaultFormattingWidth: "wide"
		})
	},
	match: {
		ordinalNumber: buildMatchPatternFn({
			matchPattern: /^(\d+)(\.)?/i,
			parsePattern: /\d+/i,
			valueCallback: (value) => parseInt(value)
		}),
		era: buildMatchFn({
			matchPatterns: {
				narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
				abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
				wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^v/i, /^n/i] },
			defaultParseWidth: "any"
		}),
		quarter: buildMatchFn({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^q[1234]/i,
				wide: /^[1234](\.)? Quartal/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (index) => index + 1
		}),
		month: buildMatchFn({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
				wide: /^(jänner|januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^j[aä]/i,
					/^f/i,
					/^mär/i,
					/^ap/i,
					/^mai/i,
					/^jun/i,
					/^jul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: buildMatchFn({
			matchPatterns: {
				narrow: /^[smdmf]/i,
				short: /^(so|mo|di|mi|do|fr|sa)/i,
				abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
				wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/^so/i,
				/^mo/i,
				/^di/i,
				/^mi/i,
				/^do/i,
				/^f/i,
				/^sa/i
			] },
			defaultParseWidth: "any"
		}),
		dayPeriod: buildMatchFn({
			matchPatterns: {
				narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
				abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
				wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: {
				am: /^v/i,
				pm: /^n/i,
				midnight: /^Mitte/i,
				noon: /^Mitta/i,
				morning: /morgens/i,
				afternoon: /nachmittags/i,
				evening: /abends/i,
				night: /nachts/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 4
	}
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/pt/_lib/formatDistance.js
var formatDistanceLocale$5 = {
	lessThanXSeconds: {
		one: "menos de um segundo",
		other: "menos de {{count}} segundos"
	},
	xSeconds: {
		one: "1 segundo",
		other: "{{count}} segundos"
	},
	halfAMinute: "meio minuto",
	lessThanXMinutes: {
		one: "menos de um minuto",
		other: "menos de {{count}} minutos"
	},
	xMinutes: {
		one: "1 minuto",
		other: "{{count}} minutos"
	},
	aboutXHours: {
		one: "aproximadamente 1 hora",
		other: "aproximadamente {{count}} horas"
	},
	xHours: {
		one: "1 hora",
		other: "{{count}} horas"
	},
	xDays: {
		one: "1 dia",
		other: "{{count}} dias"
	},
	aboutXWeeks: {
		one: "aproximadamente 1 semana",
		other: "aproximadamente {{count}} semanas"
	},
	xWeeks: {
		one: "1 semana",
		other: "{{count}} semanas"
	},
	aboutXMonths: {
		one: "aproximadamente 1 mês",
		other: "aproximadamente {{count}} meses"
	},
	xMonths: {
		one: "1 mês",
		other: "{{count}} meses"
	},
	aboutXYears: {
		one: "aproximadamente 1 ano",
		other: "aproximadamente {{count}} anos"
	},
	xYears: {
		one: "1 ano",
		other: "{{count}} anos"
	},
	overXYears: {
		one: "mais de 1 ano",
		other: "mais de {{count}} anos"
	},
	almostXYears: {
		one: "quase 1 ano",
		other: "quase {{count}} anos"
	}
};
var formatDistance$6 = (token, count, options) => {
	let result;
	const tokenValue = formatDistanceLocale$5[token];
	if (typeof tokenValue === "string") result = tokenValue;
	else if (count === 1) result = tokenValue.one;
	else result = tokenValue.other.replace("{{count}}", String(count));
	if (options?.addSuffix) {
		if (options.comparison && options.comparison > 0) return "daqui a " + result;
		else return "há " + result;
	}
	return result;
};
var formatLong$6 = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE, d 'de' MMMM 'de' y",
			long: "d 'de' MMMM 'de' y",
			medium: "d 'de' MMM 'de' y",
			short: "dd/MM/y"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "HH:mm:ss zzzz",
			long: "HH:mm:ss z",
			medium: "HH:mm:ss",
			short: "HH:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'às' {{time}}",
			long: "{{date}} 'às' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/pt/_lib/formatRelative.js
var formatRelativeLocale$6 = {
	lastWeek: (date) => {
		const weekday = date.getDay();
		return "'" + (weekday === 0 || weekday === 6 ? "último" : "última") + "' eeee 'às' p";
	},
	yesterday: "'ontem às' p",
	today: "'hoje às' p",
	tomorrow: "'amanhã às' p",
	nextWeek: "eeee 'às' p",
	other: "P"
};
var formatRelative$6 = (token, date, _baseDate, _options) => {
	const format = formatRelativeLocale$6[token];
	if (typeof format === "function") return format(date);
	return format;
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/pt/_lib/localize.js
var eraValues$6 = {
	narrow: ["aC", "dC"],
	abbreviated: ["a.C.", "d.C."],
	wide: ["antes de Cristo", "depois de Cristo"]
};
var quarterValues$6 = {
	narrow: [
		"1",
		"2",
		"3",
		"4"
	],
	abbreviated: [
		"T1",
		"T2",
		"T3",
		"T4"
	],
	wide: [
		"1º trimestre",
		"2º trimestre",
		"3º trimestre",
		"4º trimestre"
	]
};
var monthValues$6 = {
	narrow: [
		"j",
		"f",
		"m",
		"a",
		"m",
		"j",
		"j",
		"a",
		"s",
		"o",
		"n",
		"d"
	],
	abbreviated: [
		"jan",
		"fev",
		"mar",
		"abr",
		"mai",
		"jun",
		"jul",
		"ago",
		"set",
		"out",
		"nov",
		"dez"
	],
	wide: [
		"janeiro",
		"fevereiro",
		"março",
		"abril",
		"maio",
		"junho",
		"julho",
		"agosto",
		"setembro",
		"outubro",
		"novembro",
		"dezembro"
	]
};
var dayValues$6 = {
	narrow: [
		"d",
		"s",
		"t",
		"q",
		"q",
		"s",
		"s"
	],
	short: [
		"dom",
		"seg",
		"ter",
		"qua",
		"qui",
		"sex",
		"sáb"
	],
	abbreviated: [
		"dom",
		"seg",
		"ter",
		"qua",
		"qui",
		"sex",
		"sáb"
	],
	wide: [
		"domingo",
		"segunda-feira",
		"terça-feira",
		"quarta-feira",
		"quinta-feira",
		"sexta-feira",
		"sábado"
	]
};
var dayPeriodValues$6 = {
	narrow: {
		am: "AM",
		pm: "PM",
		midnight: "meia-noite",
		noon: "meio-dia",
		morning: "manhã",
		afternoon: "tarde",
		evening: "noite",
		night: "madrugada"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "meia-noite",
		noon: "meio-dia",
		morning: "manhã",
		afternoon: "tarde",
		evening: "noite",
		night: "madrugada"
	},
	wide: {
		am: "AM",
		pm: "PM",
		midnight: "meia-noite",
		noon: "meio-dia",
		morning: "manhã",
		afternoon: "tarde",
		evening: "noite",
		night: "madrugada"
	}
};
var formattingDayPeriodValues$3 = {
	narrow: {
		am: "AM",
		pm: "PM",
		midnight: "meia-noite",
		noon: "meio-dia",
		morning: "da manhã",
		afternoon: "da tarde",
		evening: "da noite",
		night: "da madrugada"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "meia-noite",
		noon: "meio-dia",
		morning: "da manhã",
		afternoon: "da tarde",
		evening: "da noite",
		night: "da madrugada"
	},
	wide: {
		am: "AM",
		pm: "PM",
		midnight: "meia-noite",
		noon: "meio-dia",
		morning: "da manhã",
		afternoon: "da tarde",
		evening: "da noite",
		night: "da madrugada"
	}
};
var ordinalNumber$6 = (dirtyNumber, _options) => {
	return Number(dirtyNumber) + "º";
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/pt.js
/**
* @category Locales
* @summary Portuguese locale.
* @language Portuguese
* @iso-639-2 por
* @author Dário Freire [@dfreire](https://github.com/dfreire)
* @author Adrián de la Rosa [@adrm](https://github.com/adrm)
*/
var pt = {
	code: "pt",
	formatDistance: formatDistance$6,
	formatLong: formatLong$6,
	formatRelative: formatRelative$6,
	localize: {
		ordinalNumber: ordinalNumber$6,
		era: buildLocalizeFn({
			values: eraValues$6,
			defaultWidth: "wide"
		}),
		quarter: buildLocalizeFn({
			values: quarterValues$6,
			defaultWidth: "wide",
			argumentCallback: (quarter) => quarter - 1
		}),
		month: buildLocalizeFn({
			values: monthValues$6,
			defaultWidth: "wide"
		}),
		day: buildLocalizeFn({
			values: dayValues$6,
			defaultWidth: "wide"
		}),
		dayPeriod: buildLocalizeFn({
			values: dayPeriodValues$6,
			defaultWidth: "wide",
			formattingValues: formattingDayPeriodValues$3,
			defaultFormattingWidth: "wide"
		})
	},
	match: {
		ordinalNumber: buildMatchPatternFn({
			matchPattern: /^(\d+)(º|ª)?/i,
			parsePattern: /\d+/i,
			valueCallback: (value) => parseInt(value, 10)
		}),
		era: buildMatchFn({
			matchPatterns: {
				narrow: /^(ac|dc|a|d)/i,
				abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
				wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				any: [/^ac/i, /^dc/i],
				wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
			},
			defaultParseWidth: "any"
		}),
		quarter: buildMatchFn({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^T[1234]/i,
				wide: /^[1234](º|ª)? trimestre/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (index) => index + 1
		}),
		month: buildMatchFn({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
				wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^mar/i,
					/^ab/i,
					/^mai/i,
					/^jun/i,
					/^jul/i,
					/^ag/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: buildMatchFn({
			matchPatterns: {
				narrow: /^[dstq]/i,
				short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
				abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
				wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^d/i,
					/^s/i,
					/^t/i,
					/^q/i,
					/^q/i,
					/^s/i,
					/^s/i
				],
				any: [
					/^d/i,
					/^seg/i,
					/^t/i,
					/^qua/i,
					/^qui/i,
					/^sex/i,
					/^s[áa]/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: buildMatchFn({
			matchPatterns: {
				narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
				any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^meia/i,
				noon: /^meio/i,
				morning: /manh[ãa]/i,
				afternoon: /tarde/i,
				evening: /noite/i,
				night: /madrugada/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 0,
		firstWeekContainsDate: 4
	}
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/cs/_lib/formatDistance.js
var formatDistanceLocale$4 = {
	lessThanXSeconds: {
		one: {
			regular: "méně než 1 sekunda",
			past: "před méně než 1 sekundou",
			future: "za méně než 1 sekundu"
		},
		few: {
			regular: "méně než {{count}} sekundy",
			past: "před méně než {{count}} sekundami",
			future: "za méně než {{count}} sekundy"
		},
		many: {
			regular: "méně než {{count}} sekund",
			past: "před méně než {{count}} sekundami",
			future: "za méně než {{count}} sekund"
		}
	},
	xSeconds: {
		one: {
			regular: "1 sekunda",
			past: "před 1 sekundou",
			future: "za 1 sekundu"
		},
		few: {
			regular: "{{count}} sekundy",
			past: "před {{count}} sekundami",
			future: "za {{count}} sekundy"
		},
		many: {
			regular: "{{count}} sekund",
			past: "před {{count}} sekundami",
			future: "za {{count}} sekund"
		}
	},
	halfAMinute: {
		type: "other",
		other: {
			regular: "půl minuty",
			past: "před půl minutou",
			future: "za půl minuty"
		}
	},
	lessThanXMinutes: {
		one: {
			regular: "méně než 1 minuta",
			past: "před méně než 1 minutou",
			future: "za méně než 1 minutu"
		},
		few: {
			regular: "méně než {{count}} minuty",
			past: "před méně než {{count}} minutami",
			future: "za méně než {{count}} minuty"
		},
		many: {
			regular: "méně než {{count}} minut",
			past: "před méně než {{count}} minutami",
			future: "za méně než {{count}} minut"
		}
	},
	xMinutes: {
		one: {
			regular: "1 minuta",
			past: "před 1 minutou",
			future: "za 1 minutu"
		},
		few: {
			regular: "{{count}} minuty",
			past: "před {{count}} minutami",
			future: "za {{count}} minuty"
		},
		many: {
			regular: "{{count}} minut",
			past: "před {{count}} minutami",
			future: "za {{count}} minut"
		}
	},
	aboutXHours: {
		one: {
			regular: "přibližně 1 hodina",
			past: "přibližně před 1 hodinou",
			future: "přibližně za 1 hodinu"
		},
		few: {
			regular: "přibližně {{count}} hodiny",
			past: "přibližně před {{count}} hodinami",
			future: "přibližně za {{count}} hodiny"
		},
		many: {
			regular: "přibližně {{count}} hodin",
			past: "přibližně před {{count}} hodinami",
			future: "přibližně za {{count}} hodin"
		}
	},
	xHours: {
		one: {
			regular: "1 hodina",
			past: "před 1 hodinou",
			future: "za 1 hodinu"
		},
		few: {
			regular: "{{count}} hodiny",
			past: "před {{count}} hodinami",
			future: "za {{count}} hodiny"
		},
		many: {
			regular: "{{count}} hodin",
			past: "před {{count}} hodinami",
			future: "za {{count}} hodin"
		}
	},
	xDays: {
		one: {
			regular: "1 den",
			past: "před 1 dnem",
			future: "za 1 den"
		},
		few: {
			regular: "{{count}} dny",
			past: "před {{count}} dny",
			future: "za {{count}} dny"
		},
		many: {
			regular: "{{count}} dní",
			past: "před {{count}} dny",
			future: "za {{count}} dní"
		}
	},
	aboutXWeeks: {
		one: {
			regular: "přibližně 1 týden",
			past: "přibližně před 1 týdnem",
			future: "přibližně za 1 týden"
		},
		few: {
			regular: "přibližně {{count}} týdny",
			past: "přibližně před {{count}} týdny",
			future: "přibližně za {{count}} týdny"
		},
		many: {
			regular: "přibližně {{count}} týdnů",
			past: "přibližně před {{count}} týdny",
			future: "přibližně za {{count}} týdnů"
		}
	},
	xWeeks: {
		one: {
			regular: "1 týden",
			past: "před 1 týdnem",
			future: "za 1 týden"
		},
		few: {
			regular: "{{count}} týdny",
			past: "před {{count}} týdny",
			future: "za {{count}} týdny"
		},
		many: {
			regular: "{{count}} týdnů",
			past: "před {{count}} týdny",
			future: "za {{count}} týdnů"
		}
	},
	aboutXMonths: {
		one: {
			regular: "přibližně 1 měsíc",
			past: "přibližně před 1 měsícem",
			future: "přibližně za 1 měsíc"
		},
		few: {
			regular: "přibližně {{count}} měsíce",
			past: "přibližně před {{count}} měsíci",
			future: "přibližně za {{count}} měsíce"
		},
		many: {
			regular: "přibližně {{count}} měsíců",
			past: "přibližně před {{count}} měsíci",
			future: "přibližně za {{count}} měsíců"
		}
	},
	xMonths: {
		one: {
			regular: "1 měsíc",
			past: "před 1 měsícem",
			future: "za 1 měsíc"
		},
		few: {
			regular: "{{count}} měsíce",
			past: "před {{count}} měsíci",
			future: "za {{count}} měsíce"
		},
		many: {
			regular: "{{count}} měsíců",
			past: "před {{count}} měsíci",
			future: "za {{count}} měsíců"
		}
	},
	aboutXYears: {
		one: {
			regular: "přibližně 1 rok",
			past: "přibližně před 1 rokem",
			future: "přibližně za 1 rok"
		},
		few: {
			regular: "přibližně {{count}} roky",
			past: "přibližně před {{count}} roky",
			future: "přibližně za {{count}} roky"
		},
		many: {
			regular: "přibližně {{count}} roků",
			past: "přibližně před {{count}} roky",
			future: "přibližně za {{count}} roků"
		}
	},
	xYears: {
		one: {
			regular: "1 rok",
			past: "před 1 rokem",
			future: "za 1 rok"
		},
		few: {
			regular: "{{count}} roky",
			past: "před {{count}} roky",
			future: "za {{count}} roky"
		},
		many: {
			regular: "{{count}} roků",
			past: "před {{count}} roky",
			future: "za {{count}} roků"
		}
	},
	overXYears: {
		one: {
			regular: "více než 1 rok",
			past: "před více než 1 rokem",
			future: "za více než 1 rok"
		},
		few: {
			regular: "více než {{count}} roky",
			past: "před více než {{count}} roky",
			future: "za více než {{count}} roky"
		},
		many: {
			regular: "více než {{count}} roků",
			past: "před více než {{count}} roky",
			future: "za více než {{count}} roků"
		}
	},
	almostXYears: {
		one: {
			regular: "skoro 1 rok",
			past: "skoro před 1 rokem",
			future: "skoro za 1 rok"
		},
		few: {
			regular: "skoro {{count}} roky",
			past: "skoro před {{count}} roky",
			future: "skoro za {{count}} roky"
		},
		many: {
			regular: "skoro {{count}} roků",
			past: "skoro před {{count}} roky",
			future: "skoro za {{count}} roků"
		}
	}
};
var formatDistance$5 = (token, count, options) => {
	let pluralResult;
	const tokenValue = formatDistanceLocale$4[token];
	if (tokenValue.type === "other") pluralResult = tokenValue.other;
	else if (count === 1) pluralResult = tokenValue.one;
	else if (count > 1 && count < 5) pluralResult = tokenValue.few;
	else pluralResult = tokenValue.many;
	const suffixExist = options?.addSuffix === true;
	const comparison = options?.comparison;
	let timeResult;
	if (suffixExist && comparison === -1) timeResult = pluralResult.past;
	else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
	else timeResult = pluralResult.regular;
	return timeResult.replace("{{count}}", String(count));
};
var formatLong$5 = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE, d. MMMM yyyy",
			long: "d. MMMM yyyy",
			medium: "d. M. yyyy",
			short: "dd.MM.yyyy"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "H:mm:ss zzzz",
			long: "H:mm:ss z",
			medium: "H:mm:ss",
			short: "H:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'v' {{time}}",
			long: "{{date}} 'v' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/cs/_lib/formatRelative.js
var accusativeWeekdays$1 = [
	"neděli",
	"pondělí",
	"úterý",
	"středu",
	"čtvrtek",
	"pátek",
	"sobotu"
];
var formatRelativeLocale$5 = {
	lastWeek: "'poslední' eeee 've' p",
	yesterday: "'včera v' p",
	today: "'dnes v' p",
	tomorrow: "'zítra v' p",
	nextWeek: (date) => {
		return "'v " + accusativeWeekdays$1[date.getDay()] + " o' p";
	},
	other: "P"
};
var formatRelative$5 = (token, date) => {
	const format = formatRelativeLocale$5[token];
	if (typeof format === "function") return format(date);
	return format;
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/cs/_lib/localize.js
var eraValues$5 = {
	narrow: ["př. n. l.", "n. l."],
	abbreviated: ["př. n. l.", "n. l."],
	wide: ["před naším letopočtem", "našeho letopočtu"]
};
var quarterValues$5 = {
	narrow: [
		"1",
		"2",
		"3",
		"4"
	],
	abbreviated: [
		"1. čtvrtletí",
		"2. čtvrtletí",
		"3. čtvrtletí",
		"4. čtvrtletí"
	],
	wide: [
		"1. čtvrtletí",
		"2. čtvrtletí",
		"3. čtvrtletí",
		"4. čtvrtletí"
	]
};
var monthValues$5 = {
	narrow: [
		"L",
		"Ú",
		"B",
		"D",
		"K",
		"Č",
		"Č",
		"S",
		"Z",
		"Ř",
		"L",
		"P"
	],
	abbreviated: [
		"led",
		"úno",
		"bře",
		"dub",
		"kvě",
		"čvn",
		"čvc",
		"srp",
		"zář",
		"říj",
		"lis",
		"pro"
	],
	wide: [
		"leden",
		"únor",
		"březen",
		"duben",
		"květen",
		"červen",
		"červenec",
		"srpen",
		"září",
		"říjen",
		"listopad",
		"prosinec"
	]
};
var formattingMonthValues = {
	narrow: [
		"L",
		"Ú",
		"B",
		"D",
		"K",
		"Č",
		"Č",
		"S",
		"Z",
		"Ř",
		"L",
		"P"
	],
	abbreviated: [
		"led",
		"úno",
		"bře",
		"dub",
		"kvě",
		"čvn",
		"čvc",
		"srp",
		"zář",
		"říj",
		"lis",
		"pro"
	],
	wide: [
		"ledna",
		"února",
		"března",
		"dubna",
		"května",
		"června",
		"července",
		"srpna",
		"září",
		"října",
		"listopadu",
		"prosince"
	]
};
var dayValues$5 = {
	narrow: [
		"ne",
		"po",
		"út",
		"st",
		"čt",
		"pá",
		"so"
	],
	short: [
		"ne",
		"po",
		"út",
		"st",
		"čt",
		"pá",
		"so"
	],
	abbreviated: [
		"ned",
		"pon",
		"úte",
		"stř",
		"čtv",
		"pát",
		"sob"
	],
	wide: [
		"neděle",
		"pondělí",
		"úterý",
		"středa",
		"čtvrtek",
		"pátek",
		"sobota"
	]
};
var dayPeriodValues$5 = {
	narrow: {
		am: "dop.",
		pm: "odp.",
		midnight: "půlnoc",
		noon: "poledne",
		morning: "ráno",
		afternoon: "odpoledne",
		evening: "večer",
		night: "noc"
	},
	abbreviated: {
		am: "dop.",
		pm: "odp.",
		midnight: "půlnoc",
		noon: "poledne",
		morning: "ráno",
		afternoon: "odpoledne",
		evening: "večer",
		night: "noc"
	},
	wide: {
		am: "dopoledne",
		pm: "odpoledne",
		midnight: "půlnoc",
		noon: "poledne",
		morning: "ráno",
		afternoon: "odpoledne",
		evening: "večer",
		night: "noc"
	}
};
var formattingDayPeriodValues$2 = {
	narrow: {
		am: "dop.",
		pm: "odp.",
		midnight: "půlnoc",
		noon: "poledne",
		morning: "ráno",
		afternoon: "odpoledne",
		evening: "večer",
		night: "noc"
	},
	abbreviated: {
		am: "dop.",
		pm: "odp.",
		midnight: "půlnoc",
		noon: "poledne",
		morning: "ráno",
		afternoon: "odpoledne",
		evening: "večer",
		night: "noc"
	},
	wide: {
		am: "dopoledne",
		pm: "odpoledne",
		midnight: "půlnoc",
		noon: "poledne",
		morning: "ráno",
		afternoon: "odpoledne",
		evening: "večer",
		night: "noc"
	}
};
var ordinalNumber$5 = (dirtyNumber, _options) => {
	return Number(dirtyNumber) + ".";
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/cs.js
/**
* @category Locales
* @summary Czech locale.
* @language Czech
* @iso-639-2 ces
* @author David Rus [@davidrus](https://github.com/davidrus)
* @author Pavel Hrách [@SilenY](https://github.com/SilenY)
* @author Jozef Bíroš [@JozefBiros](https://github.com/JozefBiros)
*/
var cs = {
	code: "cs",
	formatDistance: formatDistance$5,
	formatLong: formatLong$5,
	formatRelative: formatRelative$5,
	localize: {
		ordinalNumber: ordinalNumber$5,
		era: buildLocalizeFn({
			values: eraValues$5,
			defaultWidth: "wide"
		}),
		quarter: buildLocalizeFn({
			values: quarterValues$5,
			defaultWidth: "wide",
			argumentCallback: (quarter) => quarter - 1
		}),
		month: buildLocalizeFn({
			values: monthValues$5,
			defaultWidth: "wide",
			formattingValues: formattingMonthValues,
			defaultFormattingWidth: "wide"
		}),
		day: buildLocalizeFn({
			values: dayValues$5,
			defaultWidth: "wide"
		}),
		dayPeriod: buildLocalizeFn({
			values: dayPeriodValues$5,
			defaultWidth: "wide",
			formattingValues: formattingDayPeriodValues$2,
			defaultFormattingWidth: "wide"
		})
	},
	match: {
		ordinalNumber: buildMatchPatternFn({
			matchPattern: /^(\d+)\.?/i,
			parsePattern: /\d+/i,
			valueCallback: (value) => parseInt(value, 10)
		}),
		era: buildMatchFn({
			matchPatterns: {
				narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
				abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
				wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^p[řr]/i, /^(po|n)/i] },
			defaultParseWidth: "any"
		}),
		quarter: buildMatchFn({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
				wide: /^[1234]\. [čc]tvrtlet[íi]/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (index) => index + 1
		}),
		month: buildMatchFn({
			matchPatterns: {
				narrow: /^[lúubdkčcszřrlp]/i,
				abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
				wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^l/i,
					/^[úu]/i,
					/^b/i,
					/^d/i,
					/^k/i,
					/^[čc]/i,
					/^[čc]/i,
					/^s/i,
					/^z/i,
					/^[řr]/i,
					/^l/i,
					/^p/i
				],
				any: [
					/^led/i,
					/^[úu]n/i,
					/^b[řr]e/i,
					/^dub/i,
					/^kv[ěe]/i,
					/^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
					/^[čc]vc|[čc]erven(ec|ce)/i,
					/^srp/i,
					/^z[áa][řr]/i,
					/^[řr][íi]j/i,
					/^lis/i,
					/^pro/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: buildMatchFn({
			matchPatterns: {
				narrow: /^[npuúsčps]/i,
				short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
				abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
				wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^n/i,
					/^p/i,
					/^[úu]/i,
					/^s/i,
					/^[čc]/i,
					/^p/i,
					/^s/i
				],
				any: [
					/^ne/i,
					/^po/i,
					/^[úu]t/i,
					/^st/i,
					/^[čc]t/i,
					/^p[áa]/i,
					/^so/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: buildMatchFn({
			matchPatterns: { any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i },
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^dop/i,
				pm: /^odp/i,
				midnight: /^p[ůu]lnoc/i,
				noon: /^poledne/i,
				morning: /r[áa]no/i,
				afternoon: /odpoledne/i,
				evening: /ve[čc]er/i,
				night: /noc/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 4
	}
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/hu/_lib/formatDistance.js
var translations = {
	about: "körülbelül",
	over: "több mint",
	almost: "majdnem",
	lessthan: "kevesebb mint"
};
var withoutSuffixes = {
	xseconds: " másodperc",
	halfaminute: "fél perc",
	xminutes: " perc",
	xhours: " óra",
	xdays: " nap",
	xweeks: " hét",
	xmonths: " hónap",
	xyears: " év"
};
var withSuffixes = {
	xseconds: {
		"-1": " másodperccel ezelőtt",
		1: " másodperc múlva",
		0: " másodperce"
	},
	halfaminute: {
		"-1": "fél perccel ezelőtt",
		1: "fél perc múlva",
		0: "fél perce"
	},
	xminutes: {
		"-1": " perccel ezelőtt",
		1: " perc múlva",
		0: " perce"
	},
	xhours: {
		"-1": " órával ezelőtt",
		1: " óra múlva",
		0: " órája"
	},
	xdays: {
		"-1": " nappal ezelőtt",
		1: " nap múlva",
		0: " napja"
	},
	xweeks: {
		"-1": " héttel ezelőtt",
		1: " hét múlva",
		0: " hete"
	},
	xmonths: {
		"-1": " hónappal ezelőtt",
		1: " hónap múlva",
		0: " hónapja"
	},
	xyears: {
		"-1": " évvel ezelőtt",
		1: " év múlva",
		0: " éve"
	}
};
var formatDistance$4 = (token, count, options) => {
	const adverb = token.match(/about|over|almost|lessthan/i);
	const unit = adverb ? token.replace(adverb[0], "") : token;
	const addSuffix = options?.addSuffix === true;
	const key = unit.toLowerCase();
	const comparison = options?.comparison || 0;
	const translated = addSuffix ? withSuffixes[key][comparison] : withoutSuffixes[key];
	let result = key === "halfaminute" ? translated : count + translated;
	if (adverb) result = translations[adverb[0].toLowerCase()] + " " + result;
	return result;
};
var formatLong$4 = {
	date: buildFormatLongFn({
		formats: {
			full: "y. MMMM d., EEEE",
			long: "y. MMMM d.",
			medium: "y. MMM d.",
			short: "y. MM. dd."
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "H:mm:ss zzzz",
			long: "H:mm:ss z",
			medium: "H:mm:ss",
			short: "H:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} {{time}}",
			long: "{{date}} {{time}}",
			medium: "{{date}} {{time}}",
			short: "{{date}} {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/hu/_lib/formatRelative.js
var accusativeWeekdays = [
	"vasárnap",
	"hétfőn",
	"kedden",
	"szerdán",
	"csütörtökön",
	"pénteken",
	"szombaton"
];
function week(isFuture) {
	return (date) => {
		const weekday = accusativeWeekdays[date.getDay()];
		return `${isFuture ? "" : "'múlt' "}'${weekday}' p'-kor'`;
	};
}
var formatRelativeLocale$4 = {
	lastWeek: week(false),
	yesterday: "'tegnap' p'-kor'",
	today: "'ma' p'-kor'",
	tomorrow: "'holnap' p'-kor'",
	nextWeek: week(true),
	other: "P"
};
var formatRelative$4 = (token, date) => {
	const format = formatRelativeLocale$4[token];
	if (typeof format === "function") return format(date);
	return format;
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/hu/_lib/localize.js
var eraValues$4 = {
	narrow: ["ie.", "isz."],
	abbreviated: ["i. e.", "i. sz."],
	wide: ["Krisztus előtt", "időszámításunk szerint"]
};
var quarterValues$4 = {
	narrow: [
		"1.",
		"2.",
		"3.",
		"4."
	],
	abbreviated: [
		"1. n.év",
		"2. n.év",
		"3. n.év",
		"4. n.év"
	],
	wide: [
		"1. negyedév",
		"2. negyedév",
		"3. negyedév",
		"4. negyedév"
	]
};
var formattingQuarterValues = {
	narrow: [
		"I.",
		"II.",
		"III.",
		"IV."
	],
	abbreviated: [
		"I. n.év",
		"II. n.év",
		"III. n.év",
		"IV. n.év"
	],
	wide: [
		"I. negyedév",
		"II. negyedév",
		"III. negyedév",
		"IV. negyedév"
	]
};
var monthValues$4 = {
	narrow: [
		"J",
		"F",
		"M",
		"Á",
		"M",
		"J",
		"J",
		"A",
		"Sz",
		"O",
		"N",
		"D"
	],
	abbreviated: [
		"jan.",
		"febr.",
		"márc.",
		"ápr.",
		"máj.",
		"jún.",
		"júl.",
		"aug.",
		"szept.",
		"okt.",
		"nov.",
		"dec."
	],
	wide: [
		"január",
		"február",
		"március",
		"április",
		"május",
		"június",
		"július",
		"augusztus",
		"szeptember",
		"október",
		"november",
		"december"
	]
};
var dayValues$4 = {
	narrow: [
		"V",
		"H",
		"K",
		"Sz",
		"Cs",
		"P",
		"Sz"
	],
	short: [
		"V",
		"H",
		"K",
		"Sze",
		"Cs",
		"P",
		"Szo"
	],
	abbreviated: [
		"V",
		"H",
		"K",
		"Sze",
		"Cs",
		"P",
		"Szo"
	],
	wide: [
		"vasárnap",
		"hétfő",
		"kedd",
		"szerda",
		"csütörtök",
		"péntek",
		"szombat"
	]
};
var dayPeriodValues$4 = {
	narrow: {
		am: "de.",
		pm: "du.",
		midnight: "éjfél",
		noon: "dél",
		morning: "reggel",
		afternoon: "du.",
		evening: "este",
		night: "éjjel"
	},
	abbreviated: {
		am: "de.",
		pm: "du.",
		midnight: "éjfél",
		noon: "dél",
		morning: "reggel",
		afternoon: "du.",
		evening: "este",
		night: "éjjel"
	},
	wide: {
		am: "de.",
		pm: "du.",
		midnight: "éjfél",
		noon: "dél",
		morning: "reggel",
		afternoon: "délután",
		evening: "este",
		night: "éjjel"
	}
};
var ordinalNumber$4 = (dirtyNumber, _options) => {
	return Number(dirtyNumber) + ".";
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/hu.js
/**
* @category Locales
* @summary Hungarian locale.
* @language Hungarian
* @iso-639-2 hun
* @author Pavlo Shpak [@pshpak](https://github.com/pshpak)
* @author Eduardo Pardo [@eduardopsll](https://github.com/eduardopsll)
* @author Zoltan Szepesi [@twodcube](https://github.com/twodcube)
*/
var hu = {
	code: "hu",
	formatDistance: formatDistance$4,
	formatLong: formatLong$4,
	formatRelative: formatRelative$4,
	localize: {
		ordinalNumber: ordinalNumber$4,
		era: buildLocalizeFn({
			values: eraValues$4,
			defaultWidth: "wide"
		}),
		quarter: buildLocalizeFn({
			values: quarterValues$4,
			defaultWidth: "wide",
			argumentCallback: (quarter) => quarter - 1,
			formattingValues: formattingQuarterValues,
			defaultFormattingWidth: "wide"
		}),
		month: buildLocalizeFn({
			values: monthValues$4,
			defaultWidth: "wide"
		}),
		day: buildLocalizeFn({
			values: dayValues$4,
			defaultWidth: "wide"
		}),
		dayPeriod: buildLocalizeFn({
			values: dayPeriodValues$4,
			defaultWidth: "wide"
		})
	},
	match: {
		ordinalNumber: buildMatchPatternFn({
			matchPattern: /^(\d+)\.?/i,
			parsePattern: /\d+/i,
			valueCallback: (value) => parseInt(value, 10)
		}),
		era: buildMatchFn({
			matchPatterns: {
				narrow: /^(ie\.|isz\.)/i,
				abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
				wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [/ie/i, /isz/i],
				abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
				any: [/előtt/i, /(szerint|i. sz.)/i]
			},
			defaultParseWidth: "any"
		}),
		quarter: buildMatchFn({
			matchPatterns: {
				narrow: /^[1234]\.?/i,
				abbreviated: /^[1234]?\.?\s?n\.év/i,
				wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1|I$/i,
				/2|II$/i,
				/3|III/i,
				/4|IV/i
			] },
			defaultParseWidth: "any",
			valueCallback: (index) => index + 1
		}),
		month: buildMatchFn({
			matchPatterns: {
				narrow: /^[jfmaásond]|sz/i,
				abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
				wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a|á/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s|sz/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^már/i,
					/^áp/i,
					/^máj/i,
					/^jún/i,
					/^júl/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: buildMatchFn({
			matchPatterns: {
				narrow: /^([vhkpc]|sz|cs|sz)/i,
				short: /^([vhkp]|sze|cs|szo)/i,
				abbreviated: /^([vhkp]|sze|cs|szo)/i,
				wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^v/i,
					/^h/i,
					/^k/i,
					/^sz/i,
					/^c/i,
					/^p/i,
					/^sz/i
				],
				any: [
					/^v/i,
					/^h/i,
					/^k/i,
					/^sze/i,
					/^c/i,
					/^p/i,
					/^szo/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: buildMatchFn({
			matchPatterns: { any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i },
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^de\.?/i,
				pm: /^du\.?/i,
				midnight: /^éjf/i,
				noon: /^dé/i,
				morning: /reg/i,
				afternoon: /^délu\.?/i,
				evening: /es/i,
				night: /éjj/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 4
	}
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/pl/_lib/formatDistance.js
var formatDistanceLocale$3 = {
	lessThanXSeconds: {
		one: {
			regular: "mniej niż sekunda",
			past: "mniej niż sekundę",
			future: "mniej niż sekundę"
		},
		twoFour: "mniej niż {{count}} sekundy",
		other: "mniej niż {{count}} sekund"
	},
	xSeconds: {
		one: {
			regular: "sekunda",
			past: "sekundę",
			future: "sekundę"
		},
		twoFour: "{{count}} sekundy",
		other: "{{count}} sekund"
	},
	halfAMinute: {
		one: "pół minuty",
		twoFour: "pół minuty",
		other: "pół minuty"
	},
	lessThanXMinutes: {
		one: {
			regular: "mniej niż minuta",
			past: "mniej niż minutę",
			future: "mniej niż minutę"
		},
		twoFour: "mniej niż {{count}} minuty",
		other: "mniej niż {{count}} minut"
	},
	xMinutes: {
		one: {
			regular: "minuta",
			past: "minutę",
			future: "minutę"
		},
		twoFour: "{{count}} minuty",
		other: "{{count}} minut"
	},
	aboutXHours: {
		one: {
			regular: "około godziny",
			past: "około godziny",
			future: "około godzinę"
		},
		twoFour: "około {{count}} godziny",
		other: "około {{count}} godzin"
	},
	xHours: {
		one: {
			regular: "godzina",
			past: "godzinę",
			future: "godzinę"
		},
		twoFour: "{{count}} godziny",
		other: "{{count}} godzin"
	},
	xDays: {
		one: {
			regular: "dzień",
			past: "dzień",
			future: "1 dzień"
		},
		twoFour: "{{count}} dni",
		other: "{{count}} dni"
	},
	aboutXWeeks: {
		one: "około tygodnia",
		twoFour: "około {{count}} tygodni",
		other: "około {{count}} tygodni"
	},
	xWeeks: {
		one: "tydzień",
		twoFour: "{{count}} tygodnie",
		other: "{{count}} tygodni"
	},
	aboutXMonths: {
		one: "około miesiąc",
		twoFour: "około {{count}} miesiące",
		other: "około {{count}} miesięcy"
	},
	xMonths: {
		one: "miesiąc",
		twoFour: "{{count}} miesiące",
		other: "{{count}} miesięcy"
	},
	aboutXYears: {
		one: "około rok",
		twoFour: "około {{count}} lata",
		other: "około {{count}} lat"
	},
	xYears: {
		one: "rok",
		twoFour: "{{count}} lata",
		other: "{{count}} lat"
	},
	overXYears: {
		one: "ponad rok",
		twoFour: "ponad {{count}} lata",
		other: "ponad {{count}} lat"
	},
	almostXYears: {
		one: "prawie rok",
		twoFour: "prawie {{count}} lata",
		other: "prawie {{count}} lat"
	}
};
function declensionGroup(scheme, count) {
	if (count === 1) return scheme.one;
	const rem100 = count % 100;
	if (rem100 <= 20 && rem100 > 10) return scheme.other;
	const rem10 = rem100 % 10;
	if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
	return scheme.other;
}
function declension(scheme, count, time) {
	const group = declensionGroup(scheme, count);
	return (typeof group === "string" ? group : group[time]).replace("{{count}}", String(count));
}
var formatDistance$3 = (token, count, options) => {
	const scheme = formatDistanceLocale$3[token];
	if (!options?.addSuffix) return declension(scheme, count, "regular");
	if (options.comparison && options.comparison > 0) return "za " + declension(scheme, count, "future");
	else return declension(scheme, count, "past") + " temu";
};
var formatLong$3 = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE, do MMMM y",
			long: "do MMMM y",
			medium: "do MMM y",
			short: "dd.MM.y"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "HH:mm:ss zzzz",
			long: "HH:mm:ss z",
			medium: "HH:mm:ss",
			short: "HH:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} {{time}}",
			long: "{{date}} {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/pl/_lib/formatRelative.js
var adjectivesLastWeek = {
	masculine: "ostatni",
	feminine: "ostatnia"
};
var adjectivesThisWeek = {
	masculine: "ten",
	feminine: "ta"
};
var adjectivesNextWeek = {
	masculine: "następny",
	feminine: "następna"
};
var dayGrammaticalGender = {
	0: "feminine",
	1: "masculine",
	2: "masculine",
	3: "feminine",
	4: "masculine",
	5: "masculine",
	6: "feminine"
};
function dayAndTimeWithAdjective(token, date, baseDate, options) {
	let adjectives;
	if (isSameWeek(date, baseDate, options)) adjectives = adjectivesThisWeek;
	else if (token === "lastWeek") adjectives = adjectivesLastWeek;
	else if (token === "nextWeek") adjectives = adjectivesNextWeek;
	else throw new Error(`Cannot determine adjectives for token ${token}`);
	const grammaticalGender = dayGrammaticalGender[date.getDay()];
	return `'${adjectives[grammaticalGender]}' eeee 'o' p`;
}
var formatRelativeLocale$3 = {
	lastWeek: dayAndTimeWithAdjective,
	yesterday: "'wczoraj o' p",
	today: "'dzisiaj o' p",
	tomorrow: "'jutro o' p",
	nextWeek: dayAndTimeWithAdjective,
	other: "P"
};
var formatRelative$3 = (token, date, baseDate, options) => {
	const format = formatRelativeLocale$3[token];
	if (typeof format === "function") return format(token, date, baseDate, options);
	return format;
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/pl/_lib/localize.js
var eraValues$3 = {
	narrow: ["p.n.e.", "n.e."],
	abbreviated: ["p.n.e.", "n.e."],
	wide: ["przed naszą erą", "naszej ery"]
};
var quarterValues$3 = {
	narrow: [
		"1",
		"2",
		"3",
		"4"
	],
	abbreviated: [
		"I kw.",
		"II kw.",
		"III kw.",
		"IV kw."
	],
	wide: [
		"I kwartał",
		"II kwartał",
		"III kwartał",
		"IV kwartał"
	]
};
var monthValues$3 = {
	narrow: [
		"S",
		"L",
		"M",
		"K",
		"M",
		"C",
		"L",
		"S",
		"W",
		"P",
		"L",
		"G"
	],
	abbreviated: [
		"sty",
		"lut",
		"mar",
		"kwi",
		"maj",
		"cze",
		"lip",
		"sie",
		"wrz",
		"paź",
		"lis",
		"gru"
	],
	wide: [
		"styczeń",
		"luty",
		"marzec",
		"kwiecień",
		"maj",
		"czerwiec",
		"lipiec",
		"sierpień",
		"wrzesień",
		"październik",
		"listopad",
		"grudzień"
	]
};
var monthFormattingValues = {
	narrow: [
		"s",
		"l",
		"m",
		"k",
		"m",
		"c",
		"l",
		"s",
		"w",
		"p",
		"l",
		"g"
	],
	abbreviated: [
		"sty",
		"lut",
		"mar",
		"kwi",
		"maj",
		"cze",
		"lip",
		"sie",
		"wrz",
		"paź",
		"lis",
		"gru"
	],
	wide: [
		"stycznia",
		"lutego",
		"marca",
		"kwietnia",
		"maja",
		"czerwca",
		"lipca",
		"sierpnia",
		"września",
		"października",
		"listopada",
		"grudnia"
	]
};
var dayValues$3 = {
	narrow: [
		"N",
		"P",
		"W",
		"Ś",
		"C",
		"P",
		"S"
	],
	short: [
		"nie",
		"pon",
		"wto",
		"śro",
		"czw",
		"pią",
		"sob"
	],
	abbreviated: [
		"niedz.",
		"pon.",
		"wt.",
		"śr.",
		"czw.",
		"pt.",
		"sob."
	],
	wide: [
		"niedziela",
		"poniedziałek",
		"wtorek",
		"środa",
		"czwartek",
		"piątek",
		"sobota"
	]
};
var dayFormattingValues = {
	narrow: [
		"n",
		"p",
		"w",
		"ś",
		"c",
		"p",
		"s"
	],
	short: [
		"nie",
		"pon",
		"wto",
		"śro",
		"czw",
		"pią",
		"sob"
	],
	abbreviated: [
		"niedz.",
		"pon.",
		"wt.",
		"śr.",
		"czw.",
		"pt.",
		"sob."
	],
	wide: [
		"niedziela",
		"poniedziałek",
		"wtorek",
		"środa",
		"czwartek",
		"piątek",
		"sobota"
	]
};
var dayPeriodValues$3 = {
	narrow: {
		am: "a",
		pm: "p",
		midnight: "półn.",
		noon: "poł",
		morning: "rano",
		afternoon: "popoł.",
		evening: "wiecz.",
		night: "noc"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "północ",
		noon: "południe",
		morning: "rano",
		afternoon: "popołudnie",
		evening: "wieczór",
		night: "noc"
	},
	wide: {
		am: "AM",
		pm: "PM",
		midnight: "północ",
		noon: "południe",
		morning: "rano",
		afternoon: "popołudnie",
		evening: "wieczór",
		night: "noc"
	}
};
var dayPeriodFormattingValues = {
	narrow: {
		am: "a",
		pm: "p",
		midnight: "o półn.",
		noon: "w poł.",
		morning: "rano",
		afternoon: "po poł.",
		evening: "wiecz.",
		night: "w nocy"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "o północy",
		noon: "w południe",
		morning: "rano",
		afternoon: "po południu",
		evening: "wieczorem",
		night: "w nocy"
	},
	wide: {
		am: "AM",
		pm: "PM",
		midnight: "o północy",
		noon: "w południe",
		morning: "rano",
		afternoon: "po południu",
		evening: "wieczorem",
		night: "w nocy"
	}
};
var ordinalNumber$3 = (dirtyNumber, _options) => {
	return String(dirtyNumber);
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/pl.js
/**
* @category Locales
* @summary Polish locale.
* @language Polish
* @iso-639-2 pol
* @author Mateusz Derks [@ertrzyiks](https://github.com/ertrzyiks)
* @author Just RAG [@justrag](https://github.com/justrag)
* @author Mikolaj Grzyb [@mikolajgrzyb](https://github.com/mikolajgrzyb)
* @author Mateusz Tokarski [@mutisz](https://github.com/mutisz)
*/
var pl = {
	code: "pl",
	formatDistance: formatDistance$3,
	formatLong: formatLong$3,
	formatRelative: formatRelative$3,
	localize: {
		ordinalNumber: ordinalNumber$3,
		era: buildLocalizeFn({
			values: eraValues$3,
			defaultWidth: "wide"
		}),
		quarter: buildLocalizeFn({
			values: quarterValues$3,
			defaultWidth: "wide",
			argumentCallback: (quarter) => quarter - 1
		}),
		month: buildLocalizeFn({
			values: monthValues$3,
			defaultWidth: "wide",
			formattingValues: monthFormattingValues,
			defaultFormattingWidth: "wide"
		}),
		day: buildLocalizeFn({
			values: dayValues$3,
			defaultWidth: "wide",
			formattingValues: dayFormattingValues,
			defaultFormattingWidth: "wide"
		}),
		dayPeriod: buildLocalizeFn({
			values: dayPeriodValues$3,
			defaultWidth: "wide",
			formattingValues: dayPeriodFormattingValues,
			defaultFormattingWidth: "wide"
		})
	},
	match: {
		ordinalNumber: buildMatchPatternFn({
			matchPattern: /^(\d+)?/i,
			parsePattern: /\d+/i,
			valueCallback: (value) => parseInt(value, 10)
		}),
		era: buildMatchFn({
			matchPatterns: {
				narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
				abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
				wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^p/i, /^n/i] },
			defaultParseWidth: "any"
		}),
		quarter: buildMatchFn({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
				wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/1/i,
					/2/i,
					/3/i,
					/4/i
				],
				any: [
					/^I kw/i,
					/^II kw/i,
					/^III kw/i,
					/^IV kw/i
				]
			},
			defaultParseWidth: "any",
			valueCallback: (index) => index + 1
		}),
		month: buildMatchFn({
			matchPatterns: {
				narrow: /^[slmkcwpg]/i,
				abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
				wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^s/i,
					/^l/i,
					/^m/i,
					/^k/i,
					/^m/i,
					/^c/i,
					/^l/i,
					/^s/i,
					/^w/i,
					/^p/i,
					/^l/i,
					/^g/i
				],
				any: [
					/^st/i,
					/^lu/i,
					/^mar/i,
					/^k/i,
					/^maj/i,
					/^c/i,
					/^lip/i,
					/^si/i,
					/^w/i,
					/^p/i,
					/^lis/i,
					/^g/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: buildMatchFn({
			matchPatterns: {
				narrow: /^[npwścs]/i,
				short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
				abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
				wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^n/i,
					/^p/i,
					/^w/i,
					/^ś/i,
					/^c/i,
					/^p/i,
					/^s/i
				],
				abbreviated: [
					/^n/i,
					/^po/i,
					/^w/i,
					/^(ś|s)r/i,
					/^c/i,
					/^pt/i,
					/^so/i
				],
				any: [
					/^n/i,
					/^po/i,
					/^w/i,
					/^(ś|s)r/i,
					/^c/i,
					/^pi/i,
					/^so/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: buildMatchFn({
			matchPatterns: {
				narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
				any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
			},
			defaultMatchWidth: "any",
			parsePatterns: {
				narrow: {
					am: /^a$/i,
					pm: /^p$/i,
					midnight: /pó(ł|l)n/i,
					noon: /po(ł|l)/i,
					morning: /rano/i,
					afternoon: /po\s*po(ł|l)/i,
					evening: /wiecz/i,
					night: /noc/i
				},
				any: {
					am: /^am/i,
					pm: /^pm/i,
					midnight: /pó(ł|l)n/i,
					noon: /po(ł|l)/i,
					morning: /rano/i,
					afternoon: /po\s*po(ł|l)/i,
					evening: /wiecz/i,
					night: /noc/i
				}
			},
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 4
	}
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/nl/_lib/formatDistance.js
var formatDistanceLocale$2 = {
	lessThanXSeconds: {
		one: "minder dan een seconde",
		other: "minder dan {{count}} seconden"
	},
	xSeconds: {
		one: "1 seconde",
		other: "{{count}} seconden"
	},
	halfAMinute: "een halve minuut",
	lessThanXMinutes: {
		one: "minder dan een minuut",
		other: "minder dan {{count}} minuten"
	},
	xMinutes: {
		one: "een minuut",
		other: "{{count}} minuten"
	},
	aboutXHours: {
		one: "ongeveer 1 uur",
		other: "ongeveer {{count}} uur"
	},
	xHours: {
		one: "1 uur",
		other: "{{count}} uur"
	},
	xDays: {
		one: "1 dag",
		other: "{{count}} dagen"
	},
	aboutXWeeks: {
		one: "ongeveer 1 week",
		other: "ongeveer {{count}} weken"
	},
	xWeeks: {
		one: "1 week",
		other: "{{count}} weken"
	},
	aboutXMonths: {
		one: "ongeveer 1 maand",
		other: "ongeveer {{count}} maanden"
	},
	xMonths: {
		one: "1 maand",
		other: "{{count}} maanden"
	},
	aboutXYears: {
		one: "ongeveer 1 jaar",
		other: "ongeveer {{count}} jaar"
	},
	xYears: {
		one: "1 jaar",
		other: "{{count}} jaar"
	},
	overXYears: {
		one: "meer dan 1 jaar",
		other: "meer dan {{count}} jaar"
	},
	almostXYears: {
		one: "bijna 1 jaar",
		other: "bijna {{count}} jaar"
	}
};
var formatDistance$2 = (token, count, options) => {
	let result;
	const tokenValue = formatDistanceLocale$2[token];
	if (typeof tokenValue === "string") result = tokenValue;
	else if (count === 1) result = tokenValue.one;
	else result = tokenValue.other.replace("{{count}}", String(count));
	if (options?.addSuffix) {
		if (options.comparison && options.comparison > 0) return "over " + result;
		else return result + " geleden";
	}
	return result;
};
var formatLong$2 = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE d MMMM y",
			long: "d MMMM y",
			medium: "d MMM y",
			short: "dd-MM-y"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "HH:mm:ss zzzz",
			long: "HH:mm:ss z",
			medium: "HH:mm:ss",
			short: "HH:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'om' {{time}}",
			long: "{{date}} 'om' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/nl/_lib/formatRelative.js
var formatRelativeLocale$2 = {
	lastWeek: "'afgelopen' eeee 'om' p",
	yesterday: "'gisteren om' p",
	today: "'vandaag om' p",
	tomorrow: "'morgen om' p",
	nextWeek: "eeee 'om' p",
	other: "P"
};
var formatRelative$2 = (token, _date, _baseDate, _options) => formatRelativeLocale$2[token];
//#endregion
//#region ../../../../../node_modules/date-fns/locale/nl/_lib/localize.js
var eraValues$2 = {
	narrow: ["v.C.", "n.C."],
	abbreviated: ["v.Chr.", "n.Chr."],
	wide: ["voor Christus", "na Christus"]
};
var quarterValues$2 = {
	narrow: [
		"1",
		"2",
		"3",
		"4"
	],
	abbreviated: [
		"K1",
		"K2",
		"K3",
		"K4"
	],
	wide: [
		"1e kwartaal",
		"2e kwartaal",
		"3e kwartaal",
		"4e kwartaal"
	]
};
var monthValues$2 = {
	narrow: [
		"J",
		"F",
		"M",
		"A",
		"M",
		"J",
		"J",
		"A",
		"S",
		"O",
		"N",
		"D"
	],
	abbreviated: [
		"jan.",
		"feb.",
		"mrt.",
		"apr.",
		"mei",
		"jun.",
		"jul.",
		"aug.",
		"sep.",
		"okt.",
		"nov.",
		"dec."
	],
	wide: [
		"januari",
		"februari",
		"maart",
		"april",
		"mei",
		"juni",
		"juli",
		"augustus",
		"september",
		"oktober",
		"november",
		"december"
	]
};
var dayValues$2 = {
	narrow: [
		"Z",
		"M",
		"D",
		"W",
		"D",
		"V",
		"Z"
	],
	short: [
		"zo",
		"ma",
		"di",
		"wo",
		"do",
		"vr",
		"za"
	],
	abbreviated: [
		"zon",
		"maa",
		"din",
		"woe",
		"don",
		"vri",
		"zat"
	],
	wide: [
		"zondag",
		"maandag",
		"dinsdag",
		"woensdag",
		"donderdag",
		"vrijdag",
		"zaterdag"
	]
};
var dayPeriodValues$2 = {
	narrow: {
		am: "AM",
		pm: "PM",
		midnight: "middernacht",
		noon: "het middaguur",
		morning: "'s ochtends",
		afternoon: "'s middags",
		evening: "'s avonds",
		night: "'s nachts"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "middernacht",
		noon: "het middaguur",
		morning: "'s ochtends",
		afternoon: "'s middags",
		evening: "'s avonds",
		night: "'s nachts"
	},
	wide: {
		am: "AM",
		pm: "PM",
		midnight: "middernacht",
		noon: "het middaguur",
		morning: "'s ochtends",
		afternoon: "'s middags",
		evening: "'s avonds",
		night: "'s nachts"
	}
};
var ordinalNumber$2 = (dirtyNumber, _options) => {
	return Number(dirtyNumber) + "e";
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/nl.js
/**
* @category Locales
* @summary Dutch locale.
* @language Dutch
* @iso-639-2 nld
* @author Jorik Tangelder [@jtangelder](https://github.com/jtangelder)
* @author Ruben Stolk [@rubenstolk](https://github.com/rubenstolk)
* @author Lode Vanhove [@bitcrumb](https://github.com/bitcrumb)
* @author Edo Rivai [@edorivai](https://github.com/edorivai)
* @author Niels Keurentjes [@curry684](https://github.com/curry684)
* @author Stefan Vermaas [@stefanvermaas](https://github.com/stefanvermaas)
*/
var nl = {
	code: "nl",
	formatDistance: formatDistance$2,
	formatLong: formatLong$2,
	formatRelative: formatRelative$2,
	localize: {
		ordinalNumber: ordinalNumber$2,
		era: buildLocalizeFn({
			values: eraValues$2,
			defaultWidth: "wide"
		}),
		quarter: buildLocalizeFn({
			values: quarterValues$2,
			defaultWidth: "wide",
			argumentCallback: (quarter) => quarter - 1
		}),
		month: buildLocalizeFn({
			values: monthValues$2,
			defaultWidth: "wide"
		}),
		day: buildLocalizeFn({
			values: dayValues$2,
			defaultWidth: "wide"
		}),
		dayPeriod: buildLocalizeFn({
			values: dayPeriodValues$2,
			defaultWidth: "wide"
		})
	},
	match: {
		ordinalNumber: buildMatchPatternFn({
			matchPattern: /^(\d+)e?/i,
			parsePattern: /\d+/i,
			valueCallback: (value) => parseInt(value, 10)
		}),
		era: buildMatchFn({
			matchPatterns: {
				narrow: /^([vn]\.? ?C\.?)/,
				abbreviated: /^([vn]\. ?Chr\.?)/,
				wide: /^((voor|na) Christus)/
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^v/, /^n/] },
			defaultParseWidth: "any"
		}),
		quarter: buildMatchFn({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^K[1234]/i,
				wide: /^[1234]e kwartaal/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (index) => index + 1
		}),
		month: buildMatchFn({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
				wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^jan/i,
					/^feb/i,
					/^m(r|a)/i,
					/^apr/i,
					/^mei/i,
					/^jun/i,
					/^jul/i,
					/^aug/i,
					/^sep/i,
					/^okt/i,
					/^nov/i,
					/^dec/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: buildMatchFn({
			matchPatterns: {
				narrow: /^[zmdwv]/i,
				short: /^(zo|ma|di|wo|do|vr|za)/i,
				abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
				wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^z/i,
					/^m/i,
					/^d/i,
					/^w/i,
					/^d/i,
					/^v/i,
					/^z/i
				],
				any: [
					/^zo/i,
					/^ma/i,
					/^di/i,
					/^wo/i,
					/^do/i,
					/^vr/i,
					/^za/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: buildMatchFn({
			matchPatterns: { any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i },
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^am/i,
				pm: /^pm/i,
				midnight: /^middernacht/i,
				noon: /^het middaguur/i,
				morning: /ochtend/i,
				afternoon: /middag/i,
				evening: /avond/i,
				night: /nacht/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 4
	}
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/ro/_lib/formatDistance.js
var formatDistanceLocale$1 = {
	lessThanXSeconds: {
		one: "mai puțin de o secundă",
		other: "mai puțin de {{count}} secunde"
	},
	xSeconds: {
		one: "1 secundă",
		other: "{{count}} secunde"
	},
	halfAMinute: "jumătate de minut",
	lessThanXMinutes: {
		one: "mai puțin de un minut",
		other: "mai puțin de {{count}} minute"
	},
	xMinutes: {
		one: "1 minut",
		other: "{{count}} minute"
	},
	aboutXHours: {
		one: "circa 1 oră",
		other: "circa {{count}} ore"
	},
	xHours: {
		one: "1 oră",
		other: "{{count}} ore"
	},
	xDays: {
		one: "1 zi",
		other: "{{count}} zile"
	},
	aboutXWeeks: {
		one: "circa o săptămână",
		other: "circa {{count}} săptămâni"
	},
	xWeeks: {
		one: "1 săptămână",
		other: "{{count}} săptămâni"
	},
	aboutXMonths: {
		one: "circa 1 lună",
		other: "circa {{count}} luni"
	},
	xMonths: {
		one: "1 lună",
		other: "{{count}} luni"
	},
	aboutXYears: {
		one: "circa 1 an",
		other: "circa {{count}} ani"
	},
	xYears: {
		one: "1 an",
		other: "{{count}} ani"
	},
	overXYears: {
		one: "peste 1 an",
		other: "peste {{count}} ani"
	},
	almostXYears: {
		one: "aproape 1 an",
		other: "aproape {{count}} ani"
	}
};
var formatDistance$1 = (token, count, options) => {
	let result;
	const tokenValue = formatDistanceLocale$1[token];
	if (typeof tokenValue === "string") result = tokenValue;
	else if (count === 1) result = tokenValue.one;
	else result = tokenValue.other.replace("{{count}}", String(count));
	if (options?.addSuffix) {
		if (options.comparison && options.comparison > 0) return "în " + result;
		else return result + " în urmă";
	}
	return result;
};
var formatLong$1 = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE, d MMMM yyyy",
			long: "d MMMM yyyy",
			medium: "d MMM yyyy",
			short: "dd.MM.yyyy"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "HH:mm:ss zzzz",
			long: "HH:mm:ss z",
			medium: "HH:mm:ss",
			short: "HH:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'la' {{time}}",
			long: "{{date}} 'la' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/ro/_lib/formatRelative.js
var formatRelativeLocale$1 = {
	lastWeek: "eeee 'trecută la' p",
	yesterday: "'ieri la' p",
	today: "'astăzi la' p",
	tomorrow: "'mâine la' p",
	nextWeek: "eeee 'viitoare la' p",
	other: "P"
};
var formatRelative$1 = (token, _date, _baseDate, _options) => formatRelativeLocale$1[token];
//#endregion
//#region ../../../../../node_modules/date-fns/locale/ro/_lib/localize.js
var eraValues$1 = {
	narrow: ["Î", "D"],
	abbreviated: ["Î.d.C.", "D.C."],
	wide: ["Înainte de Cristos", "După Cristos"]
};
var quarterValues$1 = {
	narrow: [
		"1",
		"2",
		"3",
		"4"
	],
	abbreviated: [
		"T1",
		"T2",
		"T3",
		"T4"
	],
	wide: [
		"primul trimestru",
		"al doilea trimestru",
		"al treilea trimestru",
		"al patrulea trimestru"
	]
};
var monthValues$1 = {
	narrow: [
		"I",
		"F",
		"M",
		"A",
		"M",
		"I",
		"I",
		"A",
		"S",
		"O",
		"N",
		"D"
	],
	abbreviated: [
		"ian",
		"feb",
		"mar",
		"apr",
		"mai",
		"iun",
		"iul",
		"aug",
		"sep",
		"oct",
		"noi",
		"dec"
	],
	wide: [
		"ianuarie",
		"februarie",
		"martie",
		"aprilie",
		"mai",
		"iunie",
		"iulie",
		"august",
		"septembrie",
		"octombrie",
		"noiembrie",
		"decembrie"
	]
};
var dayValues$1 = {
	narrow: [
		"d",
		"l",
		"m",
		"m",
		"j",
		"v",
		"s"
	],
	short: [
		"du",
		"lu",
		"ma",
		"mi",
		"jo",
		"vi",
		"sâ"
	],
	abbreviated: [
		"dum",
		"lun",
		"mar",
		"mie",
		"joi",
		"vin",
		"sâm"
	],
	wide: [
		"duminică",
		"luni",
		"marți",
		"miercuri",
		"joi",
		"vineri",
		"sâmbătă"
	]
};
var dayPeriodValues$1 = {
	narrow: {
		am: "a",
		pm: "p",
		midnight: "mn",
		noon: "ami",
		morning: "dim",
		afternoon: "da",
		evening: "s",
		night: "n"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "miezul nopții",
		noon: "amiază",
		morning: "dimineață",
		afternoon: "după-amiază",
		evening: "seară",
		night: "noapte"
	},
	wide: {
		am: "a.m.",
		pm: "p.m.",
		midnight: "miezul nopții",
		noon: "amiază",
		morning: "dimineață",
		afternoon: "după-amiază",
		evening: "seară",
		night: "noapte"
	}
};
var formattingDayPeriodValues$1 = {
	narrow: {
		am: "a",
		pm: "p",
		midnight: "mn",
		noon: "amiază",
		morning: "dimineață",
		afternoon: "după-amiază",
		evening: "seară",
		night: "noapte"
	},
	abbreviated: {
		am: "AM",
		pm: "PM",
		midnight: "miezul nopții",
		noon: "amiază",
		morning: "dimineață",
		afternoon: "după-amiază",
		evening: "seară",
		night: "noapte"
	},
	wide: {
		am: "a.m.",
		pm: "p.m.",
		midnight: "miezul nopții",
		noon: "amiază",
		morning: "dimineață",
		afternoon: "după-amiază",
		evening: "seară",
		night: "noapte"
	}
};
var ordinalNumber$1 = (dirtyNumber, _options) => {
	return String(dirtyNumber);
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/ro.js
/**
* @category Locales
* @summary Romanian locale.
* @language Romanian
* @iso-639-2 ron
* @author Sergiu Munteanu [@jsergiu](https://github.com/jsergiu)
* @author Adrian Ocneanu [@aocneanu](https://github.com/aocneanu)
* @author Mihai Ocneanu [@gandesc](https://github.com/gandesc)
*/
var ro = {
	code: "ro",
	formatDistance: formatDistance$1,
	formatLong: formatLong$1,
	formatRelative: formatRelative$1,
	localize: {
		ordinalNumber: ordinalNumber$1,
		era: buildLocalizeFn({
			values: eraValues$1,
			defaultWidth: "wide"
		}),
		quarter: buildLocalizeFn({
			values: quarterValues$1,
			defaultWidth: "wide",
			argumentCallback: (quarter) => quarter - 1
		}),
		month: buildLocalizeFn({
			values: monthValues$1,
			defaultWidth: "wide"
		}),
		day: buildLocalizeFn({
			values: dayValues$1,
			defaultWidth: "wide"
		}),
		dayPeriod: buildLocalizeFn({
			values: dayPeriodValues$1,
			defaultWidth: "wide",
			formattingValues: formattingDayPeriodValues$1,
			defaultFormattingWidth: "wide"
		})
	},
	match: {
		ordinalNumber: buildMatchPatternFn({
			matchPattern: /^(\d+)?/i,
			parsePattern: /\d+/i,
			valueCallback: (value) => parseInt(value, 10)
		}),
		era: buildMatchFn({
			matchPatterns: {
				narrow: /^(Î|D)/i,
				abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
				wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				any: [/^ÎC/i, /^DC/i],
				wide: [/^(Înainte de Cristos|Înaintea erei noastre)/i, /^(După Cristos|Era noastră)/i]
			},
			defaultParseWidth: "any"
		}),
		quarter: buildMatchFn({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^T[1234]/i,
				wide: /^trimestrul [1234]/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (index) => index + 1
		}),
		month: buildMatchFn({
			matchPatterns: {
				narrow: /^[ifmaasond]/i,
				abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
				wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^i/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^i/i,
					/^i/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ia/i,
					/^f/i,
					/^mar/i,
					/^ap/i,
					/^mai/i,
					/^iun/i,
					/^iul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: buildMatchFn({
			matchPatterns: {
				narrow: /^[dlmjvs]/i,
				short: /^(d|l|ma|mi|j|v|s)/i,
				abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
				wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^d/i,
					/^l/i,
					/^m/i,
					/^m/i,
					/^j/i,
					/^v/i,
					/^s/i
				],
				any: [
					/^d/i,
					/^l/i,
					/^ma/i,
					/^mi/i,
					/^j/i,
					/^v/i,
					/^s/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: buildMatchFn({
			matchPatterns: {
				narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
				any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^mn/i,
				noon: /amiaza/i,
				morning: /dimineaţa/i,
				afternoon: /după-amiaza/i,
				evening: /seara/i,
				night: /noaptea/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 1
	}
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/sv/_lib/formatDistance.js
var formatDistanceLocale = {
	lessThanXSeconds: {
		one: "mindre än en sekund",
		other: "mindre än {{count}} sekunder"
	},
	xSeconds: {
		one: "en sekund",
		other: "{{count}} sekunder"
	},
	halfAMinute: "en halv minut",
	lessThanXMinutes: {
		one: "mindre än en minut",
		other: "mindre än {{count}} minuter"
	},
	xMinutes: {
		one: "en minut",
		other: "{{count}} minuter"
	},
	aboutXHours: {
		one: "ungefär en timme",
		other: "ungefär {{count}} timmar"
	},
	xHours: {
		one: "en timme",
		other: "{{count}} timmar"
	},
	xDays: {
		one: "en dag",
		other: "{{count}} dagar"
	},
	aboutXWeeks: {
		one: "ungefär en vecka",
		other: "ungefär {{count}} veckor"
	},
	xWeeks: {
		one: "en vecka",
		other: "{{count}} veckor"
	},
	aboutXMonths: {
		one: "ungefär en månad",
		other: "ungefär {{count}} månader"
	},
	xMonths: {
		one: "en månad",
		other: "{{count}} månader"
	},
	aboutXYears: {
		one: "ungefär ett år",
		other: "ungefär {{count}} år"
	},
	xYears: {
		one: "ett år",
		other: "{{count}} år"
	},
	overXYears: {
		one: "över ett år",
		other: "över {{count}} år"
	},
	almostXYears: {
		one: "nästan ett år",
		other: "nästan {{count}} år"
	}
};
var wordMapping = [
	"noll",
	"en",
	"två",
	"tre",
	"fyra",
	"fem",
	"sex",
	"sju",
	"åtta",
	"nio",
	"tio",
	"elva",
	"tolv"
];
var formatDistance = (token, count, options) => {
	let result;
	const tokenValue = formatDistanceLocale[token];
	if (typeof tokenValue === "string") result = tokenValue;
	else if (count === 1) result = tokenValue.one;
	else result = tokenValue.other.replace("{{count}}", count < 13 ? wordMapping[count] : String(count));
	if (options?.addSuffix) {
		if (options.comparison && options.comparison > 0) return "om " + result;
		else return result + " sedan";
	}
	return result;
};
var formatLong = {
	date: buildFormatLongFn({
		formats: {
			full: "EEEE d MMMM y",
			long: "d MMMM y",
			medium: "d MMM y",
			short: "y-MM-dd"
		},
		defaultWidth: "full"
	}),
	time: buildFormatLongFn({
		formats: {
			full: "'kl'. HH:mm:ss zzzz",
			long: "HH:mm:ss z",
			medium: "HH:mm:ss",
			short: "HH:mm"
		},
		defaultWidth: "full"
	}),
	dateTime: buildFormatLongFn({
		formats: {
			full: "{{date}} 'kl.' {{time}}",
			long: "{{date}} 'kl.' {{time}}",
			medium: "{{date}} {{time}}",
			short: "{{date}} {{time}}"
		},
		defaultWidth: "full"
	})
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/sv/_lib/formatRelative.js
var formatRelativeLocale = {
	lastWeek: "'i' EEEE's kl.' p",
	yesterday: "'igår kl.' p",
	today: "'idag kl.' p",
	tomorrow: "'imorgon kl.' p",
	nextWeek: "EEEE 'kl.' p",
	other: "P"
};
var formatRelative = (token, _date, _baseDate, _options) => formatRelativeLocale[token];
//#endregion
//#region ../../../../../node_modules/date-fns/locale/sv/_lib/localize.js
var eraValues = {
	narrow: ["f.Kr.", "e.Kr."],
	abbreviated: ["f.Kr.", "e.Kr."],
	wide: ["före Kristus", "efter Kristus"]
};
var quarterValues = {
	narrow: [
		"1",
		"2",
		"3",
		"4"
	],
	abbreviated: [
		"Q1",
		"Q2",
		"Q3",
		"Q4"
	],
	wide: [
		"1:a kvartalet",
		"2:a kvartalet",
		"3:e kvartalet",
		"4:e kvartalet"
	]
};
var monthValues = {
	narrow: [
		"J",
		"F",
		"M",
		"A",
		"M",
		"J",
		"J",
		"A",
		"S",
		"O",
		"N",
		"D"
	],
	abbreviated: [
		"jan.",
		"feb.",
		"mars",
		"apr.",
		"maj",
		"juni",
		"juli",
		"aug.",
		"sep.",
		"okt.",
		"nov.",
		"dec."
	],
	wide: [
		"januari",
		"februari",
		"mars",
		"april",
		"maj",
		"juni",
		"juli",
		"augusti",
		"september",
		"oktober",
		"november",
		"december"
	]
};
var dayValues = {
	narrow: [
		"S",
		"M",
		"T",
		"O",
		"T",
		"F",
		"L"
	],
	short: [
		"sö",
		"må",
		"ti",
		"on",
		"to",
		"fr",
		"lö"
	],
	abbreviated: [
		"sön",
		"mån",
		"tis",
		"ons",
		"tors",
		"fre",
		"lör"
	],
	wide: [
		"söndag",
		"måndag",
		"tisdag",
		"onsdag",
		"torsdag",
		"fredag",
		"lördag"
	]
};
var dayPeriodValues = {
	narrow: {
		am: "fm",
		pm: "em",
		midnight: "midnatt",
		noon: "middag",
		morning: "morg.",
		afternoon: "efterm.",
		evening: "kväll",
		night: "natt"
	},
	abbreviated: {
		am: "f.m.",
		pm: "e.m.",
		midnight: "midnatt",
		noon: "middag",
		morning: "morgon",
		afternoon: "efterm.",
		evening: "kväll",
		night: "natt"
	},
	wide: {
		am: "förmiddag",
		pm: "eftermiddag",
		midnight: "midnatt",
		noon: "middag",
		morning: "morgon",
		afternoon: "eftermiddag",
		evening: "kväll",
		night: "natt"
	}
};
var formattingDayPeriodValues = {
	narrow: {
		am: "fm",
		pm: "em",
		midnight: "midnatt",
		noon: "middag",
		morning: "på morg.",
		afternoon: "på efterm.",
		evening: "på kvällen",
		night: "på natten"
	},
	abbreviated: {
		am: "fm",
		pm: "em",
		midnight: "midnatt",
		noon: "middag",
		morning: "på morg.",
		afternoon: "på efterm.",
		evening: "på kvällen",
		night: "på natten"
	},
	wide: {
		am: "fm",
		pm: "em",
		midnight: "midnatt",
		noon: "middag",
		morning: "på morgonen",
		afternoon: "på eftermiddagen",
		evening: "på kvällen",
		night: "på natten"
	}
};
var ordinalNumber = (dirtyNumber, _options) => {
	const number = Number(dirtyNumber);
	const rem100 = number % 100;
	if (rem100 > 20 || rem100 < 10) switch (rem100 % 10) {
		case 1:
		case 2: return number + ":a";
	}
	return number + ":e";
};
//#endregion
//#region ../../../../../node_modules/date-fns/locale/sv.js
/**
* @category Locales
* @summary Swedish locale.
* @language Swedish
* @iso-639-2 swe
* @author Johannes Ulén [@ejulen](https://github.com/ejulen)
* @author Alexander Nanberg [@alexandernanberg](https://github.com/alexandernanberg)
* @author Henrik Andersson [@limelights](https://github.com/limelights)
*/
var sv = {
	code: "sv",
	formatDistance,
	formatLong,
	formatRelative,
	localize: {
		ordinalNumber,
		era: buildLocalizeFn({
			values: eraValues,
			defaultWidth: "wide"
		}),
		quarter: buildLocalizeFn({
			values: quarterValues,
			defaultWidth: "wide",
			argumentCallback: (quarter) => quarter - 1
		}),
		month: buildLocalizeFn({
			values: monthValues,
			defaultWidth: "wide"
		}),
		day: buildLocalizeFn({
			values: dayValues,
			defaultWidth: "wide"
		}),
		dayPeriod: buildLocalizeFn({
			values: dayPeriodValues,
			defaultWidth: "wide",
			formattingValues: formattingDayPeriodValues,
			defaultFormattingWidth: "wide"
		})
	},
	match: {
		ordinalNumber: buildMatchPatternFn({
			matchPattern: /^(\d+)(:a|:e)?/i,
			parsePattern: /\d+/i,
			valueCallback: (value) => parseInt(value, 10)
		}),
		era: buildMatchFn({
			matchPatterns: {
				narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
				abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
				wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^f/i, /^[ev]/i] },
			defaultParseWidth: "any"
		}),
		quarter: buildMatchFn({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^q[1234]/i,
				wide: /^[1234](:a|:e)? kvartalet/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (index) => index + 1
		}),
		month: buildMatchFn({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
				wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^mar/i,
					/^ap/i,
					/^maj/i,
					/^jun/i,
					/^jul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: buildMatchFn({
			matchPatterns: {
				narrow: /^[smtofl]/i,
				short: /^(sö|må|ti|on|to|fr|lö)/i,
				abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
				wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/^s/i,
				/^m/i,
				/^ti/i,
				/^o/i,
				/^to/i,
				/^f/i,
				/^l/i
			] },
			defaultParseWidth: "any"
		}),
		dayPeriod: buildMatchFn({
			matchPatterns: { any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i },
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^f/i,
				pm: /^e/i,
				midnight: /^midn/i,
				noon: /^midd/i,
				morning: /morgon/i,
				afternoon: /eftermiddag/i,
				evening: /kväll/i,
				night: /natt/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 4
	}
};
//#endregion
//#region ../../../../../node_modules/clsx/dist/clsx.mjs
function r(e) {
	var t, f, n = "";
	if ("string" == typeof e || "number" == typeof e) n += e;
	else if ("object" == typeof e) if (Array.isArray(e)) {
		var o = e.length;
		for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
	} else for (f in e) e[f] && (n && (n += " "), n += f);
	return n;
}
function clsx() {
	for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
	return n;
}
//#endregion
//#region ../../../../../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function hasWindow() {
	return typeof window !== "undefined";
}
function getNodeName(node) {
	if (isNode(node)) return (node.nodeName || "").toLowerCase();
	return "#document";
}
function getWindow(node) {
	var _node$ownerDocument;
	return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
	var _ref;
	return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
	if (!hasWindow()) return false;
	return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
	if (!hasWindow()) return false;
	return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
	if (!hasWindow()) return false;
	return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
	if (!hasWindow() || typeof ShadowRoot === "undefined") return false;
	return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
var invalidOverflowDisplayValues = /*#__PURE__*/ new Set(["inline", "contents"]);
function isOverflowElement(element) {
	const { overflow, overflowX, overflowY, display } = getComputedStyle$1(element);
	return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !invalidOverflowDisplayValues.has(display);
}
var tableElements = /*#__PURE__*/ new Set([
	"table",
	"td",
	"th"
]);
function isTableElement(element) {
	return tableElements.has(getNodeName(element));
}
var topLayerSelectors = [":popover-open", ":modal"];
function isTopLayer(element) {
	return topLayerSelectors.some((selector) => {
		try {
			return element.matches(selector);
		} catch (_e) {
			return false;
		}
	});
}
var transformProperties = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective"
];
var willChangeValues = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective",
	"filter"
];
var containValues = [
	"paint",
	"layout",
	"strict",
	"content"
];
function isContainingBlock(elementOrCss) {
	const webkit = isWebKit();
	const css = isElement(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
	return transformProperties.some((value) => css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || willChangeValues.some((value) => (css.willChange || "").includes(value)) || containValues.some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
	let currentNode = getParentNode(element);
	while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
		if (isContainingBlock(currentNode)) return currentNode;
		else if (isTopLayer(currentNode)) return null;
		currentNode = getParentNode(currentNode);
	}
	return null;
}
function isWebKit() {
	if (typeof CSS === "undefined" || !CSS.supports) return false;
	return CSS.supports("-webkit-backdrop-filter", "none");
}
var lastTraversableNodeNames = /*#__PURE__*/ new Set([
	"html",
	"body",
	"#document"
]);
function isLastTraversableNode(node) {
	return lastTraversableNodeNames.has(getNodeName(node));
}
function getComputedStyle$1(element) {
	return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
	if (isElement(element)) return {
		scrollLeft: element.scrollLeft,
		scrollTop: element.scrollTop
	};
	return {
		scrollLeft: element.scrollX,
		scrollTop: element.scrollY
	};
}
function getParentNode(node) {
	if (getNodeName(node) === "html") return node;
	const result = node.assignedSlot || node.parentNode || isShadowRoot(node) && node.host || getDocumentElement(node);
	return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
	const parentNode = getParentNode(node);
	if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
	if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
	return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
	var _node$ownerDocument2;
	if (list === void 0) list = [];
	if (traverseIframes === void 0) traverseIframes = true;
	const scrollableAncestor = getNearestOverflowAncestor(node);
	const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
	const win = getWindow(scrollableAncestor);
	if (isBody) {
		const frameElement = getFrameElement(win);
		return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
	}
	return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
	return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
//#endregion
//#region ../../../../../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var min$1 = Math.min;
var max$1 = Math.max;
var round = Math.round;
var floor = Math.floor;
var createCoords = (v) => ({
	x: v,
	y: v
});
var oppositeSideMap = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
var oppositeAlignmentMap = {
	start: "end",
	end: "start"
};
function clamp(start, value, end) {
	return max$1(start, min$1(value, end));
}
function evaluate(value, param) {
	return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
	return placement.split("-")[0];
}
function getAlignment(placement) {
	return placement.split("-")[1];
}
function getOppositeAxis(axis) {
	return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
	return axis === "y" ? "height" : "width";
}
var yAxisSides = /*#__PURE__*/ new Set(["top", "bottom"]);
function getSideAxis(placement) {
	return yAxisSides.has(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
	return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
	if (rtl === void 0) rtl = false;
	const alignment = getAlignment(placement);
	const alignmentAxis = getAlignmentAxis(placement);
	const length = getAxisLength(alignmentAxis);
	let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
	if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
	return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
	const oppositePlacement = getOppositePlacement(placement);
	return [
		getOppositeAlignmentPlacement(placement),
		oppositePlacement,
		getOppositeAlignmentPlacement(oppositePlacement)
	];
}
function getOppositeAlignmentPlacement(placement) {
	return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
var lrPlacement = ["left", "right"];
var rlPlacement = ["right", "left"];
var tbPlacement = ["top", "bottom"];
var btPlacement = ["bottom", "top"];
function getSideList(side, isStart, rtl) {
	switch (side) {
		case "top":
		case "bottom":
			if (rtl) return isStart ? rlPlacement : lrPlacement;
			return isStart ? lrPlacement : rlPlacement;
		case "left":
		case "right": return isStart ? tbPlacement : btPlacement;
		default: return [];
	}
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
	const alignment = getAlignment(placement);
	let list = getSideList(getSide(placement), direction === "start", rtl);
	if (alignment) {
		list = list.map((side) => side + "-" + alignment);
		if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
	}
	return list;
}
function getOppositePlacement(placement) {
	return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...padding
	};
}
function getPaddingObject(padding) {
	return typeof padding !== "number" ? expandPaddingObject(padding) : {
		top: padding,
		right: padding,
		bottom: padding,
		left: padding
	};
}
function rectToClientRect(rect) {
	const { x, y, width, height } = rect;
	return {
		width,
		height,
		top: y,
		left: x,
		right: x + width,
		bottom: y + height,
		x,
		y
	};
}
//#endregion
//#region ../../../../../node_modules/@floating-ui/react/dist/floating-ui.react.utils.mjs
var index$1 = typeof document !== "undefined" ? useLayoutEffect : function noop() {};
var useSafeInsertionEffect = { ...React$1 }.useInsertionEffect || ((fn) => fn());
function useEffectEvent(callback) {
	const ref = React$1.useRef(() => {
		if (process.env.NODE_ENV !== "production") throw new Error("Cannot call an event handler while rendering.");
	});
	useSafeInsertionEffect(() => {
		ref.current = callback;
	});
	return React$1.useCallback(function() {
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		return ref.current == null ? void 0 : ref.current(...args);
	}, []);
}
//#endregion
//#region ../../../../../node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function computeCoordsFromPlacement(_ref, placement, rtl) {
	let { reference, floating } = _ref;
	const sideAxis = getSideAxis(placement);
	const alignmentAxis = getAlignmentAxis(placement);
	const alignLength = getAxisLength(alignmentAxis);
	const side = getSide(placement);
	const isVertical = sideAxis === "y";
	const commonX = reference.x + reference.width / 2 - floating.width / 2;
	const commonY = reference.y + reference.height / 2 - floating.height / 2;
	const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
	let coords;
	switch (side) {
		case "top":
			coords = {
				x: commonX,
				y: reference.y - floating.height
			};
			break;
		case "bottom":
			coords = {
				x: commonX,
				y: reference.y + reference.height
			};
			break;
		case "right":
			coords = {
				x: reference.x + reference.width,
				y: commonY
			};
			break;
		case "left":
			coords = {
				x: reference.x - floating.width,
				y: commonY
			};
			break;
		default: coords = {
			x: reference.x,
			y: reference.y
		};
	}
	switch (getAlignment(placement)) {
		case "start":
			coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
			break;
		case "end": coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
	}
	return coords;
}
/**
* Computes the `x` and `y` coordinates that will place the floating element
* next to a given reference element.
*
* This export does not have any `platform` interface logic. You will need to
* write one for the platform you are using Floating UI with.
*/
var computePosition$1 = async (reference, floating, config) => {
	const { placement = "bottom", strategy = "absolute", middleware = [], platform } = config;
	const validMiddleware = middleware.filter(Boolean);
	const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
	let rects = await platform.getElementRects({
		reference,
		floating,
		strategy
	});
	let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
	let statefulPlacement = placement;
	let middlewareData = {};
	let resetCount = 0;
	for (let i = 0; i < validMiddleware.length; i++) {
		const { name, fn } = validMiddleware[i];
		const { x: nextX, y: nextY, data, reset } = await fn({
			x,
			y,
			initialPlacement: placement,
			placement: statefulPlacement,
			strategy,
			middlewareData,
			rects,
			platform,
			elements: {
				reference,
				floating
			}
		});
		x = nextX != null ? nextX : x;
		y = nextY != null ? nextY : y;
		middlewareData = {
			...middlewareData,
			[name]: {
				...middlewareData[name],
				...data
			}
		};
		if (reset && resetCount <= 50) {
			resetCount++;
			if (typeof reset === "object") {
				if (reset.placement) statefulPlacement = reset.placement;
				if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
					reference,
					floating,
					strategy
				}) : reset.rects;
				({x, y} = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
			}
			i = -1;
		}
	}
	return {
		x,
		y,
		placement: statefulPlacement,
		strategy,
		middlewareData
	};
};
/**
* Resolves with an object of overflow side offsets that determine how much the
* element is overflowing a given clipping boundary on each side.
* - positive = overflowing the boundary by that number of pixels
* - negative = how many pixels left before it will overflow
* - 0 = lies flush with the boundary
* @see https://floating-ui.com/docs/detectOverflow
*/
async function detectOverflow(state, options) {
	var _await$platform$isEle;
	if (options === void 0) options = {};
	const { x, y, platform, rects, elements, strategy } = state;
	const { boundary = "clippingAncestors", rootBoundary = "viewport", elementContext = "floating", altBoundary = false, padding = 0 } = evaluate(options, state);
	const paddingObject = getPaddingObject(padding);
	const element = elements[altBoundary ? elementContext === "floating" ? "reference" : "floating" : elementContext];
	const clippingClientRect = rectToClientRect(await platform.getClippingRect({
		element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
		boundary,
		rootBoundary,
		strategy
	}));
	const rect = elementContext === "floating" ? {
		x,
		y,
		width: rects.floating.width,
		height: rects.floating.height
	} : rects.reference;
	const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
	const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
		x: 1,
		y: 1
	} : {
		x: 1,
		y: 1
	};
	const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements,
		rect,
		offsetParent,
		strategy
	}) : rect);
	return {
		top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
		bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
		left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
		right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
	};
}
/**
* Provides data to position an inner element of the floating element so that it
* appears centered to the reference element.
* @see https://floating-ui.com/docs/arrow
*/
var arrow$3 = (options) => ({
	name: "arrow",
	options,
	async fn(state) {
		const { x, y, placement, rects, platform, elements, middlewareData } = state;
		const { element, padding = 0 } = evaluate(options, state) || {};
		if (element == null) return {};
		const paddingObject = getPaddingObject(padding);
		const coords = {
			x,
			y
		};
		const axis = getAlignmentAxis(placement);
		const length = getAxisLength(axis);
		const arrowDimensions = await platform.getDimensions(element);
		const isYAxis = axis === "y";
		const minProp = isYAxis ? "top" : "left";
		const maxProp = isYAxis ? "bottom" : "right";
		const clientProp = isYAxis ? "clientHeight" : "clientWidth";
		const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
		const startDiff = coords[axis] - rects.reference[axis];
		const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
		let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
		if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
		const centerToReference = endDiff / 2 - startDiff / 2;
		const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
		const minPadding = min$1(paddingObject[minProp], largestPossiblePadding);
		const maxPadding = min$1(paddingObject[maxProp], largestPossiblePadding);
		const min$1$1 = minPadding;
		const max = clientSize - arrowDimensions[length] - maxPadding;
		const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
		const offset = clamp(min$1$1, center, max);
		const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
		const alignmentOffset = shouldAddOffset ? center < min$1$1 ? center - min$1$1 : center - max : 0;
		return {
			[axis]: coords[axis] + alignmentOffset,
			data: {
				[axis]: offset,
				centerOffset: center - offset - alignmentOffset,
				...shouldAddOffset && { alignmentOffset }
			},
			reset: shouldAddOffset
		};
	}
});
/**
* Optimizes the visibility of the floating element by flipping the `placement`
* in order to keep it in view when the preferred placement(s) will overflow the
* clipping boundary. Alternative to `autoPlacement`.
* @see https://floating-ui.com/docs/flip
*/
var flip$1 = function(options) {
	if (options === void 0) options = {};
	return {
		name: "flip",
		options,
		async fn(state) {
			var _middlewareData$arrow, _middlewareData$flip;
			const { placement, middlewareData, rects, initialPlacement, platform, elements } = state;
			const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = "bestFit", fallbackAxisSideDirection = "none", flipAlignment = true, ...detectOverflowOptions } = evaluate(options, state);
			if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
			const side = getSide(placement);
			const initialSideAxis = getSideAxis(initialPlacement);
			const isBasePlacement = getSide(initialPlacement) === initialPlacement;
			const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
			const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
			const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
			if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
			const placements = [initialPlacement, ...fallbackPlacements];
			const overflow = await detectOverflow(state, detectOverflowOptions);
			const overflows = [];
			let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
			if (checkMainAxis) overflows.push(overflow[side]);
			if (checkCrossAxis) {
				const sides = getAlignmentSides(placement, rects, rtl);
				overflows.push(overflow[sides[0]], overflow[sides[1]]);
			}
			overflowsData = [...overflowsData, {
				placement,
				overflows
			}];
			if (!overflows.every((side) => side <= 0)) {
				var _middlewareData$flip2, _overflowsData$filter;
				const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
				const nextPlacement = placements[nextIndex];
				if (nextPlacement) {
					if (!(checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false) || overflowsData.every((d) => getSideAxis(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) return {
						data: {
							index: nextIndex,
							overflows: overflowsData
						},
						reset: { placement: nextPlacement }
					};
				}
				let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
				if (!resetPlacement) switch (fallbackStrategy) {
					case "bestFit": {
						var _overflowsData$filter2;
						const placement = (_overflowsData$filter2 = overflowsData.filter((d) => {
							if (hasFallbackAxisSideDirection) {
								const currentSideAxis = getSideAxis(d.placement);
								return currentSideAxis === initialSideAxis || currentSideAxis === "y";
							}
							return true;
						}).map((d) => [d.placement, d.overflows.filter((overflow) => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
						if (placement) resetPlacement = placement;
						break;
					}
					case "initialPlacement": resetPlacement = initialPlacement;
				}
				if (placement !== resetPlacement) return { reset: { placement: resetPlacement } };
			}
			return {};
		}
	};
};
var originSides = /*#__PURE__*/ new Set(["left", "top"]);
async function convertValueToCoords(state, options) {
	const { placement, platform, elements } = state;
	const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
	const side = getSide(placement);
	const alignment = getAlignment(placement);
	const isVertical = getSideAxis(placement) === "y";
	const mainAxisMulti = originSides.has(side) ? -1 : 1;
	const crossAxisMulti = rtl && isVertical ? -1 : 1;
	const rawValue = evaluate(options, state);
	let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === "number" ? {
		mainAxis: rawValue,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: rawValue.mainAxis || 0,
		crossAxis: rawValue.crossAxis || 0,
		alignmentAxis: rawValue.alignmentAxis
	};
	if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
	return isVertical ? {
		x: crossAxis * crossAxisMulti,
		y: mainAxis * mainAxisMulti
	} : {
		x: mainAxis * mainAxisMulti,
		y: crossAxis * crossAxisMulti
	};
}
/**
* Modifies the placement by translating the floating element along the
* specified axes.
* A number (shorthand for `mainAxis` or distance), or an axes configuration
* object may be passed.
* @see https://floating-ui.com/docs/offset
*/
var offset$1 = function(options) {
	if (options === void 0) options = 0;
	return {
		name: "offset",
		options,
		async fn(state) {
			var _middlewareData$offse, _middlewareData$arrow;
			const { x, y, placement, middlewareData } = state;
			const diffCoords = await convertValueToCoords(state, options);
			if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
			return {
				x: x + diffCoords.x,
				y: y + diffCoords.y,
				data: {
					...diffCoords,
					placement
				}
			};
		}
	};
};
//#endregion
//#region ../../../../../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function getCssDimensions(element) {
	const css = getComputedStyle$1(element);
	let width = parseFloat(css.width) || 0;
	let height = parseFloat(css.height) || 0;
	const hasOffset = isHTMLElement(element);
	const offsetWidth = hasOffset ? element.offsetWidth : width;
	const offsetHeight = hasOffset ? element.offsetHeight : height;
	const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
	if (shouldFallback) {
		width = offsetWidth;
		height = offsetHeight;
	}
	return {
		width,
		height,
		$: shouldFallback
	};
}
function unwrapElement(element) {
	return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
	const domElement = unwrapElement(element);
	if (!isHTMLElement(domElement)) return createCoords(1);
	const rect = domElement.getBoundingClientRect();
	const { width, height, $ } = getCssDimensions(domElement);
	let x = ($ ? round(rect.width) : rect.width) / width;
	let y = ($ ? round(rect.height) : rect.height) / height;
	if (!x || !Number.isFinite(x)) x = 1;
	if (!y || !Number.isFinite(y)) y = 1;
	return {
		x,
		y
	};
}
var noOffsets = /*#__PURE__*/ createCoords(0);
function getVisualOffsets(element) {
	const win = getWindow(element);
	if (!isWebKit() || !win.visualViewport) return noOffsets;
	return {
		x: win.visualViewport.offsetLeft,
		y: win.visualViewport.offsetTop
	};
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
	if (isFixed === void 0) isFixed = false;
	if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) return false;
	return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
	if (includeScale === void 0) includeScale = false;
	if (isFixedStrategy === void 0) isFixedStrategy = false;
	const clientRect = element.getBoundingClientRect();
	const domElement = unwrapElement(element);
	let scale = createCoords(1);
	if (includeScale) {
		if (offsetParent) {
			if (isElement(offsetParent)) scale = getScale(offsetParent);
		} else scale = getScale(element);
	}
	const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
	let x = (clientRect.left + visualOffsets.x) / scale.x;
	let y = (clientRect.top + visualOffsets.y) / scale.y;
	let width = clientRect.width / scale.x;
	let height = clientRect.height / scale.y;
	if (domElement) {
		const win = getWindow(domElement);
		const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
		let currentWin = win;
		let currentIFrame = getFrameElement(currentWin);
		while (currentIFrame && offsetParent && offsetWin !== currentWin) {
			const iframeScale = getScale(currentIFrame);
			const iframeRect = currentIFrame.getBoundingClientRect();
			const css = getComputedStyle$1(currentIFrame);
			const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
			const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
			x *= iframeScale.x;
			y *= iframeScale.y;
			width *= iframeScale.x;
			height *= iframeScale.y;
			x += left;
			y += top;
			currentWin = getWindow(currentIFrame);
			currentIFrame = getFrameElement(currentWin);
		}
	}
	return rectToClientRect({
		width,
		height,
		x,
		y
	});
}
function getWindowScrollBarX(element, rect) {
	const leftScroll = getNodeScroll(element).scrollLeft;
	if (!rect) return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
	return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
	const htmlRect = documentElement.getBoundingClientRect();
	return {
		x: htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect),
		y: htmlRect.top + scroll.scrollTop
	};
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
	let { elements, rect, offsetParent, strategy } = _ref;
	const isFixed = strategy === "fixed";
	const documentElement = getDocumentElement(offsetParent);
	const topLayer = elements ? isTopLayer(elements.floating) : false;
	if (offsetParent === documentElement || topLayer && isFixed) return rect;
	let scroll = {
		scrollLeft: 0,
		scrollTop: 0
	};
	let scale = createCoords(1);
	const offsets = createCoords(0);
	const isOffsetParentAnElement = isHTMLElement(offsetParent);
	if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
		if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) scroll = getNodeScroll(offsetParent);
		if (isHTMLElement(offsetParent)) {
			const offsetRect = getBoundingClientRect(offsetParent);
			scale = getScale(offsetParent);
			offsets.x = offsetRect.x + offsetParent.clientLeft;
			offsets.y = offsetRect.y + offsetParent.clientTop;
		}
	}
	const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
	return {
		width: rect.width * scale.x,
		height: rect.height * scale.y,
		x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
		y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
	};
}
function getClientRects(element) {
	return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
	const html = getDocumentElement(element);
	const scroll = getNodeScroll(element);
	const body = element.ownerDocument.body;
	const width = max$1(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
	const height = max$1(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
	let x = -scroll.scrollLeft + getWindowScrollBarX(element);
	const y = -scroll.scrollTop;
	if (getComputedStyle$1(body).direction === "rtl") x += max$1(html.clientWidth, body.clientWidth) - width;
	return {
		width,
		height,
		x,
		y
	};
}
var SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
	const win = getWindow(element);
	const html = getDocumentElement(element);
	const visualViewport = win.visualViewport;
	let width = html.clientWidth;
	let height = html.clientHeight;
	let x = 0;
	let y = 0;
	if (visualViewport) {
		width = visualViewport.width;
		height = visualViewport.height;
		const visualViewportBased = isWebKit();
		if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
			x = visualViewport.offsetLeft;
			y = visualViewport.offsetTop;
		}
	}
	const windowScrollbarX = getWindowScrollBarX(html);
	if (windowScrollbarX <= 0) {
		const doc = html.ownerDocument;
		const body = doc.body;
		const bodyStyles = getComputedStyle(body);
		const bodyMarginInline = doc.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
		const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
		if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
	} else if (windowScrollbarX <= SCROLLBAR_MAX) width += windowScrollbarX;
	return {
		width,
		height,
		x,
		y
	};
}
var absoluteOrFixed = /*#__PURE__*/ new Set(["absolute", "fixed"]);
function getInnerBoundingClientRect(element, strategy) {
	const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
	const top = clientRect.top + element.clientTop;
	const left = clientRect.left + element.clientLeft;
	const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
	return {
		width: element.clientWidth * scale.x,
		height: element.clientHeight * scale.y,
		x: left * scale.x,
		y: top * scale.y
	};
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
	let rect;
	if (clippingAncestor === "viewport") rect = getViewportRect(element, strategy);
	else if (clippingAncestor === "document") rect = getDocumentRect(getDocumentElement(element));
	else if (isElement(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
	else {
		const visualOffsets = getVisualOffsets(element);
		rect = {
			x: clippingAncestor.x - visualOffsets.x,
			y: clippingAncestor.y - visualOffsets.y,
			width: clippingAncestor.width,
			height: clippingAncestor.height
		};
	}
	return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
	const parentNode = getParentNode(element);
	if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) return false;
	return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
	const cachedResult = cache.get(element);
	if (cachedResult) return cachedResult;
	let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
	let currentContainingBlockComputedStyle = null;
	const elementIsFixed = getComputedStyle$1(element).position === "fixed";
	let currentNode = elementIsFixed ? getParentNode(element) : element;
	while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
		const computedStyle = getComputedStyle$1(currentNode);
		const currentNodeIsContaining = isContainingBlock(currentNode);
		if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
		if (elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode)) result = result.filter((ancestor) => ancestor !== currentNode);
		else currentContainingBlockComputedStyle = computedStyle;
		currentNode = getParentNode(currentNode);
	}
	cache.set(element, result);
	return result;
}
function getClippingRect(_ref) {
	let { element, boundary, rootBoundary, strategy } = _ref;
	const clippingAncestors = [...boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary), rootBoundary];
	const firstClippingAncestor = clippingAncestors[0];
	const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
		const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
		accRect.top = max$1(rect.top, accRect.top);
		accRect.right = min$1(rect.right, accRect.right);
		accRect.bottom = min$1(rect.bottom, accRect.bottom);
		accRect.left = max$1(rect.left, accRect.left);
		return accRect;
	}, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
	return {
		width: clippingRect.right - clippingRect.left,
		height: clippingRect.bottom - clippingRect.top,
		x: clippingRect.left,
		y: clippingRect.top
	};
}
function getDimensions(element) {
	const { width, height } = getCssDimensions(element);
	return {
		width,
		height
	};
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
	const isOffsetParentAnElement = isHTMLElement(offsetParent);
	const documentElement = getDocumentElement(offsetParent);
	const isFixed = strategy === "fixed";
	const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
	let scroll = {
		scrollLeft: 0,
		scrollTop: 0
	};
	const offsets = createCoords(0);
	function setLeftRTLScrollbarOffset() {
		offsets.x = getWindowScrollBarX(documentElement);
	}
	if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
		if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) scroll = getNodeScroll(offsetParent);
		if (isOffsetParentAnElement) {
			const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
			offsets.x = offsetRect.x + offsetParent.clientLeft;
			offsets.y = offsetRect.y + offsetParent.clientTop;
		} else if (documentElement) setLeftRTLScrollbarOffset();
	}
	if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
	const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
	return {
		x: rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x,
		y: rect.top + scroll.scrollTop - offsets.y - htmlOffset.y,
		width: rect.width,
		height: rect.height
	};
}
function isStaticPositioned(element) {
	return getComputedStyle$1(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
	if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") return null;
	if (polyfill) return polyfill(element);
	let rawOffsetParent = element.offsetParent;
	if (getDocumentElement(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
	return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
	const win = getWindow(element);
	if (isTopLayer(element)) return win;
	if (!isHTMLElement(element)) {
		let svgOffsetParent = getParentNode(element);
		while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
			if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
			svgOffsetParent = getParentNode(svgOffsetParent);
		}
		return win;
	}
	let offsetParent = getTrueOffsetParent(element, polyfill);
	while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) offsetParent = getTrueOffsetParent(offsetParent, polyfill);
	if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) return win;
	return offsetParent || getContainingBlock(element) || win;
}
var getElementRects = async function(data) {
	const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
	const getDimensionsFn = this.getDimensions;
	const floatingDimensions = await getDimensionsFn(data.floating);
	return {
		reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
		floating: {
			x: 0,
			y: 0,
			width: floatingDimensions.width,
			height: floatingDimensions.height
		}
	};
};
function isRTL(element) {
	return getComputedStyle$1(element).direction === "rtl";
}
var platform = {
	convertOffsetParentRelativeRectToViewportRelativeRect,
	getDocumentElement,
	getClippingRect,
	getOffsetParent,
	getElementRects,
	getClientRects,
	getDimensions,
	getScale,
	isElement,
	isRTL
};
function rectsAreEqual(a, b) {
	return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
function observeMove(element, onMove) {
	let io = null;
	let timeoutId;
	const root = getDocumentElement(element);
	function cleanup() {
		var _io;
		clearTimeout(timeoutId);
		(_io = io) == null || _io.disconnect();
		io = null;
	}
	function refresh(skip, threshold) {
		if (skip === void 0) skip = false;
		if (threshold === void 0) threshold = 1;
		cleanup();
		const elementRectForRootMargin = element.getBoundingClientRect();
		const { left, top, width, height } = elementRectForRootMargin;
		if (!skip) onMove();
		if (!width || !height) return;
		const insetTop = floor(top);
		const insetRight = floor(root.clientWidth - (left + width));
		const insetBottom = floor(root.clientHeight - (top + height));
		const insetLeft = floor(left);
		const options = {
			rootMargin: -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px",
			threshold: max$1(0, min$1(1, threshold)) || 1
		};
		let isFirstUpdate = true;
		function handleObserve(entries) {
			const ratio = entries[0].intersectionRatio;
			if (ratio !== threshold) {
				if (!isFirstUpdate) return refresh();
				if (!ratio) timeoutId = setTimeout(() => {
					refresh(false, 1e-7);
				}, 1e3);
				else refresh(false, ratio);
			}
			if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) refresh();
			isFirstUpdate = false;
		}
		try {
			io = new IntersectionObserver(handleObserve, {
				...options,
				root: root.ownerDocument
			});
		} catch (_e) {
			io = new IntersectionObserver(handleObserve, options);
		}
		io.observe(element);
	}
	refresh(true);
	return cleanup;
}
/**
* Automatically updates the position of the floating element when necessary.
* Should only be called when the floating element is mounted on the DOM or
* visible on the screen.
* @returns cleanup function that should be invoked when the floating element is
* removed from the DOM or hidden from the screen.
* @see https://floating-ui.com/docs/autoUpdate
*/
function autoUpdate(reference, floating, update, options) {
	if (options === void 0) options = {};
	const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === "function", layoutShift = typeof IntersectionObserver === "function", animationFrame = false } = options;
	const referenceEl = unwrapElement(reference);
	const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
	ancestors.forEach((ancestor) => {
		ancestorScroll && ancestor.addEventListener("scroll", update, { passive: true });
		ancestorResize && ancestor.addEventListener("resize", update);
	});
	const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
	let reobserveFrame = -1;
	let resizeObserver = null;
	if (elementResize) {
		resizeObserver = new ResizeObserver((_ref) => {
			let [firstEntry] = _ref;
			if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
				resizeObserver.unobserve(floating);
				cancelAnimationFrame(reobserveFrame);
				reobserveFrame = requestAnimationFrame(() => {
					var _resizeObserver;
					(_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
				});
			}
			update();
		});
		if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
		resizeObserver.observe(floating);
	}
	let frameId;
	let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
	if (animationFrame) frameLoop();
	function frameLoop() {
		const nextRefRect = getBoundingClientRect(reference);
		if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) update();
		prevRefRect = nextRefRect;
		frameId = requestAnimationFrame(frameLoop);
	}
	update();
	return () => {
		var _resizeObserver2;
		ancestors.forEach((ancestor) => {
			ancestorScroll && ancestor.removeEventListener("scroll", update);
			ancestorResize && ancestor.removeEventListener("resize", update);
		});
		cleanupIo?.();
		(_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
		resizeObserver = null;
		if (animationFrame) cancelAnimationFrame(frameId);
	};
}
/**
* Modifies the placement by translating the floating element along the
* specified axes.
* A number (shorthand for `mainAxis` or distance), or an axes configuration
* object may be passed.
* @see https://floating-ui.com/docs/offset
*/
var offset$2 = offset$1;
/**
* Optimizes the visibility of the floating element by flipping the `placement`
* in order to keep it in view when the preferred placement(s) will overflow the
* clipping boundary. Alternative to `autoPlacement`.
* @see https://floating-ui.com/docs/flip
*/
var flip$2 = flip$1;
/**
* Provides data to position an inner element of the floating element so that it
* appears centered to the reference element.
* @see https://floating-ui.com/docs/arrow
*/
var arrow$2 = arrow$3;
/**
* Computes the `x` and `y` coordinates that will place the floating element
* next to a given reference element.
*/
var computePosition = (reference, floating, options) => {
	const cache = /* @__PURE__ */ new Map();
	const mergedOptions = {
		platform,
		...options
	};
	const platformWithCache = {
		...mergedOptions.platform,
		_c: cache
	};
	return computePosition$1(reference, floating, {
		...mergedOptions,
		platform: platformWithCache
	});
};
//#endregion
//#region ../../../../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
var index = typeof document !== "undefined" ? useLayoutEffect : function noop() {};
function deepEqual(a, b) {
	if (a === b) return true;
	if (typeof a !== typeof b) return false;
	if (typeof a === "function" && a.toString() === b.toString()) return true;
	let length;
	let i;
	let keys;
	if (a && b && typeof a === "object") {
		if (Array.isArray(a)) {
			length = a.length;
			if (length !== b.length) return false;
			for (i = length; i-- !== 0;) if (!deepEqual(a[i], b[i])) return false;
			return true;
		}
		keys = Object.keys(a);
		length = keys.length;
		if (length !== Object.keys(b).length) return false;
		for (i = length; i-- !== 0;) if (!{}.hasOwnProperty.call(b, keys[i])) return false;
		for (i = length; i-- !== 0;) {
			const key = keys[i];
			if (key === "_owner" && a.$$typeof) continue;
			if (!deepEqual(a[key], b[key])) return false;
		}
		return true;
	}
	return a !== a && b !== b;
}
function getDPR(element) {
	if (typeof window === "undefined") return 1;
	return (element.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function roundByDPR(element, value) {
	const dpr = getDPR(element);
	return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
	const ref = React$1.useRef(value);
	index(() => {
		ref.current = value;
	});
	return ref;
}
/**
* Provides data to position a floating element.
* @see https://floating-ui.com/docs/useFloating
*/
function useFloating$1(options) {
	if (options === void 0) options = {};
	const { placement = "bottom", strategy = "absolute", middleware = [], platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform = true, whileElementsMounted, open } = options;
	const [data, setData] = React$1.useState({
		x: 0,
		y: 0,
		strategy,
		placement,
		middlewareData: {},
		isPositioned: false
	});
	const [latestMiddleware, setLatestMiddleware] = React$1.useState(middleware);
	if (!deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
	const [_reference, _setReference] = React$1.useState(null);
	const [_floating, _setFloating] = React$1.useState(null);
	const setReference = React$1.useCallback((node) => {
		if (node !== referenceRef.current) {
			referenceRef.current = node;
			_setReference(node);
		}
	}, []);
	const setFloating = React$1.useCallback((node) => {
		if (node !== floatingRef.current) {
			floatingRef.current = node;
			_setFloating(node);
		}
	}, []);
	const referenceEl = externalReference || _reference;
	const floatingEl = externalFloating || _floating;
	const referenceRef = React$1.useRef(null);
	const floatingRef = React$1.useRef(null);
	const dataRef = React$1.useRef(data);
	const hasWhileElementsMounted = whileElementsMounted != null;
	const whileElementsMountedRef = useLatestRef(whileElementsMounted);
	const platformRef = useLatestRef(platform);
	const openRef = useLatestRef(open);
	const update = React$1.useCallback(() => {
		if (!referenceRef.current || !floatingRef.current) return;
		const config = {
			placement,
			strategy,
			middleware: latestMiddleware
		};
		if (platformRef.current) config.platform = platformRef.current;
		computePosition(referenceRef.current, floatingRef.current, config).then((data) => {
			const fullData = {
				...data,
				isPositioned: openRef.current !== false
			};
			if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
				dataRef.current = fullData;
				ReactDOM$1.flushSync(() => {
					setData(fullData);
				});
			}
		});
	}, [
		latestMiddleware,
		placement,
		strategy,
		platformRef,
		openRef
	]);
	index(() => {
		if (open === false && dataRef.current.isPositioned) {
			dataRef.current.isPositioned = false;
			setData((data) => ({
				...data,
				isPositioned: false
			}));
		}
	}, [open]);
	const isMountedRef = React$1.useRef(false);
	index(() => {
		isMountedRef.current = true;
		return () => {
			isMountedRef.current = false;
		};
	}, []);
	index(() => {
		if (referenceEl) referenceRef.current = referenceEl;
		if (floatingEl) floatingRef.current = floatingEl;
		if (referenceEl && floatingEl) {
			if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
			update();
		}
	}, [
		referenceEl,
		floatingEl,
		update,
		whileElementsMountedRef,
		hasWhileElementsMounted
	]);
	const refs = React$1.useMemo(() => ({
		reference: referenceRef,
		floating: floatingRef,
		setReference,
		setFloating
	}), [setReference, setFloating]);
	const elements = React$1.useMemo(() => ({
		reference: referenceEl,
		floating: floatingEl
	}), [referenceEl, floatingEl]);
	const floatingStyles = React$1.useMemo(() => {
		const initialStyles = {
			position: strategy,
			left: 0,
			top: 0
		};
		if (!elements.floating) return initialStyles;
		const x = roundByDPR(elements.floating, data.x);
		const y = roundByDPR(elements.floating, data.y);
		if (transform) return {
			...initialStyles,
			transform: "translate(" + x + "px, " + y + "px)",
			...getDPR(elements.floating) >= 1.5 && { willChange: "transform" }
		};
		return {
			position: strategy,
			left: x,
			top: y
		};
	}, [
		strategy,
		transform,
		elements.floating,
		data.x,
		data.y
	]);
	return React$1.useMemo(() => ({
		...data,
		update,
		refs,
		elements,
		floatingStyles
	}), [
		data,
		update,
		refs,
		elements,
		floatingStyles
	]);
}
/**
* Provides data to position an inner element of the floating element so that it
* appears centered to the reference element.
* This wraps the core `arrow` middleware to allow React refs as the element.
* @see https://floating-ui.com/docs/arrow
*/
var arrow$1 = (options) => {
	function isRef(value) {
		return {}.hasOwnProperty.call(value, "current");
	}
	return {
		name: "arrow",
		options,
		fn(state) {
			const { element, padding } = typeof options === "function" ? options(state) : options;
			if (element && isRef(element)) {
				if (element.current != null) return arrow$2({
					element: element.current,
					padding
				}).fn(state);
				return {};
			}
			if (element) return arrow$2({
				element,
				padding
			}).fn(state);
			return {};
		}
	};
};
/**
* Modifies the placement by translating the floating element along the
* specified axes.
* A number (shorthand for `mainAxis` or distance), or an axes configuration
* object may be passed.
* @see https://floating-ui.com/docs/offset
*/
var offset = (options, deps) => ({
	...offset$2(options),
	options: [options, deps]
});
/**
* Optimizes the visibility of the floating element by flipping the `placement`
* in order to keep it in view when the preferred placement(s) will overflow the
* clipping boundary. Alternative to `autoPlacement`.
* @see https://floating-ui.com/docs/flip
*/
var flip = (options, deps) => ({
	...flip$2(options),
	options: [options, deps]
});
/**
* Provides data to position an inner element of the floating element so that it
* appears centered to the reference element.
* This wraps the core `arrow` middleware to allow React refs as the element.
* @see https://floating-ui.com/docs/arrow
*/
var arrow = (options, deps) => ({
	...arrow$1(options),
	options: [options, deps]
});
//#endregion
//#region ../../../../../node_modules/@floating-ui/react/dist/floating-ui.react.mjs
var ARROW_LEFT = "ArrowLeft";
var ARROW_RIGHT = "ArrowRight";
var ARROW_UP = "ArrowUp";
var ARROW_DOWN = "ArrowDown";
var horizontalKeys = [ARROW_LEFT, ARROW_RIGHT];
var verticalKeys = [ARROW_UP, ARROW_DOWN];
[...horizontalKeys, ...verticalKeys];
var SafeReact = { ...React$1 };
var serverHandoffComplete = false;
var count = 0;
var genId = () => "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++;
function useFloatingId() {
	const [id, setId] = React$1.useState(() => serverHandoffComplete ? genId() : void 0);
	index$1(() => {
		if (id == null) setId(genId());
	}, []);
	React$1.useEffect(() => {
		serverHandoffComplete = true;
	}, []);
	return id;
}
/**
* Uses React 18's built-in `useId()` when available, or falls back to a
* slightly less performant (requiring a double render) implementation for
* earlier React versions.
* @see https://floating-ui.com/docs/react-utils#useid
*/
var useId = SafeReact.useId || useFloatingId;
var devMessageSet;
if (process.env.NODE_ENV !== "production") devMessageSet = /*#__PURE__*/ new Set();
function warn() {
	var _devMessageSet;
	for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) messages[_key] = arguments[_key];
	const message = "Floating UI: " + messages.join(" ");
	if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message))) {
		var _devMessageSet2;
		(_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message);
		console.warn(message);
	}
}
function error() {
	var _devMessageSet3;
	for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) messages[_key2] = arguments[_key2];
	const message = "Floating UI: " + messages.join(" ");
	if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message))) {
		var _devMessageSet4;
		(_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message);
		console.error(message);
	}
}
/**
* Renders a pointing arrow triangle.
* @see https://floating-ui.com/docs/FloatingArrow
*/
var FloatingArrow = /*#__PURE__*/ React$1.forwardRef(function FloatingArrow(props, ref) {
	const { context: { placement, elements: { floating }, middlewareData: { arrow, shift } }, width = 14, height = 7, tipRadius = 0, strokeWidth = 0, staticOffset, stroke, d, style: { transform, ...restStyle } = {}, ...rest } = props;
	if (process.env.NODE_ENV !== "production") {
		if (!ref) warn("The `ref` prop is required for `FloatingArrow`.");
	}
	const clipPathId = useId();
	const [isRTL, setIsRTL] = React$1.useState(false);
	index$1(() => {
		if (!floating) return;
		if (getComputedStyle$1(floating).direction === "rtl") setIsRTL(true);
	}, [floating]);
	if (!floating) return null;
	const [side, alignment] = placement.split("-");
	const isVerticalSide = side === "top" || side === "bottom";
	let computedStaticOffset = staticOffset;
	if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
	const computedStrokeWidth = strokeWidth * 2;
	const halfStrokeWidth = computedStrokeWidth / 2;
	const svgX = width / 2 * (tipRadius / -8 + 1);
	const svgY = height / 2 * tipRadius / 4;
	const isCustomShape = !!d;
	const yOffsetProp = computedStaticOffset && alignment === "end" ? "bottom" : "top";
	let xOffsetProp = computedStaticOffset && alignment === "end" ? "right" : "left";
	if (computedStaticOffset && isRTL) xOffsetProp = alignment === "end" ? "left" : "right";
	const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : "";
	const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : "";
	const dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
	const rotation = {
		top: isCustomShape ? "rotate(180deg)" : "",
		left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
		bottom: isCustomShape ? "" : "rotate(180deg)",
		right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
	}[side];
	return /*#__PURE__*/ jsxs("svg", {
		...rest,
		"aria-hidden": true,
		ref,
		width: isCustomShape ? width : width + computedStrokeWidth,
		height: width,
		viewBox: "0 0 " + width + " " + (height > width ? height : width),
		style: {
			position: "absolute",
			pointerEvents: "none",
			[xOffsetProp]: arrowX,
			[yOffsetProp]: arrowY,
			[side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)",
			transform: [rotation, transform].filter((t) => !!t).join(" "),
			...restStyle
		},
		children: [
			computedStrokeWidth > 0 && /*#__PURE__*/ jsx("path", {
				clipPath: "url(#" + clipPathId + ")",
				fill: "none",
				stroke,
				strokeWidth: computedStrokeWidth + (d ? 0 : 1),
				d: dValue
			}),
			/*#__PURE__*/ jsx("path", {
				stroke: computedStrokeWidth && !d ? rest.fill : "none",
				d: dValue
			}),
			/*#__PURE__*/ jsx("clipPath", {
				id: clipPathId,
				children: /*#__PURE__*/ jsx("rect", {
					x: -halfStrokeWidth,
					y: halfStrokeWidth * (isCustomShape ? -1 : 1),
					width: width + computedStrokeWidth,
					height: width
				})
			})
		]
	});
});
function createEventEmitter() {
	const map = /* @__PURE__ */ new Map();
	return {
		emit(event, data) {
			var _map$get;
			(_map$get = map.get(event)) == null || _map$get.forEach((listener) => listener(data));
		},
		on(event, listener) {
			if (!map.has(event)) map.set(event, /* @__PURE__ */ new Set());
			map.get(event).add(listener);
		},
		off(event, listener) {
			var _map$get2;
			(_map$get2 = map.get(event)) == null || _map$get2.delete(listener);
		}
	};
}
var FloatingNodeContext = /*#__PURE__*/ React$1.createContext(null);
var FloatingTreeContext = /*#__PURE__*/ React$1.createContext(null);
/**
* Returns the parent node id for nested floating elements, if available.
* Returns `null` for top-level floating elements.
*/
var useFloatingParentNodeId = () => {
	var _React$useContext;
	return ((_React$useContext = React$1.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
* Returns the nearest floating tree context, if available.
*/
var useFloatingTree = () => React$1.useContext(FloatingTreeContext);
function useFloatingRootContext(options) {
	const { open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
	const floatingId = useId();
	const dataRef = React$1.useRef({});
	const [events] = React$1.useState(() => createEventEmitter());
	const nested = useFloatingParentNodeId() != null;
	if (process.env.NODE_ENV !== "production") {
		const optionDomReference = elementsProp.reference;
		if (optionDomReference && !isElement(optionDomReference)) error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
	}
	const [positionReference, setPositionReference] = React$1.useState(elementsProp.reference);
	const onOpenChange = useEffectEvent((open, event, reason) => {
		dataRef.current.openEvent = open ? event : void 0;
		events.emit("openchange", {
			open,
			event,
			reason,
			nested
		});
		onOpenChangeProp?.(open, event, reason);
	});
	const refs = React$1.useMemo(() => ({ setPositionReference }), []);
	const elements = React$1.useMemo(() => ({
		reference: positionReference || elementsProp.reference || null,
		floating: elementsProp.floating || null,
		domReference: elementsProp.reference
	}), [
		positionReference,
		elementsProp.reference,
		elementsProp.floating
	]);
	return React$1.useMemo(() => ({
		dataRef,
		open,
		onOpenChange,
		elements,
		events,
		floatingId,
		refs
	}), [
		open,
		onOpenChange,
		elements,
		events,
		floatingId,
		refs
	]);
}
/**
* Provides data to position a floating element and context to add interactions.
* @see https://floating-ui.com/docs/useFloating
*/
function useFloating(options) {
	if (options === void 0) options = {};
	const { nodeId } = options;
	const internalRootContext = useFloatingRootContext({
		...options,
		elements: {
			reference: null,
			floating: null,
			...options.elements
		}
	});
	const rootContext = options.rootContext || internalRootContext;
	const computedElements = rootContext.elements;
	const [_domReference, setDomReference] = React$1.useState(null);
	const [positionReference, _setPositionReference] = React$1.useState(null);
	const domReference = (computedElements == null ? void 0 : computedElements.domReference) || _domReference;
	const domReferenceRef = React$1.useRef(null);
	const tree = useFloatingTree();
	index$1(() => {
		if (domReference) domReferenceRef.current = domReference;
	}, [domReference]);
	const position = useFloating$1({
		...options,
		elements: {
			...computedElements,
			...positionReference && { reference: positionReference }
		}
	});
	const setPositionReference = React$1.useCallback((node) => {
		const computedPositionReference = isElement(node) ? {
			getBoundingClientRect: () => node.getBoundingClientRect(),
			getClientRects: () => node.getClientRects(),
			contextElement: node
		} : node;
		_setPositionReference(computedPositionReference);
		position.refs.setReference(computedPositionReference);
	}, [position.refs]);
	const setReference = React$1.useCallback((node) => {
		if (isElement(node) || node === null) {
			domReferenceRef.current = node;
			setDomReference(node);
		}
		if (isElement(position.refs.reference.current) || position.refs.reference.current === null || node !== null && !isElement(node)) position.refs.setReference(node);
	}, [position.refs]);
	const refs = React$1.useMemo(() => ({
		...position.refs,
		setReference,
		setPositionReference,
		domReference: domReferenceRef
	}), [
		position.refs,
		setReference,
		setPositionReference
	]);
	const elements = React$1.useMemo(() => ({
		...position.elements,
		domReference
	}), [position.elements, domReference]);
	const context = React$1.useMemo(() => ({
		...position,
		...rootContext,
		refs,
		elements,
		nodeId
	}), [
		position,
		refs,
		elements,
		nodeId,
		rootContext
	]);
	index$1(() => {
		rootContext.dataRef.current.floatingContext = context;
		const node = tree == null ? void 0 : tree.nodesRef.current.find((node) => node.id === nodeId);
		if (node) node.context = context;
	});
	return React$1.useMemo(() => ({
		...position,
		context,
		refs,
		elements
	}), [
		position,
		refs,
		elements,
		context
	]);
}
//#endregion
//#region __vite-optional-peer-dep:date-fns-tz:react-datepicker
var __vite_optional_peer_dep_date_fns_tz_react_datepicker_exports = /* @__PURE__ */ __exportAll({ default: () => __vite_optional_peer_dep_date_fns_tz_react_datepicker_default });
var __vite_optional_peer_dep_date_fns_tz_react_datepicker_default;
var init___vite_optional_peer_dep_date_fns_tz_react_datepicker = __esmMin((() => {
	__vite_optional_peer_dep_date_fns_tz_react_datepicker_default = {};
	throw new Error(`Could not resolve "date-fns-tz" imported by "react-datepicker". Is it installed?`);
}));
//#endregion
//#region ../../../../../node_modules/react-datepicker/dist/index.es.js
/*!
react-datepicker v9.1.0
https://github.com/Hacker0x01/react-datepicker
Released under the MIT License.
*/
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var _extendStatics = function extendStatics(d, b) {
	_extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
		d.__proto__ = b;
	} || function(d, b) {
		for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
	};
	return _extendStatics(d, b);
};
function __extends(d, b) {
	if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	_extendStatics(d, b);
	function __() {
		this.constructor = d;
	}
	d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var _assign = function __assign() {
	_assign = Object.assign || function __assign(t) {
		for (var s, i = 1, n = arguments.length; i < n; i++) {
			s = arguments[i];
			for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
		}
		return t;
	};
	return _assign.apply(this, arguments);
};
function __spreadArray(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
}
var CalendarContainer = function(_a) {
	var _b = _a.showTimeSelectOnly, showTimeSelectOnly = _b === void 0 ? false : _b, _c = _a.showTime, showTime = _c === void 0 ? false : _c, className = _a.className, children = _a.children, inline = _a.inline;
	var ariaLabel = showTimeSelectOnly ? "Choose Time" : "Choose Date".concat(showTime ? " and Time" : "");
	return React.createElement("div", {
		className,
		"aria-label": ariaLabel,
		role: inline ? void 0 : "dialog",
		"aria-modal": inline ? void 0 : "true",
		translate: "no"
	}, children);
};
var useDetectClickOutside = function(onClickOutside, ignoreClass) {
	var ref = useRef(null);
	var onClickOutsideRef = useRef(onClickOutside);
	useEffect(function() {
		onClickOutsideRef.current = onClickOutside;
	}, [onClickOutside]);
	var handleClickOutside = useCallback(function(event) {
		var _a;
		var target = event.composed && event.composedPath && event.composedPath().find(function(eventTarget) {
			return eventTarget instanceof Node;
		}) || event.target;
		if (ref.current && !ref.current.contains(target)) {
			if (!(ignoreClass && target instanceof HTMLElement && target.classList.contains(ignoreClass))) (_a = onClickOutsideRef.current) === null || _a === void 0 || _a.call(onClickOutsideRef, event);
		}
	}, [ignoreClass]);
	useEffect(function() {
		document.addEventListener("mousedown", handleClickOutside);
		return function() {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [handleClickOutside]);
	return ref;
};
var ClickOutsideWrapper = function(_a) {
	var children = _a.children, onClickOutside = _a.onClickOutside, className = _a.className, containerRef = _a.containerRef, style = _a.style, ignoreClass = _a.ignoreClass;
	var detectRef = useDetectClickOutside(onClickOutside, ignoreClass);
	return React.createElement("div", {
		className,
		style,
		ref: function(node) {
			detectRef.current = node;
			if (containerRef) containerRef.current = node;
		}
	}, children);
};
var dateFnsTz = null;
var dateFnsTzLoadAttempted = false;
/**
* Attempts to load date-fns-tz module.
* Returns null if the module is not installed.
*/
function getDateFnsTz() {
	if (dateFnsTzLoadAttempted) return dateFnsTz;
	dateFnsTzLoadAttempted = true;
	try {
		dateFnsTz = (init___vite_optional_peer_dep_date_fns_tz_react_datepicker(), __toCommonJS(__vite_optional_peer_dep_date_fns_tz_react_datepicker_exports));
	} catch (_a) {
		/* istanbul ignore next - only executes when date-fns-tz is not installed */
		dateFnsTz = null;
	}
	return dateFnsTz;
}
/**
* Converts a date to the specified timezone.
* If no timezone is specified or date-fns-tz is not installed, returns the original date.
*
* @param date - The date to convert
* @param timeZone - The IANA timezone identifier (e.g., "America/New_York", "UTC")
* @returns The date in the specified timezone
*/
function toZonedTime(date, timeZone) {
	if (!timeZone) return date;
	var tz = getDateFnsTz();
	if (!tz) {
		if (process.env.NODE_ENV !== "production") console.warn("react-datepicker: timeZone prop requires \"date-fns-tz\" package. Please install it: npm install date-fns-tz");
		return date;
	}
	return tz.toZonedTime(date, timeZone);
}
/**
* Converts a date from the specified timezone to UTC.
* If no timezone is specified or date-fns-tz is not installed, returns the original date.
*
* @param date - The date in the specified timezone
* @param timeZone - The IANA timezone identifier (e.g., "America/New_York", "UTC")
* @returns The date in UTC
*/
function fromZonedTime(date, timeZone) {
	if (!timeZone) return date;
	var tz = getDateFnsTz();
	if (!tz) {
		if (process.env.NODE_ENV !== "production") console.warn("react-datepicker: timeZone prop requires \"date-fns-tz\" package. Please install it: npm install date-fns-tz");
		return date;
	}
	return tz.fromZonedTime(date, timeZone);
}
var KeyType;
(function(KeyType) {
	KeyType["ArrowUp"] = "ArrowUp";
	KeyType["ArrowDown"] = "ArrowDown";
	KeyType["ArrowLeft"] = "ArrowLeft";
	KeyType["ArrowRight"] = "ArrowRight";
	KeyType["PageUp"] = "PageUp";
	KeyType["PageDown"] = "PageDown";
	KeyType["Home"] = "Home";
	KeyType["End"] = "End";
	KeyType["Enter"] = "Enter";
	KeyType["Space"] = " ";
	KeyType["Tab"] = "Tab";
	KeyType["Escape"] = "Escape";
	KeyType["Backspace"] = "Backspace";
	KeyType["X"] = "x";
})(KeyType || (KeyType = {}));
function getLocaleScope() {
	return typeof window !== "undefined" ? window : globalThis;
}
var DEFAULT_YEAR_ITEM_NUMBER = 12;
function newDate(value) {
	if (value == null) return /* @__PURE__ */ new Date();
	var d = typeof value === "string" ? parseISO(value) : toDate(value);
	return isValid$2(d) ? d : /* @__PURE__ */ new Date();
}
/**
* Parses a date.
*
* @param value - The string representing the Date in a parsable form, e.g., ISO 1861
* @param dateFormat - The date format.
* @param locale - The locale.
* @param strictParsing - The strict parsing flag.
* @param refDate - The base date to be passed to date-fns parse() function.
* @returns - The parsed date or null.
*/
function parseDate(value, dateFormat, locale, strictParsing, refDate) {
	if (refDate === void 0) refDate = newDate();
	var localeObject = getLocaleObject(locale) || getLocaleObject(getDefaultLocale());
	var formats = Array.isArray(dateFormat) ? dateFormat : [dateFormat];
	for (var _i = 0, formats_1 = formats; _i < formats_1.length; _i++) {
		var format_1 = formats_1[_i];
		var parsedDate = parse(value, format_1, refDate, {
			locale: localeObject,
			useAdditionalWeekYearTokens: true,
			useAdditionalDayOfYearTokens: true
		});
		if (isValid$2(parsedDate) && (!strictParsing || value === formatDate(parsedDate, format_1, locale))) return parsedDate;
	}
	if (!strictParsing && value && value.length >= 8) {
		var nativeDate = new Date(value);
		if (isValid(nativeDate)) return nativeDate;
	}
	return null;
}
/**
* Parses a partial date string for calendar navigation purposes.
* Unlike parseDate, this function attempts to extract whatever date
* information is available (year, month) from a partial input,
* returning a date suitable for navigating the calendar view.
*
* @param value - The date string to parse.
* @param refDate - The reference date to use for missing components.
* @returns - A date for navigation or null if no date info could be extracted.
*/
function parseDateForNavigation(value, refDate) {
	if (refDate === void 0) refDate = newDate();
	if (!value) return null;
	var yearMatch = value.match(/\b(1\d{3}|2\d{3})\b/);
	if (!yearMatch || !yearMatch[1]) return null;
	var year = parseInt(yearMatch[1], 10);
	var monthMatch = value.match(/(?:^|[/\-\s])?(0?[1-9]|1[0-2])(?:[/\-\s]|$)/);
	var month = monthMatch && monthMatch[1] ? parseInt(monthMatch[1], 10) - 1 : refDate.getMonth();
	return new Date(year, month, 1);
}
/**
* Checks if a given date is a valid Date object.
* @param date - The date to be checked.
* @returns A boolean value indicating whether the date is valid.
*/
function isValid$2(date) {
	return isValid(date);
}
/**
* Safely returns a valid Date or null.
* This handles cases where a value might be passed as a string or other
* invalid type at runtime, even though TypeScript expects a Date.
* @param date - The value to check (typed as Date but could be anything at runtime)
* @returns The date if it's a valid Date object, otherwise null
*/
function safeToDate(date) {
	if (date == null) return null;
	if (isDate(date) && isValid(date)) return date;
	return null;
}
/**
* Formats a date.
*
* @param date - The date.
* @param formatStr - The format string.
* @param locale - The locale.
* @returns - The formatted date.
*/
function formatDate(date, formatStr, locale) {
	if (locale === "en") return format(date, formatStr, {
		useAdditionalWeekYearTokens: true,
		useAdditionalDayOfYearTokens: true
	});
	var localeObj = locale ? getLocaleObject(locale) : void 0;
	if (locale && !localeObj) console.warn("A locale object was not found for the provided string [\"".concat(locale, "\"]."));
	localeObj = localeObj || getLocaleObject(getDefaultLocale());
	return format(date, formatStr, {
		locale: localeObj,
		useAdditionalWeekYearTokens: true,
		useAdditionalDayOfYearTokens: true
	});
}
/**
* Safely formats a date.
*
* @param date - The date.
* @param options - An object containing the dateFormat and locale.
* @returns - The formatted date or an empty string.
*/
function safeDateFormat(date, _a) {
	var dateFormat = _a.dateFormat, locale = _a.locale;
	var formatStr = Array.isArray(dateFormat) && dateFormat.length > 0 ? dateFormat[0] : dateFormat;
	return date && formatDate(date, formatStr, locale) || "";
}
/**
* Used as a delimiter to separate two dates when formatting a date range
*/
var DATE_RANGE_SEPARATOR = " - ";
/**
* Safely formats a date range.
*
* @param startDate - The start date.
* @param endDate - The end date.
* @param props - The props.
* @returns - The formatted date range or an empty string.
*/
function safeDateRangeFormat(startDate, endDate, props) {
	if (!startDate && !endDate) return "";
	var formattedStartDate = startDate ? safeDateFormat(startDate, props) : "";
	var formattedEndDate = endDate ? safeDateFormat(endDate, props) : "";
	var dateRangeSeparator = props.rangeSeparator || DATE_RANGE_SEPARATOR;
	return "".concat(formattedStartDate).concat(dateRangeSeparator).concat(formattedEndDate);
}
/**
* Safely formats multiple dates.
*
* @param dates - The dates.
* @param props - The props.
* @returns - The formatted dates or an empty string.
*/
function safeMultipleDatesFormat(dates, props) {
	if (!(dates === null || dates === void 0 ? void 0 : dates.length)) return "";
	var formattedFirstDate = dates[0] ? safeDateFormat(dates[0], props) : "";
	if (dates.length === 1) return formattedFirstDate;
	if (dates.length === 2 && dates[1]) {
		var formattedSecondDate = safeDateFormat(dates[1], props);
		return "".concat(formattedFirstDate, ", ").concat(formattedSecondDate);
	}
	var extraDatesCount = dates.length - 1;
	return "".concat(formattedFirstDate, " (+").concat(extraDatesCount, ")");
}
/**
* Sets the time for a given date.
*
* @param date - The date.
* @param time - An object containing the hour, minute, and second.
* @returns - The date with the time set.
*/
function setTime(date, _a) {
	var _b = _a.hour, hour = _b === void 0 ? 0 : _b, _c = _a.minute, minute = _c === void 0 ? 0 : _c, _d = _a.second;
	return setHours(setMinutes(setSeconds(date, _d === void 0 ? 0 : _d), minute), hour);
}
/**
* Gets the week of the year for a given date.
*
* @param date - The date.
* @returns - The week of the year.
*/
function getWeek(date) {
	return getISOWeek(date);
}
/**
* Gets the day of the week code for a given day.
*
* @param day - The day.
* @param locale - The locale.
* @returns - The day of the week code.
*/
function getDayOfWeekCode(day, locale) {
	return formatDate(day, "ddd", locale);
}
/**
* Gets the start of the day for a given date.
*
* @param date - The date.
* @returns - The start of the day.
*/
function getStartOfDay(date) {
	return startOfDay(date);
}
/**
* Gets the start of the week for a given date.
*
* @param date - The date.
* @param locale - The locale.
* @param calendarStartDay - The day the calendar starts on.
* @returns - The start of the week.
*/
function getStartOfWeek(date, locale, calendarStartDay) {
	var localeObj = locale ? getLocaleObject(locale) : getLocaleObject(getDefaultLocale());
	return startOfWeek(date, {
		locale: localeObj,
		weekStartsOn: calendarStartDay
	});
}
/**
* Gets the start of the month for a given date.
*
* @param date - The date.
* @returns - The start of the month.
*/
function getStartOfMonth(date) {
	return startOfMonth(date);
}
/**
* Gets the start of the year for a given date.
*
* @param date - The date.
* @returns - The start of the year.
*/
function getStartOfYear(date) {
	return startOfYear(date);
}
/**
* Gets the start of the quarter for a given date.
*
* @param date - The date.
* @returns - The start of the quarter.
*/
function getStartOfQuarter(date) {
	return startOfQuarter(date);
}
/**
* Gets the start of today.
*
* @returns - The start of today.
*/
function getStartOfToday() {
	return startOfDay(newDate());
}
/**
* Gets the end of the day for a given date.
*
* @param date - The date.
* @returns - The end of the day.
*/
function getEndOfDay(date) {
	return endOfDay(date);
}
/**
* Gets the end of the week for a given date.
*
* @param date - The date.
* @returns - The end of the week.
*/
function getEndOfWeek(date) {
	return endOfWeek(date);
}
/**
* Gets the end of the month for a given date.
*
* @param date - The date.
* @returns - The end of the month.
*/
function getEndOfMonth(date) {
	return endOfMonth(date);
}
/**
* Checks if two dates are in the same year.
*
* @param date1 - The first date.
* @param date2 - The second date.
* @returns - True if the dates are in the same year, false otherwise.
*/
function isSameYear$2(date1, date2) {
	if (date1 && date2) return isSameYear(date1, date2);
	else return !date1 && !date2;
}
/**
* Checks if two dates are in the same month.
*
* @param date1 - The first date.
* @param date2 - The second date.
* @returns - True if the dates are in the same month, false otherwise.
*/
function isSameMonth$2(date1, date2) {
	if (date1 && date2) return isSameMonth(date1, date2);
	else return !date1 && !date2;
}
/**
* Checks if two dates are in the same quarter.
*
* @param date1 - The first date.
* @param date2 - The second date.
* @returns - True if the dates are in the same quarter, false otherwise.
*/
function isSameQuarter$2(date1, date2) {
	if (date1 && date2) return isSameQuarter(date1, date2);
	else return !date1 && !date2;
}
/**
* Checks if two dates are on the same day.
*
* @param date1 - The first date.
* @param date2 - The second date.
* @returns - True if the dates are on the same day, false otherwise.
*/
function isSameDay$2(date1, date2) {
	if (date1 && date2) return isSameDay(date1, date2);
	else return !date1 && !date2;
}
/**
* Checks if two dates are equal.
*
* @param date1 - The first date.
* @param date2 - The second date.
* @returns - True if the dates are equal, false otherwise.
*/
function isEqual$2(date1, date2) {
	if (date1 && date2) return isEqual(date1, date2);
	else return !date1 && !date2;
}
/**
* Checks if a day is within a date range.
*
* @param day - The day to check.
* @param startDate - The start date of the range.
* @param endDate - The end date of the range.
* @returns - True if the day is within the range, false otherwise.
*/
function isDayInRange(day, startDate, endDate) {
	var valid;
	var start = startOfDay(startDate);
	var end = endOfDay(endDate);
	try {
		valid = isWithinInterval(day, {
			start,
			end
		});
	} catch (err) {
		valid = false;
	}
	return valid;
}
/**
* Registers a locale.
*
* @param localeName - The name of the locale.
* @param localeData - The data of the locale.
*/
function registerLocale(localeName, localeData) {
	var scope = getLocaleScope();
	if (!scope.__localeData__) scope.__localeData__ = {};
	scope.__localeData__[localeName] = localeData;
}
/**
* Sets the default locale.
*
* @param localeName - The name of the locale.
*/
function setDefaultLocale(localeName) {
	var scope = getLocaleScope();
	scope.__localeId__ = localeName;
}
/**
* Gets the default locale.
*
* @returns - The default locale.
*/
function getDefaultLocale() {
	return getLocaleScope().__localeId__;
}
/**
* Gets the locale object.
*
* @param localeSpec - The locale specification.
* @returns - The locale object.
*/
function getLocaleObject(localeSpec) {
	if (typeof localeSpec === "string") {
		var scope = getLocaleScope();
		return scope.__localeData__ ? scope.__localeData__[localeSpec] : void 0;
	} else return localeSpec;
}
/**
* Formats the weekday in a given locale.
*
* @param date - The date to format.
* @param formatFunc - The formatting function.
* @param locale - The locale to use for formatting.
* @returns - The formatted weekday.
*/
function getFormattedWeekdayInLocale(date, formatFunc, locale) {
	return formatFunc(formatDate(date, "EEEE", locale));
}
/**
* Gets the minimum weekday in a given locale.
*
* @param date - The date to format.
* @param locale - The locale to use for formatting.
* @returns - The minimum weekday.
*/
function getWeekdayMinInLocale(date, locale) {
	return formatDate(date, "EEEEEE", locale);
}
/**
* Gets the short weekday in a given locale.
*
* @param date - The date to format.
* @param locale - The locale to use for formatting.
* @returns - The short weekday.
*/
function getWeekdayShortInLocale(date, locale) {
	return formatDate(date, "EEE", locale);
}
/**
* Gets the month in a given locale.
*
* @param month - The month to format.
* @param locale - The locale to use for formatting.
* @returns - The month.
*/
function getMonthInLocale(month, locale) {
	return formatDate(setMonth(newDate(), month), "LLLL", locale);
}
/**
* Gets the short month in a given locale.
*
* @param month - The month to format.
* @param locale - The locale to use for formatting.
* @returns - The short month.
*/
function getMonthShortInLocale(month, locale) {
	return formatDate(setMonth(newDate(), month), "LLL", locale);
}
/**
* Gets the short quarter in a given locale.
*
* @param quarter - The quarter to format.
* @param locale - The locale to use for formatting.
* @returns - The short quarter.
*/
function getQuarterShortInLocale(quarter, locale) {
	return formatDate(setQuarter(newDate(), quarter), "QQQ", locale);
}
/**
* Checks if a day is disabled.
*
* @param day - The day to check.
* @param options - The options to consider when checking.
* @returns - Returns true if the day is disabled, false otherwise.
*/
function isDayDisabled(day, _a) {
	var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals, includeDates = _b.includeDates, includeDateIntervals = _b.includeDateIntervals, filterDate = _b.filterDate;
	if (_b.disabled) return true;
	return isOutOfBounds(day, {
		minDate,
		maxDate
	}) || excludeDates && excludeDates.some(function(excludeDate) {
		if (excludeDate instanceof Date) return isSameDay$2(day, excludeDate);
		else return isSameDay$2(day, excludeDate.date);
	}) || excludeDateIntervals && excludeDateIntervals.some(function(_a) {
		var start = _a.start, end = _a.end;
		return isWithinInterval(day, {
			start,
			end
		});
	}) || includeDates && !includeDates.some(function(includeDate) {
		return isSameDay$2(day, includeDate);
	}) || includeDateIntervals && !includeDateIntervals.some(function(_a) {
		var start = _a.start, end = _a.end;
		return isWithinInterval(day, {
			start,
			end
		});
	}) || filterDate && !filterDate(newDate(day)) || false;
}
/**
* Checks if a day is excluded.
*
* @param day - The day to check.
* @param options - The options to consider when checking.
* @returns - Returns true if the day is excluded, false otherwise.
*/
function isDayExcluded(day, _a) {
	var _b = _a === void 0 ? {} : _a, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals;
	if (excludeDateIntervals && excludeDateIntervals.length > 0) return excludeDateIntervals.some(function(_a) {
		var start = _a.start, end = _a.end;
		return isWithinInterval(day, {
			start,
			end
		});
	});
	return excludeDates && excludeDates.some(function(excludeDate) {
		var _a;
		if (excludeDate instanceof Date) return isSameDay$2(day, excludeDate);
		else return isSameDay$2(day, (_a = excludeDate.date) !== null && _a !== void 0 ? _a : /* @__PURE__ */ new Date());
	}) || false;
}
function isMonthDisabled(month, _a) {
	var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
	return isOutOfBounds(month, {
		minDate: minDate ? startOfMonth(minDate) : void 0,
		maxDate: maxDate ? endOfMonth(maxDate) : void 0
	}) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
		return isSameMonth$2(month, excludeDate instanceof Date ? excludeDate : excludeDate.date);
	})) || includeDates && !includeDates.some(function(includeDate) {
		return isSameMonth$2(month, includeDate);
	}) || filterDate && !filterDate(newDate(month)) || false;
}
function isMonthInRange(startDate, endDate, m, day) {
	var startDateYear = getYear(startDate);
	var startDateMonth = getMonth(startDate);
	var endDateYear = getYear(endDate);
	var endDateMonth = getMonth(endDate);
	var dayYear = getYear(day);
	if (startDateYear === endDateYear && startDateYear === dayYear) return startDateMonth <= m && m <= endDateMonth;
	else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateMonth <= m || dayYear === endDateYear && endDateMonth >= m || dayYear < endDateYear && dayYear > startDateYear;
	return false;
}
/**
* To check if a date's month and year are disabled/excluded
* @param date Date to check
* @returns {boolean} true if month and year are disabled/excluded, false otherwise
*/
function isMonthYearDisabled(date, _a) {
	var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
	return isOutOfBounds(date, {
		minDate,
		maxDate
	}) || excludeDates && excludeDates.some(function(excludedDate) {
		return isSameMonth$2(excludedDate instanceof Date ? excludedDate : excludedDate.date, date);
	}) || includeDates && !includeDates.some(function(includedDate) {
		return isSameMonth$2(includedDate, date);
	}) || false;
}
function isQuarterDisabled(quarter, _a) {
	var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
	if (_b.disabled) return true;
	return isOutOfBounds(quarter, {
		minDate,
		maxDate
	}) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
		return isSameQuarter$2(quarter, excludeDate instanceof Date ? excludeDate : excludeDate.date);
	})) || includeDates && !includeDates.some(function(includeDate) {
		return isSameQuarter$2(quarter, includeDate);
	}) || filterDate && !filterDate(newDate(quarter)) || false;
}
function isYearInRange(year, start, end) {
	if (!start || !end) return false;
	if (!isValid(start) || !isValid(end)) return false;
	var startYear = getYear(start);
	var endYear = getYear(end);
	return startYear <= year && endYear >= year;
}
function isYearDisabled(year, _a) {
	var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
	if (_b.disabled) return true;
	var date = new Date(year, 0, 1);
	return isOutOfBounds(date, {
		minDate: minDate ? startOfYear(minDate) : void 0,
		maxDate: maxDate ? endOfYear(maxDate) : void 0
	}) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
		return isSameYear$2(date, excludeDate instanceof Date ? excludeDate : excludeDate.date);
	})) || includeDates && !includeDates.some(function(includeDate) {
		return isSameYear$2(date, includeDate);
	}) || filterDate && !filterDate(newDate(date)) || false;
}
function isQuarterInRange(startDate, endDate, q, day) {
	var startDateYear = getYear(startDate);
	var startDateQuarter = getQuarter(startDate);
	var endDateYear = getYear(endDate);
	var endDateQuarter = getQuarter(endDate);
	var dayYear = getYear(day);
	if (startDateYear === endDateYear && startDateYear === dayYear) return startDateQuarter <= q && q <= endDateQuarter;
	else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateQuarter <= q || dayYear === endDateYear && endDateQuarter >= q || dayYear < endDateYear && dayYear > startDateYear;
	return false;
}
function isOutOfBounds(day, _a) {
	var _b;
	var _c = _a === void 0 ? {} : _a, minDate = _c.minDate, maxDate = _c.maxDate;
	return (_b = minDate && differenceInCalendarDays(day, minDate) < 0 || maxDate && differenceInCalendarDays(day, maxDate) > 0) !== null && _b !== void 0 ? _b : false;
}
function isTimeInList(time, times) {
	return times.some(function(listTime) {
		return getHours(listTime) === getHours(time) && getMinutes(listTime) === getMinutes(time) && getSeconds(listTime) === getSeconds(time);
	});
}
function isTimeDisabled(time, _a) {
	var _b = _a === void 0 ? {} : _a, excludeTimes = _b.excludeTimes, includeTimes = _b.includeTimes, filterTime = _b.filterTime;
	return excludeTimes && isTimeInList(time, excludeTimes) || includeTimes && !isTimeInList(time, includeTimes) || filterTime && !filterTime(time) || false;
}
function isTimeInDisabledRange(time, _a) {
	var minTime = _a.minTime, maxTime = _a.maxTime;
	if (!minTime || !maxTime) throw new Error("Both minTime and maxTime props required");
	var baseTime = newDate();
	baseTime = setHours(baseTime, getHours(time));
	baseTime = setMinutes(baseTime, getMinutes(time));
	baseTime = setSeconds(baseTime, getSeconds(time));
	var min = newDate();
	min = setHours(min, getHours(minTime));
	min = setMinutes(min, getMinutes(minTime));
	min = setSeconds(min, getSeconds(minTime));
	var max = newDate();
	max = setHours(max, getHours(maxTime));
	max = setMinutes(max, getMinutes(maxTime));
	max = setSeconds(max, getSeconds(maxTime));
	var valid;
	try {
		valid = !isWithinInterval(baseTime, {
			start: min,
			end: max
		});
	} catch (err) {
		/* istanbul ignore next - date-fns historically threw on invalid intervals */
		valid = false;
	}
	return valid;
}
function monthDisabledBefore(day, _a) {
	var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
	var previousMonth = subMonths(day, 1);
	return minDate && differenceInCalendarMonths(minDate, previousMonth) > 0 || includeDates && includeDates.every(function(includeDate) {
		return differenceInCalendarMonths(includeDate, previousMonth) > 0;
	}) || false;
}
function monthDisabledAfter(day, _a) {
	var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
	var nextMonth = addMonths(day, 1);
	return maxDate && differenceInCalendarMonths(nextMonth, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
		return differenceInCalendarMonths(nextMonth, includeDate) > 0;
	}) || false;
}
function quarterDisabledBefore(date, _a) {
	var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
	var firstDateOfYear = startOfYear(date);
	var previousQuarter = subQuarters(firstDateOfYear, 1);
	return minDate && differenceInCalendarQuarters(minDate, previousQuarter) > 0 || includeDates && includeDates.every(function(includeDate) {
		return differenceInCalendarQuarters(includeDate, previousQuarter) > 0;
	}) || false;
}
function quarterDisabledAfter(date, _a) {
	var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
	var lastDateOfYear = endOfYear(date);
	var nextQuarter = addQuarters(lastDateOfYear, 1);
	return maxDate && differenceInCalendarQuarters(nextQuarter, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
		return differenceInCalendarQuarters(nextQuarter, includeDate) > 0;
	}) || false;
}
function yearDisabledBefore(day, _a) {
	var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
	var previousYear = subYears(day, 1);
	return minDate && differenceInCalendarYears(minDate, previousYear) > 0 || includeDates && includeDates.every(function(includeDate) {
		return differenceInCalendarYears(includeDate, previousYear) > 0;
	}) || false;
}
function yearsDisabledBefore(day, _a) {
	var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? DEFAULT_YEAR_ITEM_NUMBER : _c;
	var endPeriod = getYearsPeriod(getStartOfYear(subYears(day, yearItemNumber)), yearItemNumber).endPeriod;
	var minDateYear = minDate && getYear(minDate);
	return minDateYear && minDateYear > endPeriod || false;
}
function yearDisabledAfter(day, _a) {
	var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
	var nextYear = addYears(day, 1);
	return maxDate && differenceInCalendarYears(nextYear, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
		return differenceInCalendarYears(nextYear, includeDate) > 0;
	}) || false;
}
function yearsDisabledAfter(day, _a) {
	var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? DEFAULT_YEAR_ITEM_NUMBER : _c;
	var startPeriod = getYearsPeriod(addYears(day, yearItemNumber), yearItemNumber).startPeriod;
	var maxDateYear = maxDate && getYear(maxDate);
	return maxDateYear && maxDateYear < startPeriod || false;
}
function getEffectiveMinDate(_a) {
	var minDate = _a.minDate, includeDates = _a.includeDates;
	if (includeDates && minDate) {
		var minDates = includeDates.filter(function(includeDate) {
			return differenceInCalendarDays(includeDate, minDate) >= 0;
		});
		return min(minDates);
	} else if (includeDates) return min(includeDates);
	else return minDate;
}
function getEffectiveMaxDate(_a) {
	var maxDate = _a.maxDate, includeDates = _a.includeDates;
	if (includeDates && maxDate) {
		var maxDates = includeDates.filter(function(includeDate) {
			return differenceInCalendarDays(includeDate, maxDate) <= 0;
		});
		return max(maxDates);
	} else if (includeDates) return max(includeDates);
	else return maxDate;
}
/**
* Get a map of highlighted dates with their corresponding classes.
* @param highlightDates The dates to highlight.
* @param defaultClassName The default class to use for highlighting.
* @returns A map with dates as keys and arrays of class names as values.
*/
function getHighLightDaysMap(highlightDates, defaultClassName) {
	var _a;
	if (highlightDates === void 0) highlightDates = [];
	if (defaultClassName === void 0) defaultClassName = "react-datepicker__day--highlighted";
	var dateClasses = /* @__PURE__ */ new Map();
	for (var i = 0, len = highlightDates.length; i < len; i++) {
		var obj = highlightDates[i];
		if (isDate(obj)) {
			var key = formatDate(obj, "MM.dd.yyyy");
			var classNamesArr = dateClasses.get(key) || [];
			if (!classNamesArr.includes(defaultClassName)) {
				classNamesArr.push(defaultClassName);
				dateClasses.set(key, classNamesArr);
			}
		} else if (typeof obj === "object") {
			var className = (_a = Object.keys(obj)[0]) !== null && _a !== void 0 ? _a : "";
			var arrOfDates = obj[className];
			if (typeof className === "string" && Array.isArray(arrOfDates)) for (var k = 0, len_1 = arrOfDates.length; k < len_1; k++) {
				var dateK = arrOfDates[k];
				if (dateK) {
					var key = formatDate(dateK, "MM.dd.yyyy");
					var classNamesArr = dateClasses.get(key) || [];
					if (!classNamesArr.includes(className)) {
						classNamesArr.push(className);
						dateClasses.set(key, classNamesArr);
					}
				}
			}
		}
	}
	return dateClasses;
}
/**
* Compare the two arrays
* @param array1 The first array to compare.
* @param array2 The second array to compare.
* @returns true, if the passed arrays are equal, false otherwise.
*/
function arraysAreEqual(array1, array2) {
	if (array1.length !== array2.length) return false;
	return array1.every(function(value, index) {
		return value === array2[index];
	});
}
/**
* Assign the custom class to each date
* @param holidayDates array of object containing date and name of the holiday
* @param defaultClassName className to be added.
* @returns Map containing date as key and array of className and holiday name as value
*/
function getHolidaysMap(holidayDates, defaultClassName) {
	if (holidayDates === void 0) holidayDates = [];
	if (defaultClassName === void 0) defaultClassName = "react-datepicker__day--holidays";
	var dateClasses = /* @__PURE__ */ new Map();
	holidayDates.forEach(function(holiday) {
		var dateObj = holiday.date, holidayName = holiday.holidayName;
		if (!isDate(dateObj)) return;
		var key = formatDate(dateObj, "MM.dd.yyyy");
		var classNamesObj = dateClasses.get(key) || {
			className: "",
			holidayNames: []
		};
		if ("className" in classNamesObj && classNamesObj["className"] === defaultClassName && arraysAreEqual(classNamesObj["holidayNames"], [holidayName])) return;
		classNamesObj["className"] = defaultClassName;
		var holidayNameArr = classNamesObj["holidayNames"];
		classNamesObj["holidayNames"] = holidayNameArr ? __spreadArray(__spreadArray([], holidayNameArr, true), [holidayName], false) : [holidayName];
		dateClasses.set(key, classNamesObj);
	});
	return dateClasses;
}
/**
* Determines the times to inject after a given start of day, current time, and multiplier.
* @param startOfDay The start of the day.
* @param currentTime The current time.
* @param currentMultiplier The current multiplier.
* @param intervals The intervals.
* @param injectedTimes The times to potentially inject.
* @returns An array of times to inject.
*/
function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
	var l = injectedTimes.length;
	var times = [];
	for (var i = 0; i < l; i++) {
		var injectedTime = startOfDay;
		var injectedTimeValue = injectedTimes[i];
		if (injectedTimeValue) {
			injectedTime = addHours(injectedTime, getHours(injectedTimeValue));
			injectedTime = addMinutes(injectedTime, getMinutes(injectedTimeValue));
			injectedTime = addSeconds(injectedTime, getSeconds(injectedTimeValue));
		}
		var nextTime = addMinutes(startOfDay, (currentMultiplier + 1) * intervals);
		if (isAfter(injectedTime, currentTime) && isBefore(injectedTime, nextTime) && injectedTimeValue != void 0) times.push(injectedTimeValue);
	}
	return times;
}
/**
* Adds a leading zero to a number if it's less than 10.
* @param i The number to add a leading zero to.
* @returns The number as a string, with a leading zero if it was less than 10.
*/
function addZero(i) {
	return i < 10 ? "0".concat(i) : "".concat(i);
}
/**
* Gets the start and end years for a period.
* @param date The date to get the period for.
* @param yearItemNumber The number of years in the period. Defaults to DEFAULT_YEAR_ITEM_NUMBER.
* @returns An object with the start and end years for the period.
*/
function getYearsPeriod(date, yearItemNumber) {
	if (yearItemNumber === void 0) yearItemNumber = DEFAULT_YEAR_ITEM_NUMBER;
	var endPeriod = Math.ceil(getYear(date) / yearItemNumber) * yearItemNumber;
	return {
		startPeriod: endPeriod - (yearItemNumber - 1),
		endPeriod
	};
}
/**
* Gets the number of hours in a day.
* @param d The date to get the number of hours for.
* @returns The number of hours in the day.
*/
function getHoursInDay(d) {
	var startOfDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
	var startOfTheNextDay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 24);
	return Math.round((+startOfTheNextDay - +startOfDay) / 36e5);
}
/**
* Returns the start of the minute for the given date
*
* NOTE: this function is a DST and timezone-safe analog of `date-fns/startOfMinute`
* do not make changes unless you know what you're doing
*
* See comments on https://github.com/Hacker0x01/react-datepicker/pull/4244
* for more details
*
* @param d date
* @returns start of the minute
*/
function startOfMinute(d) {
	var seconds = d.getSeconds();
	var milliseconds = d.getMilliseconds();
	return toDate(d.getTime() - seconds * 1e3 - milliseconds);
}
/**
* Returns whether the given dates are in the same minute
*
* This function is a DST and timezone-safe analog of `date-fns/isSameMinute`
*
* @param d1
* @param d2
* @returns
*/
function isSameMinute(d1, d2) {
	return startOfMinute(d1).getTime() === startOfMinute(d2).getTime();
}
/**
* Returns a new datetime object representing the input date with midnight time
* @param date The date to get the midnight time for
* @returns A new datetime object representing the input date with midnight time
*/
function getMidnightDate(date) {
	if (!isDate(date)) throw new Error("Invalid date");
	var dateWithoutTime = new Date(date);
	dateWithoutTime.setHours(0, 0, 0, 0);
	return dateWithoutTime;
}
/**
* Is the first date before the second one?
* @param date The date that should be before the other one to return true
* @param dateToCompare The date to compare with
* @returns The first date is before the second date
*
* Note:
*  This function considers the mid-night of the given dates for comparison.
*  It evaluates whether date is before dateToCompare based on their mid-night timestamps.
*/
function isDateBefore(date, dateToCompare) {
	if (!isDate(date) || !isDate(dateToCompare)) throw new Error("Invalid date received");
	var midnightDate = getMidnightDate(date);
	var midnightDateToCompare = getMidnightDate(dateToCompare);
	return isBefore(midnightDate, midnightDateToCompare);
}
/**
* Checks if the space key was pressed down.
*
* @param event - The keyboard event.
* @returns - Returns true if the space key was pressed down, false otherwise.
*/
function isSpaceKeyDown(event) {
	return event.key === KeyType.Space;
}
/**
* `InputTime` is a React component that manages time input.
*
* @component
* @example
* <InputTime timeString="12:00" />
*
* @param props - The properties that define the `InputTime` component.
* @param props.onChange - Function that is called when the date changes.
* @param props.date - The initial date value.
* @param props.timeString - The initial time string value.
* @param props.timeInputLabel - The label for the time input.
* @param props.customTimeInput - An optional custom time input element.
*
* @returns The `InputTime` component.
*/
var InputTime = function(_super) {
	__extends(InputTime, _super);
	function InputTime(props) {
		var _this = _super.call(this, props) || this;
		_this.inputRef = React.createRef();
		_this.onTimeChange = function(time) {
			var _a, _b;
			_this.setState({ time });
			var propDate = _this.props.date;
			var date = propDate instanceof Date && !isNaN(+propDate) ? propDate : /* @__PURE__ */ new Date();
			if (time === null || time === void 0 ? void 0 : time.includes(":")) {
				var _c = time.split(":"), hours = _c[0], minutes = _c[1];
				date.setHours(Number(hours));
				date.setMinutes(Number(minutes));
			}
			(_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, date);
		};
		_this.renderTimeInput = function() {
			var time = _this.state.time;
			var _a = _this.props, date = _a.date, timeString = _a.timeString, customTimeInput = _a.customTimeInput;
			if (customTimeInput) return cloneElement(customTimeInput, {
				date,
				value: time,
				onChange: _this.onTimeChange
			});
			return React.createElement("input", {
				type: "time",
				className: "react-datepicker-time__input",
				placeholder: "Time",
				name: "time-input",
				ref: _this.inputRef,
				onClick: function() {
					var _a;
					(_a = _this.inputRef.current) === null || _a === void 0 || _a.focus();
				},
				required: true,
				value: time,
				onChange: function(event) {
					_this.onTimeChange(event.target.value || timeString);
				}
			});
		};
		_this.state = { time: _this.props.timeString };
		return _this;
	}
	InputTime.getDerivedStateFromProps = function(props, state) {
		if (props.timeString !== state.time) return { time: props.timeString };
		return null;
	};
	InputTime.prototype.render = function() {
		return React.createElement("div", { className: "react-datepicker__input-time-container" }, React.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), React.createElement("div", { className: "react-datepicker-time__input-container" }, React.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
	};
	return InputTime;
}(Component);
/**
* `Day` is a React component that represents a single day in a date picker.
* It handles the rendering and interaction of a day.
*
* @prop ariaLabelPrefixWhenEnabled - Aria label prefix when the day is enabled.
* @prop ariaLabelPrefixWhenDisabled - Aria label prefix when the day is disabled.
* @prop disabledKeyboardNavigation - Whether keyboard navigation is disabled.
* @prop day - The day to be displayed.
* @prop dayClassName - Function to customize the CSS class of the day.
* @prop endDate - The end date in a range.
* @prop highlightDates - Map of dates to be highlighted.
* @prop holidays - Map of holiday dates.
* @prop inline - Whether the date picker is inline.
* @prop shouldFocusDayInline - Whether the day should be focused when date picker is inline.
* @prop month - The month the day belongs to.
* @prop onClick - Click event handler.
* @prop onMouseEnter - Mouse enter event handler.
* @prop handleOnKeyDown - Key down event handler.
* @prop usePointerEvent - Whether to use pointer events.
* @prop preSelection - The date that is currently selected.
* @prop selected - The selected date.
* @prop selectingDate - The date currently being selected.
* @prop selectsEnd - Whether the day can be the end date in a range.
* @prop selectsStart - Whether the day can be the start date in a range.
* @prop selectsRange - Whether the day can be in a range.
* @prop showWeekPicker - Whether to show week picker.
* @prop showWeekNumber - Whether to show week numbers.
* @prop selectsDisabledDaysInRange - Whether to select disabled days in a range.
* @prop selectsMultiple - Whether to allow multiple date selection.
* @prop selectedDates - Array of selected dates.
* @prop startDate - The start date in a range.
* @prop renderDayContents - Function to customize the rendering of the day's contents.
* @prop containerRef - Ref for the container.
* @prop excludeDates - Array of dates to be excluded.
* @prop calendarStartDay - The start day of the week.
* @prop locale - The locale object.
* @prop monthShowsDuplicateDaysEnd - Whether to show duplicate days at the end of the month.
* @prop monthShowsDuplicateDaysStart - Whether to show duplicate days at the start of the month.
* @prop includeDates - Array of dates to be included.
* @prop includeDateIntervals - Array of date intervals to be included.
* @prop minDate - The minimum date that can be selected.
* @prop maxDate - The maximum date that can be selected.
*
* @example
* ```tsx
* import React from 'react';
* import Day from './day';
*
* function MyComponent() {
*   const handleDayClick = (event) => {
*     console.log('Day clicked', event);
*   };
*
*   const handleDayMouseEnter = (event) => {
*     console.log('Mouse entered day', event);
*   };
*
*   const renderDayContents = (date) => {
*     return <div>{date.getDate()}</div>;
*   };
*
*   return (
*     <Day
*       day={new Date()}
*       onClick={handleDayClick}
*       onMouseEnter={handleDayMouseEnter}
*       renderDayContents={renderDayContents}
*     />
*   );
* }
*
* export default MyComponent;
* ```
*/
var Day = function(_super) {
	__extends(Day, _super);
	function Day() {
		var _this = _super !== null && _super.apply(this, arguments) || this;
		_this.dayEl = createRef();
		_this.handleClick = function(event) {
			if (!_this.isDisabled() && _this.props.onClick) _this.props.onClick(event);
		};
		_this.handleMouseEnter = function(event) {
			if (!_this.isDisabled() && _this.props.onMouseEnter) _this.props.onMouseEnter(event);
		};
		_this.handleOnKeyDown = function(event) {
			var _a, _b;
			if (event.key === KeyType.Space) {
				event.preventDefault();
				event.key = KeyType.Enter;
			}
			(_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
		};
		_this.isSameDay = function(other) {
			return isSameDay$2(_this.props.day, other);
		};
		_this.isKeyboardSelected = function() {
			var _a;
			if (_this.props.disabledKeyboardNavigation) return false;
			var isSelectedDate = _this.props.selectsMultiple ? (_a = _this.props.selectedDates) === null || _a === void 0 ? void 0 : _a.some(function(date) {
				return _this.isSameDayOrWeek(date);
			}) : _this.isSameDayOrWeek(_this.props.selected);
			var isDisabled = _this.props.preSelection && _this.isDisabled(_this.props.preSelection);
			return !isSelectedDate && _this.isSameDayOrWeek(_this.props.preSelection) && !isDisabled;
		};
		_this.isDisabled = function(day) {
			if (day === void 0) day = _this.props.day;
			return isDayDisabled(day, {
				minDate: _this.props.minDate,
				maxDate: _this.props.maxDate,
				excludeDates: _this.props.excludeDates,
				excludeDateIntervals: _this.props.excludeDateIntervals,
				includeDateIntervals: _this.props.includeDateIntervals,
				includeDates: _this.props.includeDates,
				filterDate: _this.props.filterDate,
				disabled: _this.props.disabled
			});
		};
		_this.isExcluded = function() {
			return isDayExcluded(_this.props.day, {
				excludeDates: _this.props.excludeDates,
				excludeDateIntervals: _this.props.excludeDateIntervals
			});
		};
		_this.isStartOfWeek = function() {
			return isSameDay$2(_this.props.day, getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
		};
		_this.isSameWeek = function(other) {
			return _this.props.showWeekPicker && isSameDay$2(other, getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
		};
		_this.isSameDayOrWeek = function(other) {
			return _this.isSameDay(other) || _this.isSameWeek(other);
		};
		_this.getHighLightedClass = function() {
			var _a = _this.props, day = _a.day, highlightDates = _a.highlightDates;
			if (!highlightDates) return false;
			var dayStr = formatDate(day, "MM.dd.yyyy");
			return highlightDates.get(dayStr);
		};
		_this.getHolidaysClass = function() {
			var _a;
			var _b = _this.props, day = _b.day, holidays = _b.holidays;
			if (!holidays) return [void 0];
			var dayStr = formatDate(day, "MM.dd.yyyy");
			if (holidays.has(dayStr)) return [(_a = holidays.get(dayStr)) === null || _a === void 0 ? void 0 : _a.className];
			return [void 0];
		};
		_this.isInRange = function() {
			var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
			if (!startDate || !endDate) return false;
			return isDayInRange(day, startDate, endDate);
		};
		_this.isInSelectingRange = function() {
			var _a;
			var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, selectsDisabledDaysInRange = _b.selectsDisabledDaysInRange, startDate = _b.startDate, swapRange = _b.swapRange, endDate = _b.endDate;
			var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
			if (_this.isAfterMonth() || _this.isBeforeMonth()) return false;
			if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate || !selectsDisabledDaysInRange && _this.isDisabled()) return false;
			if (selectsStart && endDate && (isBefore(selectingDate, endDate) || isEqual$2(selectingDate, endDate))) return isDayInRange(day, selectingDate, endDate);
			if (selectsEnd && startDate && (isAfter(selectingDate, startDate) || isEqual$2(selectingDate, startDate))) return isDayInRange(day, startDate, selectingDate);
			if (selectsRange && startDate && !endDate) {
				if (isEqual$2(selectingDate, startDate)) return isDayInRange(day, startDate, selectingDate);
				if (isAfter(selectingDate, startDate)) return isDayInRange(day, startDate, selectingDate);
				if (swapRange && isBefore(selectingDate, startDate)) return isDayInRange(day, selectingDate, startDate);
			}
			return false;
		};
		_this.isSelectingRangeStart = function() {
			var _a;
			if (!_this.isInSelectingRange()) return false;
			var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart, swapRange = _b.swapRange, selectsRange = _b.selectsRange;
			var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
			if (selectsStart) return isSameDay$2(day, selectingDate);
			if (selectsRange && swapRange && startDate && selectingDate) return isSameDay$2(day, isBefore(selectingDate, startDate) ? selectingDate : startDate);
			return isSameDay$2(day, startDate);
		};
		_this.isSelectingRangeEnd = function() {
			var _a;
			if (!_this.isInSelectingRange()) return false;
			var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, swapRange = _b.swapRange, startDate = _b.startDate;
			var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
			if (selectsEnd) return isSameDay$2(day, selectingDate);
			if (selectsRange && swapRange && startDate && selectingDate) return isSameDay$2(day, isBefore(selectingDate, startDate) ? startDate : selectingDate);
			if (selectsRange) return isSameDay$2(day, selectingDate);
			return isSameDay$2(day, endDate);
		};
		_this.isRangeStart = function() {
			var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
			if (!startDate || !endDate) return false;
			return isSameDay$2(startDate, day);
		};
		_this.isRangeEnd = function() {
			var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
			if (!startDate || !endDate) return false;
			return isSameDay$2(endDate, day);
		};
		_this.isWeekend = function() {
			var weekday = getDay(_this.props.day);
			return weekday === 0 || weekday === 6;
		};
		_this.isAfterMonth = function() {
			return _this.props.month !== void 0 && (_this.props.month + 1) % 12 === getMonth(_this.props.day);
		};
		_this.isBeforeMonth = function() {
			return _this.props.month !== void 0 && (getMonth(_this.props.day) + 1) % 12 === _this.props.month;
		};
		_this.isCurrentDay = function() {
			return _this.isSameDay(newDate());
		};
		_this.isSelected = function() {
			var _a;
			if (_this.props.selectsMultiple) return (_a = _this.props.selectedDates) === null || _a === void 0 ? void 0 : _a.some(function(date) {
				return _this.isSameDayOrWeek(date);
			});
			return _this.isSameDayOrWeek(_this.props.selected);
		};
		_this.getClassNames = function(date) {
			return clsx("react-datepicker__day", _this.props.dayClassName ? _this.props.dayClassName(date) : void 0, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
				"react-datepicker__day--disabled": _this.isDisabled(),
				"react-datepicker__day--excluded": _this.isExcluded(),
				"react-datepicker__day--selected": _this.isSelected(),
				"react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
				"react-datepicker__day--range-start": _this.isRangeStart(),
				"react-datepicker__day--range-end": _this.isRangeEnd(),
				"react-datepicker__day--in-range": _this.isInRange(),
				"react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
				"react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
				"react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
				"react-datepicker__day--today": _this.isCurrentDay(),
				"react-datepicker__day--weekend": _this.isWeekend(),
				"react-datepicker__day--outside-month": _this.isAfterMonth() || _this.isBeforeMonth()
			}, _this.getHighLightedClass(), _this.getHolidaysClass());
		};
		_this.getAriaLabel = function() {
			var _a = _this.props, day = _a.day, _b = _a.ariaLabelPrefixWhenEnabled, ariaLabelPrefixWhenEnabled = _b === void 0 ? "Choose" : _b, _c = _a.ariaLabelPrefixWhenDisabled, ariaLabelPrefixWhenDisabled = _c === void 0 ? "Not available" : _c;
			var prefix = _this.isDisabled() || _this.isExcluded() ? ariaLabelPrefixWhenDisabled : ariaLabelPrefixWhenEnabled;
			return "".concat(prefix, " ").concat(formatDate(day, "PPPP", _this.props.locale));
		};
		_this.getTitle = function() {
			var _a = _this.props, day = _a.day, _b = _a.holidays, holidays = _b === void 0 ? /* @__PURE__ */ new Map() : _b, excludeDates = _a.excludeDates;
			var compareDt = formatDate(day, "MM.dd.yyyy");
			var titles = [];
			if (holidays.has(compareDt)) titles.push.apply(titles, holidays.get(compareDt).holidayNames);
			if (_this.isExcluded()) titles.push(excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.filter(function(excludeDate) {
				if (excludeDate instanceof Date) return isSameDay$2(excludeDate, day);
				return isSameDay$2(excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.date, day);
			}).map(function(excludeDate) {
				if (excludeDate instanceof Date) return;
				return excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.message;
			}));
			return titles.join(", ");
		};
		_this.getTabIndex = function() {
			var selectedDay = _this.props.selected;
			var preSelectionDay = _this.props.preSelection;
			return !(_this.props.showWeekPicker && (_this.props.showWeekNumber || !_this.isStartOfWeek())) && (_this.isKeyboardSelected() || _this.isSameDay(selectedDay) && isSameDay$2(preSelectionDay, selectedDay)) ? 0 : -1;
		};
		_this.handleFocusDay = function() {
			var _a;
			_this.shouldFocusDay() && ((_a = _this.dayEl.current) === null || _a === void 0 || _a.focus({ preventScroll: true }));
		};
		_this.renderDayContents = function() {
			if (_this.props.monthShowsDuplicateDaysEnd && _this.isAfterMonth()) return null;
			if (_this.props.monthShowsDuplicateDaysStart && _this.isBeforeMonth()) return null;
			return _this.props.renderDayContents ? _this.props.renderDayContents(getDate(_this.props.day), _this.props.day) : getDate(_this.props.day);
		};
		_this.render = function() {
			return React.createElement("div", {
				ref: _this.dayEl,
				className: _this.getClassNames(_this.props.day),
				onKeyDown: _this.handleOnKeyDown,
				onClick: _this.handleClick,
				onMouseEnter: !_this.props.usePointerEvent ? _this.handleMouseEnter : void 0,
				onPointerEnter: _this.props.usePointerEvent ? _this.handleMouseEnter : void 0,
				tabIndex: _this.getTabIndex(),
				"aria-label": _this.getAriaLabel(),
				role: "gridcell",
				title: _this.getTitle(),
				"aria-disabled": _this.isDisabled(),
				"aria-current": _this.isCurrentDay() ? "date" : void 0,
				"aria-selected": _this.isSelected() || _this.isInRange()
			}, _this.renderDayContents(), _this.getTitle() !== "" && React.createElement("span", { className: "overlay" }, _this.getTitle()));
		};
		return _this;
	}
	Day.prototype.componentDidMount = function() {
		this.handleFocusDay();
	};
	Day.prototype.componentDidUpdate = function() {
		this.handleFocusDay();
	};
	Day.prototype.shouldFocusDay = function() {
		var shouldFocusDay = false;
		if (this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection)) {
			if (!document.activeElement || document.activeElement === document.body) shouldFocusDay = true;
			if (this.props.inline && !this.props.shouldFocusDayInline) shouldFocusDay = false;
			if (this.isDayActiveElement()) shouldFocusDay = true;
			if (this.isDuplicateDay()) shouldFocusDay = false;
		}
		return shouldFocusDay;
	};
	Day.prototype.isDayActiveElement = function() {
		var _a, _b, _c;
		return ((_b = (_a = this.props.containerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.contains(document.activeElement)) && ((_c = document.activeElement) === null || _c === void 0 ? void 0 : _c.classList.contains("react-datepicker__day"));
	};
	Day.prototype.isDuplicateDay = function() {
		return this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth();
	};
	return Day;
}(Component);
var WeekNumber = function(_super) {
	__extends(WeekNumber, _super);
	function WeekNumber() {
		var _this = _super !== null && _super.apply(this, arguments) || this;
		_this.weekNumberEl = createRef();
		_this.handleClick = function(event) {
			if (_this.props.onClick) _this.props.onClick(event);
		};
		_this.handleOnKeyDown = function(event) {
			var _a, _b;
			if (event.key === KeyType.Space) {
				event.preventDefault();
				event.key = KeyType.Enter;
			}
			(_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
		};
		_this.isKeyboardSelected = function() {
			return !_this.props.disabledKeyboardNavigation && !isSameDay$2(_this.props.date, _this.props.selected) && isSameDay$2(_this.props.date, _this.props.preSelection);
		};
		_this.getTabIndex = function() {
			return _this.props.showWeekPicker && _this.props.showWeekNumber && (_this.isKeyboardSelected() || isSameDay$2(_this.props.date, _this.props.selected) && isSameDay$2(_this.props.preSelection, _this.props.selected)) ? 0 : -1;
		};
		_this.handleFocusWeekNumber = function(prevProps) {
			var shouldFocusWeekNumber = false;
			if (_this.getTabIndex() === 0 && !(prevProps === null || prevProps === void 0 ? void 0 : prevProps.isInputFocused) && isSameDay$2(_this.props.date, _this.props.preSelection)) {
				if (!document.activeElement || document.activeElement === document.body) shouldFocusWeekNumber = true;
				if (_this.props.inline && !_this.props.shouldFocusDayInline) shouldFocusWeekNumber = false;
				if (_this.props.containerRef && _this.props.containerRef.current && _this.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number")) shouldFocusWeekNumber = true;
			}
			shouldFocusWeekNumber && _this.weekNumberEl.current && _this.weekNumberEl.current.focus({ preventScroll: true });
		};
		return _this;
	}
	Object.defineProperty(WeekNumber, "defaultProps", {
		get: function() {
			return { ariaLabelPrefix: "week " };
		},
		enumerable: false,
		configurable: true
	});
	WeekNumber.prototype.componentDidMount = function() {
		this.handleFocusWeekNumber();
	};
	WeekNumber.prototype.componentDidUpdate = function(prevProps) {
		this.handleFocusWeekNumber(prevProps);
	};
	WeekNumber.prototype.render = function() {
		var _a = this.props, weekNumber = _a.weekNumber, isWeekDisabled = _a.isWeekDisabled, _b = _a.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? WeekNumber.defaultProps.ariaLabelPrefix : _b, onClick = _a.onClick;
		var weekNumberClasses = {
			"react-datepicker__week-number": true,
			"react-datepicker__week-number--clickable": !!onClick && !isWeekDisabled,
			"react-datepicker__week-number--selected": !!onClick && isSameDay$2(this.props.date, this.props.selected)
		};
		return React.createElement("div", {
			ref: this.weekNumberEl,
			className: clsx(weekNumberClasses),
			"aria-label": "".concat(ariaLabelPrefix, " ").concat(this.props.weekNumber),
			onClick: this.handleClick,
			onKeyDown: this.handleOnKeyDown,
			tabIndex: this.getTabIndex(),
			role: "gridcell"
		}, weekNumber);
	};
	return WeekNumber;
}(Component);
var Week = function(_super) {
	__extends(Week, _super);
	function Week() {
		var _this = _super !== null && _super.apply(this, arguments) || this;
		_this.isDisabled = function(day) {
			return isDayDisabled(day, {
				minDate: _this.props.minDate,
				maxDate: _this.props.maxDate,
				excludeDates: _this.props.excludeDates,
				excludeDateIntervals: _this.props.excludeDateIntervals,
				includeDateIntervals: _this.props.includeDateIntervals,
				includeDates: _this.props.includeDates,
				filterDate: _this.props.filterDate
			});
		};
		_this.handleDayClick = function(day, event) {
			if (_this.props.onDayClick) _this.props.onDayClick(day, event);
		};
		_this.handleDayMouseEnter = function(day) {
			if (_this.props.onDayMouseEnter) _this.props.onDayMouseEnter(day);
		};
		_this.handleWeekClick = function(day, weekNumber, event) {
			var _a, _b, _c;
			var enabledWeekDay = new Date(day);
			for (var i = 0; i < 7; i++) {
				var processingDay = new Date(day);
				processingDay.setDate(processingDay.getDate() + i);
				if (!_this.isDisabled(processingDay)) {
					enabledWeekDay = processingDay;
					break;
				}
			}
			if (typeof _this.props.onWeekSelect === "function") _this.props.onWeekSelect(enabledWeekDay, weekNumber, event);
			if (_this.props.showWeekPicker) _this.handleDayClick(enabledWeekDay, event);
			if ((_a = _this.props.shouldCloseOnSelect) !== null && _a !== void 0 ? _a : Week.defaultProps.shouldCloseOnSelect) (_c = (_b = _this.props).setOpen) === null || _c === void 0 || _c.call(_b, false);
		};
		_this.formatWeekNumber = function(date) {
			if (_this.props.formatWeekNumber) return _this.props.formatWeekNumber(date);
			return getWeek(date);
		};
		_this.isWeekDisabled = function() {
			var startOfWeek = _this.startOfWeek();
			var endOfWeek = addDays(startOfWeek, 6);
			var processingDate = new Date(startOfWeek);
			while (processingDate <= endOfWeek) {
				if (!_this.isDisabled(processingDate)) return false;
				processingDate = addDays(processingDate, 1);
			}
			return true;
		};
		_this.renderDays = function() {
			var startOfWeek = _this.startOfWeek();
			var days = [];
			var weekNumber = _this.formatWeekNumber(startOfWeek);
			if (_this.props.showWeekNumber) {
				var onClickAction = _this.props.onWeekSelect || _this.props.showWeekPicker ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : void 0;
				days.push(React.createElement(WeekNumber, _assign({ key: "W" }, Week.defaultProps, _this.props, {
					weekNumber,
					isWeekDisabled: _this.isWeekDisabled(),
					date: startOfWeek,
					onClick: onClickAction
				})));
			}
			return days.concat([
				0,
				1,
				2,
				3,
				4,
				5,
				6
			].map(function(offset) {
				var day = addDays(startOfWeek, offset);
				return React.createElement(Day, _assign({}, Week.defaultProps, _this.props, {
					ariaLabelPrefixWhenEnabled: _this.props.chooseDayAriaLabelPrefix,
					ariaLabelPrefixWhenDisabled: _this.props.disabledDayAriaLabelPrefix,
					key: day.valueOf(),
					day,
					onClick: _this.handleDayClick.bind(_this, day),
					onMouseEnter: _this.handleDayMouseEnter.bind(_this, day)
				}));
			}));
		};
		_this.startOfWeek = function() {
			return getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay);
		};
		_this.isKeyboardSelected = function() {
			return !_this.props.disabledKeyboardNavigation && !isSameDay$2(_this.startOfWeek(), _this.props.selected) && isSameDay$2(_this.startOfWeek(), _this.props.preSelection);
		};
		return _this;
	}
	Object.defineProperty(Week, "defaultProps", {
		get: function() {
			return { shouldCloseOnSelect: true };
		},
		enumerable: false,
		configurable: true
	});
	Week.prototype.render = function() {
		var weekNumberClasses = {
			"react-datepicker__week": true,
			"react-datepicker__week--selected": isSameDay$2(this.startOfWeek(), this.props.selected),
			"react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
		};
		var customWeekClassName = this.props.weekClassName ? this.props.weekClassName(this.startOfWeek()) : void 0;
		return React.createElement("div", {
			className: clsx(weekNumberClasses, customWeekClassName),
			role: "row"
		}, this.renderDays());
	};
	return Week;
}(Component);
var _a;
var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
var MONTH_COLUMNS_LAYOUT = {
	TWO_COLUMNS: "two_columns",
	THREE_COLUMNS: "three_columns",
	FOUR_COLUMNS: "four_columns"
};
var MONTH_COLUMNS = (_a = {}, _a[MONTH_COLUMNS_LAYOUT.TWO_COLUMNS] = {
	grid: [
		[0, 1],
		[2, 3],
		[4, 5],
		[6, 7],
		[8, 9],
		[10, 11]
	],
	verticalNavigationOffset: 2
}, _a[MONTH_COLUMNS_LAYOUT.THREE_COLUMNS] = {
	grid: [
		[
			0,
			1,
			2
		],
		[
			3,
			4,
			5
		],
		[
			6,
			7,
			8
		],
		[
			9,
			10,
			11
		]
	],
	verticalNavigationOffset: 3
}, _a[MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS] = {
	grid: [
		[
			0,
			1,
			2,
			3
		],
		[
			4,
			5,
			6,
			7
		],
		[
			8,
			9,
			10,
			11
		]
	],
	verticalNavigationOffset: 4
}, _a);
var MONTH_NAVIGATION_HORIZONTAL_OFFSET = 1;
function getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker) {
	if (showFourColumnMonthYearPicker) return MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS;
	if (showTwoColumnMonthYearPicker) return MONTH_COLUMNS_LAYOUT.TWO_COLUMNS;
	return MONTH_COLUMNS_LAYOUT.THREE_COLUMNS;
}
/**
* `Month` is a React component that represents a month in a calendar.
* It accepts a `MonthProps` object as props which provides various configurations and event handlers.
*
* @prop dayClassName - Function to determine the class name for a day.
* @prop monthClassName - Function to determine the class name for a month.
* @prop filterDate - Function to filter dates.
* @prop formatWeekNumber - Function to format the week number.
* @prop onDayClick - Function to handle day click events.
* @prop onDayMouseEnter - Function to handle mouse enter events on a day.
* @prop onMouseLeave - Function to handle mouse leave events.
* @prop onWeekSelect - Function to handle week selection.
* @prop setPreSelection - Function to set pre-selection.
* @prop setOpen - Function to set open state.
* @prop renderDayContents - Function to render day contents.
* @prop renderMonthContent - Function to render month content.
* @prop renderQuarterContent - Function to render quarter content.
* @prop handleOnKeyDown - Function to handle key down events.
* @prop handleOnMonthKeyDown - Function to handle key down events on a month.
* @prop ariaLabelPrefix - Aria label prefix.
* @prop chooseDayAriaLabelPrefix - Aria label prefix for choosing a day.
* @prop disabledDayAriaLabelPrefix - Aria label prefix for disabled day.
* @prop disabledKeyboardNavigation - Flag to disable keyboard navigation.
* @prop day - The day.
* @prop endDate - The end date.
* @prop orderInDisplay - The order in display.
* @prop excludeDates - Dates to exclude.
* @prop excludeDateIntervals - Date intervals to exclude.
* @prop fixedHeight - Flag to set fixed height.
* @prop highlightDates - Dates to highlight.
* @prop holidays - Holidays.
* @prop includeDates - Dates to include.
* @prop includeDateIntervals - Date intervals to include.
* @prop inline - Flag to set inline.
* @prop shouldFocusDayInline - Flag to set focus on day inline.
* @prop locale - The locale.
* @prop maxDate - The maximum date.
* @prop minDate - The minimum date.
* @prop usePointerEvent - Flag to use pointer event.
* @prop peekNextMonth - Flag to peek next month.
* @prop preSelection - The pre-selection.
* @prop selected - The selected date.
* @prop selectingDate - The selecting date.
* @prop calendarStartDay - The calendar start day.
* @prop selectsEnd - Flag to select end.
* @prop selectsStart - Flag to select start.
* @prop selectsRange - Flag to select range.
* @prop selectsDisabledDaysInRange - Flag to select disabled days in range.
* @prop selectsMultiple - Flag to select multiple.
* @prop selectedDates - The selected dates.
* @prop showWeekNumbers - Flag to show week numbers.
* @prop startDate - The start date.
* @prop shouldCloseOnSelect - Flag to close on select.
* @prop showMonthYearPicker - Flag to show month year picker.
* @prop showFullMonthYearPicker - Flag to show full month year picker.
* @prop showTwoColumnMonthYearPicker - Flag to show two column month year picker.
* @prop showFourColumnMonthYearPicker - Flag to show four column month year picker.
* @prop showQuarterYearPicker - Flag to show quarter year picker.
* @prop showWeekPicker - Flag to show week picker.
* @prop isInputFocused - Flag to set input focus.
* @prop weekAriaLabelPrefix - Aria label prefix for week.
* @prop containerRef - The container reference.
* @prop monthShowsDuplicateDaysEnd - Flag to show duplicate days at the end of the month.
* @prop monthShowsDuplicateDaysStart - Flag to show duplicate days at the start of the month.
*
* @example
* ```tsx
* function App() {
*  const handleDayClick = (date) => {
*     console.log('Day clicked: ', date);
*   };
*
*   const handleDayMouseEnter = (date) => {
*     console.log('Mouse entered on day: ', date);
*   };
*
*   return (
*     <div>
*       <Month
*         day={new Date()}
*         endDate={new Date()}
*         onDayClick={handleDayClick}
*         onDayMouseEnter={handleDayMouseEnter}
*         disabledKeyboardNavigation={false}
*         showWeekNumbers={true}
*         showMonthYearPicker={false}
*       />
*     </div>
*   );
* }
* ```
*/
var Month = function(_super) {
	__extends(Month, _super);
	function Month() {
		var _this = _super !== null && _super.apply(this, arguments) || this;
		_this.MONTH_REFS = __spreadArray([], Array(12), true).map(function() {
			return createRef();
		});
		_this.QUARTER_REFS = __spreadArray([], Array(4), true).map(function() {
			return createRef();
		});
		_this.isDisabled = function(day) {
			return isDayDisabled(day, {
				minDate: _this.props.minDate,
				maxDate: _this.props.maxDate,
				excludeDates: _this.props.excludeDates,
				excludeDateIntervals: _this.props.excludeDateIntervals,
				includeDateIntervals: _this.props.includeDateIntervals,
				includeDates: _this.props.includeDates,
				filterDate: _this.props.filterDate,
				disabled: _this.props.disabled
			});
		};
		_this.isExcluded = function(day) {
			return isDayExcluded(day, {
				excludeDates: _this.props.excludeDates,
				excludeDateIntervals: _this.props.excludeDateIntervals
			});
		};
		_this.handleDayClick = function(day, event) {
			var _a, _b;
			(_b = (_a = _this.props).onDayClick) === null || _b === void 0 || _b.call(_a, day, event, _this.props.orderInDisplay);
		};
		_this.handleDayMouseEnter = function(day) {
			var _a, _b;
			(_b = (_a = _this.props).onDayMouseEnter) === null || _b === void 0 || _b.call(_a, day);
		};
		_this.handleMouseLeave = function() {
			var _a, _b;
			(_b = (_a = _this.props).onMouseLeave) === null || _b === void 0 || _b.call(_a);
		};
		_this.isRangeStartMonth = function(m) {
			var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
			if (!startDate || !endDate) return false;
			return isSameMonth$2(setMonth(day, m), startDate);
		};
		_this.isRangeStartQuarter = function(q) {
			var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
			if (!startDate || !endDate) return false;
			return isSameQuarter$2(setQuarter(day, q), startDate);
		};
		_this.isRangeEndMonth = function(m) {
			var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
			if (!startDate || !endDate) return false;
			return isSameMonth$2(setMonth(day, m), endDate);
		};
		_this.isRangeEndQuarter = function(q) {
			var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
			if (!startDate || !endDate) return false;
			return isSameQuarter$2(setQuarter(day, q), endDate);
		};
		_this.isInSelectingRangeMonth = function(m) {
			var _a;
			var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
			var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
			if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) return false;
			if (selectsStart && endDate) return isMonthInRange(selectingDate, endDate, m, day);
			if (selectsEnd && startDate) return isMonthInRange(startDate, selectingDate, m, day);
			if (selectsRange && startDate && !endDate) return isMonthInRange(startDate, selectingDate, m, day);
			return false;
		};
		_this.isSelectingMonthRangeStart = function(m) {
			var _a;
			if (!_this.isInSelectingRangeMonth(m)) return false;
			var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart;
			var _month = setMonth(day, m);
			var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
			if (selectsStart) return isSameMonth$2(_month, selectingDate);
			else return isSameMonth$2(_month, startDate);
		};
		_this.isSelectingMonthRangeEnd = function(m) {
			var _a;
			if (!_this.isInSelectingRangeMonth(m)) return false;
			var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
			var _month = setMonth(day, m);
			var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
			if (selectsEnd || selectsRange) return isSameMonth$2(_month, selectingDate);
			else return isSameMonth$2(_month, endDate);
		};
		_this.isInSelectingRangeQuarter = function(q) {
			var _a;
			var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
			var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
			if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) return false;
			if (selectsStart && endDate) return isQuarterInRange(selectingDate, endDate, q, day);
			if (selectsEnd && startDate) return isQuarterInRange(startDate, selectingDate, q, day);
			if (selectsRange && startDate && !endDate) return isQuarterInRange(startDate, selectingDate, q, day);
			return false;
		};
		_this.isWeekInMonth = function(startOfWeek) {
			var day = _this.props.day;
			var endOfWeek = addDays(startOfWeek, 6);
			return isSameMonth$2(startOfWeek, day) || isSameMonth$2(endOfWeek, day);
		};
		_this.isCurrentMonth = function(day, m) {
			return getYear(day) === getYear(newDate()) && m === getMonth(newDate());
		};
		_this.isCurrentQuarter = function(day, q) {
			return getYear(day) === getYear(newDate()) && q === getQuarter(newDate());
		};
		_this.isSelectedMonth = function(day, m, selected) {
			return getMonth(selected) === m && getYear(day) === getYear(selected);
		};
		_this.isSelectMonthInList = function(day, m, selectedDates) {
			return selectedDates.some(function(selectedDate) {
				return _this.isSelectedMonth(day, m, selectedDate);
			});
		};
		_this.isSelectedQuarter = function(day, q, selected) {
			return getQuarter(selected) === q && getYear(day) === getYear(selected);
		};
		_this.isSelectQuarterInList = function(day, q, selectedDates) {
			return selectedDates.some(function(selectedDate) {
				return _this.isSelectedQuarter(day, q, selectedDate);
			});
		};
		_this.isMonthSelected = function() {
			var _a = _this.props, day = _a.day, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
			var monthIdx = getMonth(day);
			if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(date) {
				return _this.isSelectedMonth(day, monthIdx, date);
			});
			return !!selected && _this.isSelectedMonth(day, monthIdx, selected);
		};
		_this.isQuarterSelected = function() {
			var _a = _this.props, day = _a.day, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
			var quarterIdx = getQuarter(day);
			if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(selectedDate) {
				return _this.isSelectedQuarter(day, quarterIdx, selectedDate);
			});
			return !!selected && _this.isSelectedQuarter(day, quarterIdx, selected);
		};
		_this.renderWeeks = function() {
			if (!isValid$2(_this.props.day)) return [];
			var weeks = [];
			var isFixedHeight = _this.props.fixedHeight;
			var i = 0;
			var breakAfterNextPush = false;
			var currentWeekStart = getStartOfWeek(getStartOfMonth(_this.props.day), _this.props.locale, _this.props.calendarStartDay);
			var isPreSelected = function(preSelection) {
				return _this.props.showWeekPicker ? getStartOfWeek(preSelection, _this.props.locale, _this.props.calendarStartDay) : _this.props.preSelection;
			};
			var isSelected = function(selected) {
				return _this.props.showWeekPicker ? getStartOfWeek(selected, _this.props.locale, _this.props.calendarStartDay) : _this.props.selected;
			};
			var selected = _this.props.selected ? isSelected(_this.props.selected) : void 0;
			var preSelection = _this.props.preSelection ? isPreSelected(_this.props.preSelection) : void 0;
			while (true) {
				weeks.push(React.createElement(Week, _assign({}, _this.props, {
					ariaLabelPrefix: _this.props.weekAriaLabelPrefix,
					key: i,
					day: currentWeekStart,
					month: getMonth(_this.props.day),
					onDayClick: _this.handleDayClick,
					onDayMouseEnter: _this.handleDayMouseEnter,
					selected,
					preSelection,
					showWeekNumber: _this.props.showWeekNumbers
				})));
				if (breakAfterNextPush) break;
				i++;
				currentWeekStart = addWeeks(currentWeekStart, 1);
				var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
				var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
				if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
					if (_this.props.peekNextMonth) breakAfterNextPush = true;
					else break;
				}
			}
			return weeks;
		};
		_this.onMonthClick = function(event, m) {
			var _a = _this.isMonthDisabledForLabelDate(m), isDisabled = _a.isDisabled, labelDate = _a.labelDate;
			if (isDisabled) return;
			_this.handleDayClick(getStartOfMonth(labelDate), event);
		};
		_this.onMonthMouseEnter = function(m) {
			var _a = _this.isMonthDisabledForLabelDate(m), isDisabled = _a.isDisabled, labelDate = _a.labelDate;
			if (isDisabled) return;
			_this.handleDayMouseEnter(getStartOfMonth(labelDate));
		};
		_this.handleMonthNavigation = function(newMonth, newDate) {
			var _a, _b, _c, _d;
			(_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
			(_d = (_c = _this.MONTH_REFS[newMonth]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
		};
		_this.handleKeyboardNavigation = function(event, eventKey, month) {
			var _a;
			var _b = _this.props, selected = _b.selected, preSelection = _b.preSelection, setPreSelection = _b.setPreSelection, minDate = _b.minDate, maxDate = _b.maxDate, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker;
			if (!preSelection) return;
			var monthColumnsLayout = getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker);
			var verticalOffset = _this.getVerticalOffset(monthColumnsLayout);
			var monthsGrid = (_a = MONTH_COLUMNS[monthColumnsLayout]) === null || _a === void 0 ? void 0 : _a.grid;
			var calculateNewDateAndMonth = function(eventKey, date, month) {
				var _a, _b;
				var newCalculatedDate = date;
				var newCalculatedMonth = month;
				switch (eventKey) {
					case KeyType.ArrowRight:
						newCalculatedDate = addMonths(date, MONTH_NAVIGATION_HORIZONTAL_OFFSET);
						newCalculatedMonth = month === 11 ? 0 : month + MONTH_NAVIGATION_HORIZONTAL_OFFSET;
						break;
					case KeyType.ArrowLeft:
						newCalculatedDate = subMonths(date, MONTH_NAVIGATION_HORIZONTAL_OFFSET);
						newCalculatedMonth = month === 0 ? 11 : month - MONTH_NAVIGATION_HORIZONTAL_OFFSET;
						break;
					case KeyType.ArrowUp:
						newCalculatedDate = subMonths(date, verticalOffset);
						newCalculatedMonth = ((_a = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[0]) === null || _a === void 0 ? void 0 : _a.includes(month)) ? month + 12 - verticalOffset : month - verticalOffset;
						break;
					case KeyType.ArrowDown:
						newCalculatedDate = addMonths(date, verticalOffset);
						newCalculatedMonth = ((_b = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[monthsGrid.length - 1]) === null || _b === void 0 ? void 0 : _b.includes(month)) ? month - 12 + verticalOffset : month + verticalOffset;
				}
				return {
					newCalculatedDate,
					newCalculatedMonth
				};
			};
			var getNewDateAndMonth = function(eventKey, selectedDate, month) {
				var MAX_ITERATIONS = 40;
				var eventKeyCopy = eventKey;
				var validDateFound = false;
				var iterations = 0;
				var _a = calculateNewDateAndMonth(eventKeyCopy, selectedDate, month), newCalculatedDate = _a.newCalculatedDate, newCalculatedMonth = _a.newCalculatedMonth;
				while (!validDateFound) {
					if (iterations >= MAX_ITERATIONS) {
						newCalculatedDate = selectedDate;
						newCalculatedMonth = month;
						break;
					}
					if (minDate && newCalculatedDate < minDate) {
						eventKeyCopy = KeyType.ArrowRight;
						var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
						newCalculatedDate = obj.newCalculatedDate;
						newCalculatedMonth = obj.newCalculatedMonth;
					}
					if (maxDate && newCalculatedDate > maxDate) {
						eventKeyCopy = KeyType.ArrowLeft;
						var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
						newCalculatedDate = obj.newCalculatedDate;
						newCalculatedMonth = obj.newCalculatedMonth;
					}
					if (isMonthYearDisabled(newCalculatedDate, _this.props)) {
						var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
						newCalculatedDate = obj.newCalculatedDate;
						newCalculatedMonth = obj.newCalculatedMonth;
					} else validDateFound = true;
					iterations++;
				}
				return {
					newCalculatedDate,
					newCalculatedMonth
				};
			};
			if (eventKey === KeyType.Enter) {
				if (!_this.isMonthDisabled(month)) {
					_this.onMonthClick(event, month);
					setPreSelection === null || setPreSelection === void 0 || setPreSelection(selected);
				}
				return;
			}
			var _c = getNewDateAndMonth(eventKey, preSelection, month), newCalculatedDate = _c.newCalculatedDate, newCalculatedMonth = _c.newCalculatedMonth;
			switch (eventKey) {
				case KeyType.ArrowRight:
				case KeyType.ArrowLeft:
				case KeyType.ArrowUp:
				case KeyType.ArrowDown: _this.handleMonthNavigation(newCalculatedMonth, newCalculatedDate);
			}
		};
		_this.getVerticalOffset = function(monthColumnsLayout) {
			var _a, _b;
			return (_b = (_a = MONTH_COLUMNS[monthColumnsLayout]) === null || _a === void 0 ? void 0 : _a.verticalNavigationOffset) !== null && _b !== void 0 ? _b : 0;
		};
		_this.onMonthKeyDown = function(event, month) {
			var _a = _this.props, disabledKeyboardNavigation = _a.disabledKeyboardNavigation, handleOnMonthKeyDown = _a.handleOnMonthKeyDown;
			var eventKey = event.key;
			if (eventKey !== KeyType.Tab) event.preventDefault();
			if (!disabledKeyboardNavigation) _this.handleKeyboardNavigation(event, eventKey, month);
			handleOnMonthKeyDown && handleOnMonthKeyDown(event);
		};
		_this.onQuarterClick = function(event, q) {
			var labelDate = setQuarter(_this.props.day, q);
			if (isQuarterDisabled(labelDate, _this.props)) return;
			_this.handleDayClick(getStartOfQuarter(labelDate), event);
		};
		_this.onQuarterMouseEnter = function(q) {
			var labelDate = setQuarter(_this.props.day, q);
			if (isQuarterDisabled(labelDate, _this.props)) return;
			_this.handleDayMouseEnter(getStartOfQuarter(labelDate));
		};
		_this.handleQuarterNavigation = function(newQuarter, newDate) {
			var _a, _b, _c, _d;
			if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
			(_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
			(_d = (_c = _this.QUARTER_REFS[newQuarter - 1]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
		};
		_this.onQuarterKeyDown = function(event, quarter) {
			var _a, _b;
			var eventKey = event.key;
			if (!_this.props.disabledKeyboardNavigation) switch (eventKey) {
				case KeyType.Enter:
					_this.onQuarterClick(event, quarter);
					(_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, _this.props.selected);
					break;
				case KeyType.ArrowRight:
					if (!_this.props.preSelection) break;
					_this.handleQuarterNavigation(quarter === 4 ? 1 : quarter + 1, addQuarters(_this.props.preSelection, 1));
					break;
				case KeyType.ArrowLeft:
					if (!_this.props.preSelection) break;
					_this.handleQuarterNavigation(quarter === 1 ? 4 : quarter - 1, subQuarters(_this.props.preSelection, 1));
			}
		};
		_this.isMonthDisabledForLabelDate = function(month) {
			var _a;
			var _b = _this.props, day = _b.day, disabled = _b.disabled, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
			var labelDate = setMonth(day, month);
			if (disabled) return {
				isDisabled: true,
				labelDate: setMonth(day, month)
			};
			return {
				isDisabled: (_a = (minDate || maxDate || excludeDates || includeDates) && isMonthDisabled(labelDate, _this.props)) !== null && _a !== void 0 ? _a : false,
				labelDate
			};
		};
		_this.isMonthDisabled = function(month) {
			return _this.isMonthDisabledForLabelDate(month).isDisabled;
		};
		_this.getMonthClassNames = function(m) {
			var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate, preSelection = _a.preSelection, monthClassName = _a.monthClassName;
			var _monthClassName = monthClassName ? monthClassName(setMonth(day, m)) : void 0;
			var selection = _this.getSelection();
			return clsx("react-datepicker__month-text", "react-datepicker__month-".concat(m), _monthClassName, {
				"react-datepicker__month-text--disabled": _this.isMonthDisabled(m),
				"react-datepicker__month-text--selected": selection ? _this.isSelectMonthInList(day, m, selection) : void 0,
				"react-datepicker__month-text--keyboard-selected": !_this.props.disabledKeyboardNavigation && preSelection && _this.isSelectedMonth(day, m, preSelection) && !_this.isMonthSelected() && !_this.isMonthDisabled(m),
				"react-datepicker__month-text--in-selecting-range": _this.isInSelectingRangeMonth(m),
				"react-datepicker__month-text--in-range": startDate && endDate ? isMonthInRange(startDate, endDate, m, day) : void 0,
				"react-datepicker__month-text--range-start": _this.isRangeStartMonth(m),
				"react-datepicker__month-text--range-end": _this.isRangeEndMonth(m),
				"react-datepicker__month-text--selecting-range-start": _this.isSelectingMonthRangeStart(m),
				"react-datepicker__month-text--selecting-range-end": _this.isSelectingMonthRangeEnd(m),
				"react-datepicker__month-text--today": _this.isCurrentMonth(day, m)
			});
		};
		_this.getTabIndex = function(m) {
			if (_this.props.preSelection == null) return "-1";
			var preSelectedMonth = getMonth(_this.props.preSelection);
			var isPreSelectedMonthDisabled = _this.isMonthDisabledForLabelDate(preSelectedMonth).isDisabled;
			return m === preSelectedMonth && !(isPreSelectedMonthDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
		};
		_this.getQuarterTabIndex = function(q) {
			if (_this.props.preSelection == null) return "-1";
			var preSelectedQuarter = getQuarter(_this.props.preSelection);
			var isCurrentQuarterDisabled = isQuarterDisabled(_this.props.day, _this.props);
			return q === preSelectedQuarter && !(isCurrentQuarterDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
		};
		_this.getAriaLabel = function(month) {
			var _a = _this.props, _b = _a.chooseDayAriaLabelPrefix, chooseDayAriaLabelPrefix = _b === void 0 ? "Choose" : _b, _c = _a.disabledDayAriaLabelPrefix, disabledDayAriaLabelPrefix = _c === void 0 ? "Not available" : _c, day = _a.day, locale = _a.locale;
			var labelDate = setMonth(day, month);
			var prefix = _this.isDisabled(labelDate) || _this.isExcluded(labelDate) ? disabledDayAriaLabelPrefix : chooseDayAriaLabelPrefix;
			return "".concat(prefix, " ").concat(formatDate(labelDate, "MMMM yyyy", locale));
		};
		_this.getQuarterClassNames = function(q) {
			var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, preSelection = _a.preSelection, disabledKeyboardNavigation = _a.disabledKeyboardNavigation, disabled = _a.disabled;
			var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate || disabled) && isQuarterDisabled(setQuarter(day, q), _this.props);
			var selection = _this.getSelection();
			return clsx("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(q), {
				"react-datepicker__quarter-text--disabled": isDisabled,
				"react-datepicker__quarter-text--selected": selection ? _this.isSelectQuarterInList(day, q, selection) : void 0,
				"react-datepicker__quarter-text--keyboard-selected": !disabledKeyboardNavigation && preSelection && _this.isSelectedQuarter(day, q, preSelection) && !_this.isQuarterSelected() && !isDisabled,
				"react-datepicker__quarter-text--in-selecting-range": _this.isInSelectingRangeQuarter(q),
				"react-datepicker__quarter-text--in-range": startDate && endDate ? isQuarterInRange(startDate, endDate, q, day) : void 0,
				"react-datepicker__quarter-text--range-start": _this.isRangeStartQuarter(q),
				"react-datepicker__quarter-text--range-end": _this.isRangeEndQuarter(q),
				"react-datepicker__quarter-text--today": _this.isCurrentQuarter(day, q)
			});
		};
		_this.getMonthContent = function(m) {
			var _a = _this.props, showFullMonthYearPicker = _a.showFullMonthYearPicker, renderMonthContent = _a.renderMonthContent, locale = _a.locale, day = _a.day;
			var shortMonthText = getMonthShortInLocale(m, locale);
			var fullMonthText = getMonthInLocale(m, locale);
			if (renderMonthContent) return renderMonthContent(m, shortMonthText, fullMonthText, day);
			return showFullMonthYearPicker ? fullMonthText : shortMonthText;
		};
		_this.getQuarterContent = function(q) {
			var _a;
			var _b = _this.props, renderQuarterContent = _b.renderQuarterContent, locale = _b.locale;
			var shortQuarter = getQuarterShortInLocale(q, locale);
			return (_a = renderQuarterContent === null || renderQuarterContent === void 0 ? void 0 : renderQuarterContent(q, shortQuarter)) !== null && _a !== void 0 ? _a : shortQuarter;
		};
		_this.renderMonths = function() {
			var _a;
			var _b = _this.props, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, day = _b.day, selected = _b.selected;
			var monthColumns = (_a = MONTH_COLUMNS[getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker)]) === null || _a === void 0 ? void 0 : _a.grid;
			return monthColumns === null || monthColumns === void 0 ? void 0 : monthColumns.map(function(month, i) {
				return React.createElement("div", {
					className: "react-datepicker__month-wrapper",
					key: i
				}, month.map(function(m, j) {
					return React.createElement("div", {
						ref: _this.MONTH_REFS[m],
						key: j,
						onClick: function(event) {
							_this.onMonthClick(event, m);
						},
						onKeyDown: function(event) {
							if (isSpaceKeyDown(event)) {
								event.preventDefault();
								event.key = KeyType.Enter;
							}
							_this.onMonthKeyDown(event, m);
						},
						onMouseEnter: !_this.props.usePointerEvent ? function() {
							return _this.onMonthMouseEnter(m);
						} : void 0,
						onPointerEnter: _this.props.usePointerEvent ? function() {
							return _this.onMonthMouseEnter(m);
						} : void 0,
						tabIndex: Number(_this.getTabIndex(m)),
						className: _this.getMonthClassNames(m),
						"aria-disabled": _this.isMonthDisabled(m),
						role: "option",
						"aria-label": _this.getAriaLabel(m),
						"aria-current": _this.isCurrentMonth(day, m) ? "date" : void 0,
						"aria-selected": selected ? _this.isSelectedMonth(day, m, selected) : void 0
					}, _this.getMonthContent(m));
				}));
			});
		};
		_this.renderQuarters = function() {
			var _a = _this.props, day = _a.day, selected = _a.selected;
			return React.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [
				1,
				2,
				3,
				4
			].map(function(q, j) {
				return React.createElement("div", {
					key: j,
					ref: _this.QUARTER_REFS[j],
					role: "option",
					onClick: function(event) {
						_this.onQuarterClick(event, q);
					},
					onKeyDown: function(event) {
						_this.onQuarterKeyDown(event, q);
					},
					onMouseEnter: !_this.props.usePointerEvent ? function() {
						return _this.onQuarterMouseEnter(q);
					} : void 0,
					onPointerEnter: _this.props.usePointerEvent ? function() {
						return _this.onQuarterMouseEnter(q);
					} : void 0,
					className: _this.getQuarterClassNames(q),
					"aria-selected": selected ? _this.isSelectedQuarter(day, q, selected) : void 0,
					tabIndex: Number(_this.getQuarterTabIndex(q)),
					"aria-current": _this.isCurrentQuarter(day, q) ? "date" : void 0
				}, _this.getQuarterContent(q));
			}));
		};
		_this.getClassNames = function() {
			var _a = _this.props, selectingDate = _a.selectingDate, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, showMonthYearPicker = _a.showMonthYearPicker, showQuarterYearPicker = _a.showQuarterYearPicker, showWeekPicker = _a.showWeekPicker;
			return clsx("react-datepicker__month", { "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd) }, { "react-datepicker__monthPicker": showMonthYearPicker }, { "react-datepicker__quarterPicker": showQuarterYearPicker }, { "react-datepicker__weekPicker": showWeekPicker });
		};
		return _this;
	}
	Month.prototype.getSelection = function() {
		var _a = this.props, selected = _a.selected, selectedDates = _a.selectedDates;
		if (_a.selectsMultiple) return selectedDates;
		if (selected) return [selected];
	};
	Month.prototype.render = function() {
		var _a = this.props, showMonthYearPicker = _a.showMonthYearPicker, showQuarterYearPicker = _a.showQuarterYearPicker, day = _a.day, _b = _a.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? "Month " : _b;
		var formattedAriaLabelPrefix = ariaLabelPrefix ? ariaLabelPrefix.trim() + " " : "";
		var formattedAriaLabel = isValid$2(day) ? "".concat(formattedAriaLabelPrefix).concat(formatDate(day, "MMMM, yyyy", this.props.locale)) : "";
		if (showMonthYearPicker || showQuarterYearPicker) return React.createElement("div", {
			className: this.getClassNames(),
			onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : void 0,
			onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
			"aria-label": formattedAriaLabel,
			role: "listbox"
		}, showMonthYearPicker ? this.renderMonths() : this.renderQuarters());
		return React.createElement("div", { role: "table" }, this.props.dayNamesHeader && React.createElement("div", { role: "rowgroup" }, this.props.dayNamesHeader), this.props.monthHeader && React.createElement("div", { role: "rowgroup" }, this.props.monthHeader), React.createElement("div", {
			className: this.getClassNames(),
			onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : void 0,
			onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
			"aria-label": formattedAriaLabel,
			role: "rowgroup"
		}, this.renderWeeks()), this.props.monthFooter && React.createElement("div", { role: "rowgroup" }, this.props.monthFooter));
	};
	return Month;
}(Component);
var MonthDropdownOptions = function(_super) {
	__extends(MonthDropdownOptions, _super);
	function MonthDropdownOptions() {
		var _this = _super !== null && _super.apply(this, arguments) || this;
		_this.monthOptionButtonsRef = {};
		_this.isSelectedMonth = function(i) {
			return _this.props.month === i;
		};
		_this.handleOptionKeyDown = function(i, e) {
			var _a;
			switch (e.key) {
				case "Enter":
					e.preventDefault();
					_this.onChange(i);
					break;
				case "Escape":
					e.preventDefault();
					_this.props.onCancel();
					break;
				case "ArrowUp":
				case "ArrowDown":
					e.preventDefault();
					var newMonth = (i + (e.key === "ArrowUp" ? -1 : 1) + _this.props.monthNames.length) % _this.props.monthNames.length;
					(_a = _this.monthOptionButtonsRef[newMonth]) === null || _a === void 0 || _a.focus();
			}
		};
		_this.renderOptions = function() {
			_this.monthOptionButtonsRef = {};
			return _this.props.monthNames.map(function(month, i) {
				return React.createElement("div", {
					ref: function(el) {
						_this.monthOptionButtonsRef[i] = el;
						if (_this.isSelectedMonth(i)) el === null || el === void 0 || el.focus();
					},
					role: "button",
					tabIndex: 0,
					className: _this.isSelectedMonth(i) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
					key: month,
					onClick: _this.onChange.bind(_this, i),
					onKeyDown: _this.handleOptionKeyDown.bind(_this, i),
					"aria-selected": _this.isSelectedMonth(i) ? "true" : void 0
				}, _this.isSelectedMonth(i) ? React.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", month);
			});
		};
		_this.onChange = function(month) {
			return _this.props.onChange(month);
		};
		_this.handleClickOutside = function() {
			return _this.props.onCancel();
		};
		return _this;
	}
	MonthDropdownOptions.prototype.render = function() {
		return React.createElement(ClickOutsideWrapper, {
			className: "react-datepicker__month-dropdown",
			onClickOutside: this.handleClickOutside
		}, this.renderOptions());
	};
	return MonthDropdownOptions;
}(Component);
var MonthDropdown = function(_super) {
	__extends(MonthDropdown, _super);
	function MonthDropdown() {
		var _this = _super !== null && _super.apply(this, arguments) || this;
		_this.state = { dropdownVisible: false };
		_this.renderSelectOptions = function(monthNames) {
			return monthNames.map(function(m, i) {
				return React.createElement("option", {
					key: m,
					value: i
				}, m);
			});
		};
		_this.renderSelectMode = function(monthNames) {
			return React.createElement("select", {
				value: _this.props.month,
				className: "react-datepicker__month-select",
				onChange: function(e) {
					return _this.onChange(parseInt(e.target.value));
				}
			}, _this.renderSelectOptions(monthNames));
		};
		_this.renderReadView = function(visible, monthNames) {
			return React.createElement("button", {
				key: "read",
				type: "button",
				style: { visibility: visible ? "visible" : "hidden" },
				className: "react-datepicker__month-read-view",
				onClick: _this.toggleDropdown
			}, React.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), React.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, monthNames[_this.props.month]));
		};
		_this.renderDropdown = function(monthNames) {
			return React.createElement(MonthDropdownOptions, _assign({ key: "dropdown" }, _this.props, {
				monthNames,
				onChange: _this.onChange,
				onCancel: _this.toggleDropdown
			}));
		};
		_this.renderScrollMode = function(monthNames) {
			var dropdownVisible = _this.state.dropdownVisible;
			var result = [_this.renderReadView(!dropdownVisible, monthNames)];
			if (dropdownVisible) result.unshift(_this.renderDropdown(monthNames));
			return result;
		};
		_this.onChange = function(month) {
			_this.toggleDropdown();
			if (month !== _this.props.month) _this.props.onChange(month);
		};
		_this.toggleDropdown = function() {
			return _this.setState({ dropdownVisible: !_this.state.dropdownVisible });
		};
		return _this;
	}
	MonthDropdown.prototype.render = function() {
		var _this = this;
		var monthNames = [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			10,
			11
		].map(this.props.useShortMonthInDropdown ? function(m) {
			return getMonthShortInLocale(m, _this.props.locale);
		} : function(m) {
			return getMonthInLocale(m, _this.props.locale);
		});
		var renderedDropdown;
		switch (this.props.dropdownMode) {
			case "scroll":
				renderedDropdown = this.renderScrollMode(monthNames);
				break;
			case "select": renderedDropdown = this.renderSelectMode(monthNames);
		}
		return React.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, renderedDropdown);
	};
	return MonthDropdown;
}(Component);
var DEFAULT_YEAR_RANGE$1 = 5;
function generateMonthYears(minDate, maxDate, currentDate) {
	var list = [];
	var effectiveMinDate = minDate !== null && minDate !== void 0 ? minDate : subYears(currentDate, DEFAULT_YEAR_RANGE$1);
	var effectiveMaxDate = maxDate !== null && maxDate !== void 0 ? maxDate : addYears(currentDate, DEFAULT_YEAR_RANGE$1);
	var currDate = getStartOfMonth(effectiveMinDate);
	var lastDate = getStartOfMonth(effectiveMaxDate);
	while (!isAfter(currDate, lastDate)) {
		list.push(newDate(currDate));
		currDate = addMonths(currDate, 1);
	}
	return list;
}
var MonthYearDropdownOptions = function(_super) {
	__extends(MonthYearDropdownOptions, _super);
	function MonthYearDropdownOptions(props) {
		var _this = _super.call(this, props) || this;
		_this.renderOptions = function() {
			return _this.state.monthYearsList.map(function(monthYear) {
				var monthYearPoint = getTime(monthYear);
				var isSameMonthYear = isSameYear$2(_this.props.date, monthYear) && isSameMonth$2(_this.props.date, monthYear);
				return React.createElement("div", {
					className: isSameMonthYear ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
					key: monthYearPoint,
					onClick: _this.onChange.bind(_this, monthYearPoint),
					"aria-selected": isSameMonthYear ? "true" : void 0
				}, isSameMonthYear ? React.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", formatDate(monthYear, _this.props.dateFormat, _this.props.locale));
			});
		};
		_this.onChange = function(monthYear) {
			return _this.props.onChange(monthYear);
		};
		_this.handleClickOutside = function() {
			_this.props.onCancel();
		};
		_this.state = { monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate, _this.props.date) };
		return _this;
	}
	MonthYearDropdownOptions.prototype.render = function() {
		var dropdownClass = clsx({
			"react-datepicker__month-year-dropdown": true,
			"react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
		});
		return React.createElement(ClickOutsideWrapper, {
			className: dropdownClass,
			onClickOutside: this.handleClickOutside
		}, this.renderOptions());
	};
	return MonthYearDropdownOptions;
}(Component);
var DEFAULT_YEAR_RANGE = 5;
var MonthYearDropdown = function(_super) {
	__extends(MonthYearDropdown, _super);
	function MonthYearDropdown() {
		var _this = _super !== null && _super.apply(this, arguments) || this;
		_this.state = { dropdownVisible: false };
		_this.renderSelectOptions = function() {
			var _a, _b;
			var minDate = (_a = _this.props.minDate) !== null && _a !== void 0 ? _a : subYears(_this.props.date, DEFAULT_YEAR_RANGE);
			var maxDate = (_b = _this.props.maxDate) !== null && _b !== void 0 ? _b : addYears(_this.props.date, DEFAULT_YEAR_RANGE);
			var currDate = getStartOfMonth(minDate);
			var lastDate = getStartOfMonth(maxDate);
			var options = [];
			while (!isAfter(currDate, lastDate)) {
				var timePoint = getTime(currDate);
				options.push(React.createElement("option", {
					key: timePoint,
					value: timePoint
				}, formatDate(currDate, _this.props.dateFormat, _this.props.locale)));
				currDate = addMonths(currDate, 1);
			}
			return options;
		};
		_this.onSelectChange = function(event) {
			_this.onChange(parseInt(event.target.value));
		};
		_this.renderSelectMode = function() {
			return React.createElement("select", {
				value: getTime(getStartOfMonth(_this.props.date)),
				className: "react-datepicker__month-year-select",
				onChange: _this.onSelectChange
			}, _this.renderSelectOptions());
		};
		_this.renderReadView = function(visible) {
			var yearMonth = formatDate(_this.props.date, _this.props.dateFormat, _this.props.locale);
			return React.createElement("div", {
				key: "read",
				style: { visibility: visible ? "visible" : "hidden" },
				className: "react-datepicker__month-year-read-view",
				onClick: _this.toggleDropdown
			}, React.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), React.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, yearMonth));
		};
		_this.renderDropdown = function() {
			return React.createElement(MonthYearDropdownOptions, _assign({ key: "dropdown" }, _this.props, {
				onChange: _this.onChange,
				onCancel: _this.toggleDropdown
			}));
		};
		_this.renderScrollMode = function() {
			var dropdownVisible = _this.state.dropdownVisible;
			var result = [_this.renderReadView(!dropdownVisible)];
			if (dropdownVisible) result.unshift(_this.renderDropdown());
			return result;
		};
		_this.onChange = function(monthYearPoint) {
			_this.toggleDropdown();
			var changedDate = newDate(monthYearPoint);
			if (isSameYear$2(_this.props.date, changedDate) && isSameMonth$2(_this.props.date, changedDate)) return;
			_this.props.onChange(changedDate);
		};
		_this.toggleDropdown = function() {
			return _this.setState({ dropdownVisible: !_this.state.dropdownVisible });
		};
		return _this;
	}
	MonthYearDropdown.prototype.render = function() {
		var renderedDropdown;
		switch (this.props.dropdownMode) {
			case "scroll":
				renderedDropdown = this.renderScrollMode();
				break;
			case "select": renderedDropdown = this.renderSelectMode();
		}
		return React.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, renderedDropdown);
	};
	return MonthYearDropdown;
}(Component);
var Time = function(_super) {
	__extends(Time, _super);
	function Time() {
		var _this = _super !== null && _super.apply(this, arguments) || this;
		_this.state = { height: null };
		_this.scrollToTheSelectedTime = function() {
			requestAnimationFrame(function() {
				var _a, _b, _c;
				if (!_this.list) return;
				_this.list.scrollTop = (_c = _this.centerLi && Time.calcCenterPosition(_this.props.monthRef ? _this.props.monthRef.clientHeight - ((_b = (_a = _this.header) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0) : _this.list.clientHeight, _this.centerLi)) !== null && _c !== void 0 ? _c : 0;
			});
		};
		_this.handleClick = function(time) {
			var _a, _b;
			if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && isTimeDisabled(time, _this.props)) return;
			(_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, time);
		};
		_this.isSelectedTime = function(time) {
			var selected = safeToDate(_this.props.selected);
			return selected && isSameMinute(selected, time);
		};
		_this.isDisabledTime = function(time) {
			return (_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && isTimeDisabled(time, _this.props);
		};
		_this.liClasses = function(time) {
			var _a;
			var classes = ["react-datepicker__time-list-item", _this.props.timeClassName ? _this.props.timeClassName(time) : void 0];
			if (_this.isSelectedTime(time)) classes.push("react-datepicker__time-list-item--selected");
			if (_this.isDisabledTime(time)) classes.push("react-datepicker__time-list-item--disabled");
			if (_this.props.injectTimes && (getHours(time) * 3600 + getMinutes(time) * 60 + getSeconds(time)) % (((_a = _this.props.intervals) !== null && _a !== void 0 ? _a : Time.defaultProps.intervals) * 60) !== 0) classes.push("react-datepicker__time-list-item--injected");
			return classes.join(" ");
		};
		_this.handleOnKeyDown = function(event, time) {
			var _a, _b;
			if (event.key === KeyType.Space) {
				event.preventDefault();
				event.key = KeyType.Enter;
			}
			if ((event.key === KeyType.ArrowUp || event.key === KeyType.ArrowLeft) && event.target instanceof HTMLElement && event.target.previousSibling) {
				event.preventDefault();
				event.target.previousSibling instanceof HTMLElement && event.target.previousSibling.focus();
			}
			if ((event.key === KeyType.ArrowDown || event.key === KeyType.ArrowRight) && event.target instanceof HTMLElement && event.target.nextSibling) {
				event.preventDefault();
				event.target.nextSibling instanceof HTMLElement && event.target.nextSibling.focus();
			}
			if (event.key === KeyType.Enter) _this.handleClick(time);
			(_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
		};
		_this.renderTimes = function() {
			var _a;
			var times = [];
			var format = typeof _this.props.format === "string" ? _this.props.format : "p";
			var intervals = (_a = _this.props.intervals) !== null && _a !== void 0 ? _a : Time.defaultProps.intervals;
			var activeDate = safeToDate(_this.props.selected) || safeToDate(_this.props.openToDate) || newDate();
			var base = getStartOfDay(activeDate);
			var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function(a, b) {
				return a.getTime() - b.getTime();
			});
			var multiplier = 60 * getHoursInDay(activeDate) / intervals;
			for (var i = 0; i < multiplier; i++) {
				var currentTime = addMinutes(base, i * intervals);
				times.push(currentTime);
				if (sortedInjectTimes) {
					var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
					times = times.concat(timesToInject);
				}
			}
			var timeToFocus = times.reduce(function(prev, time) {
				if (time.getTime() <= activeDate.getTime()) return time;
				return prev;
			}, times[0]);
			return times.map(function(time) {
				return React.createElement("li", {
					key: time.valueOf(),
					onClick: _this.handleClick.bind(_this, time),
					className: _this.liClasses(time),
					ref: function(li) {
						if (time === timeToFocus) _this.centerLi = li;
					},
					onKeyDown: function(event) {
						_this.handleOnKeyDown(event, time);
					},
					tabIndex: time === timeToFocus ? 0 : -1,
					role: "option",
					"aria-selected": _this.isSelectedTime(time) ? "true" : void 0,
					"aria-disabled": _this.isDisabledTime(time) ? "true" : void 0
				}, formatDate(time, format, _this.props.locale));
			});
		};
		_this.renderTimeCaption = function() {
			if (_this.props.showTimeCaption === false) return React.createElement(React.Fragment, null);
			return React.createElement("div", {
				className: "react-datepicker__header react-datepicker__header--time ".concat(_this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
				ref: function(header) {
					_this.header = header;
				}
			}, React.createElement("div", { className: "react-datepicker-time__header" }, _this.props.timeCaption));
		};
		return _this;
	}
	Object.defineProperty(Time, "defaultProps", {
		get: function() {
			return {
				intervals: 30,
				todayButton: null,
				timeCaption: "Time",
				showTimeCaption: true
			};
		},
		enumerable: false,
		configurable: true
	});
	Time.prototype.componentDidMount = function() {
		this.scrollToTheSelectedTime();
		this.observeDatePickerHeightChanges();
	};
	Time.prototype.componentWillUnmount = function() {
		var _a;
		(_a = this.resizeObserver) === null || _a === void 0 || _a.disconnect();
	};
	Time.prototype.observeDatePickerHeightChanges = function() {
		var _this = this;
		var monthRef = this.props.monthRef;
		this.updateContainerHeight();
		if (monthRef) {
			this.resizeObserver = new ResizeObserver(function() {
				_this.updateContainerHeight();
			});
			this.resizeObserver.observe(monthRef);
		}
	};
	Time.prototype.updateContainerHeight = function() {
		if (this.props.monthRef && this.header) {
			var newHeight = this.props.monthRef.clientHeight - this.header.clientHeight;
			if (this.state.height !== newHeight) this.setState({ height: newHeight });
		}
	};
	Time.prototype.render = function() {
		var _this = this;
		var _a;
		var height = this.state.height;
		return React.createElement("div", { className: "react-datepicker__time-container ".concat(((_a = this.props.todayButton) !== null && _a !== void 0 ? _a : Time.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "") }, this.renderTimeCaption(), React.createElement("div", { className: "react-datepicker__time" }, React.createElement("div", { className: "react-datepicker__time-box" }, React.createElement("ul", {
			className: "react-datepicker__time-list",
			ref: function(list) {
				_this.list = list;
			},
			style: height ? { height } : {},
			role: "listbox",
			"aria-label": this.props.timeCaption
		}, this.renderTimes()))));
	};
	Time.calcCenterPosition = function(listHeight, centerLiRef) {
		return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
	};
	return Time;
}(Component);
var VERTICAL_NAVIGATION_OFFSET = 3;
/**
* `Year` is a component that represents a year in a date picker.
*
* @class
* @param {YearProps} props - The properties that define the `Year` component.
* @property {VoidFunction} [props.clearSelectingDate] - Function to clear the selected date.
* @property {Date} [props.date] - The currently selected date.
* @property {boolean} [props.disabledKeyboardNavigation] - If true, keyboard navigation is disabled.
* @property {Date} [props.endDate] - The end date in a range selection.
* @property {(date: Date) => void} props.onDayClick - Function to handle day click events.
* @property {Date} props.preSelection - The date that is currently in focus.
* @property {(date: Date) => void} props.setPreSelection - Function to set the pre-selected date.
* @property {{ [key: string]: any }} props.selected - The selected date(s).
* @property {boolean} props.inline - If true, the date picker is displayed inline.
* @property {Date} props.maxDate - The maximum selectable date.
* @property {Date} props.minDate - The minimum selectable date.
* @property {boolean} props.usePointerEvent - If true, pointer events are used instead of mouse events.
* @property {(date: Date) => void} props.onYearMouseEnter - Function to handle mouse enter events on a year.
* @property {(date: Date) => void} props.onYearMouseLeave - Function to handle mouse leave events on a year.
*/
var Year = function(_super) {
	__extends(Year, _super);
	function Year(props) {
		var _this = _super.call(this, props) || this;
		_this.YEAR_REFS = __spreadArray([], Array(_this.props.yearItemNumber), true).map(function() {
			return createRef();
		});
		_this.isDisabled = function(date) {
			return isDayDisabled(date, {
				minDate: _this.props.minDate,
				maxDate: _this.props.maxDate,
				excludeDates: _this.props.excludeDates,
				includeDates: _this.props.includeDates,
				filterDate: _this.props.filterDate
			});
		};
		_this.isExcluded = function(date) {
			return isDayExcluded(date, { excludeDates: _this.props.excludeDates });
		};
		_this.selectingDate = function() {
			var _a;
			return (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
		};
		_this.updateFocusOnPaginate = function(refIndex) {
			var waitForReRender = function() {
				var _a, _b;
				(_b = (_a = _this.YEAR_REFS[refIndex]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 || _b.focus();
			};
			window.requestAnimationFrame(waitForReRender);
		};
		_this.handleYearClick = function(day, event) {
			if (_this.props.onDayClick) _this.props.onDayClick(day, event);
		};
		_this.handleYearNavigation = function(newYear, newDate) {
			var _a, _b, _c, _d;
			var _e = _this.props, date = _e.date, yearItemNumber = _e.yearItemNumber;
			if (date === void 0 || yearItemNumber === void 0) return;
			var startPeriod = getYearsPeriod(date, yearItemNumber).startPeriod;
			if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
			(_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
			if (newYear - startPeriod < 0) _this.updateFocusOnPaginate(yearItemNumber - (startPeriod - newYear));
			else if (newYear - startPeriod >= yearItemNumber) _this.updateFocusOnPaginate(Math.abs(yearItemNumber - (newYear - startPeriod)));
			else (_d = (_c = _this.YEAR_REFS[newYear - startPeriod]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
		};
		_this.isSameDay = function(y, other) {
			return isSameDay$2(y, other);
		};
		_this.isCurrentYear = function(y) {
			return y === getYear(newDate());
		};
		_this.isRangeStart = function(y) {
			return _this.props.startDate && _this.props.endDate && isSameYear$2(setYear(newDate(), y), _this.props.startDate);
		};
		_this.isRangeEnd = function(y) {
			return _this.props.startDate && _this.props.endDate && isSameYear$2(setYear(newDate(), y), _this.props.endDate);
		};
		_this.isInRange = function(y) {
			return isYearInRange(y, _this.props.startDate, _this.props.endDate);
		};
		_this.isInSelectingRange = function(y) {
			var _a = _this.props, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, selectsRange = _a.selectsRange, startDate = _a.startDate, endDate = _a.endDate;
			if (!(selectsStart || selectsEnd || selectsRange) || !_this.selectingDate()) return false;
			if (selectsStart && endDate) return isYearInRange(y, _this.selectingDate(), endDate);
			if (selectsEnd && startDate) return isYearInRange(y, startDate, _this.selectingDate());
			if (selectsRange && startDate && !endDate) return isYearInRange(y, startDate, _this.selectingDate());
			return false;
		};
		_this.isSelectingRangeStart = function(y) {
			var _a;
			if (!_this.isInSelectingRange(y)) return false;
			var _b = _this.props, startDate = _b.startDate, selectsStart = _b.selectsStart;
			var _year = setYear(newDate(), y);
			if (selectsStart) return isSameYear$2(_year, (_a = _this.selectingDate()) !== null && _a !== void 0 ? _a : null);
			return isSameYear$2(_year, startDate !== null && startDate !== void 0 ? startDate : null);
		};
		_this.isSelectingRangeEnd = function(y) {
			var _a;
			if (!_this.isInSelectingRange(y)) return false;
			var _b = _this.props, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
			var _year = setYear(newDate(), y);
			if (selectsEnd || selectsRange) return isSameYear$2(_year, (_a = _this.selectingDate()) !== null && _a !== void 0 ? _a : null);
			return isSameYear$2(_year, endDate !== null && endDate !== void 0 ? endDate : null);
		};
		_this.isKeyboardSelected = function(y) {
			if (_this.props.disabledKeyboardNavigation || _this.props.date === void 0 || _this.props.preSelection == null) return;
			var _a = _this.props, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, selected = _a.selected;
			var date = getStartOfYear(setYear(_this.props.date, y));
			var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate) && isYearDisabled(y, _this.props);
			var isSelectedDay = !!selected && isSameDay$2(date, getStartOfYear(selected));
			var isKeyboardSelectedDay = isSameDay$2(date, getStartOfYear(_this.props.preSelection));
			return !_this.props.inline && !isSelectedDay && isKeyboardSelectedDay && !isDisabled;
		};
		_this.isSelectedYear = function(year) {
			var _a = _this.props, selectsMultiple = _a.selectsMultiple, selected = _a.selected, selectedDates = _a.selectedDates;
			if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(date) {
				return year === getYear(date);
			});
			return !!selected && year === getYear(selected);
		};
		_this.onYearClick = function(event, y) {
			var date = _this.props.date;
			if (date === void 0) return;
			_this.handleYearClick(getStartOfYear(setYear(date, y)), event);
		};
		_this.onYearKeyDown = function(event, y) {
			var _a, _b;
			var key = event.key;
			var _c = _this.props, date = _c.date, yearItemNumber = _c.yearItemNumber, handleOnKeyDown = _c.handleOnKeyDown;
			if (key !== KeyType.Tab) event.preventDefault();
			if (!_this.props.disabledKeyboardNavigation) switch (key) {
				case KeyType.Enter:
					if (_this.props.selected == null) break;
					_this.onYearClick(event, y);
					(_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, _this.props.selected);
					break;
				case KeyType.ArrowRight:
					if (_this.props.preSelection == null) break;
					_this.handleYearNavigation(y + 1, addYears(_this.props.preSelection, 1));
					break;
				case KeyType.ArrowLeft:
					if (_this.props.preSelection == null) break;
					_this.handleYearNavigation(y - 1, subYears(_this.props.preSelection, 1));
					break;
				case KeyType.ArrowUp:
					if (date === void 0 || yearItemNumber === void 0 || _this.props.preSelection == null) break;
					var startPeriod = getYearsPeriod(date, yearItemNumber).startPeriod;
					var offset = VERTICAL_NAVIGATION_OFFSET;
					var newYear = y - offset;
					if (newYear < startPeriod) {
						var leftOverOffset = yearItemNumber % offset;
						if (y >= startPeriod && y < startPeriod + leftOverOffset) offset = leftOverOffset;
						else offset += leftOverOffset;
						newYear = y - offset;
					}
					_this.handleYearNavigation(newYear, subYears(_this.props.preSelection, offset));
					break;
				case KeyType.ArrowDown:
					if (date === void 0 || yearItemNumber === void 0 || _this.props.preSelection == null) break;
					var endPeriod = getYearsPeriod(date, yearItemNumber).endPeriod;
					var offset = VERTICAL_NAVIGATION_OFFSET;
					var newYear = y + offset;
					if (newYear > endPeriod) {
						var leftOverOffset = yearItemNumber % offset;
						if (y <= endPeriod && y > endPeriod - leftOverOffset) offset = leftOverOffset;
						else offset += leftOverOffset;
						newYear = y + offset;
					}
					_this.handleYearNavigation(newYear, addYears(_this.props.preSelection, offset));
			}
			handleOnKeyDown && handleOnKeyDown(event);
		};
		_this.getYearClassNames = function(y) {
			var _a = _this.props, date = _a.date, disabled = _a.disabled, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, yearClassName = _a.yearClassName;
			return clsx("react-datepicker__year-text", "react-datepicker__year-".concat(y), date ? yearClassName === null || yearClassName === void 0 ? void 0 : yearClassName(setYear(date, y)) : void 0, {
				"react-datepicker__year-text--selected": _this.isSelectedYear(y),
				"react-datepicker__year-text--disabled": (minDate || maxDate || excludeDates || includeDates || filterDate || disabled) && isYearDisabled(y, _this.props),
				"react-datepicker__year-text--keyboard-selected": _this.isKeyboardSelected(y),
				"react-datepicker__year-text--range-start": _this.isRangeStart(y),
				"react-datepicker__year-text--range-end": _this.isRangeEnd(y),
				"react-datepicker__year-text--in-range": _this.isInRange(y),
				"react-datepicker__year-text--in-selecting-range": _this.isInSelectingRange(y),
				"react-datepicker__year-text--selecting-range-start": _this.isSelectingRangeStart(y),
				"react-datepicker__year-text--selecting-range-end": _this.isSelectingRangeEnd(y),
				"react-datepicker__year-text--today": _this.isCurrentYear(y)
			});
		};
		_this.getYearTabIndex = function(y) {
			if (_this.props.disabledKeyboardNavigation || _this.props.preSelection == null) return "-1";
			var preSelected = getYear(_this.props.preSelection);
			var isPreSelectedYearDisabled = isYearDisabled(y, _this.props);
			return y === preSelected && !isPreSelectedYearDisabled ? "0" : "-1";
		};
		_this.getYearContent = function(y) {
			return _this.props.renderYearContent ? _this.props.renderYearContent(y) : y;
		};
		return _this;
	}
	Year.prototype.render = function() {
		var _this = this;
		var yearsList = [];
		var _a = this.props, date = _a.date, yearItemNumber = _a.yearItemNumber, onYearMouseEnter = _a.onYearMouseEnter, onYearMouseLeave = _a.onYearMouseLeave;
		if (date === void 0) return null;
		var _b = getYearsPeriod(date, yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
		var _loop_1 = function(y) {
			yearsList.push(React.createElement("div", {
				ref: this_1.YEAR_REFS[y - startPeriod],
				onClick: function(event) {
					_this.onYearClick(event, y);
				},
				onKeyDown: function(event) {
					if (isSpaceKeyDown(event)) {
						event.preventDefault();
						event.key = KeyType.Enter;
					}
					_this.onYearKeyDown(event, y);
				},
				tabIndex: Number(this_1.getYearTabIndex(y)),
				className: this_1.getYearClassNames(y),
				onMouseEnter: !this_1.props.usePointerEvent ? function(event) {
					return onYearMouseEnter(event, y);
				} : void 0,
				onPointerEnter: this_1.props.usePointerEvent ? function(event) {
					return onYearMouseEnter(event, y);
				} : void 0,
				onMouseLeave: !this_1.props.usePointerEvent ? function(event) {
					return onYearMouseLeave(event, y);
				} : void 0,
				onPointerLeave: this_1.props.usePointerEvent ? function(event) {
					return onYearMouseLeave(event, y);
				} : void 0,
				key: y,
				"aria-current": this_1.isCurrentYear(y) ? "date" : void 0
			}, this_1.getYearContent(y)));
		};
		var this_1 = this;
		for (var y = startPeriod; y <= endPeriod; y++) _loop_1(y);
		return React.createElement("div", { className: "react-datepicker__year" }, React.createElement("div", {
			className: "react-datepicker__year-wrapper",
			onMouseLeave: !this.props.usePointerEvent ? this.props.clearSelectingDate : void 0,
			onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0
		}, yearsList));
	};
	return Year;
}(Component);
function generateYears(year, noOfYear, minDate, maxDate) {
	var list = [];
	for (var i = 0; i < 2 * noOfYear + 1; i++) {
		var newYear = year + noOfYear - i;
		var isInRange = true;
		if (minDate) isInRange = getYear(minDate) <= newYear;
		if (maxDate && isInRange) isInRange = getYear(maxDate) >= newYear;
		if (isInRange) list.push(newYear);
	}
	return list;
}
var YearDropdownOptions = function(_super) {
	__extends(YearDropdownOptions, _super);
	function YearDropdownOptions(props) {
		var _this = _super.call(this, props) || this;
		_this.yearOptionButtonsRef = {};
		_this.handleOptionKeyDown = function(year, e) {
			var _a;
			switch (e.key) {
				case "Enter":
					e.preventDefault();
					_this.onChange(year);
					break;
				case "Escape":
					e.preventDefault();
					_this.props.onCancel();
					break;
				case "ArrowUp":
				case "ArrowDown":
					e.preventDefault();
					var newYear = year + (e.key === "ArrowUp" ? 1 : -1);
					if (_this.yearOptionButtonsRef[newYear]) (_a = _this.yearOptionButtonsRef[newYear]) === null || _a === void 0 || _a.focus();
			}
		};
		_this.renderOptions = function() {
			_this.yearOptionButtonsRef = {};
			var selectedYear = _this.props.year;
			var options = _this.state.yearsList.map(function(year) {
				return React.createElement("div", {
					ref: function(el) {
						_this.yearOptionButtonsRef[year] = el;
						if (year === selectedYear) el === null || el === void 0 || el.focus();
					},
					role: "button",
					tabIndex: 0,
					className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
					key: year,
					onClick: _this.onChange.bind(_this, year),
					onKeyDown: _this.handleOptionKeyDown.bind(_this, year),
					"aria-selected": selectedYear === year ? "true" : void 0
				}, selectedYear === year ? React.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", year);
			});
			var minYear = _this.props.minDate ? getYear(_this.props.minDate) : null;
			var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : null;
			if (!maxYear || !_this.state.yearsList.find(function(year) {
				return year === maxYear;
			})) options.unshift(React.createElement("div", {
				className: "react-datepicker__year-option",
				key: "upcoming",
				onClick: _this.incrementYears
			}, React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })));
			if (!minYear || !_this.state.yearsList.find(function(year) {
				return year === minYear;
			})) options.push(React.createElement("div", {
				className: "react-datepicker__year-option",
				key: "previous",
				onClick: _this.decrementYears
			}, React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })));
			return options;
		};
		_this.onChange = function(year) {
			_this.props.onChange(year);
		};
		_this.handleClickOutside = function() {
			_this.props.onCancel();
		};
		_this.shiftYears = function(amount) {
			var years = _this.state.yearsList.map(function(year) {
				return year + amount;
			});
			_this.setState({ yearsList: years });
		};
		_this.incrementYears = function() {
			return _this.shiftYears(1);
		};
		_this.decrementYears = function() {
			return _this.shiftYears(-1);
		};
		var yearDropdownItemNumber = props.yearDropdownItemNumber, scrollableYearDropdown = props.scrollableYearDropdown;
		var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
		_this.state = { yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate) };
		_this.dropdownRef = createRef();
		return _this;
	}
	YearDropdownOptions.prototype.componentDidMount = function() {
		var dropdownCurrent = this.dropdownRef.current;
		if (dropdownCurrent) {
			var dropdownCurrentChildren = dropdownCurrent.children ? Array.from(dropdownCurrent.children) : null;
			var selectedYearOptionEl = dropdownCurrentChildren ? dropdownCurrentChildren.find(function(childEl) {
				return childEl.ariaSelected;
			}) : null;
			dropdownCurrent.scrollTop = selectedYearOptionEl && selectedYearOptionEl instanceof HTMLElement ? selectedYearOptionEl.offsetTop + (selectedYearOptionEl.clientHeight - dropdownCurrent.clientHeight) / 2 : (dropdownCurrent.scrollHeight - dropdownCurrent.clientHeight) / 2;
		}
	};
	YearDropdownOptions.prototype.render = function() {
		var dropdownClass = clsx({
			"react-datepicker__year-dropdown": true,
			"react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
		});
		return React.createElement(ClickOutsideWrapper, {
			className: dropdownClass,
			containerRef: this.dropdownRef,
			onClickOutside: this.handleClickOutside
		}, this.renderOptions());
	};
	return YearDropdownOptions;
}(Component);
var YearDropdown = function(_super) {
	__extends(YearDropdown, _super);
	function YearDropdown() {
		var _this = _super !== null && _super.apply(this, arguments) || this;
		_this.state = { dropdownVisible: false };
		_this.renderSelectOptions = function() {
			var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
			var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;
			var options = [];
			for (var i = minYear; i <= maxYear; i++) options.push(React.createElement("option", {
				key: i,
				value: i
			}, i));
			return options;
		};
		_this.onSelectChange = function(event) {
			_this.onChange(parseInt(event.target.value));
		};
		_this.renderSelectMode = function() {
			return React.createElement("select", {
				value: _this.props.year,
				className: "react-datepicker__year-select",
				onChange: _this.onSelectChange
			}, _this.renderSelectOptions());
		};
		_this.renderReadView = function(visible) {
			return React.createElement("button", {
				key: "read",
				type: "button",
				style: { visibility: visible ? "visible" : "hidden" },
				className: "react-datepicker__year-read-view",
				onClick: _this.toggleDropdown
			}, React.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), React.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, _this.props.year));
		};
		_this.renderDropdown = function() {
			return React.createElement(YearDropdownOptions, _assign({ key: "dropdown" }, _this.props, {
				onChange: _this.onChange,
				onCancel: _this.toggleDropdown
			}));
		};
		_this.renderScrollMode = function() {
			var dropdownVisible = _this.state.dropdownVisible;
			var result = [_this.renderReadView(!dropdownVisible)];
			if (dropdownVisible) result.unshift(_this.renderDropdown());
			return result;
		};
		_this.onChange = function(year) {
			_this.toggleDropdown();
			if (year === _this.props.year) return;
			_this.props.onChange(year);
		};
		_this.toggleDropdown = function(event) {
			_this.setState({ dropdownVisible: !_this.state.dropdownVisible }, function() {
				if (_this.props.adjustDateOnChange) _this.handleYearChange(_this.props.date, event);
			});
		};
		_this.handleYearChange = function(date, event) {
			var _a;
			(_a = _this.onSelect) === null || _a === void 0 || _a.call(_this, date, event);
			_this.setOpen();
		};
		_this.onSelect = function(date, event) {
			var _a, _b;
			(_b = (_a = _this.props).onSelect) === null || _b === void 0 || _b.call(_a, date, event);
		};
		_this.setOpen = function() {
			var _a, _b;
			(_b = (_a = _this.props).setOpen) === null || _b === void 0 || _b.call(_a, true);
		};
		return _this;
	}
	YearDropdown.prototype.render = function() {
		var renderedDropdown;
		switch (this.props.dropdownMode) {
			case "scroll":
				renderedDropdown = this.renderScrollMode();
				break;
			case "select": renderedDropdown = this.renderSelectMode();
		}
		return React.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, renderedDropdown);
	};
	return YearDropdown;
}(Component);
var DROPDOWN_FOCUS_CLASSNAMES = [
	"react-datepicker__year-select",
	"react-datepicker__month-select",
	"react-datepicker__month-year-select"
];
var OUTSIDE_CLICK_IGNORE_CLASS = "react-datepicker-ignore-onclickoutside";
var isDropdownSelect = function(element) {
	var classNames = (element.className || "").split(/\s+/);
	return DROPDOWN_FOCUS_CLASSNAMES.some(function(testClassname) {
		return classNames.indexOf(testClassname) >= 0;
	});
};
var Calendar = function(_super) {
	__extends(Calendar, _super);
	function Calendar(props) {
		var _this = _super.call(this, props) || this;
		_this.monthContainer = void 0;
		_this.handleClickOutside = function(event) {
			_this.props.onClickOutside(event);
		};
		_this.setClickOutsideRef = function() {
			return _this.containerRef.current;
		};
		_this.handleDropdownFocus = function(event) {
			var _a, _b;
			if (isDropdownSelect(event.target)) (_b = (_a = _this.props).onDropdownFocus) === null || _b === void 0 || _b.call(_a, event);
		};
		_this.getDateInView = function() {
			var _a = _this.props, preSelection = _a.preSelection, selected = _a.selected, openToDate = _a.openToDate;
			var minDate = getEffectiveMinDate(_this.props);
			var maxDate = getEffectiveMaxDate(_this.props);
			var current = newDate();
			var initialDate = openToDate || selected || preSelection;
			if (initialDate) return initialDate;
			else if (minDate && isBefore(current, minDate)) return minDate;
			else if (maxDate && isAfter(current, maxDate)) return maxDate;
			return current;
		};
		_this.increaseMonth = function() {
			_this.setState(function(_a) {
				var date = _a.date;
				return { date: addMonths(date, 1) };
			}, function() {
				return _this.handleMonthChange(_this.state.date);
			});
		};
		_this.decreaseMonth = function() {
			_this.setState(function(_a) {
				var date = _a.date;
				return { date: subMonths(date, 1) };
			}, function() {
				return _this.handleMonthChange(_this.state.date);
			});
		};
		_this.handleDayClick = function(day, event, monthSelectedIn) {
			_this.props.onSelect(day, event, monthSelectedIn);
			_this.props.setPreSelection && _this.props.setPreSelection(day);
		};
		_this.handleDayMouseEnter = function(day) {
			_this.setState({ selectingDate: day });
			_this.props.onDayMouseEnter && _this.props.onDayMouseEnter(day);
		};
		_this.handleMonthMouseLeave = function() {
			_this.setState({ selectingDate: void 0 });
			_this.props.onMonthMouseLeave && _this.props.onMonthMouseLeave();
		};
		_this.handleYearMouseEnter = function(event, year) {
			_this.setState({ selectingDate: setYear(newDate(), year) });
			_this.props.onYearMouseEnter && _this.props.onYearMouseEnter(event, year);
		};
		_this.handleYearMouseLeave = function(event, year) {
			_this.props.onYearMouseLeave && _this.props.onYearMouseLeave(event, year);
		};
		_this.handleYearChange = function(date) {
			var _a, _b, _c, _d;
			(_b = (_a = _this.props).onYearChange) === null || _b === void 0 || _b.call(_a, date);
			_this.setState({ isRenderAriaLiveMessage: true });
			if (_this.props.adjustDateOnChange) {
				_this.props.onSelect(date);
				(_d = (_c = _this.props).setOpen) === null || _d === void 0 || _d.call(_c, true);
			}
			_this.props.setPreSelection && _this.props.setPreSelection(date);
		};
		_this.getEnabledPreSelectionDateForMonth = function(date) {
			if (!isDayDisabled(date, _this.props)) return date;
			var startOfMonth = getStartOfMonth(date);
			var endOfMonth = getEndOfMonth(date);
			var totalDays = differenceInDays(endOfMonth, startOfMonth);
			var preSelectedDate = null;
			for (var dayIdx = 0; dayIdx <= totalDays; dayIdx++) {
				var processingDate = addDays(startOfMonth, dayIdx);
				if (!isDayDisabled(processingDate, _this.props)) {
					preSelectedDate = processingDate;
					break;
				}
			}
			return preSelectedDate;
		};
		_this.handleMonthChange = function(date) {
			var _a, _b, _c;
			var enabledPreSelectionDate = (_a = _this.getEnabledPreSelectionDateForMonth(date)) !== null && _a !== void 0 ? _a : date;
			_this.handleCustomMonthChange(enabledPreSelectionDate);
			if (_this.props.adjustDateOnChange) {
				_this.props.onSelect(enabledPreSelectionDate);
				(_c = (_b = _this.props).setOpen) === null || _c === void 0 || _c.call(_b, true);
			}
			_this.props.setPreSelection && _this.props.setPreSelection(enabledPreSelectionDate);
		};
		_this.handleCustomMonthChange = function(date) {
			var _a, _b;
			(_b = (_a = _this.props).onMonthChange) === null || _b === void 0 || _b.call(_a, date);
			_this.setState({ isRenderAriaLiveMessage: true });
		};
		_this.handleMonthYearChange = function(date) {
			_this.handleYearChange(date);
			_this.handleMonthChange(date);
		};
		_this.changeYear = function(year) {
			_this.setState(function(_a) {
				var date = _a.date;
				return { date: setYear(date, Number(year)) };
			}, function() {
				return _this.handleYearChange(_this.state.date);
			});
		};
		_this.changeMonth = function(month) {
			_this.setState(function(_a) {
				var date = _a.date;
				return { date: setMonth(date, Number(month)) };
			}, function() {
				var _a, _b;
				_this.handleMonthChange(_this.state.date);
				(_b = (_a = _this.props).onMonthSelectedInChange) === null || _b === void 0 || _b.call(_a, 0);
			});
		};
		_this.changeMonthYear = function(monthYear) {
			_this.setState(function(_a) {
				var date = _a.date;
				return { date: setYear(setMonth(date, getMonth(monthYear)), getYear(monthYear)) };
			}, function() {
				return _this.handleMonthYearChange(_this.state.date);
			});
		};
		_this.header = function(date, customDayNameCount) {
			if (date === void 0) date = _this.state.date;
			if (customDayNameCount === void 0) customDayNameCount = 0;
			if (!isValid$2(date)) return [];
			var disabled = _this.props.disabled;
			var startOfWeek = getStartOfWeek(date, _this.props.locale, _this.props.calendarStartDay);
			var dayNames = [];
			if (_this.props.showWeekNumbers) dayNames.push(React.createElement("div", {
				key: "W",
				className: "react-datepicker__day-name ".concat(disabled ? "react-datepicker__day-name--disabled" : ""),
				role: "columnheader"
			}, React.createElement("span", { className: "react-datepicker__sr-only" }, "Week number"), React.createElement("span", { "aria-hidden": "true" }, _this.props.weekLabel || "#")));
			return dayNames.concat([
				0,
				1,
				2,
				3,
				4,
				5,
				6
			].map(function(offset) {
				var day = addDays(startOfWeek, offset);
				var weekDayName = _this.formatWeekday(day, _this.props.locale);
				var fullDayName = formatDate(day, "EEEE", _this.props.locale);
				var weekDayClassName = _this.props.weekDayClassName ? _this.props.weekDayClassName(day) : void 0;
				if (_this.props.renderCustomDayName) {
					var customContent = _this.props.renderCustomDayName({
						day,
						shortName: weekDayName,
						fullName: fullDayName,
						locale: _this.props.locale,
						customDayNameCount
					});
					return React.createElement("div", {
						key: offset,
						role: "columnheader",
						className: clsx("react-datepicker__day-name", weekDayClassName, disabled ? "react-datepicker__day-name--disabled" : "")
					}, customContent);
				}
				return React.createElement("div", {
					key: offset,
					role: "columnheader",
					className: clsx("react-datepicker__day-name", weekDayClassName, disabled ? "react-datepicker__day-name--disabled" : "")
				}, React.createElement("span", { className: "react-datepicker__sr-only" }, fullDayName), React.createElement("span", { "aria-hidden": "true" }, weekDayName));
			}));
		};
		_this.formatWeekday = function(day, locale) {
			if (_this.props.formatWeekDay) return getFormattedWeekdayInLocale(day, _this.props.formatWeekDay, locale);
			return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(day, locale) : getWeekdayMinInLocale(day, locale);
		};
		_this.decreaseYear = function() {
			_this.setState(function(_a) {
				var _b;
				var date = _a.date;
				return { date: subYears(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar.defaultProps.yearItemNumber : 1) };
			}, function() {
				return _this.handleYearChange(_this.state.date);
			});
		};
		_this.clearSelectingDate = function() {
			_this.setState({ selectingDate: void 0 });
		};
		_this.renderPreviousButton = function() {
			var _a, _b, _c;
			if (_this.props.renderCustomHeader) return;
			var monthsShown = (_a = _this.props.monthsShown) !== null && _a !== void 0 ? _a : Calendar.defaultProps.monthsShown;
			var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
			var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
			var fromMonthDate = subMonths(_this.state.date, monthSelectedIn);
			var allPrevDaysDisabled;
			switch (true) {
				case _this.props.disabled:
					allPrevDaysDisabled = true;
					break;
				case _this.props.showMonthYearPicker:
					allPrevDaysDisabled = yearDisabledBefore(_this.state.date, _this.props);
					break;
				case _this.props.showYearPicker:
					allPrevDaysDisabled = yearsDisabledBefore(_this.state.date, _this.props);
					break;
				case _this.props.showQuarterYearPicker:
					allPrevDaysDisabled = quarterDisabledBefore(_this.state.date, _this.props);
					break;
				default: allPrevDaysDisabled = monthDisabledBefore(fromMonthDate, _this.props);
			}
			if (!((_c = _this.props.forceShowMonthNavigation) !== null && _c !== void 0 ? _c : Calendar.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) return;
			var iconClasses = ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"];
			var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];
			var clickHandler = _this.decreaseMonth;
			if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) clickHandler = _this.decreaseYear;
			if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
				classes.push("react-datepicker__navigation--previous--disabled");
				clickHandler = void 0;
			}
			var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
			var _d = _this.props, _e = _d.previousMonthButtonLabel, previousMonthButtonLabel = _e === void 0 ? Calendar.defaultProps.previousMonthButtonLabel : _e, _f = _d.previousYearButtonLabel, previousYearButtonLabel = _f === void 0 ? Calendar.defaultProps.previousYearButtonLabel : _f;
			var _g = _this.props, _h = _g.previousMonthAriaLabel, previousMonthAriaLabel = _h === void 0 ? typeof previousMonthButtonLabel === "string" ? previousMonthButtonLabel : "Previous Month" : _h, _j = _g.previousYearAriaLabel, previousYearAriaLabel = _j === void 0 ? typeof previousYearButtonLabel === "string" ? previousYearButtonLabel : "Previous Year" : _j;
			return React.createElement("button", {
				type: "button",
				className: classes.join(" "),
				onClick: clickHandler,
				onKeyDown: _this.props.handleOnKeyDown,
				"aria-label": isForYear ? previousYearAriaLabel : previousMonthAriaLabel
			}, React.createElement("span", { className: iconClasses.join(" ") }, isForYear ? previousYearButtonLabel : previousMonthButtonLabel));
		};
		_this.increaseYear = function() {
			_this.setState(function(_a) {
				var _b;
				var date = _a.date;
				return { date: addYears(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar.defaultProps.yearItemNumber : 1) };
			}, function() {
				return _this.handleYearChange(_this.state.date);
			});
		};
		_this.renderNextButton = function() {
			var _a;
			if (_this.props.renderCustomHeader) return;
			var allNextDaysDisabled;
			switch (true) {
				case _this.props.disabled:
					allNextDaysDisabled = true;
					break;
				case _this.props.showMonthYearPicker:
					allNextDaysDisabled = yearDisabledAfter(_this.state.date, _this.props);
					break;
				case _this.props.showYearPicker:
					allNextDaysDisabled = yearsDisabledAfter(_this.state.date, _this.props);
					break;
				case _this.props.showQuarterYearPicker:
					allNextDaysDisabled = quarterDisabledAfter(_this.state.date, _this.props);
					break;
				default: allNextDaysDisabled = monthDisabledAfter(_this.state.date, _this.props);
			}
			if (!((_a = _this.props.forceShowMonthNavigation) !== null && _a !== void 0 ? _a : Calendar.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) return;
			var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
			var iconClasses = ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"];
			if (_this.props.showTimeSelect) classes.push("react-datepicker__navigation--next--with-time");
			if (_this.props.todayButton) classes.push("react-datepicker__navigation--next--with-today-button");
			var clickHandler = _this.increaseMonth;
			if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) clickHandler = _this.increaseYear;
			if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
				classes.push("react-datepicker__navigation--next--disabled");
				clickHandler = void 0;
			}
			var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
			var _b = _this.props, _c = _b.nextMonthButtonLabel, nextMonthButtonLabel = _c === void 0 ? Calendar.defaultProps.nextMonthButtonLabel : _c, _d = _b.nextYearButtonLabel, nextYearButtonLabel = _d === void 0 ? Calendar.defaultProps.nextYearButtonLabel : _d;
			var _e = _this.props, _f = _e.nextMonthAriaLabel, nextMonthAriaLabel = _f === void 0 ? typeof nextMonthButtonLabel === "string" ? nextMonthButtonLabel : "Next Month" : _f, _g = _e.nextYearAriaLabel, nextYearAriaLabel = _g === void 0 ? typeof nextYearButtonLabel === "string" ? nextYearButtonLabel : "Next Year" : _g;
			return React.createElement("button", {
				type: "button",
				className: classes.join(" "),
				onClick: clickHandler,
				onKeyDown: _this.props.handleOnKeyDown,
				"aria-label": isForYear ? nextYearAriaLabel : nextMonthAriaLabel
			}, React.createElement("span", { className: iconClasses.join(" ") }, isForYear ? nextYearButtonLabel : nextMonthButtonLabel));
		};
		_this.renderCurrentMonth = function(date) {
			if (date === void 0) date = _this.state.date;
			var classes = ["react-datepicker__current-month"];
			if (_this.props.showYearDropdown) classes.push("react-datepicker__current-month--hasYearDropdown");
			if (_this.props.showMonthDropdown) classes.push("react-datepicker__current-month--hasMonthDropdown");
			if (_this.props.showMonthYearDropdown) classes.push("react-datepicker__current-month--hasMonthYearDropdown");
			return React.createElement("h2", { className: classes.join(" ") }, isValid$2(date) ? formatDate(date, _this.props.dateFormat, _this.props.locale) : "");
		};
		_this.renderYearDropdown = function(overrideHide) {
			if (overrideHide === void 0) overrideHide = false;
			if (!_this.props.showYearDropdown || overrideHide) return;
			return React.createElement(YearDropdown, _assign({}, Calendar.defaultProps, _this.props, {
				date: _this.state.date,
				onChange: _this.changeYear,
				year: getYear(_this.state.date)
			}));
		};
		_this.renderMonthDropdown = function(overrideHide) {
			if (overrideHide === void 0) overrideHide = false;
			if (!_this.props.showMonthDropdown || overrideHide) return;
			return React.createElement(MonthDropdown, _assign({}, Calendar.defaultProps, _this.props, {
				month: getMonth(_this.state.date),
				onChange: _this.changeMonth
			}));
		};
		_this.renderMonthYearDropdown = function(overrideHide) {
			if (overrideHide === void 0) overrideHide = false;
			if (!_this.props.showMonthYearDropdown || overrideHide) return;
			return React.createElement(MonthYearDropdown, _assign({}, Calendar.defaultProps, _this.props, {
				date: _this.state.date,
				onChange: _this.changeMonthYear
			}));
		};
		_this.handleTodayButtonClick = function(event) {
			_this.props.onSelect(getStartOfToday(), event);
			_this.props.setPreSelection && _this.props.setPreSelection(getStartOfToday());
		};
		_this.renderTodayButton = function() {
			if (!_this.props.todayButton || _this.props.showTimeSelectOnly) return;
			return React.createElement("div", {
				className: "react-datepicker__today-button",
				onClick: _this.handleTodayButtonClick
			}, _this.props.todayButton);
		};
		_this.renderDayNamesHeader = function(monthDate, customDayNameCount) {
			if (customDayNameCount === void 0) customDayNameCount = 0;
			return React.createElement("div", {
				className: "react-datepicker__day-names",
				role: "row"
			}, _this.header(monthDate, customDayNameCount));
		};
		_this.renderDefaultHeader = function(_a) {
			var monthDate = _a.monthDate, i = _a.i;
			var headerContent = React.createElement("div", { className: clsx("react-datepicker__header", {
				"react-datepicker__header--has-time-select": _this.props.showTimeSelect,
				"react-datepicker__header--middle": _this.props.monthHeaderPosition === "middle",
				"react-datepicker__header--bottom": _this.props.monthHeaderPosition === "bottom"
			}) }, _this.renderCurrentMonth(monthDate), React.createElement("div", {
				className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(_this.props.dropdownMode),
				onFocus: _this.handleDropdownFocus
			}, _this.renderMonthDropdown(i !== 0), _this.renderMonthYearDropdown(i !== 0), _this.renderYearDropdown(i !== 0)));
			if (_this.props.monthHeaderPosition === "top") return headerContent;
			return React.createElement("div", { className: "react-datepicker__header-wrapper" }, _this.renderPreviousButton() || null, _this.renderNextButton() || null, headerContent);
		};
		_this.renderCustomHeader = function(headerArgs) {
			var _a, _b;
			var monthDate = headerArgs.monthDate, i = headerArgs.i;
			if (_this.props.showTimeSelect && !_this.state.monthContainer || _this.props.showTimeSelectOnly) return null;
			var _c = _this.props, showYearPicker = _c.showYearPicker, yearItemNumber = _c.yearItemNumber;
			var visibleYearsRange;
			if (showYearPicker) {
				var _d = getYearsPeriod(monthDate, yearItemNumber);
				visibleYearsRange = {
					startYear: _d.startPeriod,
					endYear: _d.endPeriod
				};
			}
			var prevMonthButtonDisabled = monthDisabledBefore(_this.state.date, _this.props);
			var nextMonthButtonDisabled = monthDisabledAfter(_this.state.date, _this.props);
			var prevYearButtonDisabled = yearDisabledBefore(_this.state.date, _this.props);
			var nextYearButtonDisabled = yearDisabledAfter(_this.state.date, _this.props);
			return React.createElement("div", {
				className: "react-datepicker__header react-datepicker__header--custom",
				onFocus: _this.props.onDropdownFocus
			}, (_b = (_a = _this.props).renderCustomHeader) === null || _b === void 0 ? void 0 : _b.call(_a, _assign(_assign(_assign({}, _this.state), showYearPicker && { visibleYearsRange }), {
				customHeaderCount: i,
				monthDate,
				changeMonth: _this.changeMonth,
				changeYear: _this.changeYear,
				decreaseMonth: _this.decreaseMonth,
				increaseMonth: _this.increaseMonth,
				decreaseYear: _this.decreaseYear,
				increaseYear: _this.increaseYear,
				prevMonthButtonDisabled,
				nextMonthButtonDisabled,
				prevYearButtonDisabled,
				nextYearButtonDisabled
			})));
		};
		_this.renderYearHeader = function(_a) {
			var monthDate = _a.monthDate;
			var _b = _this.props, showYearPicker = _b.showYearPicker, _c = _b.yearItemNumber;
			var _d = getYearsPeriod(monthDate, _c === void 0 ? Calendar.defaultProps.yearItemNumber : _c), startPeriod = _d.startPeriod, endPeriod = _d.endPeriod;
			return React.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, showYearPicker ? "".concat(startPeriod, " - ").concat(endPeriod) : getYear(monthDate));
		};
		_this.renderHeader = function(_a) {
			var monthDate = _a.monthDate, _b = _a.i;
			var headerArgs = {
				monthDate,
				i: _b === void 0 ? 0 : _b
			};
			switch (true) {
				case _this.props.renderCustomHeader !== void 0: return _this.renderCustomHeader(headerArgs);
				case _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker: return _this.renderYearHeader(headerArgs);
				default: return _this.renderDefaultHeader(headerArgs);
			}
		};
		_this.renderMonths = function() {
			var _a, _b;
			if (_this.props.showTimeSelectOnly || _this.props.showYearPicker) return;
			var monthList = [];
			var monthsShown = (_a = _this.props.monthsShown) !== null && _a !== void 0 ? _a : Calendar.defaultProps.monthsShown;
			var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
			var fromMonthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? addYears(_this.state.date, monthsToSubtract) : subMonths(_this.state.date, monthsToSubtract);
			var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
			for (var i = 0; i < monthsShown; ++i) {
				var monthsToAdd = i - monthSelectedIn + monthsToSubtract;
				var monthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? addYears(fromMonthDate, monthsToAdd) : addMonths(fromMonthDate, monthsToAdd);
				var monthKey = "month-".concat(i);
				var monthShowsDuplicateDaysEnd = i < monthsShown - 1;
				var monthShowsDuplicateDaysStart = i > 0;
				monthList.push(React.createElement("div", {
					key: monthKey,
					ref: function(div) {
						_this.monthContainer = div !== null && div !== void 0 ? div : void 0;
					},
					className: "react-datepicker__month-container"
				}, _this.props.monthHeaderPosition === "top" && _this.renderHeader({
					monthDate,
					i
				}), React.createElement(Month, _assign({}, Calendar.defaultProps, _this.props, {
					containerRef: _this.containerRef,
					ariaLabelPrefix: _this.props.monthAriaLabelPrefix,
					day: monthDate,
					onDayClick: _this.handleDayClick,
					handleOnKeyDown: _this.props.handleOnDayKeyDown,
					handleOnMonthKeyDown: _this.props.handleOnKeyDown,
					onDayMouseEnter: _this.handleDayMouseEnter,
					onMouseLeave: _this.handleMonthMouseLeave,
					orderInDisplay: i,
					selectingDate: _this.state.selectingDate,
					monthShowsDuplicateDaysEnd,
					monthShowsDuplicateDaysStart,
					dayNamesHeader: _this.renderDayNamesHeader(monthDate, i),
					monthHeader: _this.props.monthHeaderPosition === "middle" ? _this.renderHeader({
						monthDate,
						i
					}) : void 0,
					monthFooter: _this.props.monthHeaderPosition === "bottom" ? _this.renderHeader({
						monthDate,
						i
					}) : void 0
				}))));
			}
			return monthList;
		};
		_this.renderYears = function() {
			if (_this.props.showTimeSelectOnly) return;
			if (_this.props.showYearPicker) return React.createElement("div", { className: "react-datepicker__year--container" }, _this.renderHeader({ monthDate: _this.state.date }), React.createElement(Year, _assign({}, Calendar.defaultProps, _this.props, {
				selectingDate: _this.state.selectingDate,
				date: _this.state.date,
				onDayClick: _this.handleDayClick,
				clearSelectingDate: _this.clearSelectingDate,
				onYearMouseEnter: _this.handleYearMouseEnter,
				onYearMouseLeave: _this.handleYearMouseLeave
			})));
		};
		_this.renderTimeSection = function() {
			if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) return React.createElement(Time, _assign({}, Calendar.defaultProps, _this.props, {
				onChange: _this.props.onTimeChange,
				format: _this.props.timeFormat,
				intervals: _this.props.timeIntervals,
				monthRef: _this.state.monthContainer
			}));
		};
		_this.renderInputTimeSection = function() {
			var _a, _b;
			if (!_this.props.showTimeInput) return;
			if (_this.props.selectsRange) {
				var _c = _this.props, startDate = _c.startDate, endDate = _c.endDate;
				var startTime = startDate ? new Date(startDate) : void 0;
				var startTimeString = startTime && isValid$2(startTime) && Boolean(startDate) ? "".concat(addZero(startTime.getHours()), ":").concat(addZero(startTime.getMinutes())) : "";
				var endTime = endDate ? new Date(endDate) : void 0;
				var endTimeString = endTime && isValid$2(endTime) && Boolean(endDate) ? "".concat(addZero(endTime.getHours()), ":").concat(addZero(endTime.getMinutes())) : "";
				return React.createElement(React.Fragment, null, React.createElement(InputTime, _assign({}, Calendar.defaultProps, _this.props, {
					date: startTime,
					timeString: startTimeString,
					onChange: function(time) {
						var _a, _b;
						(_b = (_a = _this.props).onTimeChange) === null || _b === void 0 || _b.call(_a, time, "start");
					},
					timeInputLabel: ((_a = _this.props.timeInputLabel) !== null && _a !== void 0 ? _a : "Time") + " (Start)"
				})), React.createElement(InputTime, _assign({}, Calendar.defaultProps, _this.props, {
					date: endTime,
					timeString: endTimeString,
					onChange: function(time) {
						var _a, _b;
						(_b = (_a = _this.props).onTimeChange) === null || _b === void 0 || _b.call(_a, time, "end");
					},
					timeInputLabel: ((_b = _this.props.timeInputLabel) !== null && _b !== void 0 ? _b : "Time") + " (End)"
				})));
			}
			var time = _this.props.selected ? new Date(_this.props.selected) : void 0;
			var timeString = time && isValid$2(time) && Boolean(_this.props.selected) ? "".concat(addZero(time.getHours()), ":").concat(addZero(time.getMinutes())) : "";
			return React.createElement(InputTime, _assign({}, Calendar.defaultProps, _this.props, {
				date: time,
				timeString,
				onChange: function(time) {
					var _a, _b;
					(_b = (_a = _this.props).onTimeChange) === null || _b === void 0 || _b.call(_a, time);
				}
			}));
		};
		_this.renderAriaLiveRegion = function() {
			var _a;
			if (!isValid$2(_this.state.date)) return React.createElement("span", {
				role: "alert",
				"aria-live": "polite",
				className: "react-datepicker__aria-live"
			});
			var _b = getYearsPeriod(_this.state.date, (_a = _this.props.yearItemNumber) !== null && _a !== void 0 ? _a : Calendar.defaultProps.yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
			var ariaLiveMessage;
			if (_this.props.showYearPicker) ariaLiveMessage = "".concat(startPeriod, " - ").concat(endPeriod);
			else if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker) ariaLiveMessage = getYear(_this.state.date);
			else ariaLiveMessage = "".concat(getMonthInLocale(getMonth(_this.state.date), _this.props.locale), " ").concat(getYear(_this.state.date));
			return React.createElement("span", {
				role: "alert",
				"aria-live": "polite",
				className: "react-datepicker__aria-live"
			}, _this.state.isRenderAriaLiveMessage && ariaLiveMessage);
		};
		_this.renderChildren = function() {
			if (_this.props.children) return React.createElement("div", { className: "react-datepicker__children-container" }, _this.props.children);
		};
		_this.containerRef = createRef();
		_this.state = {
			date: _this.getDateInView(),
			selectingDate: void 0,
			monthContainer: void 0,
			isRenderAriaLiveMessage: false
		};
		return _this;
	}
	Object.defineProperty(Calendar, "defaultProps", {
		get: function() {
			return {
				monthsShown: 1,
				forceShowMonthNavigation: false,
				outsideClickIgnoreClass: OUTSIDE_CLICK_IGNORE_CLASS,
				timeCaption: "Time",
				previousYearButtonLabel: "Previous Year",
				nextYearButtonLabel: "Next Year",
				previousMonthButtonLabel: "Previous Month",
				nextMonthButtonLabel: "Next Month",
				yearItemNumber: DEFAULT_YEAR_ITEM_NUMBER,
				monthHeaderPosition: "top"
			};
		},
		enumerable: false,
		configurable: true
	});
	Calendar.prototype.componentDidMount = function() {
		var _this = this;
		if (this.props.showTimeSelect) this.assignMonthContainer = (function() {
			_this.setState({ monthContainer: _this.monthContainer });
		})();
	};
	Calendar.prototype.componentDidUpdate = function(prevProps) {
		var _this = this;
		if (this.props.preSelection && isValid$2(this.props.preSelection) && (!isSameDay$2(this.props.preSelection, prevProps.preSelection) || this.props.monthSelectedIn !== prevProps.monthSelectedIn)) {
			var hasMonthChanged_1 = !isSameMonth$2(this.state.date, this.props.preSelection);
			this.setState({ date: this.props.preSelection }, function() {
				return hasMonthChanged_1 && _this.handleCustomMonthChange(_this.state.date);
			});
		} else if (this.props.openToDate && !isSameDay$2(this.props.openToDate, prevProps.openToDate)) this.setState({ date: this.props.openToDate });
	};
	Calendar.prototype.render = function() {
		var Container = this.props.container || CalendarContainer;
		return React.createElement(ClickOutsideWrapper, {
			onClickOutside: this.handleClickOutside,
			style: { display: "contents" },
			ignoreClass: this.props.outsideClickIgnoreClass
		}, React.createElement("div", {
			style: { display: "contents" },
			ref: this.containerRef
		}, React.createElement(Container, {
			className: clsx("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }),
			showTime: this.props.showTimeSelect || this.props.showTimeInput,
			showTimeSelectOnly: this.props.showTimeSelectOnly,
			inline: this.props.inline
		}, this.renderAriaLiveRegion(), this.props.monthHeaderPosition === "top" && this.renderPreviousButton(), this.props.monthHeaderPosition === "top" && this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren())));
	};
	return Calendar;
}(Component);
/**
* `CalendarIcon` is a React component that renders an icon for a calendar.
* The icon can be a string representing a CSS class, a React node, or a default SVG icon.
*
* @component
* @prop  icon - The icon to be displayed. This can be a string representing a CSS class or a React node.
* @prop  className - An optional string representing additional CSS classes to be applied to the icon.
* @prop  onClick - An optional function to be called when the icon is clicked.
*
* @example
* // To use a CSS class as the icon
* <CalendarIcon icon="my-icon-class" onClick={myClickHandler} />
*
* @example
* // To use a React node as the icon
* <CalendarIcon icon={<MyIconComponent />} onClick={myClickHandler} />
*
* @returns  The `CalendarIcon` component.
*/
var CalendarIcon = function(_a) {
	var icon = _a.icon, _b = _a.className, className = _b === void 0 ? "" : _b, onClick = _a.onClick;
	var defaultClass = "react-datepicker__calendar-icon";
	if (typeof icon === "string") return React.createElement("i", {
		className: "".concat(defaultClass, " ").concat(icon, " ").concat(className),
		"aria-hidden": "true",
		onClick
	});
	if (React.isValidElement(icon)) {
		var iconElement_1 = icon;
		return React.cloneElement(iconElement_1, {
			className: "".concat(iconElement_1.props.className || "", " ").concat(defaultClass, " ").concat(className),
			onClick: function(event) {
				if (typeof iconElement_1.props.onClick === "function") iconElement_1.props.onClick(event);
				if (typeof onClick === "function") onClick(event);
			}
		});
	}
	return React.createElement("svg", {
		className: "".concat(defaultClass, " ").concat(className),
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 448 512",
		onClick
	}, React.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" }));
};
/**
* `Portal` is a React component that allows you to render children into a DOM node
* that exists outside the DOM hierarchy of the parent component.
*
* @class
* @param {PortalProps} props - The properties that define the `Portal` component.
* @property {React.ReactNode} props.children - The children to be rendered into the `Portal`.
* @property {string} props.portalId - The id of the DOM node into which the `Portal` will render.
* @property {ShadowRoot} [props.portalHost] - The DOM node to host the `Portal`.
*/
var Portal = function(_super) {
	__extends(Portal, _super);
	function Portal(props) {
		var _this = _super.call(this, props) || this;
		_this.portalRoot = null;
		_this.el = document.createElement("div");
		return _this;
	}
	Portal.prototype.componentDidMount = function() {
		this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId);
		if (!this.portalRoot) {
			this.portalRoot = document.createElement("div");
			this.portalRoot.setAttribute("id", this.props.portalId);
			(this.props.portalHost || document.body).appendChild(this.portalRoot);
		}
		this.portalRoot.appendChild(this.el);
	};
	Portal.prototype.componentWillUnmount = function() {
		if (this.portalRoot) this.portalRoot.removeChild(this.el);
	};
	Portal.prototype.render = function() {
		return ReactDOM.createPortal(this.props.children, this.el);
	};
	return Portal;
}(Component);
var focusableElementsSelector = "[tabindex], a, button, input, select, textarea";
var focusableFilter = function(node) {
	if (node instanceof HTMLAnchorElement) return node.tabIndex !== -1;
	return !node.disabled && node.tabIndex !== -1;
};
/**
* `TabLoop` is a React component that manages tabbing behavior for its children.
*
* TabLoop prevents the user from tabbing outside of the popper
* It creates a tabindex loop so that "Tab" on the last element will focus the first element
* and "Shift Tab" on the first element will focus the last element
*
* @component
* @example
* <TabLoop enableTabLoop={true}>
*   <ChildComponent />
* </TabLoop>
*
* @param props - The properties that define the `TabLoop` component.
* @param props.children - The child components.
* @param props.enableTabLoop - Whether to enable the tab loop.
*
* @returns The `TabLoop` component.
*/
var TabLoop = function(_super) {
	__extends(TabLoop, _super);
	function TabLoop(props) {
		var _this = _super.call(this, props) || this;
		/**
		* `getTabChildren` is a method of the `TabLoop` class that retrieves all tabbable children of the component.
		*
		* This method uses the `tabbable` library to find all tabbable elements within the `TabLoop` component.
		* It then filters out any elements that are not visible.
		*
		* @returns An array of all tabbable and visible children of the `TabLoop` component.
		*/
		_this.getTabChildren = function() {
			var _a;
			return Array.prototype.slice.call((_a = _this.tabLoopRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(focusableElementsSelector), 1, -1).filter(focusableFilter);
		};
		_this.handleFocusStart = function() {
			var tabChildren = _this.getTabChildren();
			tabChildren && tabChildren.length > 1 && tabChildren[tabChildren.length - 1].focus();
		};
		_this.handleFocusEnd = function() {
			var tabChildren = _this.getTabChildren();
			tabChildren && tabChildren.length > 1 && tabChildren[0].focus();
		};
		_this.tabLoopRef = createRef();
		return _this;
	}
	TabLoop.prototype.render = function() {
		var _a;
		if (!((_a = this.props.enableTabLoop) !== null && _a !== void 0 ? _a : TabLoop.defaultProps.enableTabLoop)) return this.props.children;
		return React.createElement("div", {
			className: "react-datepicker__tab-loop",
			ref: this.tabLoopRef
		}, React.createElement("div", {
			className: "react-datepicker__tab-loop__start",
			tabIndex: 0,
			onFocus: this.handleFocusStart
		}), this.props.children, React.createElement("div", {
			className: "react-datepicker__tab-loop__end",
			tabIndex: 0,
			onFocus: this.handleFocusEnd
		}));
	};
	TabLoop.defaultProps = { enableTabLoop: true };
	return TabLoop;
}(Component);
/**
* `withFloating` is a higher-order component that adds floating behavior to a component.
*
* @param Component - The component to enhance.
*
* @example
* const FloatingComponent = withFloating(MyComponent);
* <FloatingComponent popperModifiers={[]} popperProps={{}} hidePopper={true} />
*
* @param popperModifiers - The modifiers to use for the popper.
* @param popperProps - The props to pass to the popper.
* @param hidePopper - Whether to hide the popper.
* @param popperPlacement - The placement of the popper.
*
* @returns A new component with floating behavior.
*/
function withFloating(Component) {
	function WithFloating(props) {
		var _a;
		var hidePopper = typeof props.hidePopper === "boolean" ? props.hidePopper : true;
		var arrowRef = useRef(null);
		var floatingProps = useFloating(_assign({
			open: !hidePopper,
			whileElementsMounted: autoUpdate,
			placement: props.popperPlacement,
			middleware: __spreadArray([
				flip({ padding: 15 }),
				offset(10),
				arrow({ element: arrowRef })
			], (_a = props.popperModifiers) !== null && _a !== void 0 ? _a : [], true)
		}, props.popperProps));
		var componentProps = _assign(_assign({}, props), {
			hidePopper,
			popperProps: _assign(_assign({}, floatingProps), { arrowRef })
		});
		return React.createElement(Component, _assign({}, componentProps));
	}
	WithFloating.displayName = "withFloating(".concat(Component.displayName || Component.name || "Component", ")");
	return WithFloating;
}
var PopperComponent$1 = function(props) {
	var className = props.className, wrapperClassName = props.wrapperClassName, _a = props.hidePopper, hidePopper = _a === void 0 ? true : _a, popperComponent = props.popperComponent, targetComponent = props.targetComponent, enableTabLoop = props.enableTabLoop, popperOnKeyDown = props.popperOnKeyDown, portalId = props.portalId, portalHost = props.portalHost, popperProps = props.popperProps, showArrow = props.showArrow, popperTargetRef = props.popperTargetRef, monthHeaderPosition = props.monthHeaderPosition;
	useEffect(function() {
		if (popperTargetRef === null || popperTargetRef === void 0 ? void 0 : popperTargetRef.current) popperProps.refs.setPositionReference(popperTargetRef.current);
	}, [popperTargetRef, popperProps.refs]);
	var popper = void 0;
	if (!hidePopper) {
		var classes = clsx("react-datepicker-popper", !showArrow && "react-datepicker-popper-offset", monthHeaderPosition === "middle" && "react-datepicker-popper--header-middle", monthHeaderPosition === "bottom" && "react-datepicker-popper--header-bottom", className);
		popper = React.createElement(TabLoop, { enableTabLoop }, React.createElement("div", {
			ref: popperProps.refs.setFloating,
			style: popperProps.floatingStyles,
			className: classes,
			"data-placement": popperProps.placement,
			onKeyDown: popperOnKeyDown
		}, popperComponent, showArrow && React.createElement(FloatingArrow, {
			ref: popperProps.arrowRef,
			context: popperProps.context,
			fill: "currentColor",
			strokeWidth: 1,
			height: 8,
			width: 16,
			style: { transform: "translateY(-1px)" },
			className: "react-datepicker__triangle"
		})));
	}
	if (props.popperContainer) popper = createElement(props.popperContainer, {}, popper);
	if (portalId && !hidePopper) popper = React.createElement(Portal, {
		portalId,
		portalHost
	}, popper);
	var wrapperClasses = clsx("react-datepicker-wrapper", wrapperClassName);
	return React.createElement(React.Fragment, null, React.createElement("div", {
		ref: popperProps.refs.setReference,
		className: wrapperClasses
	}, targetComponent), popper);
};
var PopperComponent = withFloating(PopperComponent$1);
function hasPreSelectionChanged(date1, date2) {
	if (date1 && date2) return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
	return date1 !== date2;
}
/**
* General datepicker component.
*/
var INPUT_ERR_1 = "Date input not valid.";
var DatePicker$1 = function(_super) {
	__extends(DatePicker, _super);
	function DatePicker(props) {
		var _this = _super.call(this, props) || this;
		_this.calendar = null;
		_this.input = null;
		_this.getPreSelection = function() {
			var timeZone = _this.props.timeZone;
			var baseDate = _this.props.openToDate ? _this.props.openToDate : _this.props.selectsEnd && _this.props.startDate ? _this.props.startDate : _this.props.selectsStart && _this.props.endDate ? _this.props.endDate : newDate();
			return timeZone ? toZonedTime(baseDate, timeZone) : baseDate;
		};
		_this.modifyHolidays = function() {
			var _a;
			return (_a = _this.props.holidays) === null || _a === void 0 ? void 0 : _a.reduce(function(accumulator, holiday) {
				var date = parseDate(holiday.date, "yyyy-MM-dd", void 0, false);
				if (!date) return accumulator;
				return __spreadArray(__spreadArray([], accumulator, true), [_assign(_assign({}, holiday), { date })], false);
			}, []);
		};
		_this.calcInitialState = function() {
			var timeZone = _this.props.timeZone;
			var defaultPreSelection = _this.getPreSelection();
			var minDate = getEffectiveMinDate(_this.props);
			var maxDate = getEffectiveMaxDate(_this.props);
			var boundedPreSelection = minDate && isBefore(defaultPreSelection, getStartOfDay(minDate)) ? minDate : maxDate && isAfter(defaultPreSelection, getEndOfDay(maxDate)) ? maxDate : defaultPreSelection;
			var initialPreSelection = _this.props.selectsRange ? _this.props.startDate : _this.props.selected;
			if (initialPreSelection && timeZone) initialPreSelection = toZonedTime(initialPreSelection, timeZone);
			return {
				open: _this.props.startOpen || false,
				preventFocus: false,
				inputValue: null,
				preSelection: initialPreSelection !== null && initialPreSelection !== void 0 ? initialPreSelection : boundedPreSelection,
				highlightDates: getHighLightDaysMap(_this.props.highlightDates),
				focused: false,
				shouldFocusDayInline: false,
				isRenderAriaLiveMessage: false,
				wasHidden: false
			};
		};
		_this.getInputValue = function() {
			var _a;
			var _b = _this.props, locale = _b.locale, startDate = _b.startDate, endDate = _b.endDate, rangeSeparator = _b.rangeSeparator, selected = _b.selected, selectedDates = _b.selectedDates, selectsMultiple = _b.selectsMultiple, selectsRange = _b.selectsRange, formatMultipleDates = _b.formatMultipleDates, value = _b.value;
			var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
			var inputValue = _this.state.inputValue;
			if (typeof value === "string") return value;
			else if (typeof inputValue === "string") return inputValue;
			else if (selectsRange) return safeDateRangeFormat(startDate, endDate, {
				dateFormat,
				locale,
				rangeSeparator
			});
			else if (selectsMultiple) {
				if (formatMultipleDates) {
					var formatDateFn = function(date) {
						return safeDateFormat(date, {
							dateFormat,
							locale
						});
					};
					return formatMultipleDates(selectedDates !== null && selectedDates !== void 0 ? selectedDates : [], formatDateFn);
				}
				return safeMultipleDatesFormat(selectedDates !== null && selectedDates !== void 0 ? selectedDates : [], {
					dateFormat,
					locale
				});
			}
			return safeDateFormat(selected, {
				dateFormat,
				locale
			});
		};
		_this.resetHiddenStatus = function() {
			_this.setState(_assign(_assign({}, _this.state), { wasHidden: false }));
		};
		_this.setHiddenStatus = function() {
			_this.setState(_assign(_assign({}, _this.state), { wasHidden: true }));
		};
		_this.setHiddenStateOnVisibilityHidden = function() {
			if (document.visibilityState !== "hidden") return;
			_this.setHiddenStatus();
		};
		_this.clearPreventFocusTimeout = function() {
			if (_this.preventFocusTimeout) clearTimeout(_this.preventFocusTimeout);
		};
		_this.setFocus = function() {
			var _a, _b;
			(_b = (_a = _this.input) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a, { preventScroll: true });
		};
		_this.setBlur = function() {
			var _a, _b;
			(_b = (_a = _this.input) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 || _b.call(_a);
			_this.cancelFocusInput();
		};
		_this.deferBlur = function() {
			requestAnimationFrame(function() {
				_this.setBlur();
			});
		};
		_this.setOpen = function(open, skipSetBlur) {
			if (skipSetBlur === void 0) skipSetBlur = false;
			_this.setState({
				open,
				preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
				lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
			}, function() {
				if (!open) _this.setState(function(prev) {
					return { focused: skipSetBlur ? prev.focused : false };
				}, function() {
					!skipSetBlur && _this.deferBlur();
					_this.setState({ inputValue: null });
				});
			});
		};
		_this.inputOk = function() {
			return isDate(_this.state.preSelection);
		};
		_this.isCalendarOpen = function() {
			return _this.props.open === void 0 ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
		};
		_this.handleFocus = function(event) {
			var _a, _b;
			var isAutoReFocus = _this.state.wasHidden;
			var isOpenAllowed = isAutoReFocus ? _this.state.open : true;
			if (isAutoReFocus) _this.resetHiddenStatus();
			if (!_this.state.preventFocus) {
				(_b = (_a = _this.props).onFocus) === null || _b === void 0 || _b.call(_a, event);
				if (isOpenAllowed && !_this.props.preventOpenOnFocus && !_this.props.readOnly) _this.setOpen(true);
			}
			_this.setState({ focused: true });
		};
		_this.sendFocusBackToInput = function() {
			if (_this.preventFocusTimeout) _this.clearPreventFocusTimeout();
			_this.setState({ preventFocus: true }, function() {
				_this.preventFocusTimeout = setTimeout(function() {
					_this.setFocus();
					_this.setState({ preventFocus: false });
				});
			});
		};
		_this.cancelFocusInput = function() {
			clearTimeout(_this.inputFocusTimeout);
			_this.inputFocusTimeout = void 0;
		};
		_this.deferFocusInput = function() {
			_this.cancelFocusInput();
			_this.inputFocusTimeout = setTimeout(function() {
				return _this.setFocus();
			}, 1);
		};
		_this.handleDropdownFocus = function() {
			_this.cancelFocusInput();
		};
		_this.resetInputValue = function() {
			_this.setState(_assign(_assign({}, _this.state), { inputValue: null }));
		};
		_this.handleBlur = function(event) {
			var _a, _b;
			if (!_this.state.open || _this.props.withPortal || _this.props.showTimeInput) (_b = (_a = _this.props).onBlur) === null || _b === void 0 || _b.call(_a, event);
			var inputValue = _this.state.inputValue;
			if (typeof inputValue === "string" && inputValue.length > 0) {
				if (!/[a-zA-Z0-9]/.test(inputValue) && _this.props.selected) _this.setSelected(null, void 0, true);
			}
			_this.resetInputValue();
			if (_this.state.open && _this.props.open === false) _this.setOpen(false);
			_this.setState({ focused: false });
		};
		_this.handleCalendarClickOutside = function(event) {
			var _a, _b;
			(_b = (_a = _this.props).onClickOutside) === null || _b === void 0 || _b.call(_a, event);
			if (!_this.props.inline && !event.defaultPrevented) _this.setOpen(false);
			if (_this.props.withPortal) event.preventDefault();
		};
		_this.handleChange = function() {
			var _a, _b, _c, _d, _e, _f, _g, _h;
			var allArgs = [];
			for (var _i = 0; _i < arguments.length; _i++) allArgs[_i] = arguments[_i];
			var event = allArgs[0];
			if (_this.props.onChangeRaw) {
				_this.props.onChangeRaw.apply(_this, allArgs);
				if (!event || typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) return;
			}
			_this.setState({
				inputValue: (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : null,
				lastPreSelectChange: PRESELECT_CHANGE_VIA_INPUT
			});
			var _j = _this.props, selectsRange = _j.selectsRange, startDate = _j.startDate, endDate = _j.endDate;
			var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
			var strictParsing = (_b = _this.props.strictParsing) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.strictParsing;
			var value = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : "";
			if (selectsRange) {
				var rangeSeparator = _this.props.rangeSeparator;
				var trimmedRangeSeparator = rangeSeparator.trim();
				var _k = value.split(dateFormat.includes(trimmedRangeSeparator) ? rangeSeparator : trimmedRangeSeparator, 2).map(function(val) {
					return val.trim();
				}), valueStart = _k[0], valueEnd = _k[1];
				var startDateNew = parseDate(valueStart !== null && valueStart !== void 0 ? valueStart : "", dateFormat, _this.props.locale, strictParsing);
				var endDateNew = startDateNew ? parseDate(valueEnd !== null && valueEnd !== void 0 ? valueEnd : "", dateFormat, _this.props.locale, strictParsing) : null;
				var startChanged = ((_c = safeToDate(startDate)) === null || _c === void 0 ? void 0 : _c.getTime()) !== (startDateNew === null || startDateNew === void 0 ? void 0 : startDateNew.getTime());
				var endChanged = ((_d = safeToDate(endDate)) === null || _d === void 0 ? void 0 : _d.getTime()) !== (endDateNew === null || endDateNew === void 0 ? void 0 : endDateNew.getTime());
				if (!startChanged && !endChanged) return;
				if (startDateNew && isDayDisabled(startDateNew, _this.props)) return;
				if (endDateNew && isDayDisabled(endDateNew, _this.props)) return;
				if (startDateNew) _this.setState({ preSelection: startDateNew });
				(_f = (_e = _this.props).onChange) === null || _f === void 0 || _f.call(_e, [startDateNew, endDateNew], event);
			} else {
				var date = parseDate(value, dateFormat, _this.props.locale, strictParsing, (_g = _this.props.selected) !== null && _g !== void 0 ? _g : void 0);
				if (date || !value) _this.setSelected(date, event, true);
				else if (!_this.props.inline) {
					var navDate = parseDateForNavigation(value, (_h = _this.state.preSelection) !== null && _h !== void 0 ? _h : void 0);
					if (navDate && (!_this.props.minDate || !isBefore(navDate, _this.props.minDate)) && (!_this.props.maxDate || !isAfter(navDate, _this.props.maxDate))) _this.setState({ preSelection: navDate });
				}
			}
		};
		_this.handleSelect = function(date, event, monthSelectedIn) {
			var _a;
			if (_this.props.readOnly) return;
			var _b = _this.props, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate, locale = _b.locale, swapRange = _b.swapRange;
			var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
			var isDateSelectionComplete = !selectsRange || startDate && !endDate && (swapRange || !isDateBefore(date, startDate));
			if (_this.props.shouldCloseOnSelect && !_this.props.showTimeSelect && isDateSelectionComplete) _this.sendFocusBackToInput();
			if (_this.props.onChangeRaw) {
				var formattedDate = safeDateFormat(date, {
					dateFormat,
					locale
				});
				_this.props.onChangeRaw(event, {
					date,
					formattedDate
				});
			}
			_this.setSelected(date, event, false, monthSelectedIn);
			if (_this.props.showDateSelect) _this.setState({ isRenderAriaLiveMessage: true });
			if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) _this.setPreSelection(date);
			else if (isDateSelectionComplete) _this.setOpen(false);
		};
		_this.setSelected = function(date, event, keepInput, monthSelectedIn) {
			var _a, _b;
			var timeZone = _this.props.timeZone;
			var changedDate = date;
			if (changedDate && timeZone) changedDate = fromZonedTime(changedDate, timeZone);
			if (_this.props.showYearPicker) {
				if (changedDate !== null && isYearDisabled(getYear(changedDate), _this.props)) return;
			} else if (_this.props.showMonthYearPicker) {
				if (changedDate !== null && isMonthDisabled(changedDate, _this.props)) return;
			} else if (changedDate !== null && isDayDisabled(changedDate, _this.props)) return;
			var _c = _this.props, onChange = _c.onChange, selectsRange = _c.selectsRange, startDate = _c.startDate, endDate = _c.endDate, selectsMultiple = _c.selectsMultiple, selectedDates = _c.selectedDates, minTime = _c.minTime, swapRange = _c.swapRange;
			if (!isEqual$2(_this.props.selected, changedDate) || _this.props.allowSameDay || selectsRange || selectsMultiple) {
				if (changedDate !== null) {
					if (_this.props.selected && (!keepInput || !_this.props.showTimeSelect && !_this.props.showTimeSelectOnly && !_this.props.showTimeInput)) changedDate = setTime(changedDate, {
						hour: getHours(_this.props.selected),
						minute: getMinutes(_this.props.selected),
						second: getSeconds(_this.props.selected)
					});
					if (!keepInput && (_this.props.showTimeSelect || _this.props.showTimeSelectOnly)) {
						if (minTime) changedDate = setTime(changedDate, {
							hour: minTime.getHours(),
							minute: minTime.getMinutes(),
							second: minTime.getSeconds()
						});
					}
					if (!_this.props.inline) _this.setState({ preSelection: changedDate });
					if (!_this.props.focusSelectedMonth) _this.setState({ monthSelectedIn });
				}
				if (selectsRange) {
					var onChangeRange = onChange;
					var noRanges = !startDate && !endDate;
					var hasStartRange = startDate && !endDate;
					var hasOnlyEndRange = !startDate && !!endDate;
					var isRangeFilled = startDate && endDate;
					if (noRanges) onChangeRange === null || onChangeRange === void 0 || onChangeRange([changedDate, null], event);
					else if (hasStartRange) {
						if (changedDate === null) onChangeRange === null || onChangeRange === void 0 || onChangeRange([null, null], event);
						else if (isDateBefore(changedDate, startDate)) {
							if (swapRange) onChangeRange === null || onChangeRange === void 0 || onChangeRange([changedDate, startDate], event);
							else onChangeRange === null || onChangeRange === void 0 || onChangeRange([changedDate, null], event);
						} else onChangeRange === null || onChangeRange === void 0 || onChangeRange([startDate, changedDate], event);
					} else if (hasOnlyEndRange) {
						if (changedDate && isDateBefore(changedDate, endDate)) onChangeRange === null || onChangeRange === void 0 || onChangeRange([changedDate, endDate], event);
						else onChangeRange === null || onChangeRange === void 0 || onChangeRange([changedDate, null], event);
					}
					if (isRangeFilled) onChangeRange === null || onChangeRange === void 0 || onChangeRange([changedDate, null], event);
				} else if (selectsMultiple) {
					var onChangeMultiple = onChange;
					if (changedDate !== null) {
						if (!(selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length)) onChangeMultiple === null || onChangeMultiple === void 0 || onChangeMultiple([changedDate], event);
						else if (selectedDates.some(function(selectedDate) {
							return isSameDay$2(selectedDate, changedDate);
						})) {
							var nextDates = selectedDates.filter(function(selectedDate) {
								return !isSameDay$2(selectedDate, changedDate);
							});
							onChangeMultiple === null || onChangeMultiple === void 0 || onChangeMultiple(nextDates, event);
						} else onChangeMultiple === null || onChangeMultiple === void 0 || onChangeMultiple(__spreadArray(__spreadArray([], selectedDates, true), [changedDate], false), event);
					}
				} else onChange === null || onChange === void 0 || onChange(changedDate, event);
			}
			if (!keepInput) {
				(_b = (_a = _this.props).onSelect) === null || _b === void 0 || _b.call(_a, changedDate, event);
				_this.setState({ inputValue: null });
			}
		};
		_this.setPreSelection = function(date) {
			if (_this.props.readOnly) return;
			var hasMinDate = isDate(_this.props.minDate);
			var hasMaxDate = isDate(_this.props.maxDate);
			var isValidDateSelection = true;
			if (date) {
				var dateStartOfDay = getStartOfDay(date);
				if (hasMinDate && hasMaxDate) isValidDateSelection = isDayInRange(date, _this.props.minDate, _this.props.maxDate);
				else if (hasMinDate) {
					var minDateStartOfDay = getStartOfDay(_this.props.minDate);
					isValidDateSelection = isAfter(date, minDateStartOfDay) || isEqual$2(dateStartOfDay, minDateStartOfDay);
				} else if (hasMaxDate) {
					var maxDateEndOfDay = getEndOfDay(_this.props.maxDate);
					isValidDateSelection = isBefore(date, maxDateEndOfDay) || isEqual$2(dateStartOfDay, maxDateEndOfDay);
				}
			}
			if (isValidDateSelection) _this.setState({ preSelection: date });
		};
		_this.toggleCalendar = function() {
			_this.setOpen(!_this.state.open);
		};
		_this.handleTimeChange = function(time, modifyDateType) {
			var _a, _b;
			if (_this.props.selectsMultiple) return;
			var _c = _this.props, selectsRange = _c.selectsRange, startDate = _c.startDate, endDate = _c.endDate, onChange = _c.onChange, timeZone = _c.timeZone;
			if (selectsRange) {
				var onChangeRange = onChange;
				if (modifyDateType === "start") {
					if (startDate) {
						var changedStartDate = setTime(startDate, {
							hour: getHours(time),
							minute: getMinutes(time)
						});
						_this.setState({ preSelection: changedStartDate });
						if (timeZone) changedStartDate = fromZonedTime(changedStartDate, timeZone);
						onChangeRange === null || onChangeRange === void 0 || onChangeRange([changedStartDate, endDate ? timeZone ? fromZonedTime(endDate, timeZone) : endDate : null], void 0);
					}
				} else if (modifyDateType === "end") {
					if (endDate) {
						var changedEndDate = setTime(endDate, {
							hour: getHours(time),
							minute: getMinutes(time)
						});
						_this.setState({ preSelection: changedEndDate });
						if (timeZone) changedEndDate = fromZonedTime(changedEndDate, timeZone);
						onChangeRange === null || onChangeRange === void 0 || onChangeRange([startDate ? timeZone ? fromZonedTime(startDate, timeZone) : startDate : null, changedEndDate], void 0);
					}
				} else if (startDate && !endDate) {
					var changedStartDate = setTime(startDate, {
						hour: getHours(time),
						minute: getMinutes(time)
					});
					_this.setState({ preSelection: changedStartDate });
					if (timeZone) changedStartDate = fromZonedTime(changedStartDate, timeZone);
					onChangeRange === null || onChangeRange === void 0 || onChangeRange([changedStartDate, null], void 0);
				} else if (startDate && endDate) {
					var changedEndDate = setTime(endDate, {
						hour: getHours(time),
						minute: getMinutes(time)
					});
					_this.setState({ preSelection: changedEndDate });
					if (timeZone) changedEndDate = fromZonedTime(changedEndDate, timeZone);
					onChangeRange === null || onChangeRange === void 0 || onChangeRange([timeZone ? fromZonedTime(startDate, timeZone) : startDate, changedEndDate], void 0);
				} else {
					var changedDate = setTime(_this.getPreSelection(), {
						hour: getHours(time),
						minute: getMinutes(time)
					});
					_this.setState({ preSelection: changedDate });
				}
			} else {
				var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
				var changedDate = _this.props.selected ? time : setTime(selected, {
					hour: getHours(time),
					minute: getMinutes(time)
				});
				_this.setState({ preSelection: changedDate });
				if (changedDate && timeZone) changedDate = fromZonedTime(changedDate, timeZone);
				(_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, changedDate);
			}
			if (_this.props.shouldCloseOnSelect && !_this.props.showTimeInput) {
				_this.sendFocusBackToInput();
				_this.setOpen(false);
			}
			if (_this.props.showTimeInput) _this.setOpen(true);
			if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) _this.setState({ isRenderAriaLiveMessage: true });
			_this.setState({ inputValue: null });
		};
		_this.onInputClick = function() {
			var _a, _b;
			if (!_this.props.disabled && !_this.props.readOnly) _this.setOpen(true);
			(_b = (_a = _this.props).onInputClick) === null || _b === void 0 || _b.call(_a);
		};
		_this.handleTimeOnlyArrowKey = function(eventKey) {
			var _a, _b, _c, _d;
			var currentTime = safeToDate(_this.props.selected) || _this.state.preSelection || newDate();
			var timeIntervals = (_a = _this.props.timeIntervals) !== null && _a !== void 0 ? _a : 30;
			var dateFormat = (_b = _this.props.dateFormat) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.dateFormat;
			var formatStr = Array.isArray(dateFormat) ? dateFormat[0] : dateFormat;
			var baseDate = getStartOfDay(currentTime);
			var currentMinutes = getHours(currentTime) * 60 + getMinutes(currentTime);
			var maxMinutes = 1440 - timeIntervals;
			var newTime;
			if (eventKey === KeyType.ArrowUp) {
				var newMinutes = Math.max(0, currentMinutes - timeIntervals);
				newTime = addMinutes(baseDate, newMinutes);
			} else {
				var newMinutes = Math.min(maxMinutes, currentMinutes + timeIntervals);
				newTime = addMinutes(baseDate, newMinutes);
			}
			var formattedTime = formatDate(newTime, formatStr || DatePicker.defaultProps.dateFormat, _this.props.locale);
			_this.setState({
				preSelection: newTime,
				inputValue: formattedTime
			});
			if (_this.props.selectsRange || _this.props.selectsMultiple) return;
			var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
			var changedDate = _this.props.selected ? newTime : setTime(selected, {
				hour: getHours(newTime),
				minute: getMinutes(newTime)
			});
			(_d = (_c = _this.props).onChange) === null || _d === void 0 || _d.call(_c, changedDate);
			if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) _this.setState({ isRenderAriaLiveMessage: true });
			requestAnimationFrame(function() {
				_this.scrollToTimeOption(newTime);
			});
		};
		_this.handleTimeOnlyEnterKey = function(event) {
			var _a, _b, _c, _d;
			var inputValue = event.target.value;
			var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
			var timeFormat = _this.props.timeFormat || "p";
			var defaultTime = _this.state.preSelection || safeToDate(_this.props.selected) || newDate();
			var parsedDate = parseDate(inputValue, dateFormat, _this.props.locale, (_b = _this.props.strictParsing) !== null && _b !== void 0 ? _b : false, defaultTime);
			var timeToCommit = defaultTime;
			if (parsedDate && isValid$2(parsedDate)) timeToCommit = parsedDate;
			else {
				var highlightedItem = ((_c = _this.calendar) === null || _c === void 0 ? void 0 : _c.containerRef.current) instanceof Element && _this.calendar.containerRef.current.querySelector(".react-datepicker__time-list-item[tabindex='0']");
				if (highlightedItem instanceof HTMLElement) {
					var itemText = (_d = highlightedItem.textContent) === null || _d === void 0 ? void 0 : _d.trim();
					if (itemText) {
						var itemTime = parseDate(itemText, timeFormat, _this.props.locale, false, defaultTime);
						if (itemTime && isValid$2(itemTime)) timeToCommit = itemTime;
					}
				}
			}
			_this.handleTimeChange(timeToCommit);
			_this.setOpen(false);
			_this.sendFocusBackToInput();
		};
		_this.scrollToTimeOption = function(time) {
			var _a, _b;
			if (!((_a = _this.calendar) === null || _a === void 0 ? void 0 : _a.containerRef.current)) return;
			var container = _this.calendar.containerRef.current;
			var timeListItems = Array.from(container.querySelectorAll(".react-datepicker__time-list-item"));
			var targetItem = null;
			var closestTimeDiff = Infinity;
			var timeFormat = _this.props.timeFormat || "p";
			for (var _i = 0, timeListItems_1 = timeListItems; _i < timeListItems_1.length; _i++) {
				var item = timeListItems_1[_i];
				var itemText = (_b = item.textContent) === null || _b === void 0 ? void 0 : _b.trim();
				if (itemText) {
					var itemTime = parseDate(itemText, timeFormat, _this.props.locale, false, time);
					if (itemTime && isValid$2(itemTime)) {
						if (isSameMinute(itemTime, time)) {
							targetItem = item;
							break;
						}
						var timeDiff = Math.abs(itemTime.getTime() - time.getTime());
						if (timeDiff < closestTimeDiff) {
							closestTimeDiff = timeDiff;
							targetItem = item;
						}
					}
				}
			}
			if (targetItem) {
				timeListItems.forEach(function(item) {
					item.setAttribute("tabindex", "-1");
				});
				targetItem.setAttribute("tabindex", "0");
				targetItem.scrollIntoView({
					behavior: "smooth",
					block: "center"
				});
			}
		};
		_this.onInputKeyDown = function(event) {
			var _a, _b, _c, _d, _e, _f;
			(_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
			var eventKey = event.key;
			if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
				if (eventKey === KeyType.ArrowDown || eventKey === KeyType.ArrowUp || eventKey === KeyType.Enter) (_c = _this.onInputClick) === null || _c === void 0 || _c.call(_this);
				return;
			}
			if (_this.state.open && _this.props.showTimeSelectOnly) {
				if (eventKey === KeyType.ArrowDown || eventKey === KeyType.ArrowUp) {
					event.preventDefault();
					_this.handleTimeOnlyArrowKey(eventKey);
					return;
				}
				if (eventKey === KeyType.Enter) {
					event.preventDefault();
					_this.handleTimeOnlyEnterKey(event);
					return;
				}
			}
			if (_this.state.open) {
				if (eventKey === KeyType.ArrowDown || eventKey === KeyType.ArrowUp) {
					event.preventDefault();
					var selectorString = _this.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : _this.props.showWeekPicker && _this.props.showWeekNumbers ? ".react-datepicker__week-number[tabindex=\"0\"]" : _this.props.showFullMonthYearPicker || _this.props.showMonthYearPicker ? ".react-datepicker__month-text[tabindex=\"0\"]" : ".react-datepicker__day[tabindex=\"0\"]";
					var selectedItem = ((_d = _this.calendar) === null || _d === void 0 ? void 0 : _d.containerRef.current) instanceof Element && _this.calendar.containerRef.current.querySelector(selectorString);
					selectedItem instanceof HTMLElement && selectedItem.focus({ preventScroll: true });
					return;
				}
				var copy = newDate(_this.state.preSelection);
				if (eventKey === KeyType.Enter) {
					event.preventDefault();
					event.target.blur();
					if (_this.inputOk() && _this.state.lastPreSelectChange === PRESELECT_CHANGE_VIA_NAVIGATE) {
						_this.handleSelect(copy, event);
						!_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
					} else _this.setOpen(false);
				} else if (eventKey === KeyType.Escape) {
					event.preventDefault();
					event.target.blur();
					_this.sendFocusBackToInput();
					_this.setOpen(false);
				} else if (eventKey === KeyType.Tab) _this.setOpen(false);
				if (!_this.inputOk()) (_f = (_e = _this.props).onInputError) === null || _f === void 0 || _f.call(_e, {
					code: 1,
					msg: INPUT_ERR_1
				});
			}
		};
		_this.onPortalKeyDown = function(event) {
			if (event.key === KeyType.Escape) {
				event.preventDefault();
				_this.setState({ preventFocus: true }, function() {
					_this.setOpen(false);
					setTimeout(function() {
						_this.setFocus();
						_this.setState({ preventFocus: false });
					});
				});
			}
		};
		_this.onDayKeyDown = function(event) {
			var _a, _b, _c, _d, _e, _f;
			var _g = _this.props, minDate = _g.minDate, maxDate = _g.maxDate, disabledKeyboardNavigation = _g.disabledKeyboardNavigation, showWeekPicker = _g.showWeekPicker, shouldCloseOnSelect = _g.shouldCloseOnSelect, locale = _g.locale, calendarStartDay = _g.calendarStartDay, adjustDateOnChange = _g.adjustDateOnChange, inline = _g.inline;
			(_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
			if (disabledKeyboardNavigation) return;
			var eventKey = event.key;
			var isShiftKeyActive = event.shiftKey;
			var copy = newDate(_this.state.preSelection);
			var calculateNewDate = function(eventKey, date) {
				var newCalculatedDate = date;
				switch (eventKey) {
					case KeyType.ArrowRight:
						newCalculatedDate = showWeekPicker ? addWeeks(date, 1) : addDays(date, 1);
						break;
					case KeyType.ArrowLeft:
						newCalculatedDate = showWeekPicker ? subWeeks(date, 1) : subDays(date, 1);
						break;
					case KeyType.ArrowUp:
						newCalculatedDate = subWeeks(date, 1);
						break;
					case KeyType.ArrowDown:
						newCalculatedDate = addWeeks(date, 1);
						break;
					case KeyType.PageUp:
						newCalculatedDate = isShiftKeyActive ? subYears(date, 1) : subMonths(date, 1);
						break;
					case KeyType.PageDown:
						newCalculatedDate = isShiftKeyActive ? addYears(date, 1) : addMonths(date, 1);
						break;
					case KeyType.Home:
						newCalculatedDate = getStartOfWeek(date, locale, calendarStartDay);
						break;
					case KeyType.End: newCalculatedDate = getEndOfWeek(date);
				}
				return newCalculatedDate;
			};
			var getNewDate = function(eventKey, date) {
				var MAX_ITERATIONS = 40;
				var eventKeyCopy = eventKey;
				var validDateFound = false;
				var iterations = 0;
				var newSelection = calculateNewDate(eventKey, date);
				while (!validDateFound) {
					if (iterations >= MAX_ITERATIONS) {
						newSelection = date;
						break;
					}
					if (minDate && newSelection < minDate) {
						eventKeyCopy = KeyType.ArrowRight;
						newSelection = isDayDisabled(minDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection) : minDate;
					}
					if (maxDate && newSelection > maxDate) {
						eventKeyCopy = KeyType.ArrowLeft;
						newSelection = isDayDisabled(maxDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection) : maxDate;
					}
					if (isDayDisabled(newSelection, _this.props)) {
						if (eventKeyCopy === KeyType.PageUp || eventKeyCopy === KeyType.Home) eventKeyCopy = KeyType.ArrowRight;
						if (eventKeyCopy === KeyType.PageDown || eventKeyCopy === KeyType.End) eventKeyCopy = KeyType.ArrowLeft;
						newSelection = calculateNewDate(eventKeyCopy, newSelection);
					} else validDateFound = true;
					iterations++;
				}
				return newSelection;
			};
			if (eventKey === KeyType.Enter) {
				event.preventDefault();
				_this.handleSelect(copy, event);
				!shouldCloseOnSelect && _this.setPreSelection(copy);
				return;
			} else if (eventKey === KeyType.Escape) {
				event.preventDefault();
				_this.setOpen(false);
				if (!_this.inputOk()) (_d = (_c = _this.props).onInputError) === null || _d === void 0 || _d.call(_c, {
					code: 1,
					msg: INPUT_ERR_1
				});
				return;
			}
			var newSelection = null;
			switch (eventKey) {
				case KeyType.ArrowLeft:
				case KeyType.ArrowRight:
				case KeyType.ArrowUp:
				case KeyType.ArrowDown:
				case KeyType.PageUp:
				case KeyType.PageDown:
				case KeyType.Home:
				case KeyType.End: newSelection = getNewDate(eventKey, copy);
			}
			if (!newSelection) {
				(_f = (_e = _this.props).onInputError) === null || _f === void 0 || _f.call(_e, {
					code: 1,
					msg: INPUT_ERR_1
				});
				return;
			}
			event.preventDefault();
			_this.setState({ lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE });
			if (adjustDateOnChange) _this.setSelected(newSelection);
			_this.setPreSelection(newSelection);
			if (inline) _this.setState({ shouldFocusDayInline: true });
		};
		_this.onPopperKeyDown = function(event) {
			if (event.key === KeyType.Escape) {
				event.preventDefault();
				_this.sendFocusBackToInput();
				_this.setOpen(false);
			}
		};
		_this.onClearClick = function(event) {
			if (event) {
				if (event.preventDefault) event.preventDefault();
			}
			_this.sendFocusBackToInput();
			var _a = _this.props, selectsRange = _a.selectsRange, onChange = _a.onChange;
			if (selectsRange) onChange === null || onChange === void 0 || onChange([null, null], event);
			else onChange === null || onChange === void 0 || onChange(null, event);
			_this.setState({ inputValue: null });
		};
		_this.clear = function() {
			_this.onClearClick();
		};
		_this.onScroll = function(event) {
			if (typeof _this.props.closeOnScroll === "boolean" && _this.props.closeOnScroll) {
				if (event.target === document || event.target === document.documentElement || event.target === document.body) _this.setOpen(false);
			} else if (typeof _this.props.closeOnScroll === "function") {
				if (_this.props.closeOnScroll(event)) _this.setOpen(false);
			}
		};
		_this.handleMonthSelectedInChange = function(monthSelectedIn) {
			_this.setState({ monthSelectedIn });
		};
		_this.renderCalendar = function() {
			var _a, _b;
			if (!_this.props.inline && !_this.isCalendarOpen()) return null;
			return React.createElement(Calendar, _assign({
				showMonthYearDropdown: void 0,
				ref: function(elem) {
					_this.calendar = elem;
				}
			}, _this.props, _this.state, {
				setOpen: _this.setOpen,
				dateFormat: (_a = _this.props.dateFormatCalendar) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormatCalendar,
				onSelect: _this.handleSelect,
				onClickOutside: _this.handleCalendarClickOutside,
				holidays: getHolidaysMap(_this.modifyHolidays()),
				outsideClickIgnoreClass: _this.props.outsideClickIgnoreClass,
				onDropdownFocus: _this.handleDropdownFocus,
				onTimeChange: _this.handleTimeChange,
				className: _this.props.calendarClassName,
				container: _this.props.calendarContainer,
				handleOnKeyDown: _this.props.onKeyDown,
				handleOnDayKeyDown: _this.onDayKeyDown,
				setPreSelection: _this.setPreSelection,
				dropdownMode: (_b = _this.props.dropdownMode) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.dropdownMode,
				onMonthSelectedInChange: _this.handleMonthSelectedInChange
			}), _this.props.children);
		};
		_this.renderAriaLiveRegion = function() {
			var _a;
			var locale = _this.props.locale;
			var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
			var longDateFormat = _this.props.showTimeInput || _this.props.showTimeSelect ? "PPPPp" : "PPPP";
			var ariaLiveMessage;
			if (_this.props.selectsRange) ariaLiveMessage = "Selected start date: ".concat(safeDateFormat(_this.props.startDate, {
				dateFormat: longDateFormat,
				locale
			}), ". ").concat(_this.props.endDate ? "End date: " + safeDateFormat(_this.props.endDate, {
				dateFormat: longDateFormat,
				locale
			}) : "");
			else if (_this.props.showTimeSelectOnly) ariaLiveMessage = "Selected time: ".concat(safeDateFormat(_this.props.selected, {
				dateFormat,
				locale
			}));
			else if (_this.props.showYearPicker) ariaLiveMessage = "Selected year: ".concat(safeDateFormat(_this.props.selected, {
				dateFormat: "yyyy",
				locale
			}));
			else if (_this.props.showMonthYearPicker) ariaLiveMessage = "Selected month: ".concat(safeDateFormat(_this.props.selected, {
				dateFormat: "MMMM yyyy",
				locale
			}));
			else if (_this.props.showQuarterYearPicker) ariaLiveMessage = "Selected quarter: ".concat(safeDateFormat(_this.props.selected, {
				dateFormat: "yyyy, QQQ",
				locale
			}));
			else ariaLiveMessage = "Selected date: ".concat(safeDateFormat(_this.props.selected, {
				dateFormat: longDateFormat,
				locale
			}));
			return React.createElement("span", {
				role: "alert",
				"aria-live": "polite",
				className: "react-datepicker__aria-live"
			}, ariaLiveMessage);
		};
		_this.renderDateInput = function() {
			var _a, _b;
			var _c, _d, _e, _f, _g;
			var className = clsx(_this.props.className, (_a = {}, _a[_this.props.outsideClickIgnoreClass || DatePicker.defaultProps.outsideClickIgnoreClass] = _this.state.open, _a));
			var customInput = _this.props.customInput || React.createElement("input", { type: "text" });
			var customInputRef = _this.props.customInputRef || "ref";
			var ariaProps = {};
			var ariaDescribedBy = (_c = _this.props["aria-describedby"]) !== null && _c !== void 0 ? _c : _this.props.ariaDescribedBy;
			var ariaInvalid = (_d = _this.props["aria-invalid"]) !== null && _d !== void 0 ? _d : _this.props.ariaInvalid;
			var ariaLabel = (_e = _this.props["aria-label"]) !== null && _e !== void 0 ? _e : _this.props.ariaLabel;
			var ariaLabelledBy = (_f = _this.props["aria-labelledby"]) !== null && _f !== void 0 ? _f : _this.props.ariaLabelledBy;
			var ariaRequired = (_g = _this.props["aria-required"]) !== null && _g !== void 0 ? _g : _this.props.ariaRequired;
			if (ariaDescribedBy != null) ariaProps["aria-describedby"] = ariaDescribedBy;
			if (ariaInvalid != null) ariaProps["aria-invalid"] = ariaInvalid;
			if (ariaLabel != null) ariaProps["aria-label"] = ariaLabel;
			if (ariaLabelledBy != null) ariaProps["aria-labelledby"] = ariaLabelledBy;
			if (ariaRequired != null) ariaProps["aria-required"] = ariaRequired;
			return cloneElement(customInput, _assign((_b = {}, _b[customInputRef] = function(input) {
				_this.input = input;
			}, _b.value = _this.getInputValue(), _b.onBlur = _this.handleBlur, _b.onChange = _this.handleChange, _b.onClick = _this.onInputClick, _b.onFocus = _this.handleFocus, _b.onKeyDown = _this.onInputKeyDown, _b.id = _this.props.id, _b.name = _this.props.name, _b.form = _this.props.form, _b.autoFocus = _this.props.autoFocus, _b.placeholder = _this.props.placeholderText, _b.disabled = _this.props.disabled, _b.autoComplete = _this.props.autoComplete, _b.className = clsx(customInput.props.className, className), _b.title = _this.props.title, _b.readOnly = _this.props.readOnly, _b.required = _this.props.required, _b.tabIndex = _this.props.tabIndex, _b), ariaProps));
		};
		_this.renderClearButton = function() {
			var _a = _this.props, isClearable = _a.isClearable, disabled = _a.disabled, selected = _a.selected, startDate = _a.startDate, endDate = _a.endDate, clearButtonTitle = _a.clearButtonTitle, _b = _a.clearButtonClassName, clearButtonClassName = _b === void 0 ? "" : _b, _c = _a.ariaLabelClose, ariaLabelClose = _c === void 0 ? "Close" : _c, selectedDates = _a.selectedDates, readOnly = _a.readOnly;
			if (isClearable && !readOnly && (selected != null || startDate != null || endDate != null || (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length))) return React.createElement("button", {
				type: "button",
				className: clsx("react-datepicker__close-icon", clearButtonClassName, { "react-datepicker__close-icon--disabled": disabled }),
				disabled,
				"aria-label": ariaLabelClose,
				onClick: _this.onClearClick,
				title: clearButtonTitle,
				tabIndex: -1
			});
			else return null;
		};
		_this.state = _this.calcInitialState();
		_this.preventFocusTimeout = void 0;
		return _this;
	}
	Object.defineProperty(DatePicker, "defaultProps", {
		get: function() {
			return {
				allowSameDay: false,
				dateFormat: "MM/dd/yyyy",
				dateFormatCalendar: "LLLL yyyy",
				disabled: false,
				disabledKeyboardNavigation: false,
				dropdownMode: "scroll",
				preventOpenOnFocus: false,
				monthsShown: 1,
				outsideClickIgnoreClass: OUTSIDE_CLICK_IGNORE_CLASS,
				readOnly: false,
				rangeSeparator: DATE_RANGE_SEPARATOR,
				withPortal: false,
				selectsDisabledDaysInRange: false,
				shouldCloseOnSelect: true,
				showTimeSelect: false,
				showTimeInput: false,
				showPreviousMonths: false,
				showMonthYearPicker: false,
				showFullMonthYearPicker: false,
				showTwoColumnMonthYearPicker: false,
				showFourColumnMonthYearPicker: false,
				showYearPicker: false,
				showQuarterYearPicker: false,
				showWeekPicker: false,
				strictParsing: false,
				swapRange: false,
				timeIntervals: 30,
				timeCaption: "Time",
				previousMonthAriaLabel: "Previous Month",
				previousMonthButtonLabel: "Previous Month",
				nextMonthAriaLabel: "Next Month",
				nextMonthButtonLabel: "Next Month",
				previousYearAriaLabel: "Previous Year",
				previousYearButtonLabel: "Previous Year",
				nextYearAriaLabel: "Next Year",
				nextYearButtonLabel: "Next Year",
				timeInputLabel: "Time",
				enableTabLoop: true,
				yearItemNumber: DEFAULT_YEAR_ITEM_NUMBER,
				focusSelectedMonth: false,
				showPopperArrow: true,
				excludeScrollbar: true,
				customTimeInput: null,
				calendarStartDay: void 0,
				toggleCalendarOnIconClick: false,
				usePointerEvent: false
			};
		},
		enumerable: false,
		configurable: true
	});
	DatePicker.prototype.componentDidMount = function() {
		window.addEventListener("scroll", this.onScroll, true);
		document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
	};
	DatePicker.prototype.componentDidUpdate = function(prevProps, prevState) {
		var _a, _b, _c, _d;
		if (this.props.selectsRange && hasPreSelectionChanged(prevProps.startDate, this.props.startDate)) this.setPreSelection(this.props.startDate);
		else if (hasPreSelectionChanged(prevProps.selected, this.props.selected)) this.setPreSelection(this.props.selected);
		if (this.state.monthSelectedIn !== void 0 && prevProps.monthsShown !== this.props.monthsShown) this.setState({ monthSelectedIn: 0 });
		if (this.props.selectsRange && prevState.open === false && this.state.open === true && this.state.monthSelectedIn !== 0) this.setState({ monthSelectedIn: 0 });
		if (prevProps.highlightDates !== this.props.highlightDates) this.setState({ highlightDates: getHighLightDaysMap(this.props.highlightDates) });
		if (!prevState.focused && !isEqual$2(prevProps.selected, this.props.selected)) this.setState({ inputValue: null });
		if (prevState.open !== this.state.open) {
			if (prevState.open === false && this.state.open === true) (_b = (_a = this.props).onCalendarOpen) === null || _b === void 0 || _b.call(_a);
			if (prevState.open === true && this.state.open === false) (_d = (_c = this.props).onCalendarClose) === null || _d === void 0 || _d.call(_c);
		}
	};
	DatePicker.prototype.componentWillUnmount = function() {
		this.clearPreventFocusTimeout();
		window.removeEventListener("scroll", this.onScroll, true);
		document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
	};
	DatePicker.prototype.renderInputContainer = function() {
		var _a = this.props, showIcon = _a.showIcon, icon = _a.icon, calendarIconClassname = _a.calendarIconClassname, calendarIconClassName = _a.calendarIconClassName, toggleCalendarOnIconClick = _a.toggleCalendarOnIconClick;
		var open = this.state.open;
		if (calendarIconClassname) console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props.");
		return React.createElement("div", { className: "react-datepicker__input-container".concat(showIcon ? " react-datepicker__view-calendar-icon" : "") }, showIcon && React.createElement(CalendarIcon, _assign({
			icon,
			className: clsx(calendarIconClassName, !calendarIconClassName && calendarIconClassname, open && "react-datepicker-ignore-onclickoutside")
		}, toggleCalendarOnIconClick ? { onClick: this.toggleCalendar } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
	};
	DatePicker.prototype.render = function() {
		var calendar = this.renderCalendar();
		if (this.props.inline) return calendar;
		if (this.props.withPortal) {
			var portalContainer = this.state.open ? React.createElement(TabLoop, { enableTabLoop: this.props.enableTabLoop }, React.createElement("div", {
				className: "react-datepicker__portal",
				tabIndex: -1,
				onKeyDown: this.onPortalKeyDown
			}, calendar)) : null;
			if (this.state.open && this.props.portalId) portalContainer = React.createElement(Portal, _assign({ portalId: this.props.portalId }, this.props), portalContainer);
			return React.createElement(React.Fragment, null, this.renderInputContainer(), portalContainer);
		}
		return React.createElement(PopperComponent, _assign({}, this.props, {
			className: this.props.popperClassName,
			hidePopper: !this.isCalendarOpen(),
			targetComponent: this.renderInputContainer(),
			popperComponent: calendar,
			popperOnKeyDown: this.onPopperKeyDown,
			showArrow: this.props.showPopperArrow,
			monthHeaderPosition: this.props.monthHeaderPosition
		}));
	};
	return DatePicker;
}(Component);
var PRESELECT_CHANGE_VIA_INPUT = "input";
var PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";
//#endregion
//#region src/date-picker.tsx
var REGISTERED_LOCALES = /* @__PURE__ */ new Set([
	"cs",
	"cs-CZ",
	"de",
	"de-DE",
	"en",
	"en-GB",
	"es",
	"es-ES",
	"fr",
	"fr-FR",
	"hu",
	"hu-HU",
	"it",
	"it-IT",
	"nl",
	"nl-NL",
	"pl",
	"pl-PL",
	"pt",
	"pt-PT",
	"ro",
	"ro-RO",
	"sv",
	"sv-SE"
]);
setDefaultLocale("en-GB");
registerLocale("en", enGB);
registerLocale("en-GB", enGB);
registerLocale("it-IT", it);
registerLocale("it", it);
registerLocale("es-ES", es);
registerLocale("es", es);
registerLocale("fr-FR", fr);
registerLocale("fr", fr);
registerLocale("de-DE", de);
registerLocale("de", de);
registerLocale("pt-PT", pt);
registerLocale("pt", pt);
registerLocale("cs-CZ", cs);
registerLocale("cs", cs);
registerLocale("hu-HU", hu);
registerLocale("hu", hu);
registerLocale("pl-PL", pl);
registerLocale("pl", pl);
registerLocale("nl-NL", nl);
registerLocale("nl", nl);
registerLocale("ro-RO", ro);
registerLocale("ro", ro);
registerLocale("sv-SE", sv);
registerLocale("sv", sv);
var resolveLocale = (locale) => {
	const normalized = locale.replace("_", "-");
	if (REGISTERED_LOCALES.has(normalized)) return normalized;
	const language = normalized.split("-", 1)[0] ?? "en";
	return REGISTERED_LOCALES.has(language) ? language : "en-GB";
};
function DatePicker({ id, locale, placeholder, label, value, format = "dd/MM/yyyy", range = "all", showTime = false, showValidIcon = true, errorMessage, labelCss = {}, required = false, onChange, css: cssFromProp = {} }) {
	const innerId = useMemo(() => id ?? v4(), [id]);
	const inputId = useMemo(() => `${innerId}_${v4()}`, [innerId]);
	const { locale: pageLocale } = usePage();
	const innerLocale = useMemo(() => {
		return resolveLocale(locale && !isEmpty(trim(locale)) ? locale : pageLocale);
	}, [locale, pageLocale]);
	const [innerValue, setInnerValue] = useState(value ?? null);
	useEffect(() => {
		setInnerValue(value ?? null);
	}, [value]);
	const innerOnChange = useCallback((newDate) => {
		setInnerValue(newDate);
		onChange?.(newDate);
	}, [onChange]);
	return /* @__PURE__ */ jsxs("div", {
		className: cx("input-group", css(cssFromProp)),
		children: [
			label ? /* @__PURE__ */ jsx(FormLabel, {
				htmlFor: inputId,
				required,
				css: labelCss,
				error: Boolean(errorMessage),
				children: label
			}) : null,
			/* @__PURE__ */ jsx("div", {
				className: css({
					position: "relative",
					rounded: "md",
					transition: "background 200ms ease-in-out",
					bg: "gray.50",
					".input-group:focus-within &": { bg: "gray.50" }
				}, Boolean(errorMessage) && {
					bg: "error.500/10",
					mb: "1"
				}),
				children: /* @__PURE__ */ jsxs("div", {
					className: css({
						w: "full",
						position: "relative",
						display: "flex",
						flex: "1",
						rounded: "md",
						transition: "outline 200ms ease-in-out",
						outline: "1px solid token(colors.gray.200)",
						".input-group:focus-within &": { outline: "2px solid token(colors.accent.500)" }
					}, Boolean(errorMessage) && { outline: "2px solid token(colors.error.500)" }),
					children: [/* @__PURE__ */ jsx(DatePicker$1, {
						locale: innerLocale,
						name: inputId,
						dateFormat: format,
						placeholderText: placeholder,
						maxDate: range === "past" ? /* @__PURE__ */ new Date() : void 0,
						minDate: range === "future" ? /* @__PURE__ */ new Date() : void 0,
						onChange: innerOnChange,
						selected: innerValue,
						className: css({
							bg: "transparent",
							border: "0",
							flex: "1",
							minW: "0",
							display: "block",
							w: "full",
							px: "3",
							py: "2",
							outline: "none",
							_focus: {
								outline: "none",
								shadow: "none",
								ring: "0"
							}
						}),
						showTimeInput: showTime,
						timeFormat: "HH:mm"
					}), !errorMessage && showValidIcon && !isNil(innerValue) ? /* @__PURE__ */ jsx("div", {
						className: css({
							pointerEvents: "none",
							display: "flex",
							alignItems: "center",
							pr: "3"
						}),
						children: /* @__PURE__ */ jsx("div", {
							className: css({
								bg: "valid.500",
								h: "1.15em",
								w: "1.15em",
								rounded: "full",
								overflow: "hidden",
								position: "relative"
							}),
							children: /* @__PURE__ */ jsx(FontAwesome, {
								size: .7,
								name: "fa-solid fa-check",
								css: css.raw({
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									position: "absolute",
									top: 0,
									left: 0,
									w: "full",
									h: "full",
									color: "white",
									lineHeight: 0
								})
							})
						})
					}) : null]
				})
			}),
			!isEmpty(errorMessage) ? /* @__PURE__ */ jsx(FormError, { children: errorMessage }) : null
		]
	});
}
//#endregion
//#region src/form-date.tsx
var form_date_exports = /* @__PURE__ */ __exportAll({ FormDate: () => FormDate });
var formatDateToString = (date, showTime) => {
	if (!date) return void 0;
	if (typeof date === "string") return date;
	return showTime ? date.toISOString() : format(date, "yyyy-MM-dd");
};
function FormDate({ id, locale, defaultValue: defaultValueProp, prefillUsing, placeholder, label, format = "dd/MM/yyyy", validation: propValidation, range = "all", hidden = false, width = "100", currentDate = false, showTime = false, css: cssFromProp = {} }) {
	const innerFormat = useMemo(() => {
		if (format && !isEmpty(trim(format))) return format;
		if (showTime) return "dd/MM/yyyy HH:mm";
		return "dd/MM/yyyy";
	}, [format, showTime]);
	const innerId = useMemo(() => id ?? v4(), [id]);
	const { unregister, register, setValue, formState } = useFormContext();
	const { step } = useFormStepContext();
	const { registerId } = useFormContext$1();
	const { validation, getErrorMessage } = useFormValidation(propValidation);
	const sanitizedDefaultValueProp = useMemo(() => {
		if (currentDate === true || isNumber(currentDate)) return addDays(/* @__PURE__ */ new Date(), isNumber(currentDate) ? currentDate : 0);
		if (typeof defaultValueProp === "string") {
			if (isEmpty(trim(defaultValueProp))) return null;
			return parse(defaultValueProp, innerFormat, /* @__PURE__ */ new Date());
		}
		return defaultValueProp ?? null;
	}, [
		currentDate,
		defaultValueProp,
		innerFormat
	]);
	const { defaultValue } = useFormPrefillValues(prefillUsing, { defaultValue: formatDateToString(sanitizedDefaultValueProp, showTime) });
	const parsedDefaultValue = useMemo(() => {
		if (defaultValue) return showTime ? new Date(defaultValue) : parse(defaultValue, "yyyy-MM-dd", /* @__PURE__ */ new Date());
		return null;
	}, [defaultValue, showTime]);
	useEffect(() => {
		setValue(innerId, defaultValue ?? "");
	}, [
		innerId,
		setValue,
		defaultValue
	]);
	useEffect(() => {
		return registerId(step, innerId);
	}, [
		registerId,
		step,
		innerId
	]);
	useEffect(() => {
		const newValue = formatDateToString(defaultValue, showTime);
		register(innerId, {
			...validation,
			value: newValue
		});
		return () => {
			unregister(innerId);
		};
	}, [
		defaultValue,
		innerId,
		register,
		showTime,
		unregister,
		validation
	]);
	const onChange = useCallback((date) => {
		const newValue = formatDateToString(date, showTime);
		setValue(innerId, newValue, { shouldValidate: true });
	}, [
		innerId,
		setValue,
		showTime
	]);
	const style = useMemo(() => ({ "--width": `${width}%` }), [width]);
	const error = get(formState.errors, innerId);
	return /* @__PURE__ */ jsx("div", {
		style,
		className: css({
			display: "flex",
			flexDir: "column",
			px: "1",
			w: "full",
			desktop: { w: "var(--width)" }
		}, hidden ? {
			visibility: "hidden",
			position: "absolute",
			h: 0,
			w: 0,
			overflow: "hidden"
		} : {}),
		children: /* @__PURE__ */ jsx(DatePicker, {
			onChange,
			value: parsedDefaultValue,
			id,
			required: get(validation, "required.value", false),
			label,
			placeholder,
			css: css.raw({
				w: "full",
				...cssFromProp
			}),
			errorMessage: error ? getErrorMessage(error) : void 0,
			locale,
			format: innerFormat,
			range,
			showTime
		})
	});
}
//#endregion
export { form_date_exports as n, DatePicker as r, FormDate as t };
